
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire40f8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire40f8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("axYUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = void 0;

var $1Znhr = parcelRequire("1Znhr");

var $1aYx7 = parcelRequire("1aYx7");
var $7adc3d644fbe964d$var$VNode = /** @class */ function() {
    function VNode(_b) {
        var e_1, _c;
        var children = _b.children, meta = $1Znhr.__rest(_b, [
            "children"
        ]);
        Object.assign(this, meta);
        try {
            for(var _d = $1Znhr.__values(children || []), _e = _d.next(); !_e.done; _e = _d.next()){
                var vNode = _e.value;
                if (_a.isFragment(vNode)) this.children = $1Znhr.__spreadArray($1Znhr.__spreadArray([], $1Znhr.__read(this.children || []), false), $1Znhr.__read(vNode.children || []), false);
                else this.children = $1Znhr.__spreadArray($1Znhr.__spreadArray([], $1Znhr.__read(this.children || []), false), [
                    vNode
                ], false);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return;
        this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, ".")),
            is && '[is="'.concat(is, '"]')
        ].filter(Boolean).join("");
    }
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $1Znhr.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $1aYx7.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute("is")
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== "style" && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: "class",
        htmlFor: "for"
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}();
module.exports.VNode = $7adc3d644fbe964d$var$VNode;

});
parcelRegister("1Znhr", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $172d8be976204b2c$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $172d8be976204b2c$export$3c9a16f847548506);
$parcel$export(module.exports, "__exportStar", () => $172d8be976204b2c$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $172d8be976204b2c$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $172d8be976204b2c$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $172d8be976204b2c$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $172d8be976204b2c$var$extendStatics = function(d, b) {
    $172d8be976204b2c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $172d8be976204b2c$var$extendStatics(d, b);
};
function $172d8be976204b2c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $172d8be976204b2c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $172d8be976204b2c$export$18ce0697a983be9b = function() {
    $172d8be976204b2c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $172d8be976204b2c$export$18ce0697a983be9b.apply(this, arguments);
};
function $172d8be976204b2c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $172d8be976204b2c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $172d8be976204b2c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $172d8be976204b2c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $172d8be976204b2c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $172d8be976204b2c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $172d8be976204b2c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $172d8be976204b2c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $172d8be976204b2c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $172d8be976204b2c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $172d8be976204b2c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $172d8be976204b2c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $172d8be976204b2c$export$45d3717a4c69092e(o, m, p);
}
function $172d8be976204b2c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $172d8be976204b2c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $172d8be976204b2c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($172d8be976204b2c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $172d8be976204b2c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $172d8be976204b2c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $172d8be976204b2c$export$10c90e4f7922046c(v) {
    return this instanceof $172d8be976204b2c$export$10c90e4f7922046c ? (this.v = v, this) : new $172d8be976204b2c$export$10c90e4f7922046c(v);
}
function $172d8be976204b2c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $172d8be976204b2c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $172d8be976204b2c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $172d8be976204b2c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $172d8be976204b2c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $172d8be976204b2c$export$19a8beecd37a4c45 === "function" ? $172d8be976204b2c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $172d8be976204b2c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $172d8be976204b2c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $172d8be976204b2c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $172d8be976204b2c$export$45d3717a4c69092e(result, mod, k);
    }
    $172d8be976204b2c$var$__setModuleDefault(result, mod);
    return result;
}
function $172d8be976204b2c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $172d8be976204b2c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $172d8be976204b2c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $172d8be976204b2c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $172d8be976204b2c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $172d8be976204b2c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $172d8be976204b2c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $172d8be976204b2c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $172d8be976204b2c$export$2e2bcd8739ae039 = {
    __extends: $172d8be976204b2c$export$a8ba968b8961cb8a,
    __assign: $172d8be976204b2c$export$18ce0697a983be9b,
    __rest: $172d8be976204b2c$export$3c9a16f847548506,
    __decorate: $172d8be976204b2c$export$29e00dfd3077644b,
    __param: $172d8be976204b2c$export$d5ad3fd78186038f,
    __metadata: $172d8be976204b2c$export$f1db080c865becb9,
    __awaiter: $172d8be976204b2c$export$1050f835b63b671e,
    __generator: $172d8be976204b2c$export$67ebef60e6f28a6,
    __createBinding: $172d8be976204b2c$export$45d3717a4c69092e,
    __exportStar: $172d8be976204b2c$export$f33643c0debef087,
    __values: $172d8be976204b2c$export$19a8beecd37a4c45,
    __read: $172d8be976204b2c$export$8d051b38c9118094,
    __spread: $172d8be976204b2c$export$afc72e2116322959,
    __spreadArrays: $172d8be976204b2c$export$6388937ca91ccae8,
    __spreadArray: $172d8be976204b2c$export$1216008129fb82ed,
    __await: $172d8be976204b2c$export$10c90e4f7922046c,
    __asyncGenerator: $172d8be976204b2c$export$e427f37a30a4de9b,
    __asyncDelegator: $172d8be976204b2c$export$bbd80228419bb833,
    __asyncValues: $172d8be976204b2c$export$e3b29a3d6162315f,
    __makeTemplateObject: $172d8be976204b2c$export$4fb47efe1390b86f,
    __importStar: $172d8be976204b2c$export$c21735bcef00d192,
    __importDefault: $172d8be976204b2c$export$da59b14a69baef04,
    __classPrivateFieldGet: $172d8be976204b2c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $172d8be976204b2c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $172d8be976204b2c$export$81fdc39f203e4e04,
    __addDisposableResource: $172d8be976204b2c$export$88ac25d8e944e405,
    __disposeResources: $172d8be976204b2c$export$8f076105dc360e92
};

});

parcelRegister("1aYx7", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $0db5ae3bef085140$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $0db5ae3bef085140$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $0db5ae3bef085140$export$86f54f62aa7a7514);
$parcel$export(module.exports, "uniqueID", () => $0db5ae3bef085140$export$89912e019eef22aa);
$parcel$export(module.exports, "DiffStatus", () => $0db5ae3bef085140$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $0db5ae3bef085140$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $0db5ae3bef085140$export$3f063810d7bf01bd);
$parcel$export(module.exports, "likeArray", () => $0db5ae3bef085140$export$b5a4d6f439a5044d);
$parcel$export(module.exports, "isTypedArray", () => $0db5ae3bef085140$export$b119cc7e1840e59c);
$parcel$export(module.exports, "splitArray", () => $0db5ae3bef085140$export$697c3df919c0e61a);
$parcel$export(module.exports, "countBy", () => $0db5ae3bef085140$export$1d012a0dff3dab06);
$parcel$export(module.exports, "createAsyncIterator", () => $0db5ae3bef085140$export$86c18c6347f4a8c4);
$parcel$export(module.exports, "ByteSize", () => $0db5ae3bef085140$export$271f7c16f175f804);
$parcel$export(module.exports, "Day", () => $0db5ae3bef085140$export$7a9a31a911eb9a20);
$parcel$export(module.exports, "formatDate", () => $0db5ae3bef085140$export$3ae94a2503e890a1);
$parcel$export(module.exports, "changeMonth", () => $0db5ae3bef085140$export$62ad822b3a5fd9a0);
$parcel$export(module.exports, "parseJSON", () => $0db5ae3bef085140$export$27924e57e9afff7f);
$parcel$export(module.exports, "isXDomain", () => $0db5ae3bef085140$export$71e6483fc2b024eb);
$parcel$export(module.exports, "parseURLData", () => $0db5ae3bef085140$export$eb9b2aadbe449a20);
$parcel$export(module.exports, "buildURLData", () => $0db5ae3bef085140$export$13397a83aa5915d6);
$parcel$export(module.exports, "templateOf", () => $0db5ae3bef085140$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $0db5ae3bef085140$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $0db5ae3bef085140$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $0db5ae3bef085140$export$b8a1af58c024fefd);
$parcel$export(module.exports, "stringifyDOM", () => $0db5ae3bef085140$export$b0709844452f8b6b);
$parcel$export(module.exports, "getVisibleText", () => $0db5ae3bef085140$export$be4650432daa84fd);
$parcel$export(module.exports, "importCSS", () => $0db5ae3bef085140$export$7cd14c57bbb84350);
$parcel$export(module.exports, "stringifyCSS", () => $0db5ae3bef085140$export$5100419dfae0456d);
$parcel$export(module.exports, "scrollTo", () => $0db5ae3bef085140$export$3f99968195accfaf);
$parcel$export(module.exports, "formToJSON", () => $0db5ae3bef085140$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "sleep", () => $0db5ae3bef085140$export$e772c8ff12451969);
$parcel$export(module.exports, "delegate", () => $0db5ae3bef085140$export$10b1921597150314);
$parcel$export(module.exports, "documentReady", () => $0db5ae3bef085140$export$3e2b244719956741);
$parcel$export(module.exports, "serviceWorkerUpdate", () => $0db5ae3bef085140$export$d635d04af3887bbe);
function $0db5ae3bef085140$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $0db5ae3bef085140$var$$9b05bcda60cc529c$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $0db5ae3bef085140$export$61cc6ed0f143570b;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $0db5ae3bef085140$export$dd1bc94b04021eeb;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $0db5ae3bef085140$export$a09f818797e212c4;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $0db5ae3bef085140$export$170f4e08cad8229d;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $0db5ae3bef085140$export$2a489b3f92f4996a;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $0db5ae3bef085140$export$67a6ce548ae77071;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $0db5ae3bef085140$export$a48f0734ac7c2329;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $0db5ae3bef085140$export$3f34ca2fef821bbd;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $0db5ae3bef085140$export$86f54f62aa7a7514;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $0db5ae3bef085140$export$89912e019eef22aa;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $0db5ae3bef085140$export$1c8ba402144543e5;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $0db5ae3bef085140$export$2ddabb89308e1a22;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $0db5ae3bef085140$export$14527669107aa301;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $0db5ae3bef085140$export$3f063810d7bf01bd;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $0db5ae3bef085140$export$b5a4d6f439a5044d;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $0db5ae3bef085140$export$b119cc7e1840e59c;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $0db5ae3bef085140$export$7b85fd78dd236198;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $0db5ae3bef085140$export$697c3df919c0e61a;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $0db5ae3bef085140$export$e6b5ff3168b5942b;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $0db5ae3bef085140$export$1d012a0dff3dab06;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $0db5ae3bef085140$export$69a3209f1a06c04d;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $0db5ae3bef085140$export$86c18c6347f4a8c4;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $0db5ae3bef085140$export$dce9414bed0662c;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $0db5ae3bef085140$export$271f7c16f175f804;
});
var $0db5ae3bef085140$var$$6a9944941b4c1893$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "sum", function() {
    return $0db5ae3bef085140$export$8a63f25cc62965f1;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $0db5ae3bef085140$export$e1f36757ecda301d;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $0db5ae3bef085140$export$8e694e1eafd55acb;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $0db5ae3bef085140$export$57d7c52a66287430;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $0db5ae3bef085140$export$2b4693832ca3ce16;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $0db5ae3bef085140$export$5b784e078da1ce6;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $0db5ae3bef085140$export$17ec9c9f4f23588c;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $0db5ae3bef085140$export$595dbf49c602a1f;
});
function $0db5ae3bef085140$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $0db5ae3bef085140$export$e1f36757ecda301d(...data) {
    return $0db5ae3bef085140$export$8a63f25cc62965f1(...data) / data.length;
}
function $0db5ae3bef085140$export$8e694e1eafd55acb(data, sample = false) {
    const average = $0db5ae3bef085140$export$e1f36757ecda301d(...data);
    const summary = $0db5ae3bef085140$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $0db5ae3bef085140$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($0db5ae3bef085140$export$8e694e1eafd55acb(data, sample));
}
function $0db5ae3bef085140$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($0db5ae3bef085140$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $0db5ae3bef085140$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $0db5ae3bef085140$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $0db5ae3bef085140$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
class $0db5ae3bef085140$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
function $0db5ae3bef085140$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $0db5ae3bef085140$export$dd1bc94b04021eeb(value) {
    return $0db5ae3bef085140$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $0db5ae3bef085140$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $0db5ae3bef085140$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $0db5ae3bef085140$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $0db5ae3bef085140$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $0db5ae3bef085140$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $0db5ae3bef085140$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $0db5ae3bef085140$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $0db5ae3bef085140$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $0db5ae3bef085140$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $0db5ae3bef085140$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($0db5ae3bef085140$export$2ddabb89308e1a22 || ($0db5ae3bef085140$export$2ddabb89308e1a22 = {}));
function $0db5ae3bef085140$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $0db5ae3bef085140$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $0db5ae3bef085140$export$b5a4d6f439a5044d(data) {
    if ($0db5ae3bef085140$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $0db5ae3bef085140$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $0db5ae3bef085140$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($0db5ae3bef085140$export$61cc6ed0f143570b(data)) return [];
    if ($0db5ae3bef085140$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $0db5ae3bef085140$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $0db5ae3bef085140$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $0db5ae3bef085140$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $0db5ae3bef085140$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $0db5ae3bef085140$export$1d012a0dff3dab06(list, iteratee) {
    const group = $0db5ae3bef085140$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $0db5ae3bef085140$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $0db5ae3bef085140$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol("done"), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $0db5ae3bef085140$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $0db5ae3bef085140$export$271f7c16f175f804 extends $0db5ae3bef085140$export$595dbf49c602a1f {
    constructor(...args){
        super(...args);
        this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + "B"
            }));
    }
}
var $0db5ae3bef085140$var$$f872d8bba1c0f79f$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $0db5ae3bef085140$export$c489aa6f7fd82b1a;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $0db5ae3bef085140$export$cbd942915f33be50;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $0db5ae3bef085140$export$9b886f8493244014;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $0db5ae3bef085140$export$e99cbb807a5bb10d;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $0db5ae3bef085140$export$7a9a31a911eb9a20;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $0db5ae3bef085140$export$fca4f8121099df57;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $0db5ae3bef085140$export$6ce2f08d515512;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $0db5ae3bef085140$export$951c8378cdfec6e6;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $0db5ae3bef085140$export$1a4097b876a13bf7;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $0db5ae3bef085140$export$d9bcbd5e1ff81430;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $0db5ae3bef085140$export$506c8e8f8c8edda;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $0db5ae3bef085140$export$3ae94a2503e890a1;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $0db5ae3bef085140$export$62ad822b3a5fd9a0;
});
const $0db5ae3bef085140$export$c489aa6f7fd82b1a = 1000;
const $0db5ae3bef085140$export$cbd942915f33be50 = $0db5ae3bef085140$export$c489aa6f7fd82b1a * 60;
const $0db5ae3bef085140$export$9b886f8493244014 = $0db5ae3bef085140$export$cbd942915f33be50 * 15;
const $0db5ae3bef085140$export$e99cbb807a5bb10d = $0db5ae3bef085140$export$9b886f8493244014 * 4;
const $0db5ae3bef085140$export$7a9a31a911eb9a20 = $0db5ae3bef085140$export$e99cbb807a5bb10d * 24;
const $0db5ae3bef085140$export$fca4f8121099df57 = $0db5ae3bef085140$export$7a9a31a911eb9a20 * 7;
const $0db5ae3bef085140$export$6ce2f08d515512 = $0db5ae3bef085140$export$7a9a31a911eb9a20 * 365;
const $0db5ae3bef085140$export$951c8378cdfec6e6 = $0db5ae3bef085140$export$6ce2f08d515512 / 12;
const $0db5ae3bef085140$export$1a4097b876a13bf7 = $0db5ae3bef085140$export$951c8378cdfec6e6 * 3;
class $0db5ae3bef085140$export$d9bcbd5e1ff81430 extends $0db5ae3bef085140$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args);
        this.units = [
            {
                base: $0db5ae3bef085140$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $0db5ae3bef085140$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $0db5ae3bef085140$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $0db5ae3bef085140$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $0db5ae3bef085140$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $0db5ae3bef085140$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $0db5ae3bef085140$export$6ce2f08d515512,
                name: "Y"
            }
        ];
    }
}
function $0db5ae3bef085140$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $0db5ae3bef085140$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $0db5ae3bef085140$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $0db5ae3bef085140$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $0db5ae3bef085140$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $0db5ae3bef085140$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $0db5ae3bef085140$var$$ba0e5dc395660a7c$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $0db5ae3bef085140$export$27924e57e9afff7f;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $0db5ae3bef085140$export$7ea17d45ecdcf634;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $0db5ae3bef085140$export$bb8626e4916f587b;
});
function $0db5ae3bef085140$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || $0db5ae3bef085140$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $0db5ae3bef085140$export$7ea17d45ecdcf634(raw) {
    const parsed = $0db5ae3bef085140$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $0db5ae3bef085140$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $0db5ae3bef085140$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $0db5ae3bef085140$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($0db5ae3bef085140$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}
var $0db5ae3bef085140$var$$083124ac4b1a50a0$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $0db5ae3bef085140$export$71e6483fc2b024eb;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $0db5ae3bef085140$export$eb9b2aadbe449a20;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $0db5ae3bef085140$export$13397a83aa5915d6;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $0db5ae3bef085140$export$fd89523fba250fa4;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $0db5ae3bef085140$export$504fbde693c1771c;
});
function $0db5ae3bef085140$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $0db5ae3bef085140$export$eb9b2aadbe449a20(raw = window.location.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($0db5ae3bef085140$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $0db5ae3bef085140$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : $0db5ae3bef085140$export$b5a4d6f439a5044d(value) ? $0db5ae3bef085140$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
function $0db5ae3bef085140$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$0db5ae3bef085140$export$dd1bc94b04021eeb(value) && [
            key,
            $0db5ae3bef085140$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $0db5ae3bef085140$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $0db5ae3bef085140$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $0db5ae3bef085140$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $0db5ae3bef085140$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $0db5ae3bef085140$var$$50872bf213056663$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $0db5ae3bef085140$export$1b9ac4d3de3ffd2e;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$50872bf213056663$exports, "makeSHA", function() {
    return $0db5ae3bef085140$export$d51f3b55e8d1aa73;
});
const $0db5ae3bef085140$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $0db5ae3bef085140$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $0db5ae3bef085140$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) crypto1.subtle = crypto1["webkitSubtle"];
}
async function $0db5ae3bef085140$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
var $0db5ae3bef085140$var$$93a3089d2937b23f$exports = {};
var $0db5ae3bef085140$var$$3e0a089cc13f69ad$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $0db5ae3bef085140$export$2ee022bbbc550b25;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $0db5ae3bef085140$export$a549dd5cef7f8327;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $0db5ae3bef085140$export$8eece510bcb9c62c;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $0db5ae3bef085140$export$b8a1af58c024fefd;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $0db5ae3bef085140$export$a2cf0d4bb6e06de4;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $0db5ae3bef085140$export$d66b332881d9723f;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $0db5ae3bef085140$export$b0709844452f8b6b;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $0db5ae3bef085140$export$5118471ee5d5453b;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $0db5ae3bef085140$export$be4650432daa84fd;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $0db5ae3bef085140$export$578e38b4a3e0b255;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $0db5ae3bef085140$export$7cd14c57bbb84350;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $0db5ae3bef085140$export$5100419dfae0456d;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $0db5ae3bef085140$export$28d9d24a8cd0ffc2;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $0db5ae3bef085140$export$3f99968195accfaf;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $0db5ae3bef085140$export$eafdbaa868ea9975;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $0db5ae3bef085140$export$36a0c1ca2ae264fa;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $0db5ae3bef085140$export$86d7c59254d6a2c9;
});
const $0db5ae3bef085140$var$$3e0a089cc13f69ad$var$templateMap = {};
function $0db5ae3bef085140$export$2ee022bbbc550b25(tagName) {
    if ($0db5ae3bef085140$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $0db5ae3bef085140$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $0db5ae3bef085140$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $0db5ae3bef085140$export$a549dd5cef7f8327(tagName) {
    const node = $0db5ae3bef085140$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $0db5ae3bef085140$export$8eece510bcb9c62c(Class) {
    return $0db5ae3bef085140$export$170f4e08cad8229d(Class, HTMLElement);
}
const $0db5ae3bef085140$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $0db5ae3bef085140$export$b8a1af58c024fefd(Class) {
    const name = $0db5ae3bef085140$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $0db5ae3bef085140$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $0db5ae3bef085140$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $0db5ae3bef085140$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $0db5ae3bef085140$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $0db5ae3bef085140$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $0db5ae3bef085140$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($0db5ae3bef085140$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $0db5ae3bef085140$export$5118471ee5d5453b(node, type);
}
function $0db5ae3bef085140$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $0db5ae3bef085140$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $0db5ae3bef085140$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $0db5ae3bef085140$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $0db5ae3bef085140$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${$0db5ae3bef085140$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$0db5ae3bef085140$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $0db5ae3bef085140$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $0db5ae3bef085140$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $0db5ae3bef085140$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $0db5ae3bef085140$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $0db5ae3bef085140$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $0db5ae3bef085140$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { type: type, name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? $0db5ae3bef085140$export$7ea17d45ecdcf634(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$0db5ae3bef085140$export$7ea17d45ecdcf634(value));
                break;
            case "fieldset":
                parsedValue = $0db5ae3bef085140$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = $0db5ae3bef085140$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$0db5ae3bef085140$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $0db5ae3bef085140$var$$bb23e0c794fefbef$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $0db5ae3bef085140$export$e772c8ff12451969;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $0db5ae3bef085140$export$57207d71b8c929c8;
});
function $0db5ae3bef085140$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $0db5ae3bef085140$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $0db5ae3bef085140$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $0db5ae3bef085140$var$$19ed8aeb7905a045$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $0db5ae3bef085140$export$10b1921597150314;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $0db5ae3bef085140$export$3e2b244719956741;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $0db5ae3bef085140$export$1d1d2ed6b55cf67f;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $0db5ae3bef085140$export$2155c0b5a4b77fb8;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $0db5ae3bef085140$export$9d97473344489dfc;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $0db5ae3bef085140$export$d635d04af3887bbe;
});
function $0db5ae3bef085140$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $0db5ae3bef085140$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $0db5ae3bef085140$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $0db5ae3bef085140$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $0db5ae3bef085140$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $0db5ae3bef085140$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $0db5ae3bef085140$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $0db5ae3bef085140$var$$7a08303ce13c49c5$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $0db5ae3bef085140$export$1b88f6b6d432a52a;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $0db5ae3bef085140$export$b70f6380221b1350;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $0db5ae3bef085140$export$75d6cbe4503e149;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $0db5ae3bef085140$export$b2618d51188815c2;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $0db5ae3bef085140$export$490814474ddbb428;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $0db5ae3bef085140$export$3ea201dffb50dfef;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $0db5ae3bef085140$export$d1012c7198c6b460;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $0db5ae3bef085140$export$a35a418b7b17958e;
});
class $0db5ae3bef085140$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $0db5ae3bef085140$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $0db5ae3bef085140$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $0db5ae3bef085140$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $0db5ae3bef085140$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $0db5ae3bef085140$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $0db5ae3bef085140$export$75d6cbe4503e149(type, element)))
    ]);
}
function $0db5ae3bef085140$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $0db5ae3bef085140$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $0db5ae3bef085140$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $0db5ae3bef085140$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $0db5ae3bef085140$export$490814474ddbb428(element, className, display = "block") {
    return $0db5ae3bef085140$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $0db5ae3bef085140$export$3ea201dffb50dfef(element, className, display = "block") {
    return $0db5ae3bef085140$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $0db5ae3bef085140$export$d1012c7198c6b460(element, className, remove) {
    return $0db5ae3bef085140$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $0db5ae3bef085140$export$a35a418b7b17958e(element, className, remove) {
    return $0db5ae3bef085140$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $0db5ae3bef085140$var$$69bd9f0117925302$exports = {};
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$69bd9f0117925302$exports, "describe", function() {
    return $0db5ae3bef085140$export$cd5450f3a47e3789;
});
$0db5ae3bef085140$var$$parcel$export($0db5ae3bef085140$var$$69bd9f0117925302$exports, "it", function() {
    return $0db5ae3bef085140$export$3486a10f30cf1ee4;
});
async function $0db5ae3bef085140$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $0db5ae3bef085140$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await $0db5ae3bef085140$export$e772c8ff12451969(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});


parcelRegister("cfbj0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $1Znhr = parcelRequire("1Znhr");

var $21wAu = parcelRequire("21wAu");

var $i3JFt = parcelRequire("i3JFt");

var $1aYx7 = parcelRequire("1aYx7");

var $axYUW = parcelRequire("axYUW");
var $8e9fa7cfbe5cb753$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.document = globalThis.document;
        this.treeCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || "") + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith("aria-") ? (0, $1aYx7.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $1aYx7.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $1Znhr.__values(group[$1aYx7.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $1Znhr.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $1Znhr.__values($1Znhr.__spreadArray($1Znhr.__spreadArray([], $1Znhr.__read(group[$1aYx7.DiffStatus.Same] || []), false), $1Znhr.__read(group[$1aYx7.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $1Znhr.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.createNode = function(vNode, reusedVNodes) {
        var _a, _b;
        if (vNode.text) return vNode.node = this.document.createTextNode(vNode.text);
        var reusedVNode = vNode.selector && ((_a = reusedVNodes === null || reusedVNodes === void 0 ? void 0 : reusedVNodes[vNode.selector]) === null || _a === void 0 ? void 0 : _a.shift());
        vNode.node = vNode.tagName ? (reusedVNode === null || reusedVNode === void 0 ? void 0 : reusedVNode.node) || this.document.createElement(vNode.tagName, {
            is: vNode.is
        }) : this.document.createDocumentFragment();
        var node = this.patch(reusedVNode || {
            tagName: vNode.tagName,
            node: vNode.node
        }, vNode).node;
        if (node) (_b = vNode.ref) === null || _b === void 0 || _b.call(vNode, node);
        return node;
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChildren = function(root, newNodes) {
        var e_3, _a;
        try {
            for(var _b = $1Znhr.__values($1Znhr.__spreadArray([], $1Znhr.__read(root.childNodes), false)), _c = _b.next(); !_c.done; _c = _b.next()){
                var oldNode = _c.value;
                var index = newNodes.indexOf(oldNode);
                if (index < 0) continue;
                else if (index === 0) {
                    newNodes.shift();
                    continue;
                }
                var beforeNodes = newNodes.slice(0, index);
                if (!beforeNodes[0]) continue;
                oldNode.before.apply(oldNode, $1Znhr.__spreadArray([], $1Znhr.__read(beforeNodes), false));
                newNodes = newNodes.slice(index + 1);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (newNodes[0]) root.append.apply(root, $1Znhr.__spreadArray([], $1Znhr.__read(newNodes), false));
    };
    DOMRenderer.prototype.updateChildren = function(node, oldList, newList) {
        var e_4, _a;
        var _this = this;
        var _b = (0, $1aYx7.diffKeys)(oldList.map(this.keyOf), newList.map(this.keyOf)), map = _b.map, group = _b.group;
        var deletingGroup = group[$1aYx7.DiffStatus.Old] && (0, $1aYx7.groupBy)(group[$1aYx7.DiffStatus.Old].map(function(_a) {
            var _b = $1Znhr.__read(_a, 1), key = _b[0];
            return _this.vNodeOf(oldList, key);
        }), function(_a) {
            var selector = _a.selector;
            return selector + "";
        });
        var newNodes = newList.map(function(vNode, index) {
            var key = _this.keyOf(vNode, index);
            if (map[key] !== $1aYx7.DiffStatus.Same) return _this.createNode(vNode, deletingGroup);
            var oldVNode = _this.vNodeOf(oldList, key);
            return vNode.text != null ? vNode.node = oldVNode.node : _this.patch(oldVNode, vNode).node;
        });
        for(var selector in deletingGroup)try {
            for(var _c = (e_4 = void 0, $1Znhr.__values(deletingGroup[selector])), _d = _c.next(); !_d.done; _d = _c.next()){
                var vNode = _d.value;
                this.deleteNode(vNode);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.commitChildren(node, newNodes);
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVNode, newVNode) {
        var _this = this;
        var tagName = oldVNode.tagName;
        var isXML = (0, $1aYx7.templateOf)(tagName) && (0, $1aYx7.elementTypeOf)(tagName) === "xml";
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $1aYx7.toHyphenCase)(key) : $axYUW.VNode.propsMap[key] || key);
        }, function(node, key, value) {
            if (isXML || key.includes("-")) node.setAttribute(key, value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(key, value);
            }
        });
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(node, key) {
            return node.removeProperty(key);
        });
        this.updateChildren(oldVNode.node, oldVNode.children || [], newVNode.children || []);
        newVNode.node = oldVNode.node;
        return newVNode;
    };
    DOMRenderer.prototype.render = function(vNode, node) {
        if (node === void 0) node = this.document.body;
        this.document = node.ownerDocument;
        var root = this.treeCache.get(node) || $axYUW.VNode.fromDOM(node);
        root = this.patch(root, new $axYUW.VNode($1Znhr.__assign($1Znhr.__assign({}, root), {
            children: [
                vNode
            ]
        })));
        this.treeCache.set(node, root);
        return root;
    };
    DOMRenderer.prototype.buildRenderTree = function(tree) {
        var body = this.document.implementation.createHTMLDocument().body;
        this.render(tree, body);
        var shadowRoots = $1Znhr.__spreadArray([], $1Znhr.__read((0, $21wAu.findShadowRoots)(body)), false);
        return {
            body: body,
            shadowRoots: shadowRoots
        };
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        var _a = this.buildRenderTree(tree), body = _a.body, shadowRoots = _a.shadowRoots;
        return body.getHTML({
            serializableShadowRoots: true,
            shadowRoots: shadowRoots
        });
    };
    DOMRenderer.prototype.renderToReadableStream = function(tree) {
        var _a = this.buildRenderTree(tree), body = _a.body, shadowRoots = _a.shadowRoots;
        return $i3JFt.ReadableStream.from((0, $21wAu.generateHTML)(body, {
            serializableShadowRoots: true,
            shadowRoots: shadowRoots
        }));
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $8e9fa7cfbe5cb753$var$DOMRenderer;

});
parcelRegister("21wAu", function(module, exports) {
var $1794f3fa78a04962$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1794f3fa78a04962$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $1794f3fa78a04962$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1794f3fa78a04962$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.findShadowRoots = findShadowRoots;
    exports1.generateHTML = generateHTML;
    exports1.getHTML = getHTML;
    exports1.attachDeclarativeShadowRoots = attachDeclarativeShadowRoots;
    exports1.setHTMLUnsafe = setHTMLUnsafe;
    exports1.parseHTMLUnsafe = parseHTMLUnsafe;
    var xmlSerializer = new XMLSerializer(), attachShadow = HTMLElement.prototype.attachShadow, shadowDOMs = new WeakMap();
    HTMLElement.prototype.attachShadow = function(options) {
        var shadowRoot = attachShadow.call(this, options);
        shadowDOMs.set(this, shadowRoot);
        return shadowRoot;
    };
    function findShadowRoots(root) {
        var walker, currentNode, shadowRoot;
        return $1794f3fa78a04962$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: function(node) {
                            return node instanceof HTMLElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                        }
                    });
                    currentNode = null;
                    _a.label = 1;
                case 1:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        5
                    ];
                    shadowRoot = shadowDOMs.get(currentNode);
                    if (!shadowRoot) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        shadowRoot
                    ];
                case 2:
                    _a.sent();
                    return [
                        5 /*yield**/ ,
                        $1794f3fa78a04962$var$__values(findShadowRoots(shadowRoot))
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    function generateHTML(root, _a) {
        var walker, currentNode, tagName, attributes, shadowRoot, shadowRootHTML, nextSibling, parentElement;
        var _b = _a === void 0 ? {} : _a, serializableShadowRoots = _b.serializableShadowRoots, shadowRoots = _b.shadowRoots;
        return $1794f3fa78a04962$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    shadowRoots = (shadowRoots === null || shadowRoots === void 0 ? void 0 : shadowRoots.filter(Boolean)) || [];
                    if (!(!serializableShadowRoots || !shadowRoots[0])) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        root.innerHTML
                    ];
                case 1:
                    _c.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 2:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, {
                        acceptNode: function(node) {
                            return node === root || node instanceof SVGElement ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                        }
                    });
                    currentNode = null;
                    _c.label = 3;
                case 3:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        19
                    ];
                    if (!(currentNode instanceof CDATASection)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        "<![CDATA[".concat(currentNode.nodeValue, "]]>")
                    ];
                case 4:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 5:
                    if (!(currentNode instanceof Text)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        currentNode.nodeValue || ""
                    ];
                case 6:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 7:
                    if (!(currentNode instanceof Comment)) return [
                        3 /*break*/ ,
                        9
                    ];
                    return [
                        4 /*yield*/ ,
                        "<!--".concat(currentNode.nodeValue, "-->")
                    ];
                case 8:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 9:
                    if (!(currentNode instanceof SVGElement)) return [
                        3 /*break*/ ,
                        11
                    ];
                    return [
                        4 /*yield*/ ,
                        xmlSerializer.serializeToString(currentNode)
                    ];
                case 10:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 11:
                    if (!(currentNode instanceof Element)) return [
                        3 /*break*/ ,
                        16
                    ];
                    tagName = currentNode.tagName.toLowerCase(), attributes = $1794f3fa78a04962$var$__spreadArray([], $1794f3fa78a04962$var$__read(currentNode.attributes), false).map(function(_a) {
                        var name = _a.name, value = _a.value;
                        return "".concat(name, "=").concat(JSON.parse(value));
                    }), shadowRoot = shadowDOMs.get(currentNode);
                    return [
                        4 /*yield*/ ,
                        "<".concat($1794f3fa78a04962$var$__spreadArray([
                            tagName
                        ], $1794f3fa78a04962$var$__read(attributes), false).join(" "), ">")
                    ];
                case 12:
                    _c.sent();
                    if (!(shadowRoot && shadowRoots.includes(shadowRoot))) return [
                        3 /*break*/ ,
                        14
                    ];
                    shadowRootHTML = $1794f3fa78a04962$var$__spreadArray([], $1794f3fa78a04962$var$__read(generateHTML(shadowRoot, {
                        serializableShadowRoots: serializableShadowRoots,
                        shadowRoots: shadowRoots
                    })), false).join("");
                    return [
                        4 /*yield*/ ,
                        '<template shadowrootmode="'.concat(shadowRoot.mode, '">').concat(shadowRootHTML, "</template>")
                    ];
                case 13:
                    _c.sent();
                    _c.label = 14;
                case 14:
                    if (!!currentNode.childNodes[0]) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 15:
                    _c.sent();
                    _c.label = 16;
                case 16:
                    nextSibling = currentNode.nextSibling, parentElement = currentNode.parentElement;
                    if (!(!nextSibling && parentElement && parentElement !== root)) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(parentElement.tagName.toLowerCase(), ">")
                    ];
                case 17:
                    _c.sent();
                    _c.label = 18;
                case 18:
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getHTML}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/getHTML}
     */ function getHTML(options) {
        if (options === void 0) options = {};
        return $1794f3fa78a04962$var$__spreadArray([], $1794f3fa78a04962$var$__read(generateHTML(this, options)), false).join("");
    }
    function attachDeclarativeShadowRoots(root) {
        var e_1, _a;
        var templates = root.querySelectorAll("template[shadowrootmode]");
        try {
            for(var templates_1 = $1794f3fa78a04962$var$__values(templates), templates_1_1 = templates_1.next(); !templates_1_1.done; templates_1_1 = templates_1.next()){
                var template = templates_1_1.value;
                var parentElement = template.parentElement, content = template.content;
                var shadowRoot = parentElement.attachShadow({
                    mode: template.getAttribute("shadowrootmode")
                });
                shadowRoot.append(content);
                template.remove();
                attachDeclarativeShadowRoots(shadowRoot);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTMLUnsafe}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/setHTMLUnsafe}
     */ function setHTMLUnsafe(html) {
        this.innerHTML = html;
        attachDeclarativeShadowRoots(this);
    }
    var domParser = new DOMParser(), initDocument = function(_a) {
        var _b = _a === void 0 ? document : _a, documentElement = _b.documentElement;
        return attachDeclarativeShadowRoots(documentElement);
    };
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/parseHTMLUnsafe_static}
     */ function parseHTMLUnsafe(html) {
        var document1 = domParser.parseFromString(html, "text/html");
        initDocument(document1);
        return document1;
    }
    (_a = Element.prototype).getHTML || (_a.getHTML = getHTML);
    (_b = Element.prototype).setHTMLUnsafe || (_b.setHTMLUnsafe = setHTMLUnsafe);
    (_c = ShadowRoot.prototype).getHTML || (_c.getHTML = getHTML);
    (_d = ShadowRoot.prototype).setHTMLUnsafe || (_d.setHTMLUnsafe = setHTMLUnsafe);
    Document.parseHTMLUnsafe || (Document.parseHTMLUnsafe = parseHTMLUnsafe);
    new Promise(function(resolve) {
        if (document.readyState === "complete") resolve();
        else {
            document.addEventListener("DOMContentLoaded", resolve);
            window.addEventListener("load", resolve);
        }
    }).then(function() {
        return initDocument();
    });
});

});

parcelRegister("i3JFt", function(module, exports) {

$parcel$export(module.exports, "ReadableStreamDefaultReader", () => $33f07bbd4ddcb7b3$export$a890bf36e2af9168);
$parcel$export(module.exports, "ReadableStreamBYOBRequest", () => $33f07bbd4ddcb7b3$export$fbcf11583158d2c);
$parcel$export(module.exports, "ReadableByteStreamController", () => $33f07bbd4ddcb7b3$export$2047cf34091e94ac);
$parcel$export(module.exports, "ReadableStreamBYOBReader", () => $33f07bbd4ddcb7b3$export$20068a30393fcc28);
$parcel$export(module.exports, "WritableStream", () => $33f07bbd4ddcb7b3$export$826849241f7970f8);
$parcel$export(module.exports, "WritableStreamDefaultController", () => $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2);
$parcel$export(module.exports, "WritableStreamDefaultWriter", () => $33f07bbd4ddcb7b3$export$9295348f005d6054);
$parcel$export(module.exports, "ReadableStreamDefaultController", () => $33f07bbd4ddcb7b3$export$b0bb6d0989d67700);
$parcel$export(module.exports, "ReadableStream", () => $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76);
$parcel$export(module.exports, "ByteLengthQueuingStrategy", () => $33f07bbd4ddcb7b3$export$d386b5f37d154119);
$parcel$export(module.exports, "CountQueuingStrategy", () => $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625);
$parcel$export(module.exports, "TransformStream", () => $33f07bbd4ddcb7b3$export$d102341634899398);
$parcel$export(module.exports, "TransformStreamDefaultController", () => $33f07bbd4ddcb7b3$export$a55559184460222);
/**
 * @license
 * web-streams-polyfill v4.0.0
 * Copyright 2024 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $33f07bbd4ddcb7b3$var$e() {}
function $33f07bbd4ddcb7b3$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $33f07bbd4ddcb7b3$var$r = $33f07bbd4ddcb7b3$var$e;
function $33f07bbd4ddcb7b3$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $33f07bbd4ddcb7b3$var$n = Promise, $33f07bbd4ddcb7b3$var$a = Promise.resolve.bind($33f07bbd4ddcb7b3$var$n), $33f07bbd4ddcb7b3$var$i = Promise.prototype.then, $33f07bbd4ddcb7b3$var$l = Promise.reject.bind($33f07bbd4ddcb7b3$var$n), $33f07bbd4ddcb7b3$var$s = $33f07bbd4ddcb7b3$var$a;
function $33f07bbd4ddcb7b3$var$u(e) {
    return new $33f07bbd4ddcb7b3$var$n(e);
}
function $33f07bbd4ddcb7b3$var$c(e) {
    return $33f07bbd4ddcb7b3$var$u((t)=>t(e));
}
function $33f07bbd4ddcb7b3$var$d(e) {
    return $33f07bbd4ddcb7b3$var$l(e);
}
function $33f07bbd4ddcb7b3$var$f(e, t, r) {
    return $33f07bbd4ddcb7b3$var$i.call(e, t, r);
}
function $33f07bbd4ddcb7b3$var$b(e, t, o) {
    $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$f(e, t, o), void 0, $33f07bbd4ddcb7b3$var$r);
}
function $33f07bbd4ddcb7b3$var$h(e, t) {
    $33f07bbd4ddcb7b3$var$b(e, t);
}
function $33f07bbd4ddcb7b3$var$m(e, t) {
    $33f07bbd4ddcb7b3$var$b(e, void 0, t);
}
function $33f07bbd4ddcb7b3$var$_(e, t, r) {
    return $33f07bbd4ddcb7b3$var$f(e, t, r);
}
function $33f07bbd4ddcb7b3$var$p(e) {
    $33f07bbd4ddcb7b3$var$f(e, void 0, $33f07bbd4ddcb7b3$var$r);
}
let $33f07bbd4ddcb7b3$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $33f07bbd4ddcb7b3$var$y = queueMicrotask;
    else {
        const e = $33f07bbd4ddcb7b3$var$c(void 0);
        $33f07bbd4ddcb7b3$var$y = (t)=>$33f07bbd4ddcb7b3$var$f(e, t);
    }
    return $33f07bbd4ddcb7b3$var$y(e);
};
function $33f07bbd4ddcb7b3$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $33f07bbd4ddcb7b3$var$g(e, t, r) {
    try {
        return $33f07bbd4ddcb7b3$var$c($33f07bbd4ddcb7b3$var$S(e, t, r));
    } catch (e) {
        return $33f07bbd4ddcb7b3$var$d(e);
    }
}
class $33f07bbd4ddcb7b3$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, a = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, a;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $33f07bbd4ddcb7b3$var$w = Symbol("[[AbortSteps]]"), $33f07bbd4ddcb7b3$var$R = Symbol("[[ErrorSteps]]"), $33f07bbd4ddcb7b3$var$T = Symbol("[[CancelSteps]]"), $33f07bbd4ddcb7b3$var$C = Symbol("[[PullSteps]]"), $33f07bbd4ddcb7b3$var$P = Symbol("[[ReleaseSteps]]");
function $33f07bbd4ddcb7b3$var$q(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $33f07bbd4ddcb7b3$var$B(e) : "closed" === t._state ? function(e) {
        $33f07bbd4ddcb7b3$var$B(e), $33f07bbd4ddcb7b3$var$A(e);
    }(e) : $33f07bbd4ddcb7b3$var$k(e, t._storedError);
}
function $33f07bbd4ddcb7b3$var$E(e, t) {
    return $33f07bbd4ddcb7b3$var$Or(e._ownerReadableStream, t);
}
function $33f07bbd4ddcb7b3$var$W(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $33f07bbd4ddcb7b3$var$j(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $33f07bbd4ddcb7b3$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$33f07bbd4ddcb7b3$var$P](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $33f07bbd4ddcb7b3$var$O(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $33f07bbd4ddcb7b3$var$B(e) {
    e._closedPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $33f07bbd4ddcb7b3$var$k(e, t) {
    $33f07bbd4ddcb7b3$var$B(e), $33f07bbd4ddcb7b3$var$j(e, t);
}
function $33f07bbd4ddcb7b3$var$j(e, t) {
    void 0 !== e._closedPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$A(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $33f07bbd4ddcb7b3$var$z = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $33f07bbd4ddcb7b3$var$D = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $33f07bbd4ddcb7b3$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $33f07bbd4ddcb7b3$var$F(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $33f07bbd4ddcb7b3$var$I(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $33f07bbd4ddcb7b3$var$$(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $33f07bbd4ddcb7b3$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $33f07bbd4ddcb7b3$var$Y(e) {
    return Number(e);
}
function $33f07bbd4ddcb7b3$var$x(e) {
    return 0 === e ? 0 : e;
}
function $33f07bbd4ddcb7b3$var$Q(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $33f07bbd4ddcb7b3$var$x(o), !$33f07bbd4ddcb7b3$var$z(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $33f07bbd4ddcb7b3$var$x($33f07bbd4ddcb7b3$var$D(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $33f07bbd4ddcb7b3$var$z(o) && 0 !== o ? o : 0;
}
function $33f07bbd4ddcb7b3$var$N(e, t) {
    if (!$33f07bbd4ddcb7b3$var$Er(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $33f07bbd4ddcb7b3$var$H(e) {
    return new $33f07bbd4ddcb7b3$export$a890bf36e2af9168(e);
}
function $33f07bbd4ddcb7b3$var$V(e, t) {
    e._reader._readRequests.push(t);
}
function $33f07bbd4ddcb7b3$var$U(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $33f07bbd4ddcb7b3$var$G(e) {
    return e._reader._readRequests.length;
}
function $33f07bbd4ddcb7b3$var$X(e) {
    const t = e._reader;
    return void 0 !== t && !!$33f07bbd4ddcb7b3$var$J(t);
}
class $33f07bbd4ddcb7b3$export$a890bf36e2af9168 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "ReadableStreamDefaultReader"), $33f07bbd4ddcb7b3$var$N(e, "First parameter"), $33f07bbd4ddcb7b3$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $33f07bbd4ddcb7b3$var$q(this, e), this._readRequests = new $33f07bbd4ddcb7b3$var$v;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$J(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("closed"));
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$J(this) ? void 0 === this._ownerReadableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("cancel")) : $33f07bbd4ddcb7b3$var$E(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("cancel"));
    }
    read() {
        if (!$33f07bbd4ddcb7b3$var$J(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("read"));
        if (void 0 === this._ownerReadableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("read from"));
        let e, t;
        const r = $33f07bbd4ddcb7b3$var$u((r, o)=>{
            e = r, t = o;
        });
        return $33f07bbd4ddcb7b3$var$K(this, {
            _chunkSteps: (t)=>e({
                    value: t,
                    done: !1
                }),
            _closeSteps: ()=>e({
                    value: void 0,
                    done: !0
                }),
            _errorSteps: (e)=>t(e)
        }), r;
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$J(this)) throw $33f07bbd4ddcb7b3$var$ee("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $33f07bbd4ddcb7b3$var$W(e);
            const t = new TypeError("Reader was released");
            $33f07bbd4ddcb7b3$var$Z(e, t);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$J(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $33f07bbd4ddcb7b3$export$a890bf36e2af9168;
}
function $33f07bbd4ddcb7b3$var$K(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$33f07bbd4ddcb7b3$var$C](t);
}
function $33f07bbd4ddcb7b3$var$Z(e, t) {
    const r = e._readRequests;
    e._readRequests = new $33f07bbd4ddcb7b3$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $33f07bbd4ddcb7b3$var$ee(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $33f07bbd4ddcb7b3$var$te, $33f07bbd4ddcb7b3$var$re, $33f07bbd4ddcb7b3$var$oe;
function $33f07bbd4ddcb7b3$var$ne(e) {
    return e.slice();
}
function $33f07bbd4ddcb7b3$var$ae(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.read, "read"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
let $33f07bbd4ddcb7b3$var$ie = (e)=>($33f07bbd4ddcb7b3$var$ie = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $33f07bbd4ddcb7b3$var$ie(e)), $33f07bbd4ddcb7b3$var$le = (e)=>($33f07bbd4ddcb7b3$var$le = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $33f07bbd4ddcb7b3$var$le(e));
function $33f07bbd4ddcb7b3$var$se(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $33f07bbd4ddcb7b3$var$ae(n, 0, e, t, o), n;
}
function $33f07bbd4ddcb7b3$var$ue(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $33f07bbd4ddcb7b3$var$ce(e) {
    try {
        const t = e.done, r = e.value;
        return $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$s(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $33f07bbd4ddcb7b3$var$d(e);
    }
}
const $33f07bbd4ddcb7b3$var$de = null !== ($33f07bbd4ddcb7b3$var$oe = null !== ($33f07bbd4ddcb7b3$var$te = Symbol.asyncIterator) && void 0 !== $33f07bbd4ddcb7b3$var$te ? $33f07bbd4ddcb7b3$var$te : null === ($33f07bbd4ddcb7b3$var$re = Symbol.for) || void 0 === $33f07bbd4ddcb7b3$var$re ? void 0 : $33f07bbd4ddcb7b3$var$re.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $33f07bbd4ddcb7b3$var$oe ? $33f07bbd4ddcb7b3$var$oe : "@@asyncIterator";
function $33f07bbd4ddcb7b3$var$fe(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $33f07bbd4ddcb7b3$var$ue(e, $33f07bbd4ddcb7b3$var$de))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $33f07bbd4ddcb7b3$var$be(e);
                        } catch (e) {
                            return $33f07bbd4ddcb7b3$var$d(e);
                        }
                        return $33f07bbd4ddcb7b3$var$ce(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $33f07bbd4ddcb7b3$var$ue(e.iterator, "return");
                            if (void 0 === t) return $33f07bbd4ddcb7b3$var$c({
                                done: !0,
                                value: r
                            });
                            o = $33f07bbd4ddcb7b3$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $33f07bbd4ddcb7b3$var$d(e);
                        }
                        return $33f07bbd4ddcb7b3$var$t(o) ? $33f07bbd4ddcb7b3$var$ce(o) : $33f07bbd4ddcb7b3$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($33f07bbd4ddcb7b3$var$fe(e, "sync", $33f07bbd4ddcb7b3$var$ue(e, Symbol.iterator)));
        } else o = $33f07bbd4ddcb7b3$var$ue(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $33f07bbd4ddcb7b3$var$S(o, e, []);
    if (!$33f07bbd4ddcb7b3$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $33f07bbd4ddcb7b3$var$be(e) {
    const r = $33f07bbd4ddcb7b3$var$S(e.nextMethod, e.iterator, []);
    if (!$33f07bbd4ddcb7b3$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $33f07bbd4ddcb7b3$var$he {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $33f07bbd4ddcb7b3$var$_(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise ? $33f07bbd4ddcb7b3$var$_(this._ongoingPromise, t, t) : t();
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader;
        let t, r;
        const o = $33f07bbd4ddcb7b3$var$u((e, o)=>{
            t = e, r = o;
        });
        return $33f07bbd4ddcb7b3$var$K(e, {
            _chunkSteps: (e)=>{
                this._ongoingPromise = void 0, $33f07bbd4ddcb7b3$var$y(()=>t({
                        value: e,
                        done: !1
                    }));
            },
            _closeSteps: ()=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $33f07bbd4ddcb7b3$var$W(e), t({
                    value: void 0,
                    done: !0
                });
            },
            _errorSteps: (t)=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $33f07bbd4ddcb7b3$var$W(e), r(t);
            }
        }), o;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $33f07bbd4ddcb7b3$var$E(t, e);
            return $33f07bbd4ddcb7b3$var$W(t), $33f07bbd4ddcb7b3$var$_(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $33f07bbd4ddcb7b3$var$W(t), $33f07bbd4ddcb7b3$var$c({
            value: e,
            done: !0
        });
    }
}
const $33f07bbd4ddcb7b3$var$me = {
    next () {
        return $33f07bbd4ddcb7b3$var$_e(this) ? this._asyncIteratorImpl.next() : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$pe("next"));
    },
    return (e) {
        return $33f07bbd4ddcb7b3$var$_e(this) ? this._asyncIteratorImpl.return(e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$pe("return"));
    },
    [$33f07bbd4ddcb7b3$var$de] () {
        return this;
    }
};
function $33f07bbd4ddcb7b3$var$_e(e) {
    if (!$33f07bbd4ddcb7b3$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $33f07bbd4ddcb7b3$var$he;
    } catch (e) {
        return !1;
    }
}
function $33f07bbd4ddcb7b3$var$pe(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($33f07bbd4ddcb7b3$var$me, $33f07bbd4ddcb7b3$var$de, {
    enumerable: !1
});
const $33f07bbd4ddcb7b3$var$ye = Number.isNaN || function(e) {
    return e != e;
};
function $33f07bbd4ddcb7b3$var$Se(e) {
    const t = $33f07bbd4ddcb7b3$var$se(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $33f07bbd4ddcb7b3$var$ge(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $33f07bbd4ddcb7b3$var$ve(e, t, r) {
    if ("number" != typeof (o = r) || $33f07bbd4ddcb7b3$var$ye(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $33f07bbd4ddcb7b3$var$we(e) {
    e._queue = new $33f07bbd4ddcb7b3$var$v, e._queueTotalSize = 0;
}
function $33f07bbd4ddcb7b3$var$Re(e) {
    return e === DataView;
}
class $33f07bbd4ddcb7b3$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("view");
        return this._view;
    }
    respond(e) {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("respond");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "respond"), e = $33f07bbd4ddcb7b3$var$Q(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($33f07bbd4ddcb7b3$var$le(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $33f07bbd4ddcb7b3$var$Ue(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("respondWithNewView");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($33f07bbd4ddcb7b3$var$le(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $33f07bbd4ddcb7b3$var$Ge(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype.respond, "respond"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("byobRequest");
        return $33f07bbd4ddcb7b3$var$He(this);
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("desiredSize");
        return $33f07bbd4ddcb7b3$var$Ve(this);
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $33f07bbd4ddcb7b3$var$Ye(this);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("enqueue");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $33f07bbd4ddcb7b3$var$xe(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("error");
        $33f07bbd4ddcb7b3$var$Qe(this, e);
    }
    [$33f07bbd4ddcb7b3$var$T](e) {
        $33f07bbd4ddcb7b3$var$qe(this), $33f07bbd4ddcb7b3$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$Me(this), t;
    }
    [$33f07bbd4ddcb7b3$var$C](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $33f07bbd4ddcb7b3$var$Ne(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $33f07bbd4ddcb7b3$var$V(t, e), $33f07bbd4ddcb7b3$var$Pe(this);
    }
    [$33f07bbd4ddcb7b3$var$P]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $33f07bbd4ddcb7b3$var$Te(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $33f07bbd4ddcb7b3$export$2047cf34091e94ac;
}
function $33f07bbd4ddcb7b3$var$Ce(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $33f07bbd4ddcb7b3$export$fbcf11583158d2c;
}
function $33f07bbd4ddcb7b3$var$Pe(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($33f07bbd4ddcb7b3$var$X(t) && $33f07bbd4ddcb7b3$var$G(t) > 0) return !0;
        if ($33f07bbd4ddcb7b3$var$ot(t) && $33f07bbd4ddcb7b3$var$rt(t) > 0) return !0;
        const r = $33f07bbd4ddcb7b3$var$Ve(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $33f07bbd4ddcb7b3$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $33f07bbd4ddcb7b3$var$Pe(e)), null), (t)=>($33f07bbd4ddcb7b3$var$Qe(e, t), null));
}
function $33f07bbd4ddcb7b3$var$qe(e) {
    $33f07bbd4ddcb7b3$var$De(e), e._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v;
}
function $33f07bbd4ddcb7b3$var$Ee(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $33f07bbd4ddcb7b3$var$We(t);
    "default" === t.readerType ? $33f07bbd4ddcb7b3$var$U(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $33f07bbd4ddcb7b3$var$We(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $33f07bbd4ddcb7b3$var$Oe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $33f07bbd4ddcb7b3$var$Be(e, t, r, o) {
    let n;
    try {
        n = $33f07bbd4ddcb7b3$var$se(t, r, r + o);
    } catch (t) {
        throw $33f07bbd4ddcb7b3$var$Qe(e, t), t;
    }
    $33f07bbd4ddcb7b3$var$Oe(e, n, 0, o);
}
function $33f07bbd4ddcb7b3$var$ke(e, t) {
    t.bytesFilled > 0 && $33f07bbd4ddcb7b3$var$Be(e, t.buffer, t.byteOffset, t.bytesFilled), $33f07bbd4ddcb7b3$var$$e(e);
}
function $33f07bbd4ddcb7b3$var$je(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, a = !1;
    const i = o - o % t.elementSize;
    i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
    const l = e._queue;
    for(; n > 0;){
        const r = l.peek(), o = Math.min(n, r.byteLength), a = t.byteOffset + t.bytesFilled;
        $33f07bbd4ddcb7b3$var$ae(t.buffer, a, r.buffer, r.byteOffset, o), r.byteLength === o ? l.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $33f07bbd4ddcb7b3$var$Ae(e, o, t), n -= o;
    }
    return a;
}
function $33f07bbd4ddcb7b3$var$Ae(e, t, r) {
    r.bytesFilled += t;
}
function $33f07bbd4ddcb7b3$var$ze(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$Br(e._controlledReadableByteStream)) : $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$De(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $33f07bbd4ddcb7b3$var$Le(e) {
    for(; e._pendingPullIntos.length > 0;){
        if (0 === e._queueTotalSize) return;
        const t = e._pendingPullIntos.peek();
        $33f07bbd4ddcb7b3$var$je(e, t) && ($33f07bbd4ddcb7b3$var$$e(e), $33f07bbd4ddcb7b3$var$Ee(e._controlledReadableByteStream, t));
    }
}
function $33f07bbd4ddcb7b3$var$Fe(e, t, r, o) {
    const n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
        return $33f07bbd4ddcb7b3$var$Re(e) ? 1 : e.BYTES_PER_ELEMENT;
    }(a), { byteOffset: l, byteLength: s } = t, u = r * i;
    let c;
    try {
        c = $33f07bbd4ddcb7b3$var$ie(t.buffer);
    } catch (e) {
        return void o._errorSteps(e);
    }
    const d = {
        buffer: c,
        bufferByteLength: c.byteLength,
        byteOffset: l,
        byteLength: s,
        bytesFilled: 0,
        minimumFill: u,
        elementSize: i,
        viewConstructor: a,
        readerType: "byob"
    };
    if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $33f07bbd4ddcb7b3$var$tt(n, o);
    if ("closed" !== n._state) {
        if (e._queueTotalSize > 0) {
            if ($33f07bbd4ddcb7b3$var$je(e, d)) {
                const t = $33f07bbd4ddcb7b3$var$We(d);
                return $33f07bbd4ddcb7b3$var$ze(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $33f07bbd4ddcb7b3$var$Qe(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), $33f07bbd4ddcb7b3$var$tt(n, o), $33f07bbd4ddcb7b3$var$Pe(e);
    } else {
        const e = new a(d.buffer, d.byteOffset, 0);
        o._closeSteps(e);
    }
}
function $33f07bbd4ddcb7b3$var$Ie(e, t) {
    const r = e._pendingPullIntos.peek();
    $33f07bbd4ddcb7b3$var$De(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $33f07bbd4ddcb7b3$var$$e(e);
        const r = e._controlledReadableByteStream;
        if ($33f07bbd4ddcb7b3$var$ot(r)) for(; $33f07bbd4ddcb7b3$var$rt(r) > 0;)$33f07bbd4ddcb7b3$var$Ee(r, $33f07bbd4ddcb7b3$var$$e(e));
    }(e, r) : function(e, t, r) {
        if ($33f07bbd4ddcb7b3$var$Ae(0, t, r), "none" === r.readerType) return $33f07bbd4ddcb7b3$var$ke(e, r), void $33f07bbd4ddcb7b3$var$Le(e);
        if (r.bytesFilled < r.minimumFill) return;
        $33f07bbd4ddcb7b3$var$$e(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $33f07bbd4ddcb7b3$var$Be(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o, $33f07bbd4ddcb7b3$var$Ee(e._controlledReadableByteStream, r), $33f07bbd4ddcb7b3$var$Le(e);
    }(e, t, r), $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$$e(e) {
    return e._pendingPullIntos.shift();
}
function $33f07bbd4ddcb7b3$var$Me(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$Ye(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize != 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $33f07bbd4ddcb7b3$var$Qe(e, t), t;
                }
            }
            $33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$Br(t);
        }
    }
}
function $33f07bbd4ddcb7b3$var$xe(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: a } = t;
    if ($33f07bbd4ddcb7b3$var$le(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const i = $33f07bbd4ddcb7b3$var$ie(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($33f07bbd4ddcb7b3$var$le(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $33f07bbd4ddcb7b3$var$De(e), t.buffer = $33f07bbd4ddcb7b3$var$ie(t.buffer), "none" === t.readerType && $33f07bbd4ddcb7b3$var$ke(e, t);
    }
    if ($33f07bbd4ddcb7b3$var$X(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $33f07bbd4ddcb7b3$var$Ne(e, t._readRequests.shift());
            }
        }(e), 0 === $33f07bbd4ddcb7b3$var$G(r)) $33f07bbd4ddcb7b3$var$Oe(e, i, n, a);
        else {
            e._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$$e(e);
            $33f07bbd4ddcb7b3$var$U(r, new Uint8Array(i, n, a), !1);
        }
    } else $33f07bbd4ddcb7b3$var$ot(r) ? ($33f07bbd4ddcb7b3$var$Oe(e, i, n, a), $33f07bbd4ddcb7b3$var$Le(e)) : $33f07bbd4ddcb7b3$var$Oe(e, i, n, a);
    $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$Qe(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($33f07bbd4ddcb7b3$var$qe(e), $33f07bbd4ddcb7b3$var$we(e), $33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$kr(r, t));
}
function $33f07bbd4ddcb7b3$var$Ne(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $33f07bbd4ddcb7b3$var$ze(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $33f07bbd4ddcb7b3$var$He(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $33f07bbd4ddcb7b3$var$Ve(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$Ue(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $33f07bbd4ddcb7b3$var$ie(r.buffer), $33f07bbd4ddcb7b3$var$Ie(e, t);
}
function $33f07bbd4ddcb7b3$var$Ge(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $33f07bbd4ddcb7b3$var$ie(t.buffer), $33f07bbd4ddcb7b3$var$Ie(e, o);
}
function $33f07bbd4ddcb7b3$var$Xe(e, t, r, o, n, a, i) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v, e._readableStreamController = t;
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$Pe(t), null), (e)=>($33f07bbd4ddcb7b3$var$Qe(t, e), null));
}
function $33f07bbd4ddcb7b3$var$Je(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $33f07bbd4ddcb7b3$var$Ke(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $33f07bbd4ddcb7b3$var$Ze(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $33f07bbd4ddcb7b3$var$et(e) {
    return new $33f07bbd4ddcb7b3$export$20068a30393fcc28(e);
}
function $33f07bbd4ddcb7b3$var$tt(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $33f07bbd4ddcb7b3$var$rt(e) {
    return e._reader._readIntoRequests.length;
}
function $33f07bbd4ddcb7b3$var$ot(e) {
    const t = e._reader;
    return void 0 !== t && !!$33f07bbd4ddcb7b3$var$nt(t);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$20068a30393fcc28 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "ReadableStreamBYOBReader"), $33f07bbd4ddcb7b3$var$N(e, "First parameter"), $33f07bbd4ddcb7b3$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$33f07bbd4ddcb7b3$var$Te(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $33f07bbd4ddcb7b3$var$q(this, e), this._readIntoRequests = new $33f07bbd4ddcb7b3$var$v;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$nt(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("closed"));
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$nt(this) ? void 0 === this._ownerReadableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("cancel")) : $33f07bbd4ddcb7b3$var$E(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("cancel"));
    }
    read(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$nt(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("read"));
        if (!ArrayBuffer.isView(e)) return $33f07bbd4ddcb7b3$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $33f07bbd4ddcb7b3$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $33f07bbd4ddcb7b3$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($33f07bbd4ddcb7b3$var$le(e.buffer)) return $33f07bbd4ddcb7b3$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $33f07bbd4ddcb7b3$var$L(e, t), {
                    min: $33f07bbd4ddcb7b3$var$Q(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $33f07bbd4ddcb7b3$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $33f07bbd4ddcb7b3$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $33f07bbd4ddcb7b3$var$Re(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $33f07bbd4ddcb7b3$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $33f07bbd4ddcb7b3$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("read from"));
        let n, a;
        const i = $33f07bbd4ddcb7b3$var$u((e, t)=>{
            n = e, a = t;
        });
        return $33f07bbd4ddcb7b3$var$at(this, e, o, {
            _chunkSteps: (e)=>n({
                    value: e,
                    done: !1
                }),
            _closeSteps: (e)=>n({
                    value: e,
                    done: !0
                }),
            _errorSteps: (e)=>a(e)
        }), i;
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$nt(this)) throw $33f07bbd4ddcb7b3$var$lt("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $33f07bbd4ddcb7b3$var$W(e);
            const t = new TypeError("Reader was released");
            $33f07bbd4ddcb7b3$var$it(e, t);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$nt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $33f07bbd4ddcb7b3$export$20068a30393fcc28;
}
function $33f07bbd4ddcb7b3$var$at(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $33f07bbd4ddcb7b3$var$Fe(n._readableStreamController, t, r, o);
}
function $33f07bbd4ddcb7b3$var$it(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $33f07bbd4ddcb7b3$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $33f07bbd4ddcb7b3$var$lt(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $33f07bbd4ddcb7b3$var$st(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($33f07bbd4ddcb7b3$var$ye(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $33f07bbd4ddcb7b3$var$ut(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $33f07bbd4ddcb7b3$var$ct(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Y(r),
        size: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$dt(o, `${t} has member 'size' that`)
    };
}
function $33f07bbd4ddcb7b3$var$dt(e, t) {
    return $33f07bbd4ddcb7b3$var$F(e, t), (t)=>$33f07bbd4ddcb7b3$var$Y(e(t));
}
function $33f07bbd4ddcb7b3$var$ft(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$bt(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), ()=>$33f07bbd4ddcb7b3$var$g(e, t, []);
}
function $33f07bbd4ddcb7b3$var$ht(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$mt(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r, o)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r,
            o
        ]);
}
function $33f07bbd4ddcb7b3$var$_t(e, t) {
    if (!$33f07bbd4ddcb7b3$var$gt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.read, "read"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$pt = "function" == typeof AbortController;
class $33f07bbd4ddcb7b3$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $33f07bbd4ddcb7b3$var$I(e, "First parameter");
        const r = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), o = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$ft(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$bt(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $33f07bbd4ddcb7b3$var$ht(n, e, `${t} has member 'start' that`),
                write: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$mt(i, e, `${t} has member 'write' that`),
                type: a
            };
        }(e, "First parameter");
        $33f07bbd4ddcb7b3$var$St(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $33f07bbd4ddcb7b3$var$ut(r);
        !function(e, t, r, o) {
            const n = Object.create($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype);
            let a, i, l, s;
            a = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            i = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            l = void 0 !== t.close ? ()=>t.close() : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            s = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            $33f07bbd4ddcb7b3$var$Ft(e, n, a, i, l, s, r, o);
        }(this, o, $33f07bbd4ddcb7b3$var$st(r, 1), n);
    }
    get locked() {
        if (!$33f07bbd4ddcb7b3$var$gt(this)) throw $33f07bbd4ddcb7b3$var$Nt("locked");
        return $33f07bbd4ddcb7b3$var$vt(this);
    }
    abort(e) {
        return $33f07bbd4ddcb7b3$var$gt(this) ? $33f07bbd4ddcb7b3$var$vt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $33f07bbd4ddcb7b3$var$wt(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Nt("abort"));
    }
    close() {
        return $33f07bbd4ddcb7b3$var$gt(this) ? $33f07bbd4ddcb7b3$var$vt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close a stream that already has a writer")) : $33f07bbd4ddcb7b3$var$qt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close an already-closing stream")) : $33f07bbd4ddcb7b3$var$Rt(this) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Nt("close"));
    }
    getWriter() {
        if (!$33f07bbd4ddcb7b3$var$gt(this)) throw $33f07bbd4ddcb7b3$var$Nt("getWriter");
        return $33f07bbd4ddcb7b3$var$yt(this);
    }
}
function $33f07bbd4ddcb7b3$var$yt(e) {
    return new $33f07bbd4ddcb7b3$export$9295348f005d6054(e);
}
function $33f07bbd4ddcb7b3$var$St(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $33f07bbd4ddcb7b3$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $33f07bbd4ddcb7b3$var$gt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $33f07bbd4ddcb7b3$export$826849241f7970f8;
}
function $33f07bbd4ddcb7b3$var$vt(e) {
    return void 0 !== e._writer;
}
function $33f07bbd4ddcb7b3$var$wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $33f07bbd4ddcb7b3$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $33f07bbd4ddcb7b3$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const a = $33f07bbd4ddcb7b3$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = a, n || $33f07bbd4ddcb7b3$var$Ct(e, t), a;
}
function $33f07bbd4ddcb7b3$var$Rt(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $33f07bbd4ddcb7b3$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $33f07bbd4ddcb7b3$var$or(o), $33f07bbd4ddcb7b3$var$ve(n = e._writableStreamController, $33f07bbd4ddcb7b3$var$Dt, 0), $33f07bbd4ddcb7b3$var$Mt(n), r;
}
function $33f07bbd4ddcb7b3$var$Tt(e, t) {
    "writable" !== e._state ? $33f07bbd4ddcb7b3$var$Pt(e) : $33f07bbd4ddcb7b3$var$Ct(e, t);
}
function $33f07bbd4ddcb7b3$var$Ct(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $33f07bbd4ddcb7b3$var$jt(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $33f07bbd4ddcb7b3$var$Pt(e);
}
function $33f07bbd4ddcb7b3$var$Pt(e) {
    e._state = "errored", e._writableStreamController[$33f07bbd4ddcb7b3$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $33f07bbd4ddcb7b3$var$v, void 0 === e._pendingAbortRequest) return void $33f07bbd4ddcb7b3$var$Et(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $33f07bbd4ddcb7b3$var$Et(e);
    $33f07bbd4ddcb7b3$var$b(e._writableStreamController[$33f07bbd4ddcb7b3$var$w](r._reason), ()=>(r._resolve(), $33f07bbd4ddcb7b3$var$Et(e), null), (t)=>(r._reject(t), $33f07bbd4ddcb7b3$var$Et(e), null));
}
function $33f07bbd4ddcb7b3$var$qt(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $33f07bbd4ddcb7b3$var$Et(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $33f07bbd4ddcb7b3$var$Jt(t, e._storedError);
}
function $33f07bbd4ddcb7b3$var$Wt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $33f07bbd4ddcb7b3$var$Zt(e);
    }(r) : $33f07bbd4ddcb7b3$var$or(r)), e._backpressure = t;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.abort, "abort"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$9295348f005d6054 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "WritableStreamDefaultWriter"), $33f07bbd4ddcb7b3$var$_t(e, "First parameter"), $33f07bbd4ddcb7b3$var$vt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$33f07bbd4ddcb7b3$var$qt(e) && e._backpressure ? $33f07bbd4ddcb7b3$var$Zt(this) : $33f07bbd4ddcb7b3$var$tr(this), $33f07bbd4ddcb7b3$var$Gt(this);
        else if ("erroring" === t) $33f07bbd4ddcb7b3$var$er(this, e._storedError), $33f07bbd4ddcb7b3$var$Gt(this);
        else if ("closed" === t) $33f07bbd4ddcb7b3$var$tr(this), $33f07bbd4ddcb7b3$var$Gt(r = this), $33f07bbd4ddcb7b3$var$Kt(r);
        else {
            const t = e._storedError;
            $33f07bbd4ddcb7b3$var$er(this, t), $33f07bbd4ddcb7b3$var$Xt(this, t);
        }
        var r;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("closed"));
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) throw $33f07bbd4ddcb7b3$var$Vt("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $33f07bbd4ddcb7b3$var$Ut("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $33f07bbd4ddcb7b3$var$$t(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? this._readyPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("ready"));
    }
    abort(e) {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? void 0 === this._ownerWritableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("abort")) : function(e, t) {
            return $33f07bbd4ddcb7b3$var$wt(e._ownerWritableStream, t);
        }(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("abort"));
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("close")) : $33f07bbd4ddcb7b3$var$qt(e) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close an already-closing stream")) : $33f07bbd4ddcb7b3$var$Bt(this);
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) throw $33f07bbd4ddcb7b3$var$Vt("releaseLock");
        void 0 !== this._ownerWritableStream && $33f07bbd4ddcb7b3$var$At(this);
    }
    write(e) {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? void 0 === this._ownerWritableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("write to")) : $33f07bbd4ddcb7b3$var$zt(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("write"));
    }
}
function $33f07bbd4ddcb7b3$var$Ot(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $33f07bbd4ddcb7b3$export$9295348f005d6054;
}
function $33f07bbd4ddcb7b3$var$Bt(e) {
    return $33f07bbd4ddcb7b3$var$Rt(e._ownerWritableStream);
}
function $33f07bbd4ddcb7b3$var$kt(e, t) {
    "pending" === e._closedPromiseState ? $33f07bbd4ddcb7b3$var$Jt(e, t) : function(e, t) {
        $33f07bbd4ddcb7b3$var$Xt(e, t);
    }(e, t);
}
function $33f07bbd4ddcb7b3$var$jt(e, t) {
    "pending" === e._readyPromiseState ? $33f07bbd4ddcb7b3$var$rr(e, t) : function(e, t) {
        $33f07bbd4ddcb7b3$var$er(e, t);
    }(e, t);
}
function $33f07bbd4ddcb7b3$var$At(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $33f07bbd4ddcb7b3$var$jt(e, r), $33f07bbd4ddcb7b3$var$kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $33f07bbd4ddcb7b3$var$zt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $33f07bbd4ddcb7b3$var$Yt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("write to"));
    const a = r._state;
    if ("errored" === a) return $33f07bbd4ddcb7b3$var$d(r._storedError);
    if ($33f07bbd4ddcb7b3$var$qt(r) || "closed" === a) return $33f07bbd4ddcb7b3$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === a) return $33f07bbd4ddcb7b3$var$d(r._storedError);
    const i = function(e) {
        return $33f07bbd4ddcb7b3$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $33f07bbd4ddcb7b3$var$ve(e, t, r);
        } catch (t) {
            return void $33f07bbd4ddcb7b3$var$Yt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$33f07bbd4ddcb7b3$var$qt(o) && "writable" === o._state) $33f07bbd4ddcb7b3$var$Wt(o, $33f07bbd4ddcb7b3$var$xt(e));
        $33f07bbd4ddcb7b3$var$Mt(e);
    }(o, t, n), i;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.abort, "abort"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$Dt = {};
class $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("error");
        "writable" === this._controlledWritableStream._state && $33f07bbd4ddcb7b3$var$Qt(this, e);
    }
    [$33f07bbd4ddcb7b3$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$It(this), t;
    }
    [$33f07bbd4ddcb7b3$var$R]() {
        $33f07bbd4ddcb7b3$var$we(this);
    }
}
function $33f07bbd4ddcb7b3$var$Lt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2;
}
function $33f07bbd4ddcb7b3$var$Ft(e, t, r, o, n, a, i, l) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._abortReason = void 0, t._abortController = function() {
        if ($33f07bbd4ddcb7b3$var$pt) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
    const s = $33f07bbd4ddcb7b3$var$xt(t);
    $33f07bbd4ddcb7b3$var$Wt(e, s);
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$Mt(t), null), (r)=>(t._started = !0, $33f07bbd4ddcb7b3$var$Tt(e, r), null));
}
function $33f07bbd4ddcb7b3$var$It(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$$t(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$Mt(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $33f07bbd4ddcb7b3$var$Pt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $33f07bbd4ddcb7b3$var$Dt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $33f07bbd4ddcb7b3$var$ge(e);
        const r = e._closeAlgorithm();
        $33f07bbd4ddcb7b3$var$It(e), $33f07bbd4ddcb7b3$var$b(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $33f07bbd4ddcb7b3$var$Kt(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $33f07bbd4ddcb7b3$var$Tt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $33f07bbd4ddcb7b3$var$b(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($33f07bbd4ddcb7b3$var$ge(e), !$33f07bbd4ddcb7b3$var$qt(r) && "writable" === t) {
                const t = $33f07bbd4ddcb7b3$var$xt(e);
                $33f07bbd4ddcb7b3$var$Wt(r, t);
            }
            return $33f07bbd4ddcb7b3$var$Mt(e), null;
        }, (t)=>("writable" === r._state && $33f07bbd4ddcb7b3$var$It(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $33f07bbd4ddcb7b3$var$Tt(e, t);
            }(r, t), null));
    }(e, r);
}
function $33f07bbd4ddcb7b3$var$Yt(e, t) {
    "writable" === e._controlledWritableStream._state && $33f07bbd4ddcb7b3$var$Qt(e, t);
}
function $33f07bbd4ddcb7b3$var$xt(e) {
    return $33f07bbd4ddcb7b3$var$$t(e) <= 0;
}
function $33f07bbd4ddcb7b3$var$Qt(e, t) {
    const r = e._controlledWritableStream;
    $33f07bbd4ddcb7b3$var$It(e), $33f07bbd4ddcb7b3$var$Ct(r, t);
}
function $33f07bbd4ddcb7b3$var$Nt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $33f07bbd4ddcb7b3$var$Ht(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$Vt(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $33f07bbd4ddcb7b3$var$Ut(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $33f07bbd4ddcb7b3$var$Gt(e) {
    e._closedPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $33f07bbd4ddcb7b3$var$Xt(e, t) {
    $33f07bbd4ddcb7b3$var$Gt(e), $33f07bbd4ddcb7b3$var$Jt(e, t);
}
function $33f07bbd4ddcb7b3$var$Jt(e, t) {
    void 0 !== e._closedPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $33f07bbd4ddcb7b3$var$Kt(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $33f07bbd4ddcb7b3$var$Zt(e) {
    e._readyPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $33f07bbd4ddcb7b3$var$er(e, t) {
    $33f07bbd4ddcb7b3$var$Zt(e), $33f07bbd4ddcb7b3$var$rr(e, t);
}
function $33f07bbd4ddcb7b3$var$tr(e) {
    $33f07bbd4ddcb7b3$var$Zt(e), $33f07bbd4ddcb7b3$var$or(e);
}
function $33f07bbd4ddcb7b3$var$rr(e, t) {
    void 0 !== e._readyPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $33f07bbd4ddcb7b3$var$or(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$nr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $33f07bbd4ddcb7b3$var$ar = function() {
    const e = null == $33f07bbd4ddcb7b3$var$nr ? void 0 : $33f07bbd4ddcb7b3$var$nr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $33f07bbd4ddcb7b3$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $33f07bbd4ddcb7b3$var$ir(t, r, o, n, a, i) {
    const l = $33f07bbd4ddcb7b3$var$H(t), s = $33f07bbd4ddcb7b3$var$yt(r);
    t._disturbed = !0;
    let _ = !1, y = $33f07bbd4ddcb7b3$var$c(void 0);
    return $33f07bbd4ddcb7b3$var$u((S, g)=>{
        let v;
        if (void 0 !== i) {
            if (v = ()=>{
                const e = void 0 !== i.reason ? i.reason : new $33f07bbd4ddcb7b3$var$ar("Aborted", "AbortError"), o = [];
                n || o.push(()=>"writable" === r._state ? $33f07bbd4ddcb7b3$var$wt(r, e) : $33f07bbd4ddcb7b3$var$c(void 0)), a || o.push(()=>"readable" === t._state ? $33f07bbd4ddcb7b3$var$Or(t, e) : $33f07bbd4ddcb7b3$var$c(void 0)), q(()=>Promise.all(o.map((e)=>e())), !0, e);
            }, i.aborted) return void v();
            i.addEventListener("abort", v);
        }
        var w, R, T;
        if (P(t, l._closedPromise, (e)=>(n ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$wt(r, e), !0, e), null)), P(r, s._closedPromise, (e)=>(a ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$Or(t, e), !0, e), null)), w = t, R = l._closedPromise, T = ()=>(o ? E() : q(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $33f07bbd4ddcb7b3$var$qt(t) || "closed" === r ? $33f07bbd4ddcb7b3$var$c(void 0) : "errored" === r ? $33f07bbd4ddcb7b3$var$d(t._storedError) : $33f07bbd4ddcb7b3$var$Bt(e);
                })(s)), null), "closed" === w._state ? T() : $33f07bbd4ddcb7b3$var$h(R, T), $33f07bbd4ddcb7b3$var$qt(r) || "closed" === r._state) {
            const e = new TypeError("the destination writable stream closed before all data could be piped to it");
            a ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$Or(t, e), !0, e);
        }
        function C() {
            const e = y;
            return $33f07bbd4ddcb7b3$var$f(y, ()=>e !== y ? C() : void 0);
        }
        function P(e, t, r) {
            "errored" === e._state ? r(e._storedError) : $33f07bbd4ddcb7b3$var$m(t, r);
        }
        function q(e, t, o) {
            function n() {
                return $33f07bbd4ddcb7b3$var$b(e(), ()=>O(t, o), (e)=>O(!0, e)), null;
            }
            _ || (_ = !0, "writable" !== r._state || $33f07bbd4ddcb7b3$var$qt(r) ? n() : $33f07bbd4ddcb7b3$var$h(C(), n));
        }
        function E(e, t) {
            _ || (_ = !0, "writable" !== r._state || $33f07bbd4ddcb7b3$var$qt(r) ? O(e, t) : $33f07bbd4ddcb7b3$var$h(C(), ()=>O(e, t)));
        }
        function O(e, t) {
            return $33f07bbd4ddcb7b3$var$At(s), $33f07bbd4ddcb7b3$var$W(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
        }
        $33f07bbd4ddcb7b3$var$p($33f07bbd4ddcb7b3$var$u((t, r)=>{
            !function o(n) {
                n ? t() : $33f07bbd4ddcb7b3$var$f(_ ? $33f07bbd4ddcb7b3$var$c(!0) : $33f07bbd4ddcb7b3$var$f(s._readyPromise, ()=>$33f07bbd4ddcb7b3$var$u((t, r)=>{
                        $33f07bbd4ddcb7b3$var$K(l, {
                            _chunkSteps: (r)=>{
                                y = $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$zt(s, r), void 0, $33f07bbd4ddcb7b3$var$e), t(!1);
                            },
                            _closeSteps: ()=>t(!0),
                            _errorSteps: r
                        });
                    })), o, r);
            }(!1);
        }));
    });
}
class $33f07bbd4ddcb7b3$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("desiredSize");
        return $33f07bbd4ddcb7b3$var$hr(this);
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("close");
        if (!$33f07bbd4ddcb7b3$var$mr(this)) throw new TypeError("The stream is not in a state that permits close");
        $33f07bbd4ddcb7b3$var$dr(this);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("enqueue");
        if (!$33f07bbd4ddcb7b3$var$mr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $33f07bbd4ddcb7b3$var$fr(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("error");
        $33f07bbd4ddcb7b3$var$br(this, e);
    }
    [$33f07bbd4ddcb7b3$var$T](e) {
        $33f07bbd4ddcb7b3$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$cr(this), t;
    }
    [$33f07bbd4ddcb7b3$var$C](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $33f07bbd4ddcb7b3$var$ge(this);
            this._closeRequested && 0 === this._queue.length ? ($33f07bbd4ddcb7b3$var$cr(this), $33f07bbd4ddcb7b3$var$Br(t)) : $33f07bbd4ddcb7b3$var$sr(this), e._chunkSteps(r);
        } else $33f07bbd4ddcb7b3$var$V(t, e), $33f07bbd4ddcb7b3$var$sr(this);
    }
    [$33f07bbd4ddcb7b3$var$P]() {}
}
function $33f07bbd4ddcb7b3$var$lr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $33f07bbd4ddcb7b3$export$b0bb6d0989d67700;
}
function $33f07bbd4ddcb7b3$var$sr(e) {
    if (!$33f07bbd4ddcb7b3$var$ur(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $33f07bbd4ddcb7b3$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $33f07bbd4ddcb7b3$var$sr(e)), null), (t)=>($33f07bbd4ddcb7b3$var$br(e, t), null));
}
function $33f07bbd4ddcb7b3$var$ur(e) {
    const t = e._controlledReadableStream;
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return !1;
    if (!e._started) return !1;
    if ($33f07bbd4ddcb7b3$var$Wr(t) && $33f07bbd4ddcb7b3$var$G(t) > 0) return !0;
    return $33f07bbd4ddcb7b3$var$hr(e) > 0;
}
function $33f07bbd4ddcb7b3$var$cr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$dr(e) {
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($33f07bbd4ddcb7b3$var$cr(e), $33f07bbd4ddcb7b3$var$Br(t));
}
function $33f07bbd4ddcb7b3$var$fr(e, t) {
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return;
    const r = e._controlledReadableStream;
    if ($33f07bbd4ddcb7b3$var$Wr(r) && $33f07bbd4ddcb7b3$var$G(r) > 0) $33f07bbd4ddcb7b3$var$U(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $33f07bbd4ddcb7b3$var$br(e, t), t;
        }
        try {
            $33f07bbd4ddcb7b3$var$ve(e, t, r);
        } catch (t) {
            throw $33f07bbd4ddcb7b3$var$br(e, t), t;
        }
    }
    $33f07bbd4ddcb7b3$var$sr(e);
}
function $33f07bbd4ddcb7b3$var$br(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($33f07bbd4ddcb7b3$var$we(e), $33f07bbd4ddcb7b3$var$cr(e), $33f07bbd4ddcb7b3$var$kr(r, t));
}
function $33f07bbd4ddcb7b3$var$hr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$mr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $33f07bbd4ddcb7b3$var$_r(e, t, r, o, n, a, i) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$sr(t), null), (e)=>($33f07bbd4ddcb7b3$var$br(t, e), null));
}
function $33f07bbd4ddcb7b3$var$pr(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$yr(e, t) {
    return $33f07bbd4ddcb7b3$var$Te(e._readableStreamController) ? function(e) {
        let t, r, o, n, a, i = $33f07bbd4ddcb7b3$var$H(e), l = !1, s = !1, d = !1, f = !1, b = !1;
        const h = $33f07bbd4ddcb7b3$var$u((e)=>{
            a = e;
        });
        function _(e) {
            $33f07bbd4ddcb7b3$var$m(e._closedPromise, (t)=>(e !== i || ($33f07bbd4ddcb7b3$var$Qe(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(n._readableStreamController, t), f && b || a(void 0)), null));
        }
        function p() {
            $33f07bbd4ddcb7b3$var$nt(i) && ($33f07bbd4ddcb7b3$var$W(i), i = $33f07bbd4ddcb7b3$var$H(e), _(i));
            $33f07bbd4ddcb7b3$var$K(i, {
                _chunkSteps: (t)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        s = !1, d = !1;
                        const r = t;
                        let i = t;
                        if (!f && !b) try {
                            i = $33f07bbd4ddcb7b3$var$Se(t);
                        } catch (t) {
                            return $33f07bbd4ddcb7b3$var$Qe(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(n._readableStreamController, t), void a($33f07bbd4ddcb7b3$var$Or(e, t));
                        }
                        f || $33f07bbd4ddcb7b3$var$xe(o._readableStreamController, r), b || $33f07bbd4ddcb7b3$var$xe(n._readableStreamController, i), l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    l = !1, f || $33f07bbd4ddcb7b3$var$Ye(o._readableStreamController), b || $33f07bbd4ddcb7b3$var$Ye(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(n._readableStreamController, 0), f && b || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function S(t, r) {
            $33f07bbd4ddcb7b3$var$J(i) && ($33f07bbd4ddcb7b3$var$W(i), i = $33f07bbd4ddcb7b3$var$et(e), _(i));
            const u = r ? n : o, c = r ? o : n;
            $33f07bbd4ddcb7b3$var$at(i, t, 1, {
                _chunkSteps: (t)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        s = !1, d = !1;
                        const o = r ? b : f;
                        if (r ? f : b) o || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $33f07bbd4ddcb7b3$var$Se(t);
                            } catch (t) {
                                return $33f07bbd4ddcb7b3$var$Qe(u._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(c._readableStreamController, t), void a($33f07bbd4ddcb7b3$var$Or(e, t));
                            }
                            o || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, t), $33f07bbd4ddcb7b3$var$xe(c._readableStreamController, r);
                        }
                        l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    l = !1;
                    const t = r ? b : f, o = r ? f : b;
                    t || $33f07bbd4ddcb7b3$var$Ye(u._readableStreamController), o || $33f07bbd4ddcb7b3$var$Ye(c._readableStreamController), void 0 !== e && (t || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(c._readableStreamController, 0)), t && o || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function g() {
            if (l) return s = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            l = !0;
            const e = $33f07bbd4ddcb7b3$var$He(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function v() {
            if (l) return d = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            l = !0;
            const e = $33f07bbd4ddcb7b3$var$He(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, b) {
                const o = $33f07bbd4ddcb7b3$var$ne([
                    t,
                    r
                ]), n = $33f07bbd4ddcb7b3$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function R(o) {
            if (b = !0, r = o, f) {
                const o = $33f07bbd4ddcb7b3$var$ne([
                    t,
                    r
                ]), n = $33f07bbd4ddcb7b3$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function T() {}
        return o = $33f07bbd4ddcb7b3$var$Pr(T, g, w), n = $33f07bbd4ddcb7b3$var$Pr(T, v, R), _(i), [
            o,
            n
        ];
    }(e) : function(e, t) {
        const r = $33f07bbd4ddcb7b3$var$H(e);
        let o, n, a, i, l, s = !1, d = !1, f = !1, b = !1;
        const h = $33f07bbd4ddcb7b3$var$u((e)=>{
            l = e;
        });
        function _() {
            if (s) return d = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            s = !0;
            return $33f07bbd4ddcb7b3$var$K(r, {
                _chunkSteps: (e)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        d = !1;
                        const t = e, r = e;
                        f || $33f07bbd4ddcb7b3$var$fr(a._readableStreamController, t), b || $33f07bbd4ddcb7b3$var$fr(i._readableStreamController, r), s = !1, d && _();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, f || $33f07bbd4ddcb7b3$var$dr(a._readableStreamController), b || $33f07bbd4ddcb7b3$var$dr(i._readableStreamController), f && b || l(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            }), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function p(t) {
            if (f = !0, o = t, b) {
                const t = $33f07bbd4ddcb7b3$var$ne([
                    o,
                    n
                ]), r = $33f07bbd4ddcb7b3$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function S(t) {
            if (b = !0, n = t, f) {
                const t = $33f07bbd4ddcb7b3$var$ne([
                    o,
                    n
                ]), r = $33f07bbd4ddcb7b3$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function g() {}
        return a = $33f07bbd4ddcb7b3$var$Cr(g, _, p), i = $33f07bbd4ddcb7b3$var$Cr(g, _, S), $33f07bbd4ddcb7b3$var$m(r._closedPromise, (e)=>($33f07bbd4ddcb7b3$var$br(a._readableStreamController, e), $33f07bbd4ddcb7b3$var$br(i._readableStreamController, e), f && b || l(void 0), null)), [
            a,
            i
        ];
    }(e);
}
function $33f07bbd4ddcb7b3$var$Sr(r) {
    var o;
    return $33f07bbd4ddcb7b3$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            return $33f07bbd4ddcb7b3$var$_(e, (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $33f07bbd4ddcb7b3$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $33f07bbd4ddcb7b3$var$fr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            try {
                return $33f07bbd4ddcb7b3$var$c(r.cancel(e));
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
        }
        return o = $33f07bbd4ddcb7b3$var$Cr($33f07bbd4ddcb7b3$var$e, n, a, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $33f07bbd4ddcb7b3$var$fe(r, "async");
        function a() {
            let e;
            try {
                e = $33f07bbd4ddcb7b3$var$be(n);
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            return $33f07bbd4ddcb7b3$var$_($33f07bbd4ddcb7b3$var$c(e), (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $33f07bbd4ddcb7b3$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $33f07bbd4ddcb7b3$var$fr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            const r = n.iterator;
            let o;
            try {
                o = $33f07bbd4ddcb7b3$var$ue(r, "return");
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            if (void 0 === o) return $33f07bbd4ddcb7b3$var$c(void 0);
            return $33f07bbd4ddcb7b3$var$_($33f07bbd4ddcb7b3$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $33f07bbd4ddcb7b3$var$Cr($33f07bbd4ddcb7b3$var$e, a, i, 0), o;
    }(r);
}
function $33f07bbd4ddcb7b3$var$gr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$vr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$wr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$Rr(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $33f07bbd4ddcb7b3$var$Tr(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
    return void 0 !== a && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(a, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: a
    };
}
Object.defineProperties($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $33f07bbd4ddcb7b3$var$I(e, "First parameter");
        const r = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), o = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$Q(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $33f07bbd4ddcb7b3$var$gr(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === a ? void 0 : $33f07bbd4ddcb7b3$var$vr(a, r, `${t} has member 'pull' that`),
                start: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$wr(i, r, `${t} has member 'start' that`),
                type: void 0 === l ? void 0 : $33f07bbd4ddcb7b3$var$Rr(l, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($33f07bbd4ddcb7b3$var$qr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype);
                let n, a, i;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
                const l = t.autoAllocateChunkSize;
                if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $33f07bbd4ddcb7b3$var$Xe(e, o, n, a, i, r, l);
            }(this, o, $33f07bbd4ddcb7b3$var$st(r, 0));
        } else {
            const e = $33f07bbd4ddcb7b3$var$ut(r);
            !function(e, t, r, o) {
                const n = Object.create($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype);
                let a, i, l;
                a = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), l = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), $33f07bbd4ddcb7b3$var$_r(e, n, a, i, l, r, o);
            }(this, o, $33f07bbd4ddcb7b3$var$st(r, 1), e);
        }
    }
    get locked() {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("locked");
        return $33f07bbd4ddcb7b3$var$Wr(this);
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$Er(this) ? $33f07bbd4ddcb7b3$var$Wr(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $33f07bbd4ddcb7b3$var$Or(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$jr("cancel"));
    }
    getReader(e) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("getReader");
        return void 0 === function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Ze(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $33f07bbd4ddcb7b3$var$H(this) : $33f07bbd4ddcb7b3$var$et(this);
    }
    pipeThrough(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("pipeThrough");
        $33f07bbd4ddcb7b3$var$$(e, 1, "pipeThrough");
        const r = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $33f07bbd4ddcb7b3$var$M(r, "readable", "ReadableWritablePair"), $33f07bbd4ddcb7b3$var$N(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $33f07bbd4ddcb7b3$var$M(o, "writable", "ReadableWritablePair"), $33f07bbd4ddcb7b3$var$_t(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $33f07bbd4ddcb7b3$var$Tr(t, "Second parameter");
        if ($33f07bbd4ddcb7b3$var$Wr(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($33f07bbd4ddcb7b3$var$vt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $33f07bbd4ddcb7b3$var$p($33f07bbd4ddcb7b3$var$ir(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$jr("pipeTo"));
        if (void 0 === e) return $33f07bbd4ddcb7b3$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$33f07bbd4ddcb7b3$var$gt(e)) return $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $33f07bbd4ddcb7b3$var$Tr(t, "Second parameter");
        } catch (e) {
            return $33f07bbd4ddcb7b3$var$d(e);
        }
        return $33f07bbd4ddcb7b3$var$Wr(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $33f07bbd4ddcb7b3$var$vt(e) ? $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $33f07bbd4ddcb7b3$var$ir(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("tee");
        return $33f07bbd4ddcb7b3$var$ne($33f07bbd4ddcb7b3$var$yr(this));
    }
    values(e) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("values");
        return function(e, t) {
            const r = $33f07bbd4ddcb7b3$var$H(e), o = new $33f07bbd4ddcb7b3$var$he(r, t), n = Object.create($33f07bbd4ddcb7b3$var$me);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$33f07bbd4ddcb7b3$var$de](e) {
        return this.values(e);
    }
    static from(e) {
        return $33f07bbd4ddcb7b3$var$Sr(e);
    }
}
function $33f07bbd4ddcb7b3$var$Cr(e, t, r, o = 1, n = ()=>1) {
    const a = Object.create($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype);
    $33f07bbd4ddcb7b3$var$qr(a);
    return $33f07bbd4ddcb7b3$var$_r(a, Object.create($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype), e, t, r, o, n), a;
}
function $33f07bbd4ddcb7b3$var$Pr(e, t, r) {
    const o = Object.create($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype);
    $33f07bbd4ddcb7b3$var$qr(o);
    return $33f07bbd4ddcb7b3$var$Xe(o, Object.create($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $33f07bbd4ddcb7b3$var$qr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $33f07bbd4ddcb7b3$var$Er(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76;
}
function $33f07bbd4ddcb7b3$var$Wr(e) {
    return void 0 !== e._reader;
}
function $33f07bbd4ddcb7b3$var$Or(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $33f07bbd4ddcb7b3$var$c(void 0);
    if ("errored" === t._state) return $33f07bbd4ddcb7b3$var$d(t._storedError);
    $33f07bbd4ddcb7b3$var$Br(t);
    const o = t._reader;
    if (void 0 !== o && $33f07bbd4ddcb7b3$var$nt(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $33f07bbd4ddcb7b3$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $33f07bbd4ddcb7b3$var$_(t._readableStreamController[$33f07bbd4ddcb7b3$var$T](r), $33f07bbd4ddcb7b3$var$e);
}
function $33f07bbd4ddcb7b3$var$Br(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($33f07bbd4ddcb7b3$var$A(t), $33f07bbd4ddcb7b3$var$J(t))) {
        const e = t._readRequests;
        t._readRequests = new $33f07bbd4ddcb7b3$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $33f07bbd4ddcb7b3$var$kr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($33f07bbd4ddcb7b3$var$j(r, t), $33f07bbd4ddcb7b3$var$J(r) ? $33f07bbd4ddcb7b3$var$Z(r, t) : $33f07bbd4ddcb7b3$var$it(r, t));
}
function $33f07bbd4ddcb7b3$var$jr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $33f07bbd4ddcb7b3$var$Ar(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $33f07bbd4ddcb7b3$var$M(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $33f07bbd4ddcb7b3$var$Y(r)
    };
}
Object.defineProperties($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.from, "from"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.tee, "tee"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, $33f07bbd4ddcb7b3$var$de, {
    value: $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$zr = (e)=>e.byteLength;
$33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$var$zr, "size");
class $33f07bbd4ddcb7b3$export$d386b5f37d154119 {
    constructor(e){
        $33f07bbd4ddcb7b3$var$$(e, 1, "ByteLengthQueuingStrategy"), e = $33f07bbd4ddcb7b3$var$Ar(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$33f07bbd4ddcb7b3$var$Lr(this)) throw $33f07bbd4ddcb7b3$var$Dr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$33f07bbd4ddcb7b3$var$Lr(this)) throw $33f07bbd4ddcb7b3$var$Dr("size");
        return $33f07bbd4ddcb7b3$var$zr;
    }
}
function $33f07bbd4ddcb7b3$var$Dr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $33f07bbd4ddcb7b3$var$Lr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $33f07bbd4ddcb7b3$export$d386b5f37d154119;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$Fr = ()=>1;
$33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$var$Fr, "size");
class $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625 {
    constructor(e){
        $33f07bbd4ddcb7b3$var$$(e, 1, "CountQueuingStrategy"), e = $33f07bbd4ddcb7b3$var$Ar(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$33f07bbd4ddcb7b3$var$$r(this)) throw $33f07bbd4ddcb7b3$var$Ir("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$33f07bbd4ddcb7b3$var$$r(this)) throw $33f07bbd4ddcb7b3$var$Ir("size");
        return $33f07bbd4ddcb7b3$var$Fr;
    }
}
function $33f07bbd4ddcb7b3$var$Ir(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $33f07bbd4ddcb7b3$var$$r(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625;
}
function $33f07bbd4ddcb7b3$var$Mr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$Yr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$xr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r, o)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r,
            o
        ]);
}
function $33f07bbd4ddcb7b3$var$Qr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), n = $33f07bbd4ddcb7b3$var$ct(r, "Third parameter"), a = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Qr(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$Mr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === a ? void 0 : $33f07bbd4ddcb7b3$var$Yr(a, e, `${t} has member 'start' that`),
                transform: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$xr(i, e, `${t} has member 'transform' that`),
                writableType: l
            };
        }(e, "First parameter");
        if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
        const i = $33f07bbd4ddcb7b3$var$st(n, 0), l = $33f07bbd4ddcb7b3$var$ut(n), s = $33f07bbd4ddcb7b3$var$st(o, 1), f = $33f07bbd4ddcb7b3$var$ut(o);
        let h;
        !function(e, t, r, o, n, a) {
            function i() {
                return t;
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $33f07bbd4ddcb7b3$var$_(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $33f07bbd4ddcb7b3$var$Zr(r, t);
                    });
                    return $33f07bbd4ddcb7b3$var$Zr(r, t);
                }(e, t);
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $33f07bbd4ddcb7b3$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $33f07bbd4ddcb7b3$var$Jr(r), $33f07bbd4ddcb7b3$var$b(n, ()=>("errored" === o._state ? $33f07bbd4ddcb7b3$var$ro(r, o._storedError) : ($33f07bbd4ddcb7b3$var$br(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$to(r)), null), (e)=>($33f07bbd4ddcb7b3$var$br(o._readableStreamController, e), $33f07bbd4ddcb7b3$var$ro(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $33f07bbd4ddcb7b3$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $33f07bbd4ddcb7b3$var$Jr(t), $33f07bbd4ddcb7b3$var$b(o, ()=>("errored" === r._state ? $33f07bbd4ddcb7b3$var$ro(t, r._storedError) : ($33f07bbd4ddcb7b3$var$dr(r._readableStreamController), $33f07bbd4ddcb7b3$var$to(t)), null), (e)=>($33f07bbd4ddcb7b3$var$br(r._readableStreamController, e), $33f07bbd4ddcb7b3$var$ro(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $33f07bbd4ddcb7b3$var$Gr(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $33f07bbd4ddcb7b3$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $33f07bbd4ddcb7b3$var$Jr(r), $33f07bbd4ddcb7b3$var$b(n, ()=>("errored" === o._state ? $33f07bbd4ddcb7b3$var$ro(r, o._storedError) : ($33f07bbd4ddcb7b3$var$Yt(o._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e), $33f07bbd4ddcb7b3$var$to(r)), null), (t)=>($33f07bbd4ddcb7b3$var$Yt(o._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e), $33f07bbd4ddcb7b3$var$ro(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, a = ()=>1) {
                const i = Object.create($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype);
                return $33f07bbd4ddcb7b3$var$St(i), $33f07bbd4ddcb7b3$var$Ft(i, Object.create($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, a), i;
            }(i, l, c, s, r, o), e._readable = $33f07bbd4ddcb7b3$var$Cr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $33f07bbd4ddcb7b3$var$Gr(e, !0), e._transformStreamController = void 0;
        }(this, $33f07bbd4ddcb7b3$var$u((e)=>{
            h = e;
        }), s, f, i, l), function(e, t) {
            const r = Object.create($33f07bbd4ddcb7b3$export$a55559184460222.prototype);
            let o, n, a;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $33f07bbd4ddcb7b3$var$Kr(r, e), $33f07bbd4ddcb7b3$var$c(void 0);
                } catch (e) {
                    return $33f07bbd4ddcb7b3$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, a);
        }(this, a), void 0 !== a.start ? h(a.start(this._transformStreamController)) : h(void 0);
    }
    get readable() {
        if (!$33f07bbd4ddcb7b3$var$Nr(this)) throw $33f07bbd4ddcb7b3$var$oo("readable");
        return this._readable;
    }
    get writable() {
        if (!$33f07bbd4ddcb7b3$var$Nr(this)) throw $33f07bbd4ddcb7b3$var$oo("writable");
        return this._writable;
    }
}
function $33f07bbd4ddcb7b3$var$Nr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $33f07bbd4ddcb7b3$export$d102341634899398;
}
function $33f07bbd4ddcb7b3$var$Hr(e, t) {
    $33f07bbd4ddcb7b3$var$br(e._readable._readableStreamController, t), $33f07bbd4ddcb7b3$var$Vr(e, t);
}
function $33f07bbd4ddcb7b3$var$Vr(e, t) {
    $33f07bbd4ddcb7b3$var$Jr(e._transformStreamController), $33f07bbd4ddcb7b3$var$Yt(e._writable._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e);
}
function $33f07bbd4ddcb7b3$var$Ur(e) {
    e._backpressure && $33f07bbd4ddcb7b3$var$Gr(e, !1);
}
function $33f07bbd4ddcb7b3$var$Gr(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $33f07bbd4ddcb7b3$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("desiredSize");
        return $33f07bbd4ddcb7b3$var$hr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("enqueue");
        $33f07bbd4ddcb7b3$var$Kr(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("error");
        var t;
        t = e, $33f07bbd4ddcb7b3$var$Hr(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $33f07bbd4ddcb7b3$var$dr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $33f07bbd4ddcb7b3$var$Vr(t, r);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$Xr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $33f07bbd4ddcb7b3$export$a55559184460222;
}
function $33f07bbd4ddcb7b3$var$Jr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$Kr(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$33f07bbd4ddcb7b3$var$mr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $33f07bbd4ddcb7b3$var$fr(o, t);
    } catch (e) {
        throw $33f07bbd4ddcb7b3$var$Vr(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$33f07bbd4ddcb7b3$var$ur(e);
    }(o);
    n !== r._backpressure && $33f07bbd4ddcb7b3$var$Gr(r, !0);
}
function $33f07bbd4ddcb7b3$var$Zr(e, t) {
    return $33f07bbd4ddcb7b3$var$_(e._transformAlgorithm(t), void 0, (t)=>{
        throw $33f07bbd4ddcb7b3$var$Hr(e._controlledTransformStream, t), t;
    });
}
function $33f07bbd4ddcb7b3$var$eo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$to(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$ro(e, t) {
    void 0 !== e._finishPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$oo(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.error, "error"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});


parcelRegister("aM14C", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("8O2Cb", function(module, exports) {

var $jISCq = parcelRequire("jISCq");
module.exports = $jISCq("6hwdd").then(()=>parcelRequire("ggMY5"));

});
parcelRegister("jISCq", function(module, exports) {
"use strict";

function $e5bc7e8688fb0259$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("9LwRO")).resolve(id));
}
module.exports = $e5bc7e8688fb0259$var$load;

});
parcelRegister("9LwRO", function(module, exports) {

$parcel$export(module.exports, "register", () => $71c1ff86f17894d3$export$6503ec6e8aabbaf, (v) => $71c1ff86f17894d3$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $71c1ff86f17894d3$export$f7ad0328861e2f03, (v) => $71c1ff86f17894d3$export$f7ad0328861e2f03 = v);
var $71c1ff86f17894d3$export$6503ec6e8aabbaf;
var $71c1ff86f17894d3$export$f7ad0328861e2f03;
"use strict";
var $71c1ff86f17894d3$var$mapping = new Map();
function $71c1ff86f17894d3$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$71c1ff86f17894d3$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $71c1ff86f17894d3$var$resolve(id) {
    var resolved = $71c1ff86f17894d3$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$71c1ff86f17894d3$export$6503ec6e8aabbaf = $71c1ff86f17894d3$var$register;
$71c1ff86f17894d3$export$f7ad0328861e2f03 = $71c1ff86f17894d3$var$resolve;

});



parcelRegister("gMgVc", function(module, exports) {

var $jISCq = parcelRequire("jISCq");
module.exports = $jISCq("c9LoJ").then(()=>parcelRequire("c2cXb"));

});

parcelRegister("9aeU0", function(module, exports) {

var $jISCq = parcelRequire("jISCq");
module.exports = $jISCq("acNkV").then(()=>parcelRequire("k5tLT"));

});

parcelRegister("dzTwg", function(module, exports) {

var $jISCq = parcelRequire("jISCq");
module.exports = $jISCq("gLIJH").then(()=>parcelRequire("2Fv9o"));

});

parcelRegister("gnYLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $bedded74fea3583c$export$2e2bcd8739ae039);

var $f9c8S = parcelRequire("f9c8S");
const { WritableStream: $bedded74fea3583c$var$WritableStream } = (0, $f9c8S.default);
class $bedded74fea3583c$export$fea83bdfcd3f94c extends $bedded74fea3583c$var$WritableStream {
    #writer;
    constructor(writer){
        super(writer);
        this.#writer = writer;
        // Stupid Safari hack to extend native classes
        // https://bugs.webkit.org/show_bug.cgi?id=226201
        Object.setPrototypeOf(this, $bedded74fea3583c$export$fea83bdfcd3f94c.prototype);
        /** @private */ this._closed = false;
    }
    async close() {
        this._closed = true;
        const w = this.getWriter();
        const p = w.close();
        w.releaseLock();
        return p;
    // return super.close ? super.close() : this.getWriter().close()
    }
    /** @param {number} position */ seek(position) {
        return this.write({
            type: "seek",
            position: position
        });
    }
    /** @param {number} size */ truncate(size) {
        return this.write({
            type: "truncate",
            size: size
        });
    }
    // The write(data) method steps are:
    write(data) {
        if (this._closed) return Promise.reject(new TypeError("Cannot write to a CLOSED writable stream"));
        // 1. Let writer be the result of getting a writer for this.
        const writer = this.getWriter();
        // 2. Let result be the result of writing a chunk to writer given data.
        const result = writer.write(data);
        // 3. Release writer.
        writer.releaseLock();
        // 4. Return result.
        return result;
    }
}
Object.defineProperty($bedded74fea3583c$export$fea83bdfcd3f94c.prototype, Symbol.toStringTag, {
    value: "FileSystemWritableFileStream",
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($bedded74fea3583c$export$fea83bdfcd3f94c.prototype, {
    close: {
        enumerable: true
    },
    seek: {
        enumerable: true
    },
    truncate: {
        enumerable: true
    },
    write: {
        enumerable: true
    }
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable && !globalThis.FileSystemWritableFileStream) globalThis.FileSystemWritableFileStream = $bedded74fea3583c$export$fea83bdfcd3f94c;
var $bedded74fea3583c$export$2e2bcd8739ae039 = $bedded74fea3583c$export$fea83bdfcd3f94c;

});
parcelRegister("f9c8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0711d7049896793$export$2e2bcd8739ae039);
const $b0711d7049896793$var$config = {
    ReadableStream: globalThis.ReadableStream,
    WritableStream: globalThis.WritableStream,
    TransformStream: globalThis.TransformStream,
    DOMException: globalThis.DOMException,
    Blob: globalThis.Blob,
    File: globalThis.File
};
var $b0711d7049896793$export$2e2bcd8739ae039 = $b0711d7049896793$var$config;

});


parcelRegister("2Fv9o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemDirectoryHandle", () => $1f1792f500151ec9$export$80c69d2381792bb3);
$parcel$export(module.exports, "default", () => $1f1792f500151ec9$export$2e2bcd8739ae039);

var $bAgeV = parcelRequire("bAgeV");

var $jG9Jm = parcelRequire("jG9Jm");
const { GONE: $1f1792f500151ec9$var$GONE, MOD_ERR: $1f1792f500151ec9$var$MOD_ERR } = (0, $jG9Jm.errors);
const $1f1792f500151ec9$var$kAdapter = Symbol("adapter");



class $1f1792f500151ec9$export$80c69d2381792bb3 extends (0, $bAgeV.default) {
    /** @type {FileSystemDirectoryHandle} */ [$1f1792f500151ec9$var$kAdapter];
    constructor(adapter){
        super(adapter);
        this[$1f1792f500151ec9$var$kAdapter] = adapter;
    }
    /**
   * @param {string} name Name of the directory
   * @param {object} [options]
   * @param {boolean} [options.create] create the directory if don't exist
   * @returns {Promise<FileSystemDirectoryHandle>}
   */ async getDirectoryHandle(name, options = {}) {
        if (name === "") throw new TypeError(`Name can't be an empty string.`);
        if (name === "." || name === ".." || name.includes("/")) throw new TypeError(`Name contains invalid characters.`);
        options.create = !!options.create;
        const handle = await this[$1f1792f500151ec9$var$kAdapter].getDirectoryHandle(name, options);
        return new $1f1792f500151ec9$export$80c69d2381792bb3(handle);
    }
    /** @returns {AsyncGenerator<[string, FileSystemHandle | FileSystemDirectoryHandle]>} */ async *entries() {
        const { FileSystemFileHandle: FileSystemFileHandle } = await (parcelRequire("8O2Cb"));
        for await (const [_, entry] of this[$1f1792f500151ec9$var$kAdapter].entries())yield [
            entry.name,
            entry.kind === "file" ? new FileSystemFileHandle(entry) : new $1f1792f500151ec9$export$80c69d2381792bb3(entry)
        ];
    }
    /** @deprecated use .entries() instead */ async *getEntries() {
        const { FileSystemFileHandle: FileSystemFileHandle } = await (parcelRequire("8O2Cb"));
        console.warn("deprecated, use .entries() instead");
        for await (let entry of this[$1f1792f500151ec9$var$kAdapter].entries())yield entry.kind === "file" ? new FileSystemFileHandle(entry) : new $1f1792f500151ec9$export$80c69d2381792bb3(entry);
    }
    /**
   * @param {string} name Name of the file
   * @param {object} [options]
   * @param {boolean} [options.create] create the file if don't exist
   */ async getFileHandle(name, options = {}) {
        const { FileSystemFileHandle: FileSystemFileHandle } = await (parcelRequire("8O2Cb"));
        if (name === "") throw new TypeError(`Name can't be an empty string.`);
        if (name === "." || name === ".." || name.includes("/")) throw new TypeError(`Name contains invalid characters.`);
        options.create = !!options.create;
        const handle = await this[$1f1792f500151ec9$var$kAdapter].getFileHandle(name, options);
        return new FileSystemFileHandle(handle);
    }
    /**
   * @param {string} name
   * @param {object} [options]
   * @param {boolean} [options.recursive]
   */ async removeEntry(name, options = {}) {
        if (name === "") throw new TypeError(`Name can't be an empty string.`);
        if (name === "." || name === ".." || name.includes("/")) throw new TypeError(`Name contains invalid characters.`);
        options.recursive = !!options.recursive // cuz node's fs.rm require boolean
        ;
        return this[$1f1792f500151ec9$var$kAdapter].removeEntry(name, options);
    }
    async resolve(possibleDescendant) {
        if (await possibleDescendant.isSameEntry(this)) return [];
        const openSet = [
            {
                handle: this,
                path: []
            }
        ];
        while(openSet.length){
            let { handle: current, path: path } = openSet.pop();
            for await (const entry of current.values()){
                if (await entry.isSameEntry(possibleDescendant)) return [
                    ...path,
                    entry.name
                ];
                if (entry.kind === "directory") openSet.push({
                    handle: entry,
                    path: [
                        ...path,
                        entry.name
                    ]
                });
            }
        }
        return null;
    }
    async *keys() {
        for await (const [name] of this[$1f1792f500151ec9$var$kAdapter].entries())yield name;
    }
    async *values() {
        for await (const [_, entry] of this)yield entry;
    }
    [Symbol.asyncIterator]() {
        return this.entries();
    }
}
Object.defineProperty($1f1792f500151ec9$export$80c69d2381792bb3.prototype, Symbol.toStringTag, {
    value: "FileSystemDirectoryHandle",
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($1f1792f500151ec9$export$80c69d2381792bb3.prototype, {
    getDirectoryHandle: {
        enumerable: true
    },
    entries: {
        enumerable: true
    },
    getFileHandle: {
        enumerable: true
    },
    removeEntry: {
        enumerable: true
    }
});
if (globalThis.FileSystemDirectoryHandle) {
    const proto = globalThis.FileSystemDirectoryHandle.prototype;
    proto.resolve = async function resolve(possibleDescendant) {
        if (await possibleDescendant.isSameEntry(this)) return [];
        const openSet = [
            {
                handle: this,
                path: []
            }
        ];
        while(openSet.length){
            let { handle: current, path: path } = openSet.pop();
            for await (const entry of current.values()){
                if (await entry.isSameEntry(possibleDescendant)) return [
                    ...path,
                    entry.name
                ];
                if (entry.kind === "directory") openSet.push({
                    handle: entry,
                    path: [
                        ...path,
                        entry.name
                    ]
                });
            }
        }
        return null;
    };
    // Safari allows us operate on deleted files,
    // so we need to check if they still exist.
    // Hope to remove this one day.
    async function ensureDoActuallyStillExist(handle) {
        const root = await navigator.storage.getDirectory();
        const path = await root.resolve(handle);
        if (path === null) throw new DOMException(...$1f1792f500151ec9$var$GONE);
    }
    const entries = proto.entries;
    proto.entries = async function*() {
        await ensureDoActuallyStillExist(this);
        yield* entries.call(this);
    };
    proto[Symbol.asyncIterator] = async function*() {
        yield* this.entries();
    };
    const removeEntry = proto.removeEntry;
    proto.removeEntry = async function(name, options = {}) {
        return removeEntry.call(this, name, options).catch(async (err)=>{
            const unknown = err instanceof DOMException && err.name === "UnknownError";
            if (unknown && !options.recursive) {
                const empty = (await entries.call(this).next()).done;
                if (!empty) throw new DOMException(...$1f1792f500151ec9$var$MOD_ERR);
            }
            throw err;
        });
    };
}
var $1f1792f500151ec9$export$2e2bcd8739ae039 = $1f1792f500151ec9$export$80c69d2381792bb3;

});
parcelRegister("bAgeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $86efa75949c14e44$export$2e2bcd8739ae039);
const $86efa75949c14e44$var$kAdapter = Symbol("adapter");
/**
 * @typedef {Object} FileSystemHandlePermissionDescriptor
 * @property {('read'|'readwrite')} [mode='read']
 */ class $86efa75949c14e44$export$90d155f9f7c2d644 {
    /** @type {FileSystemHandle} */ [$86efa75949c14e44$var$kAdapter];
    /** @type {string} */ name;
    /** @type {('file'|'directory')} */ kind;
    /** @param {FileSystemHandle & {writable}} adapter */ constructor(adapter){
        this.kind = adapter.kind;
        this.name = adapter.name;
        this[$86efa75949c14e44$var$kAdapter] = adapter;
    }
    /** @param {FileSystemHandlePermissionDescriptor} descriptor */ async queryPermission(descriptor = {}) {
        const { mode: mode = "read" } = descriptor;
        const handle = this[$86efa75949c14e44$var$kAdapter];
        if (handle.queryPermission) return handle.queryPermission({
            mode: mode
        });
        if (mode === "read") return "granted";
        else if (mode === "readwrite") return handle.writable ? "granted" : "denied";
        else throw new TypeError(`Mode ${mode} must be 'read' or 'readwrite'`);
    }
    async requestPermission({ mode: mode = "read" } = {}) {
        const handle = this[$86efa75949c14e44$var$kAdapter];
        if (handle.requestPermission) return handle.requestPermission({
            mode: mode
        });
        if (mode === "read") return "granted";
        else if (mode === "readwrite") return handle.writable ? "granted" : "denied";
        else throw new TypeError(`Mode ${mode} must be 'read' or 'readwrite'`);
    }
    /**
   * Attempts to remove the entry represented by handle from the underlying file system.
   *
   * @param {object} options
   * @param {boolean} [options.recursive=false]
   */ async remove(options = {}) {
        await this[$86efa75949c14e44$var$kAdapter].remove(options);
    }
    /**
   * @param {FileSystemHandle} other
   */ async isSameEntry(other) {
        if (this === other) return true;
        if (!other || typeof other !== "object" || this.kind !== other.kind || !other[$86efa75949c14e44$var$kAdapter]) return false;
        return this[$86efa75949c14e44$var$kAdapter].isSameEntry(other[$86efa75949c14e44$var$kAdapter]);
    }
}
Object.defineProperty($86efa75949c14e44$export$90d155f9f7c2d644.prototype, Symbol.toStringTag, {
    value: "FileSystemHandle",
    writable: false,
    enumerable: false,
    configurable: true
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemHandle) globalThis.FileSystemHandle.prototype.queryPermission ??= function(descriptor) {
    return "granted";
};
var $86efa75949c14e44$export$2e2bcd8739ae039 = $86efa75949c14e44$export$90d155f9f7c2d644;

});

parcelRegister("jG9Jm", function(module, exports) {

$parcel$export(module.exports, "errors", () => $e5397ce30315ba90$export$30f3b02011db23c0);
$parcel$export(module.exports, "config", () => $e5397ce30315ba90$export$e506a1d27d1eaa20);
$parcel$export(module.exports, "fromDataTransfer", () => $e5397ce30315ba90$export$34af8373a76882c2);
$parcel$export(module.exports, "getDirHandlesFromInput", () => $e5397ce30315ba90$export$7d17e35d81e093f2);
$parcel$export(module.exports, "getFileHandlesFromInput", () => $e5397ce30315ba90$export$45ac616e835cfe89);
const $e5397ce30315ba90$export$30f3b02011db23c0 = {
    INVALID: [
        "seeking position failed.",
        "InvalidStateError"
    ],
    GONE: [
        "A requested file or directory could not be found at the time an operation was processed.",
        "NotFoundError"
    ],
    MISMATCH: [
        "The path supplied exists, but was not an entry of requested type.",
        "TypeMismatchError"
    ],
    MOD_ERR: [
        "The object can not be modified in this way.",
        "InvalidModificationError"
    ],
    SYNTAX: (m)=>[
            `Failed to execute 'write' on 'UnderlyingSinkBase': Invalid params passed. ${m}`,
            "SyntaxError"
        ],
    SECURITY: [
        "It was determined that certain files are unsafe for access within a Web application, or that too many calls are being made on file resources.",
        "SecurityError"
    ],
    DISALLOWED: [
        "The request is not allowed by the user agent or the platform in the current context.",
        "NotAllowedError"
    ]
};
const $e5397ce30315ba90$export$e506a1d27d1eaa20 = {
    writable: globalThis.WritableStream
};



async function $e5397ce30315ba90$export$34af8373a76882c2(entries) {
    console.warn("deprecated fromDataTransfer - use `dt.items[0].getAsFileSystemHandle()` instead");
    const [memory, sandbox, fs] = await Promise.all([
        (parcelRequire("38THd")),
        (parcelRequire("9aeU0")),
        (parcelRequire("dzTwg"))
    ]);
    const folder = new memory.FolderHandle("", false);
    folder._entries = entries.map((entry)=>entry.isFile ? new sandbox.FileHandle(entry, false) : new sandbox.FolderHandle(entry, false));
    return new fs.FileSystemDirectoryHandle(folder);
}


async function $e5397ce30315ba90$export$7d17e35d81e093f2(input) {
    const { FolderHandle: FolderHandle, FileHandle: FileHandle } = await (parcelRequire("38THd"));
    const { FileSystemDirectoryHandle: FileSystemDirectoryHandle } = await (parcelRequire("dzTwg"));
    const files = Array.from(input.files);
    const rootName = files[0].webkitRelativePath.split("/", 1)[0];
    const root = new FolderHandle(rootName, false);
    files.forEach((file)=>{
        const path = file.webkitRelativePath.split("/");
        path.shift();
        const name = path.pop();
        const dir = path.reduce((dir, path)=>{
            if (!dir._entries[path]) dir._entries[path] = new FolderHandle(path, false);
            return dir._entries[path];
        }, root);
        dir._entries[name] = new FileHandle(file.name, file, false);
    });
    return new FileSystemDirectoryHandle(root);
}


async function $e5397ce30315ba90$export$45ac616e835cfe89(input) {
    const { FileHandle: FileHandle } = await (parcelRequire("38THd"));
    const { FileSystemFileHandle: FileSystemFileHandle } = await (parcelRequire("8O2Cb"));
    return Array.from(input.files).map((file)=>new FileSystemFileHandle(new FileHandle(file.name, file, false)));
}

});
parcelRegister("38THd", function(module, exports) {

var $jISCq = parcelRequire("jISCq");
module.exports = $jISCq("9AOUm").then(()=>parcelRequire("40oxC"));

});



parcelRegister("ggMY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemFileHandle", () => $bd841fffd4068e5b$export$db2751aad7d8e0f3);
$parcel$export(module.exports, "default", () => $bd841fffd4068e5b$export$2e2bcd8739ae039);

var $bAgeV = parcelRequire("bAgeV");

var $gnYLk = parcelRequire("gnYLk");

var $jG9Jm = parcelRequire("jG9Jm");
const { INVALID: $bd841fffd4068e5b$var$INVALID, SYNTAX: $bd841fffd4068e5b$var$SYNTAX, GONE: $bd841fffd4068e5b$var$GONE } = (0, $jG9Jm.errors);
const $bd841fffd4068e5b$var$kAdapter = Symbol("adapter");
class $bd841fffd4068e5b$export$db2751aad7d8e0f3 extends (0, $bAgeV.default) {
    /** @type {FileSystemFileHandle} */ [$bd841fffd4068e5b$var$kAdapter];
    constructor(adapter){
        super(adapter);
        this[$bd841fffd4068e5b$var$kAdapter] = adapter;
    }
    /**
   * @param  {Object} [options={}]
   * @param  {boolean} [options.keepExistingData]
   * @returns {Promise<FileSystemWritableFileStream>}
   */ async createWritable(options = {}) {
        return new (0, $gnYLk.default)(await this[$bd841fffd4068e5b$var$kAdapter].createWritable(options));
    }
    /**
   * @returns {Promise<File>}
   */ async getFile() {
        return this[$bd841fffd4068e5b$var$kAdapter].getFile();
    }
}
Object.defineProperty($bd841fffd4068e5b$export$db2751aad7d8e0f3.prototype, Symbol.toStringTag, {
    value: "FileSystemFileHandle",
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($bd841fffd4068e5b$export$db2751aad7d8e0f3.prototype, {
    createWritable: {
        enumerable: true
    },
    getFile: {
        enumerable: true
    }
});
// Safari doesn't support async createWritable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable) {
    const wm = new WeakMap();
    let workerUrl;
    // Worker code that should be inlined (can't use any external functions)
    const code = ()=>{
        let fileHandle, handle;
        onmessage = async (evt)=>{
            const port = evt.ports[0];
            const cmd = evt.data;
            switch(cmd.type){
                case "open":
                    const file = cmd.name;
                    let dir = await navigator.storage.getDirectory();
                    for (const folder of cmd.path)dir = await dir.getDirectoryHandle(folder);
                    fileHandle = await dir.getFileHandle(file);
                    handle = await fileHandle.createSyncAccessHandle();
                    break;
                case "write":
                    handle.write(cmd.data, {
                        at: cmd.position
                    });
                    handle.flush();
                    break;
                case "truncate":
                    handle.truncate(cmd.size);
                    break;
                case "abort":
                case "close":
                    handle.close();
                    break;
            }
            port.postMessage(0);
        };
    };
    globalThis.FileSystemFileHandle.prototype.createWritable = async function(options) {
        // Safari only support writing data in a worker with sync access handle.
        if (!workerUrl) {
            const stringCode = `(${code.toString()})()`;
            const blob = new Blob([
                stringCode
            ], {
                type: "text/javascript"
            });
            workerUrl = URL.createObjectURL(blob);
        }
        const worker = new Worker(workerUrl, {
            type: "module"
        });
        let position = 0;
        const textEncoder = new TextEncoder();
        let size = await this.getFile().then((file)=>file.size);
        const send = (message)=>new Promise((resolve, reject)=>{
                const mc = new MessageChannel();
                mc.port1.onmessage = (evt)=>{
                    if (evt.data instanceof Error) reject(evt.data);
                    else resolve(evt.data);
                    mc.port1.close();
                    mc.port2.close();
                    mc.port1.onmessage = null;
                };
                worker.postMessage(message, [
                    mc.port2
                ]);
            });
        // Safari also don't support transferable file system handles.
        // So we need to pass the path to the worker. This is a bit hacky and ugly.
        const root = await navigator.storage.getDirectory();
        const parent = await wm.get(this);
        const path = await root.resolve(parent);
        // Should likely never happen, but just in case...
        if (path === null) throw new DOMException(...$bd841fffd4068e5b$var$GONE);
        let controller;
        await send({
            type: "open",
            path: path,
            name: this.name
        });
        if (options?.keepExistingData === false) {
            await send({
                type: "truncate",
                size: 0
            });
            size = 0;
        }
        const ws = new (0, $gnYLk.default)({
            start: (ctrl)=>{
                controller = ctrl;
            },
            async write (chunk) {
                const isPlainObject = chunk?.constructor === Object;
                if (isPlainObject) chunk = {
                    ...chunk
                };
                else chunk = {
                    type: "write",
                    data: chunk,
                    position: position
                };
                if (chunk.type === "write") {
                    if (!("data" in chunk)) {
                        await send({
                            type: "close"
                        });
                        throw new DOMException(...$bd841fffd4068e5b$var$SYNTAX("write requires a data argument"));
                    }
                    chunk.position ??= position;
                    if (typeof chunk.data === "string") chunk.data = textEncoder.encode(chunk.data);
                    else if (chunk.data instanceof ArrayBuffer) chunk.data = new Uint8Array(chunk.data);
                    else if (!(chunk.data instanceof Uint8Array) && ArrayBuffer.isView(chunk.data)) chunk.data = new Uint8Array(chunk.data.buffer, chunk.data.byteOffset, chunk.data.byteLength);
                    else if (!(chunk.data instanceof Uint8Array)) {
                        const ab = await new Response(chunk.data).arrayBuffer();
                        chunk.data = new Uint8Array(ab);
                    }
                    if (Number.isInteger(chunk.position) && chunk.position >= 0) position = chunk.position;
                    position += chunk.data.byteLength;
                    size += chunk.data.byteLength;
                } else if (chunk.type === "seek") {
                    if (Number.isInteger(chunk.position) && chunk.position >= 0) {
                        if (size < chunk.position) throw new DOMException(...$bd841fffd4068e5b$var$INVALID);
                        console.log("seeking", chunk);
                        position = chunk.position;
                        return; // Don't need to enqueue seek...
                    } else {
                        await send({
                            type: "close"
                        });
                        throw new DOMException(...$bd841fffd4068e5b$var$SYNTAX("seek requires a position argument"));
                    }
                } else if (chunk.type === "truncate") {
                    if (Number.isInteger(chunk.size) && chunk.size >= 0) {
                        size = chunk.size;
                        if (position > size) position = size;
                    } else {
                        await send({
                            type: "close"
                        });
                        throw new DOMException(...$bd841fffd4068e5b$var$SYNTAX("truncate requires a size argument"));
                    }
                }
                await send(chunk);
            },
            async close () {
                await send({
                    type: "close"
                });
                worker.terminate();
            },
            async abort (reason) {
                await send({
                    type: "abort",
                    reason: reason
                });
                worker.terminate();
            }
        });
        return ws;
    };
    const orig = FileSystemDirectoryHandle.prototype.getFileHandle;
    FileSystemDirectoryHandle.prototype.getFileHandle = async function(...args) {
        const handle = await orig.call(this, ...args);
        wm.set(handle, this);
        return handle;
    };
}
var $bd841fffd4068e5b$export$2e2bcd8739ae039 = $bd841fffd4068e5b$export$db2751aad7d8e0f3;

});

parcelRegister("hhKM0", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");

var $6T8SH = parcelRequire("6T8SH");
module.exports = (key)=>{
    const env = {};
    if (typeof WorkerGlobalScope !== "undefined") env.type = "webworker";
    else if ($6T8SH()) env.type = "electron";
    else if (typeof document === "object") env.type = "browser";
    else if (typeof $4Jj9n === "object" && true) env.type = "node";
    if (typeof key === "undefined") return env;
    return env[key];
};

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});

parcelRegister("6T8SH", function(module, exports) {
// https://github.com/electron/electron/issues/2288

var $4Jj9n = parcelRequire("4Jj9n");
function $503ec4c02d8ed77b$var$isElectron() {
    // Renderer process
    if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") return true;
    // Main process
    if (typeof $4Jj9n !== "undefined" && typeof $4Jj9n.versions === "object" && !!$4Jj9n.versions.electron) return true;
    // Detect the user agent when the `nodeIntegration` option is set to false
    if (typeof navigator === "object" && typeof navigator.userAgent === "string" && navigator.userAgent.indexOf("Electron") >= 0) return true;
    return false;
}
module.exports = $503ec4c02d8ed77b$var$isElectron;

});


var $4d842655b16a6eb0$exports = {};
"use strict";
Object.defineProperty($4d842655b16a6eb0$exports, "__esModule", {
    value: true
});
$4d842655b16a6eb0$exports.Fragment = $4d842655b16a6eb0$exports.jsxDEV = $4d842655b16a6eb0$exports.jsxs = void 0;
$4d842655b16a6eb0$exports.jsx = $4d842655b16a6eb0$var$jsx;

var $1Znhr = parcelRequire("1Znhr");

var $1aYx7 = parcelRequire("1aYx7");

var $axYUW = parcelRequire("axYUW");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $4d842655b16a6eb0$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $1Znhr.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === "function" && (0, $1aYx7.isHTMLElementClass)(type)) type = (0, $1aYx7.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $axYUW.VNode(node) : node === 0 || node ? new $axYUW.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === "string" ? new $axYUW.VNode($1Znhr.__assign($1Znhr.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($1Znhr.__assign($1Znhr.__assign({}, commonProps), props));
}
$4d842655b16a6eb0$exports.jsxs = $4d842655b16a6eb0$var$jsx;
$4d842655b16a6eb0$exports.jsxDEV = $4d842655b16a6eb0$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $4d842655b16a6eb0$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $1Znhr.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $axYUW.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $1aYx7.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
$4d842655b16a6eb0$exports.Fragment = $4d842655b16a6eb0$var$Fragment;


var $5ec47347fc6130b4$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $5ec47347fc6130b4$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $5ec47347fc6130b4$var$InstrumentedPromise$1)) throw new TypeError("Cannot call a class as a function");
    var promise = new $5ec47347fc6130b4$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $5ec47347fc6130b4$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $5ec47347fc6130b4$var$InstrumentedPromise$1.prototype;
    return promise;
};
$5ec47347fc6130b4$var$InstrumentedPromise$1.__proto__ = $5ec47347fc6130b4$var$OriginalPromise;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.__proto__ = $5ec47347fc6130b4$var$OriginalPromise.prototype;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $5ec47347fc6130b4$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent("Event");
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent("unhandledrejection", false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $5ec47347fc6130b4$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === "undefined";
}
function $5ec47347fc6130b4$export$cea1c58a6db52bca() {
    Promise = $5ec47347fc6130b4$var$InstrumentedPromise$1;
}
function $5ec47347fc6130b4$export$dfb5619354ba860() {
    if ($5ec47347fc6130b4$export$baf72085f5fb4df()) $5ec47347fc6130b4$export$cea1c58a6db52bca();
}
var $5ec47347fc6130b4$export$2e2bcd8739ae039 = $5ec47347fc6130b4$var$InstrumentedPromise$1;


var $53a0e53619b2c4c1$exports = {};
"use strict";
Object.defineProperty($53a0e53619b2c4c1$exports, "__esModule", {
    value: true
});

var $1Znhr = parcelRequire("1Znhr");

$1Znhr.__exportStar((parcelRequire("axYUW")), $53a0e53619b2c4c1$exports);

$1Znhr.__exportStar((parcelRequire("cfbj0")), $53a0e53619b2c4c1$exports);



var $aM14C = parcelRequire("aM14C");

var $1aYx7 = parcelRequire("1aYx7");


var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $1aYx7 = parcelRequire("1aYx7");

var $aM14C = parcelRequire("aM14C");


var $aM14C = parcelRequire("aM14C");

var $1aYx7 = parcelRequire("1aYx7");

function $658a8f813065c2f1$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $658a8f813065c2f1$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $658a8f813065c2f1$var$$0c03e47eb1097734$exports = {};
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$0c03e47eb1097734$exports, "observer", function() {
    return $658a8f813065c2f1$export$b6ae1bc530f4c149;
});
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$0c03e47eb1097734$exports, "attribute", function() {
    return $658a8f813065c2f1$export$af4b9a83f4b00434;
});
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$0c03e47eb1097734$exports, "reaction", function() {
    return $658a8f813065c2f1$export$7203b476385689ae;
});
var $658a8f813065c2f1$var$$552a56cc5ff3f479$exports = {};
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$552a56cc5ff3f479$exports, "Defer", function() {
    return $658a8f813065c2f1$export$c7e91f8aec23ae14;
});
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$552a56cc5ff3f479$exports, "getMobxData", function() {
    return $658a8f813065c2f1$export$b06b4c21253e26e2;
});
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$552a56cc5ff3f479$exports, "animated", function() {
    return $658a8f813065c2f1$export$4077c0dfbe9c3861;
});
class $658a8f813065c2f1$export$c7e91f8aec23ae14 {
    constructor(){
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Promise((resolve, reject)=>{
                this.resolve = resolve;
                this.reject = reject;
            })
        });
    }
}
function $658a8f813065c2f1$export$b06b4c21253e26e2(observable) {
    var _a;
    for (const key of Object.getOwnPropertySymbols(observable)){
        const store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
        if (store instanceof Map) return Object.fromEntries(Array.from(store, ([key, { value_: value_ }])=>[
                key,
                value_
            ]));
    }
}
const $658a8f813065c2f1$export$4077c0dfbe9c3861 = (root, targetSelector)=>new Promise((resolve)=>{
        const ended = (0, $1aYx7.delegate)(targetSelector, (event)=>{
            root.removeEventListener("animationend", ended);
            root.removeEventListener("animationcancel", ended);
            resolve(event);
        });
        root.addEventListener("animationend", ended);
        root.addEventListener("animationcancel", ended);
    });
var $658a8f813065c2f1$var$$0c03e47eb1097734$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
function $658a8f813065c2f1$var$$0c03e47eb1097734$var$wrapFunction(func) {
    return (props)=>{
        const tree = func(props), renderer = new (0, $53a0e53619b2c4c1$exports.DOMRenderer)();
        const disposer = (0, $aM14C.autorun)(()=>{
            const newTree = func(props);
            if (tree.node) Object.assign(tree, renderer.patch(tree, newTree));
        });
        const { ref: ref } = tree;
        tree.ref = (node)=>{
            if (node) tree.node = node;
            else disposer();
            ref === null || ref === void 0 || ref(node);
        };
        return tree;
    };
}
const $658a8f813065c2f1$var$$0c03e47eb1097734$var$reactionMap = new WeakMap();
function $658a8f813065c2f1$var$$0c03e47eb1097734$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    class ObserverComponent extends Component {
        get props() {
            return $658a8f813065c2f1$export$b06b4c21253e26e2(this);
        }
        constructor(){
            super();
            _ObserverComponent_instances.add(this);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "update", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { update: update } = Object.getPrototypeOf(this);
                    return new Promise((resolve)=>this.disposers.push((0, $aM14C.autorun)(()=>update.call(this).then(resolve))));
                }
            });
            Promise.resolve().then(()=>$658a8f813065c2f1$var$$0c03e47eb1097734$var$__classPrivateFieldGet(this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call(this));
        }
        disconnectedCallback() {
            var _a;
            for (const disposer of this.disposers)disposer();
            this.disposers.length = 0;
            (_a = super["disconnectedCallback"]) === null || _a === void 0 || _a.call(this);
        }
        setAttribute(name, value) {
            const old = super.getAttribute(name), names = this.constructor["observedAttributes"];
            super.setAttribute(name, value);
            if (names.includes(name)) this.attributeChangedCallback(name, old, value);
        }
        attributeChangedCallback(name, old, value) {
            var _a;
            this[(0, $1aYx7.toCamelCase)(name)] = (0, $1aYx7.parseJSON)(value);
            (_a = super["attributeChangedCallback"]) === null || _a === void 0 || _a.call(this, name, old, value);
        }
        syncPropAttr(name) {
            var _a;
            var value = this[(0, $1aYx7.toCamelCase)(name)];
            if (!(value != null) || value === false) return this.removeAttribute(name);
            value = value === true ? name : value;
            if (typeof value === "object") {
                value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                value = typeof value === "object" ? JSON.stringify(value) : value;
            }
            super.setAttribute(name, value);
        }
    }
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        const names = this.constructor["observedAttributes"] || [], reactions = $658a8f813065c2f1$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
        this.disposers.push(...names.map((name)=>(0, $aM14C.autorun)(()=>this.syncPropAttr(name))), ...reactions.map(({ expression: expression, effect: effect })=>(0, $aM14C.reaction)((reaction)=>expression(this, reaction), effect.bind(this))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $658a8f813065c2f1$export$b6ae1bc530f4c149(func, _) {
    return (0, $1aYx7.isHTMLElementClass)(func) ? $658a8f813065c2f1$var$$0c03e47eb1097734$var$wrapClass(func) : $658a8f813065c2f1$var$$0c03e47eb1097734$var$wrapFunction(func);
}
function $658a8f813065c2f1$export$af4b9a83f4b00434(_, { name: name, addInitializer: addInitializer }) {
    addInitializer(function() {
        const names = this.constructor["observedAttributes"], attribute = (0, $1aYx7.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
function $658a8f813065c2f1$export$7203b476385689ae(expression) {
    return (effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $658a8f813065c2f1$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $658a8f813065c2f1$var$$0c03e47eb1097734$var$reactionMap.set(this, reactions);
        });
}
var $658a8f813065c2f1$var$$317b1f21909c74b8$exports = {};
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$317b1f21909c74b8$exports, "component", function() {
    return $658a8f813065c2f1$export$d8556a2a8f973135;
});
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$317b1f21909c74b8$exports, "on", function() {
    return $658a8f813065c2f1$export$af631764ddc44097;
});
const $658a8f813065c2f1$var$$317b1f21909c74b8$var$eventMap = new WeakMap();
function $658a8f813065c2f1$export$d8556a2a8f973135(meta) {
    return (Class, { addInitializer: addInitializer })=>{
        class RendererComponent extends Class {
            get root() {
                return (this.internals || this).shadowRoot || this;
            }
            constructor(){
                var _a;
                super();
                Object.defineProperty(this, "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.tagName.includes("-") ? this.attachInternals() : undefined
                });
                Object.defineProperty(this, "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $53a0e53619b2c4c1$exports.DOMRenderer)()
                });
                Object.defineProperty(this, "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !((_a = this.internals) === null || _a === void 0 ? void 0 : _a.shadowRoot)) this.attachShadow(meta);
            }
            async connectedCallback() {
                var _a, _b;
                const { mode: mode } = meta;
                const renderChildren = !(mode != null);
                const { root: root } = this, events = $658a8f813065c2f1$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, selector: selector, handler: handler } of events){
                    if (renderChildren && /^:host/.test(selector)) console.warn(`[WebCell] DOM Event delegation of "${selector}" won't work if you don't invoke "this.attachShadow()" manually.`);
                    root.addEventListener(type, handler);
                }
                (_a = super["connectedCallback"]) === null || _a === void 0 || _a.call(this);
                if (this.mounted) return;
                await this.update();
                this.mounted = true;
                (_b = this.mountedCallback) === null || _b === void 0 || _b.call(this);
            }
            async update() {
                var _a;
                const vNode = (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this);
                const content = (0, $1aYx7.isEmpty)(vNode) ? meta.mode ? (0, $4d842655b16a6eb0$exports.jsx)("slot", {}) : null : vNode;
                if (!(content != null)) return;
                const render = ()=>{
                    var _a;
                    this.renderer.render(content, this.root);
                    (_a = this.updatedCallback) === null || _a === void 0 || _a.call(this);
                };
                if (!meta.transitible || typeof document.startViewTransition !== "function") return render();
                const { updateCallbackDone: updateCallbackDone, finished: finished } = document.startViewTransition(render);
                try {
                    await finished;
                } catch (_b) {
                    return updateCallbackDone;
                }
            }
            disconnectedCallback() {
                var _a;
                const { root: root } = this, events = $658a8f813065c2f1$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, handler: handler } of events)root.removeEventListener(type, handler);
                (_a = super["disconnectedCallback"]) === null || _a === void 0 || _a.call(this);
            }
            emit(event, detail, { cancelable: cancelable, bubbles: bubbles, composed: composed } = {}) {
                return this.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    cancelable: cancelable,
                    bubbles: bubbles,
                    composed: composed
                }));
            }
        }
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $658a8f813065c2f1$export$af631764ddc44097(type, selector) {
    return (method, { addInitializer: addInitializer })=>addInitializer(function() {
            const events = $658a8f813065c2f1$var$$317b1f21909c74b8$var$eventMap.get(this) || [], handler = (0, $1aYx7.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $658a8f813065c2f1$var$$317b1f21909c74b8$var$eventMap.set(this, events);
        });
}
var $658a8f813065c2f1$var$$29675797ddd6c4f7$exports = {};
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$29675797ddd6c4f7$exports, "formField", function() {
    return $658a8f813065c2f1$export$2a668e8d088a0667;
});
var $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $658a8f813065c2f1$export$2a668e8d088a0667(Class, _) {
    let FormFieldComponent = (()=>{
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        let _classSuper = Class;
        let _instanceExtraInitializers = [];
        let _setValue_decorators;
        let _name_decorators;
        let _name_initializers = [];
        let _name_extraInitializers = [];
        let _value_decorators;
        let _value_initializers = [];
        let _value_extraInitializers = [];
        let _required_decorators;
        let _required_initializers = [];
        let _required_extraInitializers = [];
        let _disabled_decorators;
        let _disabled_initializers = [];
        let _disabled_extraInitializers = [];
        let _autofocus_decorators;
        let _autofocus_initializers = [];
        let _autofocus_extraInitializers = [];
        return _a = class FormFieldComponent extends _classSuper {
            setValue(value) {
                this.internals.setFormValue(value);
            }
            formDisabledCallback(disabled) {
                this.disabled = disabled;
            }
            get name() {
                return $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
            }
            set name(value) {
                $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
            }
            get value() {
                return $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
            }
            set value(value) {
                $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
            }
            get required() {
                return $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
            }
            set required(value) {
                $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
            }
            get disabled() {
                return $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
            }
            set disabled(value) {
                $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
            }
            get autofocus() {
                return $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
            }
            set autofocus(value) {
                $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
            }
            set defaultValue(raw) {
                var _b;
                this.setAttribute("value", raw);
                (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
            }
            get defaultValue() {
                return this.getAttribute("value");
            }
            get form() {
                return this.internals.form;
            }
            get validity() {
                return this.internals.validity;
            }
            get validationMessage() {
                return this.internals.validationMessage;
            }
            get willValidate() {
                return this.internals.willValidate;
            }
            checkValidity() {
                return this.internals.checkValidity();
            }
            reportValidity() {
                return this.internals.reportValidity();
            }
            constructor(){
                super(...arguments);
                _FormFieldComponent_name_accessor_storage.set(this, ($658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _instanceExtraInitializers), $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set(this, ($658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_extraInitializers), $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_initializers, void 0)));
                _FormFieldComponent_required_accessor_storage.set(this, ($658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_extraInitializers), $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_initializers, void 0)));
                _FormFieldComponent_disabled_accessor_storage.set(this, ($658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_extraInitializers), $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_initializers, void 0)));
                _FormFieldComponent_autofocus_accessor_storage.set(this, ($658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_extraInitializers), $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_initializers, void 0)));
                $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_extraInitializers);
            }
        }, _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                $658a8f813065c2f1$export$7203b476385689ae(({ value: value })=>value)
            ];
            _name_decorators = [
                $658a8f813065c2f1$export$af4b9a83f4b00434,
                (0, $aM14C.observable)
            ];
            _value_decorators = [
                (0, $aM14C.observable)
            ];
            _required_decorators = [
                $658a8f813065c2f1$export$af4b9a83f4b00434,
                (0, $aM14C.observable)
            ];
            _disabled_decorators = [
                $658a8f813065c2f1$export$af4b9a83f4b00434,
                (0, $aM14C.observable)
            ];
            _autofocus_decorators = [
                $658a8f813065c2f1$export$af4b9a83f4b00434,
                (0, $aM14C.observable)
            ];
            $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"setValue" in obj,
                    get: (obj)=>obj.setValue
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"name" in obj,
                    get: (obj)=>obj.name,
                    set: (obj, value)=>{
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _name_extraInitializers);
            $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"value" in obj,
                    get: (obj)=>obj.value,
                    set: (obj, value)=>{
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _value_extraInitializers);
            $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"required" in obj,
                    get: (obj)=>obj.required,
                    set: (obj, value)=>{
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _required_extraInitializers);
            $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"disabled" in obj,
                    get: (obj)=>obj.disabled,
                    set: (obj, value)=>{
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _disabled_extraInitializers);
            $658a8f813065c2f1$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"autofocus" in obj,
                    get: (obj)=>obj.autofocus,
                    set: (obj, value)=>{
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _autofocus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    })();
    return FormFieldComponent;
}
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$exports = {};
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$8acf79bd061a8fc3$exports, "AsyncCell", function() {
    return $658a8f813065c2f1$export$854a54a999c89982;
});
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$8acf79bd061a8fc3$exports, "lazy", function() {
    return $658a8f813065c2f1$export$488013bae63b21da;
});
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $658a8f813065c2f1$export$854a54a999c89982 = (()=>{
    var _AsyncCell_component_accessor_storage, _AsyncCell_delegatedProps_accessor_storage;
    let _classDecorators = [
        $658a8f813065c2f1$export$d8556a2a8f973135({
            tagName: "async-cell"
        }),
        $658a8f813065c2f1$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _component_decorators;
    let _component_initializers = [];
    let _component_extraInitializers = [];
    let _delegatedProps_decorators;
    let _delegatedProps_initializers = [];
    let _delegatedProps_extraInitializers = [];
    var AsyncCell = _classThis = class extends _classSuper {
        get component() {
            return $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_component_accessor_storage, "f");
        }
        set component(value) {
            $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_component_accessor_storage, value, "f");
        }
        get delegatedProps() {
            return $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_delegatedProps_accessor_storage, "f");
        }
        set delegatedProps(value) {
            $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_delegatedProps_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.load();
        }
        async load() {
            this.component = undefined;
            const Tag = await this.loader();
            this.component = (_a)=>{
                var { children: children } = _a, props = $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__rest(_a, [
                    "children"
                ]);
                return (0, $4d842655b16a6eb0$exports.jsx)(Tag, Object.assign({}, props, {
                    children: children
                }));
            };
            this.emit("load", this.component);
        }
        render() {
            const { component: Tag, props: props, delegatedProps: delegatedProps } = this;
            const _a = Object.assign(Object.assign({}, props), delegatedProps), { children: children } = _a, data = $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__rest(_a, [
                "children"
            ]);
            return Tag && (0, $4d842655b16a6eb0$exports.jsx)(Tag, Object.assign({}, data, {
                children: children
            }));
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "loader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AsyncCell_component_accessor_storage.set(this, $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_initializers, void 0));
            _AsyncCell_delegatedProps_accessor_storage.set(this, ($658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_extraInitializers), $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__runInitializers(this, _delegatedProps_initializers, void 0)));
            $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__runInitializers(this, _delegatedProps_extraInitializers);
        }
    };
    _AsyncCell_component_accessor_storage = new WeakMap();
    _AsyncCell_delegatedProps_accessor_storage = new WeakMap();
    $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__setFunctionName(_classThis, "AsyncCell");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $aM14C.observable)
        ];
        _delegatedProps_decorators = [
            (0, $aM14C.observable)
        ];
        $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: (obj)=>"component" in obj,
                get: (obj)=>obj.component,
                set: (obj, value)=>{
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _component_extraInitializers);
        $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _delegatedProps_decorators, {
            kind: "accessor",
            name: "delegatedProps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"delegatedProps" in obj,
                get: (obj)=>obj.delegatedProps,
                set: (obj, value)=>{
                    obj.delegatedProps = value;
                }
            },
            metadata: _metadata
        }, _delegatedProps_initializers, _delegatedProps_extraInitializers);
        $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AsyncCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $658a8f813065c2f1$var$$8acf79bd061a8fc3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AsyncCell = _classThis;
})();
function $658a8f813065c2f1$export$488013bae63b21da(loader) {
    return (props)=>(0, $4d842655b16a6eb0$exports.jsx)($658a8f813065c2f1$export$854a54a999c89982, {
            delegatedProps: props,
            loader: async ()=>(await loader()).default
        });
}
var $658a8f813065c2f1$var$$d4436c849e74ae70$exports = {};
$658a8f813065c2f1$var$$parcel$export($658a8f813065c2f1$var$$d4436c849e74ae70$exports, "AnimateCSS", function() {
    return $658a8f813065c2f1$export$2e9a7bb10257a509;
});
var $658a8f813065c2f1$var$$819b340f625a29f4$exports = {};
var $658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $658a8f813065c2f1$var$$d4436c849e74ae70$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $658a8f813065c2f1$var$$d4436c849e74ae70$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $658a8f813065c2f1$var$$d4436c849e74ae70$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $658a8f813065c2f1$var$$d4436c849e74ae70$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $658a8f813065c2f1$export$2e9a7bb10257a509 = (()=>{
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    let _classDecorators = [
        $658a8f813065c2f1$export$d8556a2a8f973135({
            tagName: "animation-css"
        }),
        $658a8f813065c2f1$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _playing_decorators;
    let _playing_initializers = [];
    let _playing_extraInitializers = [];
    let _typeChanged_decorators;
    var AnimateCSS = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _AnimateCSS_type_accessor_storage.set(this, ($658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers(this, _instanceExtraInitializers), $658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers(this, _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set(this, ($658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers(this, _type_extraInitializers), $658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_initializers, false)));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_extraInitializers)
            });
        }
        get type() {
            return $658a8f813065c2f1$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
        }
        set type(value) {
            $658a8f813065c2f1$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
        }
        get playing() {
            return $658a8f813065c2f1$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
        }
        set playing(value) {
            $658a8f813065c2f1$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
        }
        async connectedCallback() {
            await (0, $1aYx7.importCSS)("https://unpkg.com/animate.css@4/animate.min.css");
            this.typeChanged();
        }
        async typeChanged() {
            this.playing = true;
            await $658a8f813065c2f1$export$4077c0dfbe9c3861(this, ".animate__animated");
            this.playing = false;
        }
        render() {
            const { type: type, playing: playing, component: Tag } = this;
            return playing ? (0, $4d842655b16a6eb0$exports.jsx)(Tag, {
                className: `animate__animated animate__${type}`
            }) : type.includes("Out") ? (0, $4d842655b16a6eb0$exports.jsx)((0, $4d842655b16a6eb0$exports.Fragment), {}) : (0, $4d842655b16a6eb0$exports.jsx)(Tag, {});
        }
    };
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $658a8f813065c2f1$var$$d4436c849e74ae70$var$__setFunctionName(_classThis, "AnimateCSS");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            $658a8f813065c2f1$export$af4b9a83f4b00434,
            (0, $aM14C.observable)
        ];
        _playing_decorators = [
            $658a8f813065c2f1$export$af4b9a83f4b00434,
            (0, $aM14C.observable)
        ];
        _typeChanged_decorators = [
            $658a8f813065c2f1$export$7203b476385689ae(({ type: type })=>type)
        ];
        $658a8f813065c2f1$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $658a8f813065c2f1$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"playing" in obj,
                get: (obj)=>obj.playing,
                set: (obj, value)=>{
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _playing_extraInitializers);
        $658a8f813065c2f1$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: (obj)=>"typeChanged" in obj,
                get: (obj)=>obj.typeChanged
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $658a8f813065c2f1$var$$d4436c849e74ae70$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $658a8f813065c2f1$var$$d4436c849e74ae70$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
})();
$658a8f813065c2f1$var$$parcel$exportWildcard($658a8f813065c2f1$var$$d4436c849e74ae70$exports, $658a8f813065c2f1$var$$819b340f625a29f4$exports);


function $c379f9436bbe0249$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $c379f9436bbe0249$var$$22de11b45b0eeb97$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $c379f9436bbe0249$export$c7e91f8aec23ae14;
});
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $c379f9436bbe0249$export$51ca94569b882c51;
});
class $c379f9436bbe0249$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $c379f9436bbe0249$export$51ca94569b882c51 = ()=>new $c379f9436bbe0249$export$c7e91f8aec23ae14();
var $c379f9436bbe0249$var$$e3640f413e0c36e7$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $c379f9436bbe0249$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
class $c379f9436bbe0249$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $c379f9436bbe0249$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $c379f9436bbe0249$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) queue[queue.length - 1].reject(reason), done = true;
                if (canceler) canceler();
            },
            complete () {
                if (!done) queue[queue.length - 1].resolve(), done = true;
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug);
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error);
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === "function") target.on(name, next).on("error", error);
            else {
                target.addEventListener(name, next);
                target.addEventListener("error", error);
            }
            return ()=>{
                if (typeof target.off === "function") target.off(name, next).off("error", error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener("error", error);
                }
            };
        });
    }
}
var $c379f9436bbe0249$var$$603f33a01a36ab56$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $c379f9436bbe0249$export$d16acf4b6e75743d;
});
function $c379f9436bbe0249$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $c379f9436bbe0249$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $c379f9436bbe0249$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}


function $ecf668de0cd72cb2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $ecf668de0cd72cb2$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $ecf668de0cd72cb2$var$$63d86f11b44ac799$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$63d86f11b44ac799$exports, "Status", function() {
    return $ecf668de0cd72cb2$export$96e9906d6d93a972;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$63d86f11b44ac799$exports, "Theme", function() {
    return $ecf668de0cd72cb2$export$14faa19a0f3bbeb2;
});
var $ecf668de0cd72cb2$export$96e9906d6d93a972;
(function(Status) {
    Status["primary"] = "primary";
    Status["secondary"] = "secondary";
    Status["tertiary"] = "tertiary";
    Status["success"] = "success";
    Status["info"] = "info";
    Status["warning"] = "warning";
    Status["danger"] = "danger";
})($ecf668de0cd72cb2$export$96e9906d6d93a972 || ($ecf668de0cd72cb2$export$96e9906d6d93a972 = {}));
var $ecf668de0cd72cb2$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})($ecf668de0cd72cb2$export$14faa19a0f3bbeb2 || ($ecf668de0cd72cb2$export$14faa19a0f3bbeb2 = {}));
var $ecf668de0cd72cb2$var$$63c790b9c4a0fb72$exports = {};
var $ecf668de0cd72cb2$var$$bc5b3c994c26f289$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$bc5b3c994c26f289$exports, "Ratio", function() {
    return $ecf668de0cd72cb2$export$438ad6fc467f929b;
});
var $ecf668de0cd72cb2$var$$bc5b3c994c26f289$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$438ad6fc467f929b = (_a)=>{
    var { className: className, style: style, aspectRatio: aspectRatio = "1x1", children: children } = _a, props = $ecf668de0cd72cb2$var$$bc5b3c994c26f289$var$__rest(_a, [
        "className",
        "style",
        "aspectRatio",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("ratio", typeof aspectRatio === "string" && `ratio-${aspectRatio}`, className),
        style: Object.assign(Object.assign({}, style), typeof aspectRatio === "number" ? {
            "--bs-aspect-ratio": `${aspectRatio * 100}%`
        } : null)
    }, props, {
        children: children
    }));
};
var $ecf668de0cd72cb2$var$$72880cb85e950d46$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$72880cb85e950d46$exports, "Container", function() {
    return $ecf668de0cd72cb2$export$42a852a2b6b56249;
});
var $ecf668de0cd72cb2$var$$72880cb85e950d46$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$42a852a2b6b56249 = (_a)=>{
    var { className: className = "", fluid: fluid, children: children } = _a, props = $ecf668de0cd72cb2$var$$72880cb85e950d46$var$__rest(_a, [
        "className",
        "fluid",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `container${fluid === true ? "-fluid" : fluid ? `-${fluid}` : ""} ${className}`
    }, props, {
        children: children
    }));
};
var $ecf668de0cd72cb2$var$$f09e7170f0f51b36$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f09e7170f0f51b36$exports, "ScrollBoundary", function() {
    return $ecf668de0cd72cb2$export$d086fcc3bc3f366f;
});
function $ecf668de0cd72cb2$var$$f09e7170f0f51b36$var$touch(edge, onTouch) {
    return (node)=>node && new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>isIntersecting && onTouch(edge)).observe(node);
}
const $ecf668de0cd72cb2$export$d086fcc3bc3f366f = ({ className: className, onTouch: onTouch, top: top, left: left, right: right, bottom: bottom, children: children })=>(0, $4d842655b16a6eb0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("position-relative", className),
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $ecf668de0cd72cb2$var$$f09e7170f0f51b36$var$touch("top", onTouch),
                children: top
            }),
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $ecf668de0cd72cb2$var$$f09e7170f0f51b36$var$touch("left", onTouch),
                children: left
            }),
            children,
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $ecf668de0cd72cb2$var$$f09e7170f0f51b36$var$touch("right", onTouch),
                children: right
            }),
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $ecf668de0cd72cb2$var$$f09e7170f0f51b36$var$touch("bottom", onTouch),
                children: bottom
            })
        ]
    });
var $ecf668de0cd72cb2$var$$afd912368a35cd9a$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$afd912368a35cd9a$exports, "Collapse", function() {
    return $ecf668de0cd72cb2$export$78768a9af065a7b;
});
var $ecf668de0cd72cb2$var$$afd912368a35cd9a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$78768a9af065a7b = (_a)=>{
    var { className: className, dimension: dimension = "width", in: show, children: children } = _a, props = $ecf668de0cd72cb2$var$$afd912368a35cd9a$var$__rest(_a, [
        "className",
        "dimension",
        "in",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("collapse", {
            "collapse-horizontal": dimension === "height",
            show: show
        }, className)
    }, props, {
        children: children
    }));
};
var $ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports, "OffcanvasTitle", function() {
    return $ecf668de0cd72cb2$export$1b33297d19c3da30;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports, "OffcanvasHeader", function() {
    return $ecf668de0cd72cb2$export$b6c1518fb8dc5e75;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports, "OffcanvasBody", function() {
    return $ecf668de0cd72cb2$export$c324d20ecc5b7dee;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports, "Offcanvas", function() {
    return $ecf668de0cd72cb2$export$591ca0244c9dfcd4;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports, "OffcanvasBox", function() {
    return $ecf668de0cd72cb2$export$1de07a2f4bdee270;
});
var $ecf668de0cd72cb2$var$$c1c7ccde32bca97a$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c1c7ccde32bca97a$exports, "Button", function() {
    return $ecf668de0cd72cb2$export$353f5b6fc5456de1;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c1c7ccde32bca97a$exports, "isButton", function() {
    return $ecf668de0cd72cb2$export$35a0171ee384c875;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c1c7ccde32bca97a$exports, "IconButton", function() {
    return $ecf668de0cd72cb2$export$c25acd513dcc8062;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c1c7ccde32bca97a$exports, "CloseButton", function() {
    return $ecf668de0cd72cb2$export$de65de8213222d10;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c1c7ccde32bca97a$exports, "ToggleButton", function() {
    return $ecf668de0cd72cb2$export$d2b052e7b4be1756;
});
var $ecf668de0cd72cb2$var$$a68e72fb637d83af$exports = {};
var $ecf668de0cd72cb2$var$$4927147f477cca2e$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$4927147f477cca2e$exports, "Badge", function() {
    return $ecf668de0cd72cb2$export$37acb3580601e69a;
});
var $ecf668de0cd72cb2$var$$4927147f477cca2e$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$37acb3580601e69a = (_a)=>{
    var { className: className, bg: bg, text: text, pill: pill, href: href, children: children } = _a, rest = $ecf668de0cd72cb2$var$$4927147f477cca2e$var$__rest(_a, [
        "className",
        "bg",
        "text",
        "pill",
        "href",
        "children"
    ]);
    const Class = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("badge", bg && `text-bg-${bg}`, text && `text-${text}`, pill && `rounded-pill`, href && "text-decoration-none", className);
    return href ? (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({}, rest, {
        className: Class,
        href: href,
        children: children
    })) : (0, $4d842655b16a6eb0$exports.jsx)("span", Object.assign({}, rest, {
        className: Class,
        children: children
    }));
};
var $ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$exports, "Icon", function() {
    return $ecf668de0cd72cb2$export$f04a61298a47a40f;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$exports, "BGIcon", function() {
    return $ecf668de0cd72cb2$export$af1945c3768d186c;
});
var $ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$f04a61298a47a40f = (_a)=>{
    var { className: className, style: style, color: color, name: name, size: size, children: children } = _a, rest = $ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$var$__rest(_a, [
        "className",
        "style",
        "color",
        "name",
        "size",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("i", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`bi-${name}`, color && `text-${color}`, className),
        style: Object.assign(Object.assign({}, style), {
            fontSize: size ? `${size}rem` : undefined
        })
    }, rest));
};
const $ecf668de0cd72cb2$export$af1945c3768d186c = (_a)=>{
    var { className: className = "", type: type = "square", color: color = "primary", children: children } = _a, props = $ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$var$__rest(_a, [
        "className",
        "type",
        "color",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("d-inline-block", "p-3", `bg-${color}`, `rounded${type === "square" ? "" : "-circle"}`, className)
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$f04a61298a47a40f, Object.assign({
            color: color === "light" ? "dark" : "light"
        }, props))
    }));
};
var $ecf668de0cd72cb2$var$$4720465b54b9bde5$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$4720465b54b9bde5$exports, "FAIcon", function() {
    return $ecf668de0cd72cb2$export$9151c10c0bcf31d3;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$4720465b54b9bde5$exports, "FABGIcon", function() {
    return $ecf668de0cd72cb2$export$bc62d7a28670119b;
});
var $ecf668de0cd72cb2$var$$4720465b54b9bde5$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$9151c10c0bcf31d3 = (_a)=>{
    var { group: group = "solid", name: name, size: size, fixedWidth: fixedWidth, color: color, inverse: inverse, border: border, rotate: rotate, flip: flip, animation: animation, pull: pull, stack: stack, listItem: listItem, className: className, children: children } = _a, rest = $ecf668de0cd72cb2$var$$4720465b54b9bde5$var$__rest(_a, [
        "group",
        "name",
        "size",
        "fixedWidth",
        "color",
        "inverse",
        "border",
        "rotate",
        "flip",
        "animation",
        "pull",
        "stack",
        "listItem",
        "className",
        "children"
    ]);
    const icon = (0, $4d842655b16a6eb0$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("fa" + group[0], "fa-" + name, size && "fa-" + (typeof size === "number" ? size + "x" : size), fixedWidth && "fa-fw", inverse && "fa-inverse", border && "fa-border", rotate && "fa-rotate-" + rotate, flip && "fa-flip-" + flip, animation && "fa-" + animation, pull && "fa-pull-" + pull, stack && `fa-stack-${stack}x`, color && "text-" + color, className),
        "aria-hidden": "true"
    }, rest));
    return listItem ? (0, $4d842655b16a6eb0$exports.jsx)("span", {
        className: "fa-li",
        children: icon
    }) : icon;
};
const $ecf668de0cd72cb2$export$bc62d7a28670119b = (_a)=>{
    var { size: size, color: color, className: className, type: type } = _a, rest = $ecf668de0cd72cb2$var$$4720465b54b9bde5$var$__rest(_a, [
        "size",
        "color",
        "className",
        "type"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("fa-stack", size && "fa-" + (typeof size === "number" ? size + "x" : size), color && "text-" + color, className),
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$9151c10c0bcf31d3, {
                name: type,
                stack: 2
            }),
            (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$9151c10c0bcf31d3, Object.assign({}, rest, {
                stack: 1,
                inverse: true
            }))
        ]
    });
};
var $ecf668de0cd72cb2$var$$bdccd8f4843146f6$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$bdccd8f4843146f6$exports, "ProgressBar", function() {
    return $ecf668de0cd72cb2$export$c17561cb55d4db30;
});
const $ecf668de0cd72cb2$export$c17561cb55d4db30 = ({ className: className = "", striped: striped, animated: animated, variant: variant = "primary", min: min = 0, max: max = 100, now: now = min, label: label, children: children })=>(0, $1aYx7.isEmpty)(children) ? (0, $4d842655b16a6eb0$exports.jsx)("div", {
        className: `progress ${className}`,
        role: "progressbar",
        ariaValueMin: min + "",
        ariaValueMax: max + "",
        ariaValueNow: now + "",
        children: (0, $4d842655b16a6eb0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("progress-bar", `text-bg-${variant}`, striped && "progress-bar-striped", animated && `progress-bar-animated`),
            style: {
                width: now + "%"
            },
            children: typeof label === "function" ? label(now) : label && `${now}%`
        })
    }) : (0, $4d842655b16a6eb0$exports.jsx)("div", {
        className: `progress-stacked ${className}`,
        children: children
    });
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a68e72fb637d83af$exports, $ecf668de0cd72cb2$var$$4927147f477cca2e$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a68e72fb637d83af$exports, $ecf668de0cd72cb2$var$$6ed7cbf81486b3b8$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a68e72fb637d83af$exports, $ecf668de0cd72cb2$var$$4720465b54b9bde5$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a68e72fb637d83af$exports, $ecf668de0cd72cb2$var$$bdccd8f4843146f6$exports);
var $ecf668de0cd72cb2$var$$c1c7ccde32bca97a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$353f5b6fc5456de1 = (_a)=>{
    var { className: className, href: href, variant: variant, size: size, active: active, children: children } = _a, props = $ecf668de0cd72cb2$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "href",
        "variant",
        "size",
        "active",
        "children"
    ]);
    const { disabled: disabled, tabIndex: tabIndex } = props, Class = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("btn", variant && `btn-${variant}`, size && `btn-${size}`, className);
    return href ? (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({
        role: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(Class, {
            disabled: disabled,
            active: active
        }),
        tabIndex: disabled ? -1 : tabIndex,
        ariaDisabled: disabled === null || disabled === void 0 ? void 0 : disabled.toString(),
        ariaPressed: active === null || active === void 0 ? void 0 : active.toString(),
        href: href
    }, props, {
        children: children
    })) : (0, $4d842655b16a6eb0$exports.jsx)("button", Object.assign({
        className: Class
    }, props, {
        ariaPressed: active === null || active === void 0 ? void 0 : active.toString(),
        children: children
    }));
};
function $ecf668de0cd72cb2$export$35a0171ee384c875(node) {
    var _a;
    const { selector: selector, props: props } = node;
    return /^(a|input|button)/.test(selector) && ((_a = props === null || props === void 0 ? void 0 : props.className) === null || _a === void 0 ? void 0 : _a.btn);
}
const $ecf668de0cd72cb2$export$c25acd513dcc8062 = (_a)=>{
    var { className: className, name: name } = _a, button = $ecf668de0cd72cb2$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "name"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$353f5b6fc5456de1, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("p-1", className),
        style: {
            lineHeight: "0.8"
        }
    }, button, {
        children: (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$f04a61298a47a40f, {
            name: name
        })
    }));
};
const $ecf668de0cd72cb2$export$de65de8213222d10 = (_a)=>{
    var { className: className = "" } = _a, props = $ecf668de0cd72cb2$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("button", Object.assign({
        className: `btn-close ${className}`,
        type: "button",
        ariaLabel: "Close"
    }, props));
};
const $ecf668de0cd72cb2$export$d2b052e7b4be1756 = (_a)=>{
    var { className: className = "", id: id = (0, $1aYx7.uniqueID)(), variant: variant = "primary", children: children } = _a, props = $ecf668de0cd72cb2$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "id",
        "variant",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)("input", Object.assign({
                className: "btn-check",
                id: id,
                autocomplete: "off"
            }, props)),
            (0, $4d842655b16a6eb0$exports.jsx)("label", {
                className: `btn btn-${variant} ${className}`,
                htmlFor: id,
                children: children
            })
        ]
    });
};
var $ecf668de0cd72cb2$var$$f01a97a2de8a9291$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$1b33297d19c3da30 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("h5", Object.assign({
        className: `offcanvas-title ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$b6c1518fb8dc5e75 = (_a)=>{
    var { className: className = "", closeButton: closeButton, children: children, onHide: onHide } = _a, props = $ecf668de0cd72cb2$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "closeButton",
        "children",
        "onHide"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("div", Object.assign({
        className: `offcanvas-header ${className}`
    }, props, {
        children: [
            children,
            closeButton && (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$de65de8213222d10, {
                onClick: onHide
            })
        ]
    }));
};
const $ecf668de0cd72cb2$export$c324d20ecc5b7dee = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `offcanvas-body ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$591ca0244c9dfcd4 = (_a)=>{
    var { className: className = "", style: style, backdrop: backdrop = true, show: show, onHide: onHide, children: children } = _a, props = $ecf668de0cd72cb2$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "style",
        "backdrop",
        "show",
        "onHide",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("offcanvas", show ? "offcanvas-end show" : "offcanvas-start", className),
                style: Object.assign({
                    maxWidth: "75vw"
                }, style),
                tabIndex: -1
            }, backdrop === "static" ? {
                "data-bs-backdrop": "static"
            } : {}, props, {
                children: children
            })),
            show && (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "offcanvas-backdrop show",
                onClick: onHide
            })
        ]
    });
};
const $ecf668de0cd72cb2$export$1de07a2f4bdee270 = (_a)=>{
    var { title: title, titleId: titleId = (0, $1aYx7.uniqueID)(), closeButton: closeButton, onHide: onHide, children: children } = _a, props = $ecf668de0cd72cb2$var$$f01a97a2de8a9291$var$__rest(_a, [
        "title",
        "titleId",
        "closeButton",
        "onHide",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$591ca0244c9dfcd4, Object.assign({}, props, {
        onHide: onHide,
        "aria-labelledby": titleId,
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$b6c1518fb8dc5e75, {
                closeButton: closeButton,
                onHide: onHide,
                children: (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$1b33297d19c3da30, {
                    id: titleId,
                    children: title
                })
            }),
            (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$c324d20ecc5b7dee, {
                children: children
            })
        ]
    }));
};
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$63c790b9c4a0fb72$exports, $ecf668de0cd72cb2$var$$bc5b3c994c26f289$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$63c790b9c4a0fb72$exports, $ecf668de0cd72cb2$var$$72880cb85e950d46$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$63c790b9c4a0fb72$exports, $ecf668de0cd72cb2$var$$f09e7170f0f51b36$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$63c790b9c4a0fb72$exports, $ecf668de0cd72cb2$var$$afd912368a35cd9a$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$63c790b9c4a0fb72$exports, $ecf668de0cd72cb2$var$$f01a97a2de8a9291$exports);
var $ecf668de0cd72cb2$var$$a9c2f09022d17944$exports = {};
var $ecf668de0cd72cb2$var$$f7c1ec19aba15bac$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f7c1ec19aba15bac$exports, "ListGroup", function() {
    return $ecf668de0cd72cb2$export$9cc9809463a041c4;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$f7c1ec19aba15bac$exports, "ListGroupItem", function() {
    return $ecf668de0cd72cb2$export$3175656842a28549;
});
var $ecf668de0cd72cb2$var$$f7c1ec19aba15bac$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$9cc9809463a041c4 = (_a)=>{
    var { className: className = "", variant: variant, numbered: numbered, horizontal: horizontal, children: children } = _a, props = $ecf668de0cd72cb2$var$$f7c1ec19aba15bac$var$__rest(_a, [
        "className",
        "variant",
        "numbered",
        "horizontal",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("list-group", variant && `list-group-${variant}`, numbered && `list-group-numbered`, horizontal && `list-group-horizontal${horizontal === true ? "" : `-${horizontal}`}`, className)
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$3175656842a28549 = (_a)=>{
    var { className: className = "", variant: variant, href: href, active: active, disabled: disabled, children: children } = _a, props = $ecf668de0cd72cb2$var$$f7c1ec19aba15bac$var$__rest(_a, [
        "className",
        "variant",
        "href",
        "active",
        "disabled",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("list-group-item", variant && `list-group-item-${variant}`, href && "list-group-item-action", {
            active: active,
            disabled: disabled
        }, disabled && "pe-none", className),
        ariaCurrent: active ? "true" : undefined,
        ariaDisabled: disabled ? "true" : undefined,
        href: href
    }, props, {
        children: children
    }));
};
var $ecf668de0cd72cb2$var$$fae440e6475ac9b3$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$fae440e6475ac9b3$exports, "Table", function() {
    return $ecf668de0cd72cb2$export$54ec01a60f47d33d;
});
var $ecf668de0cd72cb2$var$$fae440e6475ac9b3$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$54ec01a60f47d33d = (_a)=>{
    var { className: className, variant: variant, size: size, responsive: responsive, striped: striped, hover: hover, bordered: bordered, borderless: borderless, caption: caption, children: children } = _a, props = $ecf668de0cd72cb2$var$$fae440e6475ac9b3$var$__rest(_a, [
        "className",
        "variant",
        "size",
        "responsive",
        "striped",
        "hover",
        "bordered",
        "borderless",
        "caption",
        "children"
    ]);
    const table = (0, $4d842655b16a6eb0$exports.jsx)("table", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("table", variant && `table-${variant}`, size && `table-${size}`, striped && `table-striped${striped === "columns" ? "-columns" : ""}`, hover && "table-hover", bordered && "table-bordered", borderless && "table-borderless", caption && `caption-${caption}`)
    }, props, {
        children: children
    }));
    return responsive ? (0, $4d842655b16a6eb0$exports.jsx)("div", {
        className: `table-responsive${responsive === true ? "" : `-${responsive}`}`,
        children: table
    }) : table;
};
var $ecf668de0cd72cb2$var$$748e31f0f7788c85$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$748e31f0f7788c85$exports, "Jumbotron", function() {
    return $ecf668de0cd72cb2$export$97aba50a380f875b;
});
var $ecf668de0cd72cb2$var$$748e31f0f7788c85$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$97aba50a380f875b = (_a)=>{
    var { fluid: fluid, className: className = `py-5 ${fluid ? "" : "px-5"}`, bg: bg = "body-tertiary", rounded: rounded = fluid ? 0 : 3, title: title, description: description, children: children } = _a, props = $ecf668de0cd72cb2$var$$748e31f0f7788c85$var$__rest(_a, [
        "fluid",
        "className",
        "bg",
        "rounded",
        "title",
        "description",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("header", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bg && `bg-${bg}`, rounded && `rounded-${rounded}`, className)
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$42a852a2b6b56249, {
            fluid: fluid,
            children: [
                (0, $4d842655b16a6eb0$exports.jsx)("h1", {
                    className: "display-4",
                    children: title
                }),
                (0, $4d842655b16a6eb0$exports.jsx)("p", {
                    className: "lead",
                    children: description
                }),
                children && (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                    children: [
                        (0, $4d842655b16a6eb0$exports.jsx)("hr", {
                            className: "my-4"
                        }),
                        children
                    ]
                })
            ]
        })
    }));
};
var $ecf668de0cd72cb2$var$$478aa14554285d4f$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$478aa14554285d4f$exports, "Card", function() {
    return $ecf668de0cd72cb2$export$60332b2344f7fe41;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$478aa14554285d4f$exports, "CardBody", function() {
    return $ecf668de0cd72cb2$export$851de33184ecdac4;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$478aa14554285d4f$exports, "CardHeader", function() {
    return $ecf668de0cd72cb2$export$5665775b26e26c5d;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$478aa14554285d4f$exports, "CardFooter", function() {
    return $ecf668de0cd72cb2$export$e9897d434e0741ee;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$478aa14554285d4f$exports, "CardTitle", function() {
    return $ecf668de0cd72cb2$export$474db65c3c394e1c;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$478aa14554285d4f$exports, "CardImg", function() {
    return $ecf668de0cd72cb2$export$96c5f37208f78bd7;
});
var $ecf668de0cd72cb2$var$$6e5adc7420b5d0fd$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$6e5adc7420b5d0fd$exports, "Image", function() {
    return $ecf668de0cd72cb2$export$3e431a229df88919;
});
var $ecf668de0cd72cb2$var$$6e5adc7420b5d0fd$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$3e431a229df88919 = (_a)=>{
    var { className: className, fluid: fluid, rounded: rounded, roundedCircle: roundedCircle, thumbnail: thumbnail } = _a, props = $ecf668de0cd72cb2$var$$6e5adc7420b5d0fd$var$__rest(_a, [
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("img", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(fluid && "img-fluid", thumbnail && `img-thumbnail`, {
            rounded: rounded
        }, roundedCircle && "rounded-circle", className)
    }, props));
};
var $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$60332b2344f7fe41 = (_a)=>{
    var { className: className, bg: bg, text: text, border: border, body: body, children: children } = _a, props = $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("card", bg && `text-bg-${bg}`, text && `text-${text}`, border && `border-${border}`, className)
    }, props, {
        children: body ? (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$851de33184ecdac4, {
            children: children
        }) : children
    }));
};
const $ecf668de0cd72cb2$export$5665775b26e26c5d = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `card-header ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$851de33184ecdac4 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `card-body ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$e9897d434e0741ee = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `card-footer ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$474db65c3c394e1c = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("h5", Object.assign({
        className: `card-title ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$96c5f37208f78bd7 = (_a)=>{
    var { className: className = "", variant: variant } = _a, props = $ecf668de0cd72cb2$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "variant"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$3e431a229df88919, Object.assign({
        className: `card-img${variant ? `-${variant}` : ""} ${className}`
    }, props));
};
var $ecf668de0cd72cb2$var$$165c2960ea0ef6da$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$165c2960ea0ef6da$exports, "MediaObject", function() {
    return $ecf668de0cd72cb2$export$c5be64db09f93414;
});
var $ecf668de0cd72cb2$var$$165c2960ea0ef6da$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$c5be64db09f93414 = (_a)=>{
    var { className: className, listItem: listItem, title: title, image: image, imageRow: imageRow = "start", imageColumn: imageColumn = "start", children: children } = _a, rest = $ecf668de0cd72cb2$var$$165c2960ea0ef6da$var$__rest(_a, [
        "className",
        "listItem",
        "title",
        "image",
        "imageRow",
        "imageColumn",
        "children"
    ]);
    const start = imageColumn === "start";
    const Tag = listItem ? "li" : "div", Class = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("d-flex", !start && "flex-row-reverse", className);
    const body = (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "flex-shrink-0",
                children: typeof image === "string" ? (0, $4d842655b16a6eb0$exports.jsx)("img", {
                    className: `align-self-${imageRow}`,
                    style: {
                        width: "4rem"
                    },
                    src: image,
                    alt: title
                }) : image
            }),
            (0, $4d842655b16a6eb0$exports.jsxs)("div", {
                className: `flex-grow-1 ${start ? "ms-3" : "me-3"}`,
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("h5", {
                        className: "mt-0",
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
    return (0, $4d842655b16a6eb0$exports.jsx)(Tag, Object.assign({}, rest, {
        className: Class,
        children: body
    }));
};
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c630f4f8ebbb88df$exports, "AccordionItem", function() {
    return $ecf668de0cd72cb2$export$d99097c13d4dac9f;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c630f4f8ebbb88df$exports, "AccordionHeader", function() {
    return $ecf668de0cd72cb2$export$5e3e5deaaf81ee41;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c630f4f8ebbb88df$exports, "AccordionBody", function() {
    return $ecf668de0cd72cb2$export$4f68206c92b94e7b;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$c630f4f8ebbb88df$exports, "Accordion", function() {
    return $ecf668de0cd72cb2$export$a766cd26d0d69044;
});
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$d99097c13d4dac9f = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `accordion-item ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$5e3e5deaaf81ee41 = (_a)=>{
    var { className: className = "", children: children, onClick: onClick } = _a, props = $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children",
        "onClick"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("h2", Object.assign({
        className: `accordion-header ${className}`
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsx)("button", {
            className: "accordion-button",
            type: "button",
            onClick: onClick,
            children: children
        })
    }));
};
const $ecf668de0cd72cb2$export$4f68206c92b94e7b = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$78768a9af065a7b, Object.assign({
        className: `accordion-collapse ${className}`
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsx)("div", {
            className: "accordion-body",
            children: children
        })
    }));
};
let $ecf668de0cd72cb2$export$a766cd26d0d69044 = (()=>{
    var _Accordion_flush_accessor_storage, _Accordion_alwaysOpen_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "accordion-box",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _flush_decorators;
    let _flush_initializers = [];
    let _flush_extraInitializers = [];
    let _alwaysOpen_decorators;
    let _alwaysOpen_initializers = [];
    let _alwaysOpen_extraInitializers = [];
    let _handleFlush_decorators;
    let _handleClick_decorators;
    var Accordion = _classThis = class extends _classSuper {
        get flush() {
            return $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet(this, _Accordion_flush_accessor_storage, "f");
        }
        set flush(value) {
            $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet(this, _Accordion_flush_accessor_storage, value, "f");
        }
        get alwaysOpen() {
            return $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet(this, _Accordion_alwaysOpen_accessor_storage, "f");
        }
        set alwaysOpen(value) {
            $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet(this, _Accordion_alwaysOpen_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.classList.add("accordion");
        }
        handleFlush(flush) {
            this.classList.toggle("accordion-flush", flush);
        }
        handleClick(_, { nextElementSibling: currentCollapse }) {
            if (!this.alwaysOpen) {
                for (const collapse of this.querySelectorAll(".accordion-collapse"))if (collapse !== currentCollapse) {
                    collapse.classList.remove("show");
                    collapse.previousElementSibling.querySelector("button").ariaExpanded = "false";
                }
            }
            currentCollapse.classList.toggle("show");
            currentCollapse.previousElementSibling.querySelector("button").ariaExpanded = "false";
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsx)("slot", {});
        }
        constructor(){
            super(...arguments);
            _Accordion_flush_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers(this, _instanceExtraInitializers), $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers(this, _flush_initializers, false)));
            _Accordion_alwaysOpen_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers(this, _flush_extraInitializers), $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers(this, _alwaysOpen_initializers, false)));
            $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers(this, _alwaysOpen_extraInitializers);
        }
    };
    _Accordion_flush_accessor_storage = new WeakMap();
    _Accordion_alwaysOpen_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__setFunctionName(_classThis, "Accordion");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _flush_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _alwaysOpen_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _handleFlush_decorators = [
            (0, $658a8f813065c2f1$export$7203b476385689ae)(({ flush: flush })=>flush)
        ];
        _handleClick_decorators = [
            (0, $658a8f813065c2f1$export$af631764ddc44097)("click", ".accordion-header")
        ];
        $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _flush_decorators, {
            kind: "accessor",
            name: "flush",
            static: false,
            private: false,
            access: {
                has: (obj)=>"flush" in obj,
                get: (obj)=>obj.flush,
                set: (obj, value)=>{
                    obj.flush = value;
                }
            },
            metadata: _metadata
        }, _flush_initializers, _flush_extraInitializers);
        $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _alwaysOpen_decorators, {
            kind: "accessor",
            name: "alwaysOpen",
            static: false,
            private: false,
            access: {
                has: (obj)=>"alwaysOpen" in obj,
                get: (obj)=>obj.alwaysOpen,
                set: (obj, value)=>{
                    obj.alwaysOpen = value;
                }
            },
            metadata: _metadata
        }, _alwaysOpen_initializers, _alwaysOpen_extraInitializers);
        $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _handleFlush_decorators, {
            kind: "method",
            name: "handleFlush",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleFlush" in obj,
                get: (obj)=>obj.handleFlush
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _handleClick_decorators, {
            kind: "method",
            name: "handleClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleClick" in obj,
                get: (obj)=>obj.handleClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Accordion = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Accordion = _classThis;
})();
var $ecf668de0cd72cb2$var$$d3445d44d351b213$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$d3445d44d351b213$exports, "Tab", function() {
    return $ecf668de0cd72cb2$export$3e41faf802a29e71;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$d3445d44d351b213$exports, "Tabs", function() {
    return $ecf668de0cd72cb2$export$b2539bed5023c21c;
});
var $ecf668de0cd72cb2$var$$ac181fb217a2566a$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ac181fb217a2566a$exports, "NavLink", function() {
    return $ecf668de0cd72cb2$export$b0d92dbee9b5b60d;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ac181fb217a2566a$exports, "NavDropdown", function() {
    return $ecf668de0cd72cb2$export$461cb598b7fcff7b;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ac181fb217a2566a$exports, "Nav", function() {
    return $ecf668de0cd72cb2$export$39140c7d8b0ba7b3;
});
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$exports, "Dropdown", function() {
    return $ecf668de0cd72cb2$export$931cbfb6bfb85fc;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$exports, "DropdownToggle", function() {
    return $ecf668de0cd72cb2$export$8d5b7ffbb681f107;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$exports, "DropdownMenu", function() {
    return $ecf668de0cd72cb2$export$e44a253a59704894;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$exports, "DropdownItem", function() {
    return $ecf668de0cd72cb2$export$6648d5fa18559e7f;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$exports, "DropdownButton", function() {
    return $ecf668de0cd72cb2$export$181f40ec41159e56;
});
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$931cbfb6bfb85fc = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `dropdown ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$8d5b7ffbb681f107 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$353f5b6fc5456de1, Object.assign({}, props, {
        className: `dropdown-toggle ${className}`,
        type: "button",
        children: children
    }));
};
const $ecf668de0cd72cb2$export$e44a253a59704894 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("nav", Object.assign({
        className: `dropdown-menu ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$6648d5fa18559e7f = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({
        className: `dropdown-item ${className}`
    }, props, {
        children: children
    }));
};
let $ecf668de0cd72cb2$export$181f40ec41159e56 = (()=>{
    var _DropdownButton_boxClass_accessor_storage, _DropdownButton_buttonClass_accessor_storage, _DropdownButton_variant_accessor_storage, _DropdownButton_size_accessor_storage, _DropdownButton_caption_accessor_storage, _DropdownButton_disabled_accessor_storage, _DropdownButton_show_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "dropdown-button",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _boxClass_decorators;
    let _boxClass_initializers = [];
    let _boxClass_extraInitializers = [];
    let _buttonClass_decorators;
    let _buttonClass_initializers = [];
    let _buttonClass_extraInitializers = [];
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    let _caption_decorators;
    let _caption_initializers = [];
    let _caption_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _show_decorators;
    let _show_initializers = [];
    let _show_extraInitializers = [];
    var DropdownButton = _classThis = class extends _classSuper {
        get boxClass() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_boxClass_accessor_storage, "f");
        }
        set boxClass(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_boxClass_accessor_storage, value, "f");
        }
        get buttonClass() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_buttonClass_accessor_storage, "f");
        }
        set buttonClass(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_buttonClass_accessor_storage, value, "f");
        }
        get variant() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_variant_accessor_storage, "f");
        }
        set variant(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_variant_accessor_storage, value, "f");
        }
        get size() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_size_accessor_storage, "f");
        }
        set size(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_size_accessor_storage, value, "f");
        }
        get caption() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_caption_accessor_storage, "f");
        }
        set caption(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_caption_accessor_storage, value, "f");
        }
        get disabled() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_disabled_accessor_storage, "f");
        }
        set disabled(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_disabled_accessor_storage, value, "f");
        }
        get show() {
            return $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_show_accessor_storage, "f");
        }
        set show(value) {
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_show_accessor_storage, value, "f");
        }
        renderContent() {
            const { boxClass: boxClass, buttonClass: buttonClass, variant: variant, size: size, caption: caption } = this, { disabled: disabled, show: show } = this;
            return (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$931cbfb6bfb85fc, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(boxClass, {
                    show: show
                }),
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$8d5b7ffbb681f107, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(buttonClass, {
                            show: show
                        }),
                        variant: variant,
                        size: size,
                        disabled: disabled,
                        onClick: ()=>this.show = !show,
                        children: caption
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$e44a253a59704894, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
                            show: show
                        }),
                        children: (0, $4d842655b16a6eb0$exports.jsx)("slot", {})
                    })
                ]
            });
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("style", {
                        children: `:host {
                        display: inline-block;
                    }`
                    }),
                    this.renderContent()
                ]
            });
        }
        constructor(){
            super(...arguments);
            _DropdownButton_boxClass_accessor_storage.set(this, $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _boxClass_initializers, void 0));
            _DropdownButton_buttonClass_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _boxClass_extraInitializers), $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _buttonClass_initializers, void 0)));
            _DropdownButton_variant_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _buttonClass_extraInitializers), $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _variant_initializers, void 0)));
            _DropdownButton_size_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _variant_extraInitializers), $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _size_initializers, void 0)));
            _DropdownButton_caption_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _size_extraInitializers), $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _caption_initializers, void 0)));
            _DropdownButton_disabled_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _caption_extraInitializers), $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _disabled_initializers, false)));
            _DropdownButton_show_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _disabled_extraInitializers), $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _show_initializers, false)));
            $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(this, _show_extraInitializers);
        }
    };
    _DropdownButton_boxClass_accessor_storage = new WeakMap();
    _DropdownButton_buttonClass_accessor_storage = new WeakMap();
    _DropdownButton_variant_accessor_storage = new WeakMap();
    _DropdownButton_size_accessor_storage = new WeakMap();
    _DropdownButton_caption_accessor_storage = new WeakMap();
    _DropdownButton_disabled_accessor_storage = new WeakMap();
    _DropdownButton_show_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__setFunctionName(_classThis, "DropdownButton");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _boxClass_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _buttonClass_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _variant_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _size_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _caption_decorators = [
            (0, $aM14C.observable)
        ];
        _disabled_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _show_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _boxClass_decorators, {
            kind: "accessor",
            name: "boxClass",
            static: false,
            private: false,
            access: {
                has: (obj)=>"boxClass" in obj,
                get: (obj)=>obj.boxClass,
                set: (obj, value)=>{
                    obj.boxClass = value;
                }
            },
            metadata: _metadata
        }, _boxClass_initializers, _boxClass_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _buttonClass_decorators, {
            kind: "accessor",
            name: "buttonClass",
            static: false,
            private: false,
            access: {
                has: (obj)=>"buttonClass" in obj,
                get: (obj)=>obj.buttonClass,
                set: (obj, value)=>{
                    obj.buttonClass = value;
                }
            },
            metadata: _metadata
        }, _buttonClass_initializers, _buttonClass_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _size_decorators, {
            kind: "accessor",
            name: "size",
            static: false,
            private: false,
            access: {
                has: (obj)=>"size" in obj,
                get: (obj)=>obj.size,
                set: (obj, value)=>{
                    obj.size = value;
                }
            },
            metadata: _metadata
        }, _size_initializers, _size_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _caption_decorators, {
            kind: "accessor",
            name: "caption",
            static: false,
            private: false,
            access: {
                has: (obj)=>"caption" in obj,
                get: (obj)=>obj.caption,
                set: (obj, value)=>{
                    obj.caption = value;
                }
            },
            metadata: _metadata
        }, _caption_initializers, _caption_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _disabled_decorators, {
            kind: "accessor",
            name: "disabled",
            static: false,
            private: false,
            access: {
                has: (obj)=>"disabled" in obj,
                get: (obj)=>obj.disabled,
                set: (obj, value)=>{
                    obj.disabled = value;
                }
            },
            metadata: _metadata
        }, _disabled_initializers, _disabled_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _show_decorators, {
            kind: "accessor",
            name: "show",
            static: false,
            private: false,
            access: {
                has: (obj)=>"show" in obj,
                get: (obj)=>obj.show,
                set: (obj, value)=>{
                    obj.show = value;
                }
            },
            metadata: _metadata
        }, _show_initializers, _show_extraInitializers);
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        DropdownButton = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$ecf67e051fd0aa49$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return DropdownButton = _classThis;
})();
var $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$b0d92dbee9b5b60d = (_a)=>{
    var { className: className = "", active: active, children: children } = _a, props = $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__rest(_a, [
        "className",
        "active",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({
        className: `nav-link ${active ? "active" : ""} ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$461cb598b7fcff7b = (_a)=>{
    var { title: title, children: children } = _a, props = $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__rest(_a, [
        "title",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$181f40ec41159e56, Object.assign({
        boxClass: "nav-item",
        buttonClass: "nav-link",
        caption: title
    }, props, {
        children: children
    }));
};
let $ecf668de0cd72cb2$export$39140c7d8b0ba7b3 = (()=>{
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "bs-nav",
            mode: "open"
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var Nav = _classThis = class extends _classSuper {
        connectedCallback() {
            var _a;
            const navBar = this.closest("offcanvas-navbar, .navbar");
            if (!navBar) return this.classList.add("nav");
            const expand = navBar.expand || ((_a = navBar.className.match(/navbar-expand(-(\S+))?/)) === null || _a === void 0 ? void 0 : _a[2]);
            this.classList.add("navbar-nav", "align-items-center", expand && "flex-column", expand && `flex-${expand}-row`);
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsx)("slot", {});
        }
    };
    $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__setFunctionName(_classThis, "Nav");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Nav = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$ac181fb217a2566a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Nav = _classThis;
})();
var $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ecf668de0cd72cb2$export$3e41faf802a29e71 = (()=>{
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "tab-pane"
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var Tab = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "caption", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        connectedCallback() {
            this.classList.add("tab-pane");
            this.role = "tabpanel";
        }
    };
    $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__setFunctionName(_classThis, "Tab");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Tab = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Tab = _classThis;
})();
let $ecf668de0cd72cb2$export$b2539bed5023c21c = (()=>{
    var _Tabs_tabMeta_accessor_storage, _Tabs_currentIndex_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "tabs-box",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _tabMeta_decorators;
    let _tabMeta_initializers = [];
    let _tabMeta_extraInitializers = [];
    let _currentIndex_decorators;
    let _currentIndex_initializers = [];
    let _currentIndex_extraInitializers = [];
    let _handleTabClick_decorators;
    let _turnPaneTo_decorators;
    var Tabs = _classThis = class extends _classSuper {
        get tabMeta() {
            return $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__classPrivateFieldGet(this, _Tabs_tabMeta_accessor_storage, "f");
        }
        set tabMeta(value) {
            $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__classPrivateFieldSet(this, _Tabs_tabMeta_accessor_storage, value, "f");
        }
        get currentIndex() {
            return $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__classPrivateFieldGet(this, _Tabs_currentIndex_accessor_storage, "f");
        }
        set currentIndex(value) {
            $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__classPrivateFieldSet(this, _Tabs_currentIndex_accessor_storage, value, "f");
        }
        mountedCallback() {
            const tabs = [
                ...this.querySelectorAll("tab-pane")
            ];
            this.tabMeta = tabs.map((tab)=>{
                tab.hidden = true;
                return {
                    caption: tab.caption
                };
            });
            this.turnPaneTo(this.currentIndex);
        }
        handleTabClick(event, { dataset: { index: index } }) {
            event.preventDefault();
            event.stopPropagation();
            this.currentIndex = +index;
        }
        turnPaneTo(index) {
            const previous = this.querySelector("tab-pane.active");
            if (previous) {
                previous.hidden = true;
                previous.classList.remove("active", "show");
            }
            const next = this.children[index];
            next.hidden = false;
            next.classList.add("active", "show");
        }
        renderContent() {
            const { tabMeta: tabMeta, currentIndex: currentIndex } = this;
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$39140c7d8b0ba7b3, {
                        className: "nav-tabs",
                        role: "tablist",
                        children: tabMeta.map(({ caption: caption }, index)=>(0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$b0d92dbee9b5b60d, {
                                role: "tab",
                                "data-index": index,
                                className: currentIndex === index ? "active" : "",
                                ariaSelected: `${currentIndex === index}`,
                                children: caption
                            }))
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("div", {
                        className: "tab-content",
                        children: (0, $4d842655b16a6eb0$exports.jsx)("slot", {})
                    })
                ]
            });
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
        constructor(){
            super(...arguments);
            _Tabs_tabMeta_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(this, _instanceExtraInitializers), $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(this, _tabMeta_initializers, [])));
            _Tabs_currentIndex_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(this, _tabMeta_extraInitializers), $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(this, _currentIndex_initializers, 0)));
            $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(this, _currentIndex_extraInitializers);
        }
    };
    _Tabs_tabMeta_accessor_storage = new WeakMap();
    _Tabs_currentIndex_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__setFunctionName(_classThis, "Tabs");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _tabMeta_decorators = [
            (0, $aM14C.observable)
        ];
        _currentIndex_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _handleTabClick_decorators = [
            (0, $658a8f813065c2f1$export$af631764ddc44097)("click", ".nav-tabs > .nav-link")
        ];
        _turnPaneTo_decorators = [
            (0, $658a8f813065c2f1$export$7203b476385689ae)(({ currentIndex: currentIndex })=>currentIndex)
        ];
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _tabMeta_decorators, {
            kind: "accessor",
            name: "tabMeta",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tabMeta" in obj,
                get: (obj)=>obj.tabMeta,
                set: (obj, value)=>{
                    obj.tabMeta = value;
                }
            },
            metadata: _metadata
        }, _tabMeta_initializers, _tabMeta_extraInitializers);
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _currentIndex_decorators, {
            kind: "accessor",
            name: "currentIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentIndex" in obj,
                get: (obj)=>obj.currentIndex,
                set: (obj, value)=>{
                    obj.currentIndex = value;
                }
            },
            metadata: _metadata
        }, _currentIndex_initializers, _currentIndex_extraInitializers);
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _handleTabClick_decorators, {
            kind: "method",
            name: "handleTabClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleTabClick" in obj,
                get: (obj)=>obj.handleTabClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _turnPaneTo_decorators, {
            kind: "method",
            name: "turnPaneTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnPaneTo" in obj,
                get: (obj)=>obj.turnPaneTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Tabs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$d3445d44d351b213$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Tabs = _classThis;
})();
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$fae440e6475ac9b3$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$748e31f0f7788c85$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$478aa14554285d4f$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$165c2960ea0ef6da$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$c630f4f8ebbb88df$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$d3445d44d351b213$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$a9c2f09022d17944$exports, $ecf668de0cd72cb2$var$$f7c1ec19aba15bac$exports);
var $ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "FormGroup", function() {
    return $ecf668de0cd72cb2$export$2d00230e1e6f7fbc;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "FormLabel", function() {
    return $ecf668de0cd72cb2$export$842aba50ed0ce9d7;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "FloatingLabel", function() {
    return $ecf668de0cd72cb2$export$8522a2827ec13639;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "InputGroup", function() {
    return $ecf668de0cd72cb2$export$6e5a9cd40e0c9b97;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "InputGroupText", function() {
    return $ecf668de0cd72cb2$export$219ad5c362b47f2f;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "FormControl", function() {
    return $ecf668de0cd72cb2$export$fe5d99d8691b3f62;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "FormCheck", function() {
    return $ecf668de0cd72cb2$export$5cd9378d879de45f;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$76979d798b5a3bd5$exports, "FormField", function() {
    return $ecf668de0cd72cb2$export$56e87bf42978147a;
});
var $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$2d00230e1e6f7fbc = (_a)=>{
    var { children: children } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({}, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$842aba50ed0ce9d7 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("label", Object.assign({
        className: `form-label ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$8522a2827ec13639 = (_a)=>{
    var { className: className = "", style: style, label: label, children: children } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "style",
        "label",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("div", {
        className: `form-floating ${className}`,
        style: style,
        children: [
            children,
            (0, $4d842655b16a6eb0$exports.jsx)("label", Object.assign({}, props, {
                children: label
            }))
        ]
    });
};
const $ecf668de0cd72cb2$export$6e5a9cd40e0c9b97 = (_a)=>{
    var { className: className = "", size: size, children: children } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "size",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("input-group", size && `input-group-${size}`, className)
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$219ad5c362b47f2f = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("span", Object.assign({
        className: `input-group-text ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$fe5d99d8691b3f62 = (_a)=>{
    var { as: Tag = "input", className: className = "", htmlSize: htmlSize, size: size, plaintext: plaintext } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "as",
        "className",
        "htmlSize",
        "size",
        "plaintext"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)(Tag, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("form-control", size && `form-control-${size}`, props.readOnly && plaintext && `form-control-plaintext`, props.type === "color" && `form-control-color`, className)
    }, props, {
        size: htmlSize
    }));
};
const $ecf668de0cd72cb2$export$5cd9378d879de45f = (_a)=>{
    var { id: id = (0, $1aYx7.uniqueID)(), className: className = "", style: style, title: title, type: type, inline: inline, reverse: reverse, label: label } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "id",
        "className",
        "style",
        "title",
        "type",
        "inline",
        "reverse",
        "label"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(label && "form-check", inline && "form-check-inline", reverse && "form-check-reverse", type === "switch" && "form-switch", className),
        style: style,
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)("input", Object.assign({
                className: "form-check-input",
                type: type === "switch" ? "checkbox" : type,
                role: type === "switch" ? "switch" : undefined,
                id: id
            }, props)),
            label && (0, $4d842655b16a6eb0$exports.jsx)("label", {
                className: "form-check-label",
                htmlFor: id,
                title: title,
                children: label
            })
        ]
    });
};
const $ecf668de0cd72cb2$export$56e87bf42978147a = (_a)=>{
    var { className: className, label: label, labelFloat: labelFloat } = _a, props = $ecf668de0cd72cb2$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "label",
        "labelFloat"
    ]);
    label || (label = props.title || props.placeholder);
    const field = (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$fe5d99d8691b3f62, Object.assign({}, props));
    return labelFloat ? (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$8522a2827ec13639, {
        className: className,
        label: label,
        children: field
    }) : (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$2d00230e1e6f7fbc, {
        className: className,
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$842aba50ed0ce9d7, {
                children: label
            }),
            field
        ]
    });
};
var $ecf668de0cd72cb2$var$$d6a5aaf30399725f$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$d6a5aaf30399725f$exports, "ButtonGroup", function() {
    return $ecf668de0cd72cb2$export$69b1032f2ecdf404;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$d6a5aaf30399725f$exports, "ButtonToolbar", function() {
    return $ecf668de0cd72cb2$export$478f41ba79e7b570;
});
var $ecf668de0cd72cb2$var$$d6a5aaf30399725f$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$69b1032f2ecdf404 = (_a)=>{
    var { className: className = "", vertical: vertical, size: size, children: children } = _a, props = $ecf668de0cd72cb2$var$$d6a5aaf30399725f$var$__rest(_a, [
        "className",
        "vertical",
        "size",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`btn-group${vertical ? "-vertical" : ""}`, size && `btn-group-${size}`, className),
        role: "group"
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$478f41ba79e7b570 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$d6a5aaf30399725f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `btn-toolbar ${className}`,
        role: "toolbar"
    }, props, {
        children: children
    }));
};
var $ecf668de0cd72cb2$var$$3f0c6c9020e942c5$exports = {};
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$be58a6a40ab07fd2$exports, "CarouselItem", function() {
    return $ecf668de0cd72cb2$export$42c20acb2971398c;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$be58a6a40ab07fd2$exports, "CarouselCaption", function() {
    return $ecf668de0cd72cb2$export$a81c9b47f1cf1e63;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$be58a6a40ab07fd2$exports, "Carousel", function() {
    return $ecf668de0cd72cb2$export$144901db2ea8e967;
});
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$42c20acb2971398c = (_a)=>{
    var { className: className = "", interval: interval, children: children } = _a, props = $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__rest(_a, [
        "className",
        "interval",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `carousel-item ${className}`
    }, props, {
        "data-bs-interval": interval,
        children: children
    }));
};
const $ecf668de0cd72cb2$export$a81c9b47f1cf1e63 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `carousel-caption ${className}`
    }, props, {
        children: children
    }));
};
let $ecf668de0cd72cb2$export$144901db2ea8e967 = (()=>{
    var _Carousel_interval_accessor_storage, _Carousel_itemMeta_accessor_storage, _Carousel_currentIndex_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "carousel-box",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _interval_decorators;
    let _interval_initializers = [];
    let _interval_extraInitializers = [];
    let _itemMeta_decorators;
    let _itemMeta_initializers = [];
    let _itemMeta_extraInitializers = [];
    let _currentIndex_decorators;
    let _currentIndex_initializers = [];
    let _currentIndex_extraInitializers = [];
    let _handleButtonClick_decorators;
    let _handleButtonPress_decorators;
    let _handleIndicatorsButtonClick_decorators;
    let _handleIndicatorsButtonPress_decorators;
    let _handleActiveItem_decorators;
    var Carousel = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _Carousel_interval_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _instanceExtraInitializers), $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _interval_initializers, void 0)));
            _Carousel_itemMeta_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _interval_extraInitializers), $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _itemMeta_initializers, [])));
            _Carousel_currentIndex_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _itemMeta_extraInitializers), $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _currentIndex_initializers, 0)));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(this, _currentIndex_extraInitializers)
            });
        }
        get interval() {
            return $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_interval_accessor_storage, "f");
        }
        set interval(value) {
            $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_interval_accessor_storage, value, "f");
        }
        get itemMeta() {
            return $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_itemMeta_accessor_storage, "f");
        }
        set itemMeta(value) {
            $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_itemMeta_accessor_storage, value, "f");
        }
        get currentIndex() {
            return $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_currentIndex_accessor_storage, "f");
        }
        set currentIndex(value) {
            $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_currentIndex_accessor_storage, value, "f");
        }
        connectedCallback() {
            if (this.interval) this.timer || (this.timer = window.setInterval(()=>this.turnByOffset(1), this.interval));
            else this.handleActiveItem(this.currentIndex);
        }
        disconnectedCallback() {
            clearInterval(this.timer);
        }
        mountedCallback() {
            const items = [
                ...this.querySelectorAll(".carousel-item")
            ];
            if (this.itemMeta.length !== items.length) this.itemMeta = items.map((item)=>{
                var _a;
                return {
                    caption: (((_a = item.querySelector(".carousel-caption")) === null || _a === void 0 ? void 0 : _a.textContent) || item.textContent).trim()
                };
            });
        }
        turnByOffset(delta) {
            this.currentIndex = (this.currentIndex + delta) % this.itemMeta.length;
        }
        handleButtonClick(_, { dataset: dataset }) {
            this.turnByOffset(dataset.bsSlide === "next" ? 1 : -1);
        }
        handleButtonPress({ key: key }, { dataset: dataset }) {
            if (key === "Enter") this.turnByOffset(dataset.bsSlide === "next" ? 1 : -1);
        }
        handleIndicatorsButtonClick(_, { dataset: dataset }) {
            this.currentIndex = +dataset.bsSlideTo;
        }
        handleIndicatorsButtonPress({ key: key }, { dataset: dataset }) {
            if (key === "Enter") this.currentIndex = +dataset.bsSlideTo;
        }
        handleActiveItem(currentIndex) {
            var _a;
            (_a = this.querySelector(".carousel-item.active")) === null || _a === void 0 || _a.classList.remove("active");
            this.children[currentIndex].classList.add("active");
        }
        renderContent() {
            const { itemMeta: itemMeta, currentIndex: currentIndex } = this;
            return (0, $4d842655b16a6eb0$exports.jsxs)("div", {
                className: "carousel",
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("div", {
                        className: "carousel-indicators",
                        children: itemMeta.map(({ caption: caption }, index)=>(0, $4d842655b16a6eb0$exports.jsx)("button", {
                                type: "button",
                                ariaLabel: caption,
                                "data-bs-slide-to": index,
                                className: currentIndex === index ? "active" : "",
                                ariaCurrent: currentIndex === index ? "true" : ""
                            }))
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("div", {
                        className: "carousel-inner",
                        children: (0, $4d842655b16a6eb0$exports.jsx)("slot", {})
                    }),
                    (0, $4d842655b16a6eb0$exports.jsxs)("button", {
                        type: "button",
                        className: "carousel-control-prev",
                        "data-bs-slide": "prev",
                        children: [
                            (0, $4d842655b16a6eb0$exports.jsx)("span", {
                                className: "carousel-control-prev-icon",
                                ariaHidden: "true"
                            }),
                            (0, $4d842655b16a6eb0$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: "-1"
                            })
                        ]
                    }),
                    (0, $4d842655b16a6eb0$exports.jsxs)("button", {
                        type: "button",
                        className: "carousel-control-next",
                        "data-bs-slide": "next",
                        children: [
                            (0, $4d842655b16a6eb0$exports.jsx)("span", {
                                className: "carousel-control-next-icon",
                                ariaHidden: "true"
                            }),
                            (0, $4d842655b16a6eb0$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: "+1"
                            })
                        ]
                    })
                ]
            });
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
    };
    _Carousel_interval_accessor_storage = new WeakMap();
    _Carousel_itemMeta_accessor_storage = new WeakMap();
    _Carousel_currentIndex_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__setFunctionName(_classThis, "Carousel");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _interval_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _itemMeta_decorators = [
            (0, $aM14C.observable)
        ];
        _currentIndex_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _handleButtonClick_decorators = [
            (0, $658a8f813065c2f1$export$af631764ddc44097)("click", ".carousel > button")
        ];
        _handleButtonPress_decorators = [
            (0, $658a8f813065c2f1$export$af631764ddc44097)("keyup", ".carousel > button")
        ];
        _handleIndicatorsButtonClick_decorators = [
            (0, $658a8f813065c2f1$export$af631764ddc44097)("click", ".carousel-indicators button")
        ];
        _handleIndicatorsButtonPress_decorators = [
            (0, $658a8f813065c2f1$export$af631764ddc44097)("keyup", ".carousel-indicators button")
        ];
        _handleActiveItem_decorators = [
            (0, $658a8f813065c2f1$export$7203b476385689ae)(({ currentIndex: currentIndex })=>currentIndex)
        ];
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _interval_decorators, {
            kind: "accessor",
            name: "interval",
            static: false,
            private: false,
            access: {
                has: (obj)=>"interval" in obj,
                get: (obj)=>obj.interval,
                set: (obj, value)=>{
                    obj.interval = value;
                }
            },
            metadata: _metadata
        }, _interval_initializers, _interval_extraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _itemMeta_decorators, {
            kind: "accessor",
            name: "itemMeta",
            static: false,
            private: false,
            access: {
                has: (obj)=>"itemMeta" in obj,
                get: (obj)=>obj.itemMeta,
                set: (obj, value)=>{
                    obj.itemMeta = value;
                }
            },
            metadata: _metadata
        }, _itemMeta_initializers, _itemMeta_extraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _currentIndex_decorators, {
            kind: "accessor",
            name: "currentIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentIndex" in obj,
                get: (obj)=>obj.currentIndex,
                set: (obj, value)=>{
                    obj.currentIndex = value;
                }
            },
            metadata: _metadata
        }, _currentIndex_initializers, _currentIndex_extraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleButtonClick_decorators, {
            kind: "method",
            name: "handleButtonClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleButtonClick" in obj,
                get: (obj)=>obj.handleButtonClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleButtonPress_decorators, {
            kind: "method",
            name: "handleButtonPress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleButtonPress" in obj,
                get: (obj)=>obj.handleButtonPress
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleIndicatorsButtonClick_decorators, {
            kind: "method",
            name: "handleIndicatorsButtonClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleIndicatorsButtonClick" in obj,
                get: (obj)=>obj.handleIndicatorsButtonClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleIndicatorsButtonPress_decorators, {
            kind: "method",
            name: "handleIndicatorsButtonPress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleIndicatorsButtonPress" in obj,
                get: (obj)=>obj.handleIndicatorsButtonPress
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleActiveItem_decorators, {
            kind: "method",
            name: "handleActiveItem",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleActiveItem" in obj,
                get: (obj)=>obj.handleActiveItem
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Carousel = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Carousel = _classThis;
})();
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$3f0c6c9020e942c5$exports, $ecf668de0cd72cb2$var$$6e5adc7420b5d0fd$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$3f0c6c9020e942c5$exports, $ecf668de0cd72cb2$var$$be58a6a40ab07fd2$exports);
var $ecf668de0cd72cb2$var$$07e74c2207adaaa3$exports = {};
var $ecf668de0cd72cb2$var$$d3540d749a8620d4$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$d3540d749a8620d4$exports, "Spinner", function() {
    return $ecf668de0cd72cb2$export$7f7cbe89f1eacd2;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$d3540d749a8620d4$exports, "SpinnerBox", function() {
    return $ecf668de0cd72cb2$export$d4c790f923031725;
});
var $ecf668de0cd72cb2$var$$d3540d749a8620d4$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$7f7cbe89f1eacd2 = (_a)=>{
    var { className: className, variant: variant, size: size, animation: animation = "border", children: children = "Loading..." } = _a, props = $ecf668de0cd72cb2$var$$d3540d749a8620d4$var$__rest(_a, [
        "className",
        "variant",
        "size",
        "animation",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`spinner-${animation}`, size && `spinner-${animation}-${size}`, variant && `text-${variant}`, className),
        role: "status"
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsx)("span", {
            className: "visually-hidden",
            children: children
        })
    }));
};
const $ecf668de0cd72cb2$export$d4c790f923031725 = (_a)=>{
    var { className: className = "", cover: cover, variant: variant, size: size, animation: animation, role: role, children: children } = _a, props = $ecf668de0cd72cb2$var$$d3540d749a8620d4$var$__rest(_a, [
        "className",
        "cover",
        "variant",
        "size",
        "animation",
        "role",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("div", Object.assign({
        className: `position-relative ${className}`
    }, props, {
        children: [
            children,
            cover && (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "modal-backdrop show d-flex justify-content-center align-items-center",
                children: (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$7f7cbe89f1eacd2, {
                    variant: variant,
                    size: size,
                    animation: animation,
                    role: role,
                    ariaHidden: "true"
                })
            })
        ]
    }));
};
var $ecf668de0cd72cb2$var$$a6f317a49298db85$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$a6f317a49298db85$exports, "Tooltip", function() {
    return $ecf668de0cd72cb2$export$28c660c63b792dea;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$a6f317a49298db85$exports, "TooltipBox", function() {
    return $ecf668de0cd72cb2$export$e4d8dc88bb9cc931;
});
var $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$28c660c63b792dea = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("div", Object.assign({
        className: `tooltip bs-tooltip show position-absolute ${className}`,
        role: "tooltip"
    }, props, {
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "tooltip-arrow"
            }),
            (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "tooltip-inner",
                children: children
            })
        ]
    }));
};
let $ecf668de0cd72cb2$export$e4d8dc88bb9cc931 = (()=>{
    var _TooltipBox_show_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "tooltip-box",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _show_decorators;
    let _show_initializers = [];
    let _show_extraInitializers = [];
    var TooltipBox = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "content", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _TooltipBox_show_accessor_storage.set(this, $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__runInitializers(this, _show_initializers, false));
            Object.defineProperty(this, "handleToggle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ecf668de0cd72cb2$var$$a6f317a49298db85$var$__runInitializers(this, _show_extraInitializers), ()=>this.show = !this.show)
            });
        }
        get show() {
            return $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__classPrivateFieldGet(this, _TooltipBox_show_accessor_storage, "f");
        }
        set show(value) {
            $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__classPrivateFieldSet(this, _TooltipBox_show_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.style.display = "inline-block";
            this.addEventListener("mouseenter", this.handleToggle);
            this.addEventListener("mouseleave", this.handleToggle);
        }
        disconnectedCallback() {
            this.removeEventListener("mouseenter", this.handleToggle);
            this.removeEventListener("mouseleave", this.handleToggle);
        }
        render() {
            const { content: content, show: show } = this;
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("slot", {}),
                    show && (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$28c660c63b792dea, {
                        children: content
                    })
                ]
            });
        }
    };
    _TooltipBox_show_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__setFunctionName(_classThis, "TooltipBox");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _show_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__esDecorate(_classThis, null, _show_decorators, {
            kind: "accessor",
            name: "show",
            static: false,
            private: false,
            access: {
                has: (obj)=>"show" in obj,
                get: (obj)=>obj.show,
                set: (obj, value)=>{
                    obj.show = value;
                }
            },
            metadata: _metadata
        }, _show_initializers, _show_extraInitializers);
        $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TooltipBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$a6f317a49298db85$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TooltipBox = _classThis;
})();
var $ecf668de0cd72cb2$var$$99cde405e93e4bfc$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$99cde405e93e4bfc$exports, "DialogClose", function() {
    return $ecf668de0cd72cb2$export$fba2fb7cd781b7ac;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$99cde405e93e4bfc$exports, "Dialog", function() {
    return $ecf668de0cd72cb2$export$3ddf2d174ce01153;
});
var $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
class $ecf668de0cd72cb2$export$fba2fb7cd781b7ac extends Error {
    constructor(message = "Dialog closed"){
        super(message);
    }
}
let $ecf668de0cd72cb2$export$3ddf2d174ce01153 = (()=>{
    var _a, _Dialog_defer_accessor_storage;
    let _defer_decorators;
    let _defer_initializers = [];
    let _defer_extraInitializers = [];
    return _a = class Dialog {
        get defer() {
            return $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__classPrivateFieldGet(this, _Dialog_defer_accessor_storage, "f");
        }
        set defer(value) {
            $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__classPrivateFieldSet(this, _Dialog_defer_accessor_storage, value, "f");
        }
        constructor(Factory){
            _Dialog_defer_accessor_storage.set(this, $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__runInitializers(this, _defer_initializers, void 0));
            Object.defineProperty(this, "Component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__runInitializers(this, _defer_extraInitializers)
            });
            this.Component = (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)(()=>(0, $4d842655b16a6eb0$exports.jsx)(Factory, {
                    defer: this.defer
                }));
        }
        open() {
            this.defer = new (0, $c379f9436bbe0249$export$c7e91f8aec23ae14)();
            this.defer.promise.finally(()=>this.defer = undefined);
            return this.defer.promise;
        }
    }, _Dialog_defer_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _defer_decorators = [
            (0, $aM14C.observable)
        ];
        $ecf668de0cd72cb2$var$$99cde405e93e4bfc$var$__esDecorate(_a, null, _defer_decorators, {
            kind: "accessor",
            name: "defer",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defer" in obj,
                get: (obj)=>obj.defer,
                set: (obj, value)=>{
                    obj.defer = value;
                }
            },
            metadata: _metadata
        }, _defer_initializers, _defer_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports, "Modal", function() {
    return $ecf668de0cd72cb2$export$2b77a92f1a5ad772;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports, "ModalHeader", function() {
    return $ecf668de0cd72cb2$export$f50a68e3694789ee;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports, "ModalTitle", function() {
    return $ecf668de0cd72cb2$export$b26fae16ba5468aa;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports, "ModalBody", function() {
    return $ecf668de0cd72cb2$export$cb540d8b0ef7906c;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports, "ModalFooter", function() {
    return $ecf668de0cd72cb2$export$519437715052e656;
});
var $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$emitHide(event) {
    if (event.type === "keyup" ? event.key === "Escape" : event.type === "click" && event.currentTarget.className === "btn-close") event.currentTarget.closest(".modal").dispatchEvent(new CustomEvent("hide"));
}
const $ecf668de0cd72cb2$export$2b77a92f1a5ad772 = (_a)=>{
    var { className: className, backdrop: backdrop, size: size, fullscreen: fullscreen, centered: centered, scrollable: scrollable, animation: animation, show: show, ref: ref, children: children } = _a, props = $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "backdrop",
        "size",
        "fullscreen",
        "centered",
        "scrollable",
        "animation",
        "show",
        "ref",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("modal", {
            fade: animation,
            show: show
        }, className),
        "data-bs-backdrop": backdrop != null ? backdrop + "" : undefined,
        tabIndex: -1,
        ariaHidden: !show + "",
        ref: (node)=>{
            var _a, _b;
            return node ? (_a = globalThis.addEventListener) === null || _a === void 0 ? void 0 : _a.call(globalThis, "keyup", $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$emitHide) : (_b = globalThis.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(globalThis, "keyup", $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$emitHide);
        }
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("modal-dialog", size && `modal-${size}`, fullscreen && `modal-fullscreen${fullscreen === true ? "" : `-${fullscreen}`}`, centered && "modal-dialog-centered", scrollable && "modal-dialog-scrollable"),
            children: (0, $4d842655b16a6eb0$exports.jsx)("div", {
                className: "modal-content",
                children: children
            })
        })
    }));
};
const $ecf668de0cd72cb2$export$f50a68e3694789ee = (_a)=>{
    var { className: className = "", children: children, closeButton: closeButton } = _a, props = $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children",
        "closeButton"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("div", Object.assign({
        className: `modal-header ${className}`
    }, props, {
        children: [
            children,
            closeButton && (0, $4d842655b16a6eb0$exports.jsx)("button", {
                type: "button",
                className: "btn-close",
                ariaLabel: "Close",
                onClick: $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$emitHide
            })
        ]
    }));
};
const $ecf668de0cd72cb2$export$b26fae16ba5468aa = (_a)=>{
    var { className: className = "fs-5", children: children } = _a, props = $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("h1", Object.assign({
        className: `modal-title ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$cb540d8b0ef7906c = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `modal-body ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$519437715052e656 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("div", Object.assign({
        className: `modal-footer ${className}`
    }, props, {
        children: children
    }));
};
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$07e74c2207adaaa3$exports, $ecf668de0cd72cb2$var$$d3540d749a8620d4$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$07e74c2207adaaa3$exports, $ecf668de0cd72cb2$var$$a6f317a49298db85$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$07e74c2207adaaa3$exports, $ecf668de0cd72cb2$var$$99cde405e93e4bfc$exports);
$ecf668de0cd72cb2$var$$parcel$exportWildcard($ecf668de0cd72cb2$var$$07e74c2207adaaa3$exports, $ecf668de0cd72cb2$var$$ed39adb4ffdd84c9$exports);
var $ecf668de0cd72cb2$var$$97590922d21716c6$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$97590922d21716c6$exports, "NavbarBrand", function() {
    return $ecf668de0cd72cb2$export$2df9f3e5f6d355f6;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$97590922d21716c6$exports, "NavbarToggle", function() {
    return $ecf668de0cd72cb2$export$e018030c18c7f90a;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$97590922d21716c6$exports, "Navbar", function() {
    return $ecf668de0cd72cb2$export$42cfbb80f7861e77;
});
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$97590922d21716c6$exports, "OffcanvasNavbar", function() {
    return $ecf668de0cd72cb2$export$d31319d8cbfdaf50;
});
var $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$97590922d21716c6$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ecf668de0cd72cb2$var$$97590922d21716c6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecf668de0cd72cb2$export$2df9f3e5f6d355f6 = (_a)=>{
    var { className: className = "", children: children } = _a, props = $ecf668de0cd72cb2$var$$97590922d21716c6$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({
        className: `navbar-brand ${className}`
    }, props, {
        children: children
    }));
};
const $ecf668de0cd72cb2$export$e018030c18c7f90a = (_a)=>{
    var { className: className = "", type: type, children: children } = _a, props = $ecf668de0cd72cb2$var$$97590922d21716c6$var$__rest(_a, [
        "className",
        "type",
        "children"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsx)("button", Object.assign({
        className: `navbar-toggler ${className}`,
        type: "button"
    }, props, {
        children: (0, $4d842655b16a6eb0$exports.jsx)("span", {
            className: "navbar-toggler-icon"
        })
    }));
};
const $ecf668de0cd72cb2$export$42cfbb80f7861e77 = ({ variant: variant = "light", bg: bg = "body-tertiary", fixed: fixed, sticky: sticky, expand: expand, children: children })=>(0, $4d842655b16a6eb0$exports.jsx)("nav", {
        className: `navbar bg-${bg} ${fixed ? `fixed-${fixed}` : ""} ${sticky ? `sticky-${sticky}` : ""} ${expand ? `navbar-expand${expand === true ? "" : `-${expand}`}` : ""}`,
        "data-bs-theme": variant,
        children: children
    });
let $ecf668de0cd72cb2$export$d31319d8cbfdaf50 = (()=>{
    var _OffcanvasNavbar_variant_accessor_storage, _OffcanvasNavbar_bg_accessor_storage, _OffcanvasNavbar_expand_accessor_storage, _OffcanvasNavbar_fixed_accessor_storage, _OffcanvasNavbar_sticky_accessor_storage, _OffcanvasNavbar_fluid_accessor_storage, _OffcanvasNavbar_title_accessor_storage, _OffcanvasNavbar_brand_accessor_storage, _OffcanvasNavbar_open_accessor_storage, _OffcanvasNavbar_closeButton_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "offcanvas-navbar",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _bg_decorators;
    let _bg_initializers = [];
    let _bg_extraInitializers = [];
    let _expand_decorators;
    let _expand_initializers = [];
    let _expand_extraInitializers = [];
    let _fixed_decorators;
    let _fixed_initializers = [];
    let _fixed_extraInitializers = [];
    let _sticky_decorators;
    let _sticky_initializers = [];
    let _sticky_extraInitializers = [];
    let _fluid_decorators;
    let _fluid_initializers = [];
    let _fluid_extraInitializers = [];
    let _title_decorators;
    let _title_initializers = [];
    let _title_extraInitializers = [];
    let _brand_decorators;
    let _brand_initializers = [];
    let _brand_extraInitializers = [];
    let _open_decorators;
    let _open_initializers = [];
    let _open_extraInitializers = [];
    let _closeButton_decorators;
    let _closeButton_initializers = [];
    let _closeButton_extraInitializers = [];
    var OffcanvasNavbar = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _OffcanvasNavbar_variant_accessor_storage.set(this, $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _variant_initializers, void 0));
            _OffcanvasNavbar_bg_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _variant_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _bg_initializers, void 0)));
            _OffcanvasNavbar_expand_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _bg_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _expand_initializers, void 0)));
            _OffcanvasNavbar_fixed_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _expand_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _fixed_initializers, void 0)));
            _OffcanvasNavbar_sticky_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _fixed_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _sticky_initializers, void 0)));
            _OffcanvasNavbar_fluid_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _sticky_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _fluid_initializers, void 0)));
            _OffcanvasNavbar_title_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _fluid_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _title_initializers, void 0)));
            Object.defineProperty(this, "titleId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _title_extraInitializers), (0, $1aYx7.uniqueID)())
            });
            _OffcanvasNavbar_brand_accessor_storage.set(this, $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _brand_initializers, void 0));
            Object.defineProperty(this, "offcanvasId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _brand_extraInitializers), (0, $1aYx7.uniqueID)())
            });
            _OffcanvasNavbar_open_accessor_storage.set(this, $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _open_initializers, false));
            _OffcanvasNavbar_closeButton_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _open_extraInitializers), $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _closeButton_initializers, true)));
            Object.defineProperty(this, "close", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(this, _closeButton_extraInitializers), (event)=>{
                    if (event instanceof KeyboardEvent && ![
                        "Escape",
                        "Enter"
                    ].includes(event.key)) return;
                    this.open = false;
                })
            });
            Object.defineProperty(this, "handleLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (0, $1aYx7.delegate)("a[href].nav-link", this.close)
            });
        }
        get variant() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_variant_accessor_storage, "f");
        }
        set variant(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_variant_accessor_storage, value, "f");
        }
        get bg() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_bg_accessor_storage, "f");
        }
        set bg(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_bg_accessor_storage, value, "f");
        }
        get expand() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_expand_accessor_storage, "f");
        }
        set expand(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_expand_accessor_storage, value, "f");
        }
        get fixed() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_fixed_accessor_storage, "f");
        }
        set fixed(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_fixed_accessor_storage, value, "f");
        }
        get sticky() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_sticky_accessor_storage, "f");
        }
        set sticky(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_sticky_accessor_storage, value, "f");
        }
        get fluid() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_fluid_accessor_storage, "f");
        }
        set fluid(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_fluid_accessor_storage, value, "f");
        }
        get title() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_title_accessor_storage, "f");
        }
        set title(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_title_accessor_storage, value, "f");
        }
        get brand() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_brand_accessor_storage, "f");
        }
        set brand(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_brand_accessor_storage, value, "f");
        }
        get open() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_open_accessor_storage, "f");
        }
        set open(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_open_accessor_storage, value, "f");
        }
        get closeButton() {
            return $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_closeButton_accessor_storage, "f");
        }
        set closeButton(value) {
            $ecf668de0cd72cb2$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_closeButton_accessor_storage, value, "f");
        }
        connectedCallback() {
            var _a;
            (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, "keyup", this.close, true);
            this.addEventListener("click", this.handleLink);
        }
        disconnectedCallback() {
            var _a;
            (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, "keyup", this.close, true);
            this.addEventListener("click", this.handleLink);
        }
        renderContent() {
            const { variant: variant, bg: bg, expand: expand, fixed: fixed, sticky: sticky, fluid: fluid, brand: brand } = this, { title: title, titleId: titleId, offcanvasId: offcanvasId, open: open, closeButton: closeButton } = this;
            return (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$42cfbb80f7861e77, {
                variant: variant,
                bg: bg,
                expand: expand,
                fixed: fixed,
                sticky: sticky,
                children: (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$42a852a2b6b56249, {
                    fluid: fluid,
                    children: [
                        brand || title,
                        (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$e018030c18c7f90a, {
                            "aria-controls": offcanvasId,
                            ariaLabel: "Toggle navigation",
                            onClick: ()=>this.open = true
                        }),
                        (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$591ca0244c9dfcd4, {
                            id: offcanvasId,
                            "aria-labelledby": titleId,
                            show: open,
                            onHide: this.close,
                            children: [
                                (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$b6c1518fb8dc5e75, {
                                    closeButton: closeButton,
                                    onHide: ()=>this.open = false,
                                    children: (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$1b33297d19c3da30, {
                                        id: titleId,
                                        children: brand || title
                                    })
                                }),
                                (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$c324d20ecc5b7dee, {
                                    children: (0, $4d842655b16a6eb0$exports.jsx)("slot", {})
                                })
                            ]
                        })
                    ]
                })
            });
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
    };
    _OffcanvasNavbar_variant_accessor_storage = new WeakMap();
    _OffcanvasNavbar_bg_accessor_storage = new WeakMap();
    _OffcanvasNavbar_expand_accessor_storage = new WeakMap();
    _OffcanvasNavbar_fixed_accessor_storage = new WeakMap();
    _OffcanvasNavbar_sticky_accessor_storage = new WeakMap();
    _OffcanvasNavbar_fluid_accessor_storage = new WeakMap();
    _OffcanvasNavbar_title_accessor_storage = new WeakMap();
    _OffcanvasNavbar_brand_accessor_storage = new WeakMap();
    _OffcanvasNavbar_open_accessor_storage = new WeakMap();
    _OffcanvasNavbar_closeButton_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$97590922d21716c6$var$__setFunctionName(_classThis, "OffcanvasNavbar");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _bg_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _expand_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _fixed_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _sticky_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _fluid_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _title_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _brand_decorators = [
            (0, $aM14C.observable)
        ];
        _open_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _closeButton_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _bg_decorators, {
            kind: "accessor",
            name: "bg",
            static: false,
            private: false,
            access: {
                has: (obj)=>"bg" in obj,
                get: (obj)=>obj.bg,
                set: (obj, value)=>{
                    obj.bg = value;
                }
            },
            metadata: _metadata
        }, _bg_initializers, _bg_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _expand_decorators, {
            kind: "accessor",
            name: "expand",
            static: false,
            private: false,
            access: {
                has: (obj)=>"expand" in obj,
                get: (obj)=>obj.expand,
                set: (obj, value)=>{
                    obj.expand = value;
                }
            },
            metadata: _metadata
        }, _expand_initializers, _expand_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _fixed_decorators, {
            kind: "accessor",
            name: "fixed",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fixed" in obj,
                get: (obj)=>obj.fixed,
                set: (obj, value)=>{
                    obj.fixed = value;
                }
            },
            metadata: _metadata
        }, _fixed_initializers, _fixed_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _sticky_decorators, {
            kind: "accessor",
            name: "sticky",
            static: false,
            private: false,
            access: {
                has: (obj)=>"sticky" in obj,
                get: (obj)=>obj.sticky,
                set: (obj, value)=>{
                    obj.sticky = value;
                }
            },
            metadata: _metadata
        }, _sticky_initializers, _sticky_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _fluid_decorators, {
            kind: "accessor",
            name: "fluid",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fluid" in obj,
                get: (obj)=>obj.fluid,
                set: (obj, value)=>{
                    obj.fluid = value;
                }
            },
            metadata: _metadata
        }, _fluid_initializers, _fluid_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _title_decorators, {
            kind: "accessor",
            name: "title",
            static: false,
            private: false,
            access: {
                has: (obj)=>"title" in obj,
                get: (obj)=>obj.title,
                set: (obj, value)=>{
                    obj.title = value;
                }
            },
            metadata: _metadata
        }, _title_initializers, _title_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _brand_decorators, {
            kind: "accessor",
            name: "brand",
            static: false,
            private: false,
            access: {
                has: (obj)=>"brand" in obj,
                get: (obj)=>obj.brand,
                set: (obj, value)=>{
                    obj.brand = value;
                }
            },
            metadata: _metadata
        }, _brand_initializers, _brand_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _open_decorators, {
            kind: "accessor",
            name: "open",
            static: false,
            private: false,
            access: {
                has: (obj)=>"open" in obj,
                get: (obj)=>obj.open,
                set: (obj, value)=>{
                    obj.open = value;
                }
            },
            metadata: _metadata
        }, _open_initializers, _open_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _closeButton_decorators, {
            kind: "accessor",
            name: "closeButton",
            static: false,
            private: false,
            access: {
                has: (obj)=>"closeButton" in obj,
                get: (obj)=>obj.closeButton,
                set: (obj, value)=>{
                    obj.closeButton = value;
                }
            },
            metadata: _metadata
        }, _closeButton_initializers, _closeButton_extraInitializers);
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        OffcanvasNavbar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$97590922d21716c6$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return OffcanvasNavbar = _classThis;
})();
var $ecf668de0cd72cb2$var$$0ebd9548c1f64027$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$0ebd9548c1f64027$exports, "CountDown", function() {
    return $ecf668de0cd72cb2$export$ddd3857461e99bb8;
});
var $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$colors = Object.keys($ecf668de0cd72cb2$export$96e9906d6d93a972).filter((color)=>color !== "tertiary").slice(0, 4);
let $ecf668de0cd72cb2$export$ddd3857461e99bb8 = (()=>{
    var _CountDown_endTime_accessor_storage, _CountDown_rest_accessor_storage, _CountDown_units_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "count-down"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _endTime_decorators;
    let _endTime_initializers = [];
    let _endTime_extraInitializers = [];
    let _rest_decorators;
    let _rest_initializers = [];
    let _rest_extraInitializers = [];
    let _units_decorators;
    let _units_initializers = [];
    let _units_extraInitializers = [];
    let _get_timeSections_decorators;
    var CountDown = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CountDown_endTime_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _instanceExtraInitializers), $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _endTime_initializers, Date.now())));
            _CountDown_rest_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _endTime_extraInitializers), $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _rest_initializers, 0)));
            _CountDown_units_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _rest_extraInitializers), $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _units_initializers, [
                {
                    scale: 24,
                    label: "D"
                },
                {
                    scale: 60,
                    label: "h"
                },
                {
                    scale: 60,
                    label: "m"
                },
                {
                    scale: 1000,
                    label: "s"
                }
            ])));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(this, _units_extraInitializers)
            });
            Object.defineProperty(this, "tick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const rest = this.endTime - Date.now();
                    if (rest > 0) {
                        this.rest = rest;
                        if (!this.timer) this.timer = self.setInterval(this.tick, 1000);
                    } else if (this.timer) clearInterval(this.timer);
                }
            });
        }
        get endTime() {
            return $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_endTime_accessor_storage, "f");
        }
        set endTime(value) {
            $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_endTime_accessor_storage, value, "f");
        }
        get rest() {
            return $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_rest_accessor_storage, "f");
        }
        set rest(value) {
            $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_rest_accessor_storage, value, "f");
        }
        get units() {
            return $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_units_accessor_storage, "f");
        }
        set units(value) {
            $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_units_accessor_storage, value, "f");
        }
        get timeSections() {
            var { rest: rest } = this;
            return this.units.reduce((list, { label: label }, index, units)=>{
                const scale = units.slice(index).map(({ scale: scale })=>scale).reduce((sum, scale)=>sum * scale, 1);
                const value = ~~(rest / scale);
                rest -= value * scale;
                list.push({
                    value: value,
                    label: label
                });
                return list;
            }, []);
        }
        mountedCallback() {
            if (typeof this.endTime !== "number") this.endTime = new Date(this.endTime).valueOf();
            this.tick();
        }
        disconnectedCallback() {
            clearInterval(this.timer);
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsx)("ol", {
                className: "list-inline text-white",
                children: this.timeSections.map(({ value: value, label: label }, index)=>(0, $4d842655b16a6eb0$exports.jsx)("li", {
                        className: `list-inline-item fs-1 bg-${$ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$colors[index]} d-inline-flex align-items-center justify-content-center rounded-4`,
                        style: {
                            width: "5.5rem",
                            height: "5.5rem"
                        },
                        children: (0, $4d842655b16a6eb0$exports.jsxs)("small", {
                            children: [
                                (value + "").padStart(2, "0"),
                                (0, $4d842655b16a6eb0$exports.jsx)("sub", {
                                    children: label
                                })
                            ]
                        })
                    }, label))
            });
        }
    };
    _CountDown_endTime_accessor_storage = new WeakMap();
    _CountDown_rest_accessor_storage = new WeakMap();
    _CountDown_units_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__setFunctionName(_classThis, "CountDown");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _endTime_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _rest_decorators = [
            (0, $aM14C.observable)
        ];
        _units_decorators = [
            (0, $aM14C.observable)
        ];
        _get_timeSections_decorators = [
            (0, $aM14C.computed)
        ];
        $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _endTime_decorators, {
            kind: "accessor",
            name: "endTime",
            static: false,
            private: false,
            access: {
                has: (obj)=>"endTime" in obj,
                get: (obj)=>obj.endTime,
                set: (obj, value)=>{
                    obj.endTime = value;
                }
            },
            metadata: _metadata
        }, _endTime_initializers, _endTime_extraInitializers);
        $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _rest_decorators, {
            kind: "accessor",
            name: "rest",
            static: false,
            private: false,
            access: {
                has: (obj)=>"rest" in obj,
                get: (obj)=>obj.rest,
                set: (obj, value)=>{
                    obj.rest = value;
                }
            },
            metadata: _metadata
        }, _rest_initializers, _rest_extraInitializers);
        $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _units_decorators, {
            kind: "accessor",
            name: "units",
            static: false,
            private: false,
            access: {
                has: (obj)=>"units" in obj,
                get: (obj)=>obj.units,
                set: (obj, value)=>{
                    obj.units = value;
                }
            },
            metadata: _metadata
        }, _units_initializers, _units_extraInitializers);
        $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _get_timeSections_decorators, {
            kind: "getter",
            name: "timeSections",
            static: false,
            private: false,
            access: {
                has: (obj)=>"timeSections" in obj,
                get: (obj)=>obj.timeSections
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CountDown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$0ebd9548c1f64027$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CountDown = _classThis;
})();
var $ecf668de0cd72cb2$var$$833abb125114b381$exports = {};
$ecf668de0cd72cb2$var$$parcel$export($ecf668de0cd72cb2$var$$833abb125114b381$exports, "MonthCalendar", function() {
    return $ecf668de0cd72cb2$export$d7a7c85c0f5afc4a;
});
var $ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ecf668de0cd72cb2$var$$833abb125114b381$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ecf668de0cd72cb2$export$d7a7c85c0f5afc4a = (()=>{
    var _MonthCalendar_variant_accessor_storage, _MonthCalendar_locale_accessor_storage, _MonthCalendar_value_accessor_storage, _MonthCalendar_currentDate_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "month-calendar"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _get_weekFormatter_decorators;
    let _currentDate_decorators;
    let _currentDate_initializers = [];
    let _currentDate_extraInitializers = [];
    let _get_dateGrid_decorators;
    var MonthCalendar = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _MonthCalendar_variant_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _instanceExtraInitializers), $ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _variant_initializers, "primary")));
            _MonthCalendar_locale_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _variant_extraInitializers), $ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _locale_initializers, void 0)));
            _MonthCalendar_value_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _locale_extraInitializers), $ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _value_initializers, [])));
            _MonthCalendar_currentDate_accessor_storage.set(this, ($ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _value_extraInitializers), $ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _currentDate_initializers, new Date())));
            Object.defineProperty(this, "renderDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(this, _currentDate_extraInitializers), (date)=>{
                    const { value: value } = this, dateText = (0, $1aYx7.formatDate)(date, "YYYY-MM-DD");
                    const list = value === null || value === void 0 ? void 0 : value.filter(({ date: date })=>(0, $1aYx7.formatDate)(date, "YYYY-MM-DD") === dateText);
                    return (0, $4d842655b16a6eb0$exports.jsxs)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
                            "opacity-50": date.getMonth() !== this.currentDate.getMonth(),
                            "fw-bold": dateText === (0, $1aYx7.formatDate)(new Date(), "YYYY-MM-DD")
                        }),
                        children: [
                            (0, $4d842655b16a6eb0$exports.jsx)("time", {
                                className: "d-block",
                                dateTime: date.toJSON(),
                                children: date.getDate()
                            }),
                            list === null || list === void 0 ? void 0 : list.map((item)=>typeof item.content === "object" ? item.content : (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$37acb3580601e69a, {
                                    className: "d-inline-block text-decoration-none w-100 text-truncate",
                                    href: item.link,
                                    onClick: ()=>this.emit("select", item),
                                    children: item.content
                                }))
                        ]
                    }, date + "");
                })
            });
        }
        get variant() {
            return $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_variant_accessor_storage, "f");
        }
        set variant(value) {
            $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_variant_accessor_storage, value, "f");
        }
        get locale() {
            return $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_locale_accessor_storage, "f");
        }
        set locale(value) {
            $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_locale_accessor_storage, value, "f");
        }
        get value() {
            return $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_value_accessor_storage, "f");
        }
        set value(value) {
            $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_value_accessor_storage, value, "f");
        }
        get weekFormatter() {
            var _a;
            const { locale: locale = (_a = globalThis.navigator) === null || _a === void 0 ? void 0 : _a.language } = this;
            return new Intl.DateTimeFormat(locale, {
                weekday: "long"
            });
        }
        get currentDate() {
            return $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_currentDate_accessor_storage, "f");
        }
        set currentDate(value) {
            $ecf668de0cd72cb2$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_currentDate_accessor_storage, value, "f");
        }
        get dateGrid() {
            let startDate = new Date(this.currentDate);
            startDate.setDate(1);
            startDate = new Date(+startDate - startDate.getDay() * (0, $1aYx7.Day));
            const dateList = Array.from(new Array(42), (_, index)=>new Date(+startDate + index * (0, $1aYx7.Day)));
            return (0, $1aYx7.splitArray)(dateList, 7);
        }
        changeMonth(delta) {
            this.currentDate = (0, $1aYx7.changeMonth)(this.currentDate, delta);
            this.emit("change", this.currentDate);
        }
        render() {
            const { style: style, variant: variant, weekFormatter: weekFormatter, currentDate: currentDate, dateGrid: dateGrid } = this;
            return (0, $4d842655b16a6eb0$exports.jsxs)($ecf668de0cd72cb2$export$54ec01a60f47d33d, {
                style: Object.assign({
                    tableLayout: "fixed"
                }, style),
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("caption", {
                        children: (0, $4d842655b16a6eb0$exports.jsxs)("div", {
                            className: "d-flex justify-content-between align-items-center",
                            children: [
                                (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$353f5b6fc5456de1, {
                                    variant: variant,
                                    onClick: ()=>this.changeMonth(-1),
                                    children: "<"
                                }),
                                (0, $1aYx7.formatDate)(currentDate, "YYYY-MM"),
                                (0, $4d842655b16a6eb0$exports.jsx)($ecf668de0cd72cb2$export$353f5b6fc5456de1, {
                                    variant: variant,
                                    onClick: ()=>this.changeMonth(1),
                                    children: ">"
                                })
                            ]
                        })
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("thead", {
                        children: (0, $4d842655b16a6eb0$exports.jsx)("tr", {
                            children: dateGrid[0].map((date, index, { length: length })=>(0, $4d842655b16a6eb0$exports.jsx)("td", {
                                    className: `bg-${variant} text-white`,
                                    style: {
                                        width: `calc(100% / ${length})`
                                    },
                                    children: weekFormatter.format(date)
                                }, index))
                        })
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("tbody", {
                        children: dateGrid.map((days)=>(0, $4d842655b16a6eb0$exports.jsx)("tr", {
                                children: days.map(this.renderDate)
                            }, days[0] + ""))
                    })
                ]
            });
        }
    };
    _MonthCalendar_variant_accessor_storage = new WeakMap();
    _MonthCalendar_locale_accessor_storage = new WeakMap();
    _MonthCalendar_value_accessor_storage = new WeakMap();
    _MonthCalendar_currentDate_accessor_storage = new WeakMap();
    $ecf668de0cd72cb2$var$$833abb125114b381$var$__setFunctionName(_classThis, "MonthCalendar");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _locale_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _value_decorators = [
            (0, $aM14C.observable)
        ];
        _get_weekFormatter_decorators = [
            (0, $aM14C.computed)
        ];
        _currentDate_decorators = [
            (0, $aM14C.observable)
        ];
        _get_dateGrid_decorators = [
            (0, $aM14C.computed)
        ];
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(_classThis, null, _locale_decorators, {
            kind: "accessor",
            name: "locale",
            static: false,
            private: false,
            access: {
                has: (obj)=>"locale" in obj,
                get: (obj)=>obj.locale,
                set: (obj, value)=>{
                    obj.locale = value;
                }
            },
            metadata: _metadata
        }, _locale_initializers, _locale_extraInitializers);
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(_classThis, null, _value_decorators, {
            kind: "accessor",
            name: "value",
            static: false,
            private: false,
            access: {
                has: (obj)=>"value" in obj,
                get: (obj)=>obj.value,
                set: (obj, value)=>{
                    obj.value = value;
                }
            },
            metadata: _metadata
        }, _value_initializers, _value_extraInitializers);
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(_classThis, null, _get_weekFormatter_decorators, {
            kind: "getter",
            name: "weekFormatter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"weekFormatter" in obj,
                get: (obj)=>obj.weekFormatter
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(_classThis, null, _currentDate_decorators, {
            kind: "accessor",
            name: "currentDate",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentDate" in obj,
                get: (obj)=>obj.currentDate,
                set: (obj, value)=>{
                    obj.currentDate = value;
                }
            },
            metadata: _metadata
        }, _currentDate_initializers, _currentDate_extraInitializers);
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(_classThis, null, _get_dateGrid_decorators, {
            kind: "getter",
            name: "dateGrid",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dateGrid" in obj,
                get: (obj)=>obj.dateGrid
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        MonthCalendar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ecf668de0cd72cb2$var$$833abb125114b381$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return MonthCalendar = _classThis;
})();


var $da37ce670175a8d0$var$R = class {
    type = 3;
    name = "";
    prefix = "";
    value = "";
    suffix = "";
    modifier = 3;
    constructor(t, r, n, o, c, l){
        this.type = t, this.name = r, this.prefix = n, this.value = o, this.suffix = c, this.modifier = l;
    }
    hasCustomName() {
        return this.name !== "" && typeof this.name != "number";
    }
}, $da37ce670175a8d0$var$be = /[$_\p{ID_Start}]/u, $da37ce670175a8d0$var$Pe = /[$_\u200C\u200D\p{ID_Continue}]/u, $da37ce670175a8d0$var$M = ".*";
function $da37ce670175a8d0$var$Re(e, t) {
    return (t ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(e);
}
function $da37ce670175a8d0$var$v(e, t = !1) {
    let r = [], n = 0;
    for(; n < e.length;){
        let o = e[n], c = function(l) {
            if (!t) throw new TypeError(l);
            r.push({
                type: "INVALID_CHAR",
                index: n,
                value: e[n++]
            });
        };
        if (o === "*") {
            r.push({
                type: "ASTERISK",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === "+" || o === "?") {
            r.push({
                type: "OTHER_MODIFIER",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === "\\") {
            r.push({
                type: "ESCAPED_CHAR",
                index: n++,
                value: e[n++]
            });
            continue;
        }
        if (o === "{") {
            r.push({
                type: "OPEN",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === "}") {
            r.push({
                type: "CLOSE",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (o === ":") {
            let l = "", s = n + 1;
            for(; s < e.length;){
                let i = e.substr(s, 1);
                if (s === n + 1 && $da37ce670175a8d0$var$be.test(i) || s !== n + 1 && $da37ce670175a8d0$var$Pe.test(i)) {
                    l += e[s++];
                    continue;
                }
                break;
            }
            if (!l) {
                c(`Missing parameter name at ${n}`);
                continue;
            }
            r.push({
                type: "NAME",
                index: n,
                value: l
            }), n = s;
            continue;
        }
        if (o === "(") {
            let l = 1, s = "", i = n + 1, a = !1;
            if (e[i] === "?") {
                c(`Pattern cannot start with "?" at ${i}`);
                continue;
            }
            for(; i < e.length;){
                if (!$da37ce670175a8d0$var$Re(e[i], !1)) {
                    c(`Invalid character '${e[i]}' at ${i}.`), a = !0;
                    break;
                }
                if (e[i] === "\\") {
                    s += e[i++] + e[i++];
                    continue;
                }
                if (e[i] === ")") {
                    if (l--, l === 0) {
                        i++;
                        break;
                    }
                } else if (e[i] === "(" && (l++, e[i + 1] !== "?")) {
                    c(`Capturing groups are not allowed at ${i}`), a = !0;
                    break;
                }
                s += e[i++];
            }
            if (a) continue;
            if (l) {
                c(`Unbalanced pattern at ${n}`);
                continue;
            }
            if (!s) {
                c(`Missing pattern at ${n}`);
                continue;
            }
            r.push({
                type: "REGEX",
                index: n,
                value: s
            }), n = i;
            continue;
        }
        r.push({
            type: "CHAR",
            index: n,
            value: e[n++]
        });
    }
    return r.push({
        type: "END",
        index: n,
        value: ""
    }), r;
}
function $da37ce670175a8d0$var$D(e, t = {}) {
    let r = $da37ce670175a8d0$var$v(e);
    t.delimiter ??= "/#?", t.prefixes ??= "./";
    let n = `[^${$da37ce670175a8d0$var$S(t.delimiter)}]+?`, o = [], c = 0, l = 0, s = "", i = new Set, a = (h)=>{
        if (l < r.length && r[l].type === h) return r[l++].value;
    }, f = ()=>a("OTHER_MODIFIER") ?? a("ASTERISK"), d = (h)=>{
        let u = a(h);
        if (u !== void 0) return u;
        let { type: p, index: A } = r[l];
        throw new TypeError(`Unexpected ${p} at ${A}, expected ${h}`);
    }, T = ()=>{
        let h = "", u;
        for(; u = a("CHAR") ?? a("ESCAPED_CHAR");)h += u;
        return h;
    }, Se = (h)=>h, L = t.encodePart || Se, I = "", U = (h)=>{
        I += h;
    }, $ = ()=>{
        I.length && (o.push(new $da37ce670175a8d0$var$R(3, "", "", L(I), "", 3)), I = "");
    }, V = (h, u, p, A, Y)=>{
        let g = 3;
        switch(Y){
            case "?":
                g = 1;
                break;
            case "*":
                g = 0;
                break;
            case "+":
                g = 2;
                break;
        }
        if (!u && !p && g === 3) {
            U(h);
            return;
        }
        if ($(), !u && !p) {
            if (!h) return;
            o.push(new $da37ce670175a8d0$var$R(3, "", "", L(h), "", g));
            return;
        }
        let m;
        p ? p === "*" ? m = $da37ce670175a8d0$var$M : m = p : m = n;
        let O = 2;
        m === n ? (O = 1, m = "") : m === $da37ce670175a8d0$var$M && (O = 0, m = "");
        let P;
        if (u ? P = u : p && (P = c++), i.has(P)) throw new TypeError(`Duplicate name '${P}'.`);
        i.add(P), o.push(new $da37ce670175a8d0$var$R(O, P, L(h), m, L(A), g));
    };
    for(; l < r.length;){
        let h = a("CHAR"), u = a("NAME"), p = a("REGEX");
        if (!u && !p && (p = a("ASTERISK")), u || p) {
            let g = h ?? "";
            t.prefixes.indexOf(g) === -1 && (U(g), g = ""), $();
            let m = f();
            V(g, u, p, "", m);
            continue;
        }
        let A = h ?? a("ESCAPED_CHAR");
        if (A) {
            U(A);
            continue;
        }
        if (a("OPEN")) {
            let g = T(), m = a("NAME"), O = a("REGEX");
            !m && !O && (O = a("ASTERISK"));
            let P = T();
            d("CLOSE");
            let xe = f();
            V(g, m, O, P, xe);
            continue;
        }
        $(), d("END");
    }
    return o;
}
function $da37ce670175a8d0$var$S(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function $da37ce670175a8d0$var$X(e) {
    return e && e.ignoreCase ? "ui" : "u";
}
function $da37ce670175a8d0$var$Z(e, t, r) {
    return $da37ce670175a8d0$var$F($da37ce670175a8d0$var$D(e, r), t, r);
}
function $da37ce670175a8d0$var$k(e) {
    switch(e){
        case 0:
            return "*";
        case 1:
            return "?";
        case 2:
            return "+";
        case 3:
            return "";
    }
}
function $da37ce670175a8d0$var$F(e, t, r = {}) {
    r.delimiter ??= "/#?", r.prefixes ??= "./", r.sensitive ??= !1, r.strict ??= !1, r.end ??= !0, r.start ??= !0, r.endsWith = "";
    let n = r.start ? "^" : "";
    for (let s of e){
        if (s.type === 3) {
            s.modifier === 3 ? n += $da37ce670175a8d0$var$S(s.value) : n += `(?:${$da37ce670175a8d0$var$S(s.value)})${$da37ce670175a8d0$var$k(s.modifier)}`;
            continue;
        }
        t && t.push(s.name);
        let i = `[^${$da37ce670175a8d0$var$S(r.delimiter)}]+?`, a = s.value;
        if (s.type === 1 ? a = i : s.type === 0 && (a = $da37ce670175a8d0$var$M), !s.prefix.length && !s.suffix.length) {
            s.modifier === 3 || s.modifier === 1 ? n += `(${a})${$da37ce670175a8d0$var$k(s.modifier)}` : n += `((?:${a})${$da37ce670175a8d0$var$k(s.modifier)})`;
            continue;
        }
        if (s.modifier === 3 || s.modifier === 1) {
            n += `(?:${$da37ce670175a8d0$var$S(s.prefix)}(${a})${$da37ce670175a8d0$var$S(s.suffix)})`, n += $da37ce670175a8d0$var$k(s.modifier);
            continue;
        }
        n += `(?:${$da37ce670175a8d0$var$S(s.prefix)}`, n += `((?:${a})(?:`, n += $da37ce670175a8d0$var$S(s.suffix), n += $da37ce670175a8d0$var$S(s.prefix), n += `(?:${a}))*)${$da37ce670175a8d0$var$S(s.suffix)})`, s.modifier === 0 && (n += "?");
    }
    let o = `[${$da37ce670175a8d0$var$S(r.endsWith)}]|$`, c = `[${$da37ce670175a8d0$var$S(r.delimiter)}]`;
    if (r.end) return r.strict || (n += `${c}?`), r.endsWith.length ? n += `(?=${o})` : n += "$", new RegExp(n, $da37ce670175a8d0$var$X(r));
    r.strict || (n += `(?:${c}(?=${o}))?`);
    let l = !1;
    if (e.length) {
        let s = e[e.length - 1];
        s.type === 3 && s.modifier === 3 && (l = r.delimiter.indexOf(s) > -1);
    }
    return l || (n += `(?=${c}|${o})`), new RegExp(n, $da37ce670175a8d0$var$X(r));
}
var $da37ce670175a8d0$var$x = {
    delimiter: "",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $da37ce670175a8d0$var$B = {
    delimiter: ".",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $da37ce670175a8d0$var$q = {
    delimiter: "/",
    prefixes: "/",
    sensitive: !0,
    strict: !0
};
function $da37ce670175a8d0$var$J(e, t) {
    return e.length ? e[0] === "/" ? !0 : !t || e.length < 2 ? !1 : (e[0] == "\\" || e[0] == "{") && e[1] == "/" : !1;
}
function $da37ce670175a8d0$var$Q(e, t) {
    return e.startsWith(t) ? e.substring(t.length, e.length) : e;
}
function $da37ce670175a8d0$var$Ee(e, t) {
    return e.endsWith(t) ? e.substr(0, e.length - t.length) : e;
}
function $da37ce670175a8d0$var$W(e) {
    return !e || e.length < 2 ? !1 : e[0] === "[" || (e[0] === "\\" || e[0] === "{") && e[1] === "[";
}
var $da37ce670175a8d0$var$ee = [
    "ftp",
    "file",
    "http",
    "https",
    "ws",
    "wss"
];
function $da37ce670175a8d0$var$N(e) {
    if (!e) return !0;
    for (let t of $da37ce670175a8d0$var$ee)if (e.test(t)) return !0;
    return !1;
}
function $da37ce670175a8d0$var$te(e, t) {
    if (e = $da37ce670175a8d0$var$Q(e, "#"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.hash = e, r.hash ? r.hash.substring(1, r.hash.length) : "";
}
function $da37ce670175a8d0$var$re(e, t) {
    if (e = $da37ce670175a8d0$var$Q(e, "?"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.search = e, r.search ? r.search.substring(1, r.search.length) : "";
}
function $da37ce670175a8d0$var$ne(e, t) {
    return t || e === "" ? e : $da37ce670175a8d0$var$W(e) ? $da37ce670175a8d0$var$j(e) : $da37ce670175a8d0$var$z(e);
}
function $da37ce670175a8d0$var$se(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.password = e, r.password;
}
function $da37ce670175a8d0$var$ie(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.username = e, r.username;
}
function $da37ce670175a8d0$var$ae(e, t, r) {
    if (r || e === "") return e;
    if (t && !$da37ce670175a8d0$var$ee.includes(t)) return new URL(`${t}:${e}`).pathname;
    let n = e[0] == "/";
    return e = new URL(n ? e : "/-" + e, "https://example.com").pathname, n || (e = e.substring(2, e.length)), e;
}
function $da37ce670175a8d0$var$oe(e, t, r) {
    return $da37ce670175a8d0$var$_(t) === e && (e = ""), r || e === "" ? e : $da37ce670175a8d0$var$K(e);
}
function $da37ce670175a8d0$var$ce(e, t) {
    return e = $da37ce670175a8d0$var$Ee(e, ":"), t || e === "" ? e : $da37ce670175a8d0$var$y(e);
}
function $da37ce670175a8d0$var$_(e) {
    switch(e){
        case "ws":
        case "http":
            return "80";
        case "wws":
        case "https":
            return "443";
        case "ftp":
            return "21";
        default:
            return "";
    }
}
function $da37ce670175a8d0$var$y(e) {
    if (e === "") return e;
    if (/^[-+.A-Za-z0-9]*$/.test(e)) return e.toLowerCase();
    throw new TypeError(`Invalid protocol '${e}'.`);
}
function $da37ce670175a8d0$var$le(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.username = e, t.username;
}
function $da37ce670175a8d0$var$fe(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.password = e, t.password;
}
function $da37ce670175a8d0$var$z(e) {
    if (e === "") return e;
    if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(e)) throw new TypeError(`Invalid hostname '${e}'`);
    let t = new URL("https://example.com");
    return t.hostname = e, t.hostname;
}
function $da37ce670175a8d0$var$j(e) {
    if (e === "") return e;
    if (/[^0-9a-fA-F[\]:]/g.test(e)) throw new TypeError(`Invalid IPv6 hostname '${e}'`);
    return e.toLowerCase();
}
function $da37ce670175a8d0$var$K(e) {
    if (e === "" || /^[0-9]*$/.test(e) && parseInt(e) <= 65535) return e;
    throw new TypeError(`Invalid port '${e}'.`);
}
function $da37ce670175a8d0$var$he(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.pathname = e[0] !== "/" ? "/-" + e : e, e[0] !== "/" ? t.pathname.substring(2, t.pathname.length) : t.pathname;
}
function $da37ce670175a8d0$var$ue(e) {
    return e === "" ? e : new URL(`data:${e}`).pathname;
}
function $da37ce670175a8d0$var$de(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.search = e, t.search.substring(1, t.search.length);
}
function $da37ce670175a8d0$var$pe(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.hash = e, t.hash.substring(1, t.hash.length);
}
var $da37ce670175a8d0$var$H = class {
    #i;
    #n = [];
    #t = {};
    #e = 0;
    #s = 1;
    #l = 0;
    #o = 0;
    #d = 0;
    #p = 0;
    #g = !1;
    constructor(t){
        this.#i = t;
    }
    get result() {
        return this.#t;
    }
    parse() {
        for(this.#n = $da37ce670175a8d0$var$v(this.#i, !0); this.#e < this.#n.length; this.#e += this.#s){
            if (this.#s = 1, this.#n[this.#e].type === "END") {
                if (this.#o === 0) {
                    this.#b(), this.#f() ? this.#r(9, 1) : this.#h() ? this.#r(8, 1) : this.#r(7, 0);
                    continue;
                } else if (this.#o === 2) {
                    this.#u(5);
                    continue;
                }
                this.#r(10, 0);
                break;
            }
            if (this.#d > 0) {
                if (this.#A()) this.#d -= 1;
                else continue;
            }
            if (this.#T()) {
                this.#d += 1;
                continue;
            }
            switch(this.#o){
                case 0:
                    this.#P() && this.#u(1);
                    break;
                case 1:
                    if (this.#P()) {
                        this.#C();
                        let t = 7, r = 1;
                        this.#E() ? (t = 2, r = 3) : this.#g && (t = 2), this.#r(t, r);
                    }
                    break;
                case 2:
                    this.#S() ? this.#u(3) : (this.#x() || this.#h() || this.#f()) && this.#u(5);
                    break;
                case 3:
                    this.#O() ? this.#r(4, 1) : this.#S() && this.#r(5, 1);
                    break;
                case 4:
                    this.#S() && this.#r(5, 1);
                    break;
                case 5:
                    this.#y() ? this.#p += 1 : this.#w() && (this.#p -= 1), this.#k() && !this.#p ? this.#r(6, 1) : this.#x() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 6:
                    this.#x() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 7:
                    this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 8:
                    this.#f() && this.#r(9, 1);
                    break;
                case 9:
                    break;
                case 10:
                    break;
            }
        }
        this.#t.hostname !== void 0 && this.#t.port === void 0 && (this.#t.port = "");
    }
    #r(t, r) {
        switch(this.#o){
            case 0:
                break;
            case 1:
                this.#t.protocol = this.#c();
                break;
            case 2:
                break;
            case 3:
                this.#t.username = this.#c();
                break;
            case 4:
                this.#t.password = this.#c();
                break;
            case 5:
                this.#t.hostname = this.#c();
                break;
            case 6:
                this.#t.port = this.#c();
                break;
            case 7:
                this.#t.pathname = this.#c();
                break;
            case 8:
                this.#t.search = this.#c();
                break;
            case 9:
                this.#t.hash = this.#c();
                break;
            case 10:
                break;
        }
        this.#o !== 0 && t !== 10 && ([
            1,
            2,
            3,
            4
        ].includes(this.#o) && [
            6,
            7,
            8,
            9
        ].includes(t) && (this.#t.hostname ??= ""), [
            1,
            2,
            3,
            4,
            5,
            6
        ].includes(this.#o) && [
            8,
            9
        ].includes(t) && (this.#t.pathname ??= this.#g ? "/" : ""), [
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ].includes(this.#o) && t === 9 && (this.#t.search ??= "")), this.#R(t, r);
    }
    #R(t, r) {
        this.#o = t, this.#l = this.#e + r, this.#e += r, this.#s = 0;
    }
    #b() {
        this.#e = this.#l, this.#s = 0;
    }
    #u(t) {
        this.#b(), this.#o = t;
    }
    #m(t) {
        return t < 0 && (t = this.#n.length - t), t < this.#n.length ? this.#n[t] : this.#n[this.#n.length - 1];
    }
    #a(t, r) {
        let n = this.#m(t);
        return n.value === r && (n.type === "CHAR" || n.type === "ESCAPED_CHAR" || n.type === "INVALID_CHAR");
    }
    #P() {
        return this.#a(this.#e, ":");
    }
    #E() {
        return this.#a(this.#e + 1, "/") && this.#a(this.#e + 2, "/");
    }
    #S() {
        return this.#a(this.#e, "@");
    }
    #O() {
        return this.#a(this.#e, ":");
    }
    #k() {
        return this.#a(this.#e, ":");
    }
    #x() {
        return this.#a(this.#e, "/");
    }
    #h() {
        if (this.#a(this.#e, "?")) return !0;
        if (this.#n[this.#e].value !== "?") return !1;
        let t = this.#m(this.#e - 1);
        return t.type !== "NAME" && t.type !== "REGEX" && t.type !== "CLOSE" && t.type !== "ASTERISK";
    }
    #f() {
        return this.#a(this.#e, "#");
    }
    #T() {
        return this.#n[this.#e].type == "OPEN";
    }
    #A() {
        return this.#n[this.#e].type == "CLOSE";
    }
    #y() {
        return this.#a(this.#e, "[");
    }
    #w() {
        return this.#a(this.#e, "]");
    }
    #c() {
        let t = this.#n[this.#e], r = this.#m(this.#l).index;
        return this.#i.substring(r, t.index);
    }
    #C() {
        let t = {};
        Object.assign(t, $da37ce670175a8d0$var$x), t.encodePart = $da37ce670175a8d0$var$y;
        let r = $da37ce670175a8d0$var$Z(this.#c(), void 0, t);
        this.#g = $da37ce670175a8d0$var$N(r);
    }
};
var $da37ce670175a8d0$var$G = [
    "protocol",
    "username",
    "password",
    "hostname",
    "port",
    "pathname",
    "search",
    "hash"
], $da37ce670175a8d0$var$E = "*";
function $da37ce670175a8d0$var$ge(e, t) {
    if (typeof e != "string") throw new TypeError("parameter 1 is not of type 'string'.");
    let r = new URL(e, t);
    return {
        protocol: r.protocol.substring(0, r.protocol.length - 1),
        username: r.username,
        password: r.password,
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname,
        search: r.search !== "" ? r.search.substring(1, r.search.length) : void 0,
        hash: r.hash !== "" ? r.hash.substring(1, r.hash.length) : void 0
    };
}
function $da37ce670175a8d0$var$b(e, t) {
    return t ? $da37ce670175a8d0$var$C(e) : e;
}
function $da37ce670175a8d0$var$w(e, t, r) {
    let n;
    if (typeof t.baseURL == "string") try {
        n = new URL(t.baseURL), t.protocol === void 0 && (e.protocol = $da37ce670175a8d0$var$b(n.protocol.substring(0, n.protocol.length - 1), r)), !r && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && (e.username = $da37ce670175a8d0$var$b(n.username, r)), !r && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && t.password === void 0 && (e.password = $da37ce670175a8d0$var$b(n.password, r)), t.protocol === void 0 && t.hostname === void 0 && (e.hostname = $da37ce670175a8d0$var$b(n.hostname, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && (e.port = $da37ce670175a8d0$var$b(n.port, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && (e.pathname = $da37ce670175a8d0$var$b(n.pathname, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && (e.search = $da37ce670175a8d0$var$b(n.search.substring(1, n.search.length), r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && t.hash === void 0 && (e.hash = $da37ce670175a8d0$var$b(n.hash.substring(1, n.hash.length), r));
    } catch  {
        throw new TypeError(`invalid baseURL '${t.baseURL}'.`);
    }
    if (typeof t.protocol == "string" && (e.protocol = $da37ce670175a8d0$var$ce(t.protocol, r)), typeof t.username == "string" && (e.username = $da37ce670175a8d0$var$ie(t.username, r)), typeof t.password == "string" && (e.password = $da37ce670175a8d0$var$se(t.password, r)), typeof t.hostname == "string" && (e.hostname = $da37ce670175a8d0$var$ne(t.hostname, r)), typeof t.port == "string" && (e.port = $da37ce670175a8d0$var$oe(t.port, e.protocol, r)), typeof t.pathname == "string") {
        if (e.pathname = t.pathname, n && !$da37ce670175a8d0$var$J(e.pathname, r)) {
            let o = n.pathname.lastIndexOf("/");
            o >= 0 && (e.pathname = $da37ce670175a8d0$var$b(n.pathname.substring(0, o + 1), r) + e.pathname);
        }
        e.pathname = $da37ce670175a8d0$var$ae(e.pathname, e.protocol, r);
    }
    return typeof t.search == "string" && (e.search = $da37ce670175a8d0$var$re(t.search, r)), typeof t.hash == "string" && (e.hash = $da37ce670175a8d0$var$te(t.hash, r)), e;
}
function $da37ce670175a8d0$var$C(e) {
    return e.replace(/([+*?:{}()\\])/g, "\\$1");
}
function $da37ce670175a8d0$var$Oe(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
function $da37ce670175a8d0$var$ke(e, t) {
    t.delimiter ??= "/#?", t.prefixes ??= "./", t.sensitive ??= !1, t.strict ??= !1, t.end ??= !0, t.start ??= !0, t.endsWith = "";
    let r = ".*", n = `[^${$da37ce670175a8d0$var$Oe(t.delimiter)}]+?`, o = /[$_\u200C\u200D\p{ID_Continue}]/u, c = "";
    for(let l = 0; l < e.length; ++l){
        let s = e[l];
        if (s.type === 3) {
            if (s.modifier === 3) {
                c += $da37ce670175a8d0$var$C(s.value);
                continue;
            }
            c += `{${$da37ce670175a8d0$var$C(s.value)}}${$da37ce670175a8d0$var$k(s.modifier)}`;
            continue;
        }
        let i = s.hasCustomName(), a = !!s.suffix.length || !!s.prefix.length && (s.prefix.length !== 1 || !t.prefixes.includes(s.prefix)), f = l > 0 ? e[l - 1] : null, d = l < e.length - 1 ? e[l + 1] : null;
        if (!a && i && s.type === 1 && s.modifier === 3 && d && !d.prefix.length && !d.suffix.length) {
            if (d.type === 3) {
                let T = d.value.length > 0 ? d.value[0] : "";
                a = o.test(T);
            } else a = !d.hasCustomName();
        }
        if (!a && !s.prefix.length && f && f.type === 3) {
            let T = f.value[f.value.length - 1];
            a = t.prefixes.includes(T);
        }
        a && (c += "{"), c += $da37ce670175a8d0$var$C(s.prefix), i && (c += `:${s.name}`), s.type === 2 ? c += `(${s.value})` : s.type === 1 ? i || (c += `(${n})`) : s.type === 0 && (!i && (!f || f.type === 3 || f.modifier !== 3 || a || s.prefix !== "") ? c += "*" : c += `(${r})`), s.type === 1 && i && s.suffix.length && o.test(s.suffix[0]) && (c += "\\"), c += $da37ce670175a8d0$var$C(s.suffix), a && (c += "}"), s.modifier !== 3 && (c += $da37ce670175a8d0$var$k(s.modifier));
    }
    return c;
}
var $da37ce670175a8d0$export$a348b14d2b61192c = class {
    #i;
    #n = {};
    #t = {};
    #e = {};
    #s = {};
    #l = !1;
    constructor(t = {}, r, n){
        try {
            let o;
            if (typeof r == "string" ? o = r : n = r, typeof t == "string") {
                let i = new $da37ce670175a8d0$var$H(t);
                if (i.parse(), t = i.result, o === void 0 && typeof t.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
                t.baseURL = o;
            } else {
                if (!t || typeof t != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
                if (o) throw new TypeError("parameter 1 is not of type 'string'.");
            }
            typeof n > "u" && (n = {
                ignoreCase: !1
            });
            let c = {
                ignoreCase: n.ignoreCase === !0
            }, l = {
                pathname: $da37ce670175a8d0$var$E,
                protocol: $da37ce670175a8d0$var$E,
                username: $da37ce670175a8d0$var$E,
                password: $da37ce670175a8d0$var$E,
                hostname: $da37ce670175a8d0$var$E,
                port: $da37ce670175a8d0$var$E,
                search: $da37ce670175a8d0$var$E,
                hash: $da37ce670175a8d0$var$E
            };
            this.#i = $da37ce670175a8d0$var$w(l, t, !0), $da37ce670175a8d0$var$_(this.#i.protocol) === this.#i.port && (this.#i.port = "");
            let s;
            for (s of $da37ce670175a8d0$var$G){
                if (!(s in this.#i)) continue;
                let i = {}, a = this.#i[s];
                switch(this.#t[s] = [], s){
                    case "protocol":
                        Object.assign(i, $da37ce670175a8d0$var$x), i.encodePart = $da37ce670175a8d0$var$y;
                        break;
                    case "username":
                        Object.assign(i, $da37ce670175a8d0$var$x), i.encodePart = $da37ce670175a8d0$var$le;
                        break;
                    case "password":
                        Object.assign(i, $da37ce670175a8d0$var$x), i.encodePart = $da37ce670175a8d0$var$fe;
                        break;
                    case "hostname":
                        Object.assign(i, $da37ce670175a8d0$var$B), $da37ce670175a8d0$var$W(a) ? i.encodePart = $da37ce670175a8d0$var$j : i.encodePart = $da37ce670175a8d0$var$z;
                        break;
                    case "port":
                        Object.assign(i, $da37ce670175a8d0$var$x), i.encodePart = $da37ce670175a8d0$var$K;
                        break;
                    case "pathname":
                        $da37ce670175a8d0$var$N(this.#n.protocol) ? (Object.assign(i, $da37ce670175a8d0$var$q, c), i.encodePart = $da37ce670175a8d0$var$he) : (Object.assign(i, $da37ce670175a8d0$var$x, c), i.encodePart = $da37ce670175a8d0$var$ue);
                        break;
                    case "search":
                        Object.assign(i, $da37ce670175a8d0$var$x, c), i.encodePart = $da37ce670175a8d0$var$de;
                        break;
                    case "hash":
                        Object.assign(i, $da37ce670175a8d0$var$x, c), i.encodePart = $da37ce670175a8d0$var$pe;
                        break;
                }
                try {
                    this.#s[s] = $da37ce670175a8d0$var$D(a, i), this.#n[s] = $da37ce670175a8d0$var$F(this.#s[s], this.#t[s], i), this.#e[s] = $da37ce670175a8d0$var$ke(this.#s[s], i), this.#l = this.#l || this.#s[s].some((f)=>f.type === 2);
                } catch  {
                    throw new TypeError(`invalid ${s} pattern '${this.#i[s]}'.`);
                }
            }
        } catch (o) {
            throw new TypeError(`Failed to construct 'URLPattern': ${o.message}`);
        }
    }
    test(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return !1;
        try {
            typeof t == "object" ? n = $da37ce670175a8d0$var$w(n, t, !1) : n = $da37ce670175a8d0$var$w(n, $da37ce670175a8d0$var$ge(t, r), !1);
        } catch  {
            return !1;
        }
        let o;
        for (o of $da37ce670175a8d0$var$G)if (!this.#n[o].exec(n[o])) return !1;
        return !0;
    }
    exec(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return;
        try {
            typeof t == "object" ? n = $da37ce670175a8d0$var$w(n, t, !1) : n = $da37ce670175a8d0$var$w(n, $da37ce670175a8d0$var$ge(t, r), !1);
        } catch  {
            return null;
        }
        let o = {};
        r ? o.inputs = [
            t,
            r
        ] : o.inputs = [
            t
        ];
        let c;
        for (c of $da37ce670175a8d0$var$G){
            let l = this.#n[c].exec(n[c]);
            if (!l) return null;
            let s = {};
            for (let [i, a] of this.#t[c].entries())if (typeof a == "string" || typeof a == "number") {
                let f = l[i + 1];
                s[a] = f;
            }
            o[c] = {
                input: n[c] ?? "",
                groups: s
            };
        }
        return o;
    }
    static compareComponent(t, r, n) {
        let o = (i, a)=>{
            for (let f of [
                "type",
                "modifier",
                "prefix",
                "value",
                "suffix"
            ]){
                if (i[f] < a[f]) return -1;
                if (i[f] === a[f]) continue;
                return 1;
            }
            return 0;
        }, c = new $da37ce670175a8d0$var$R(3, "", "", "", "", 3), l = new $da37ce670175a8d0$var$R(0, "", "", "", "", 3), s = (i, a)=>{
            let f = 0;
            for(; f < Math.min(i.length, a.length); ++f){
                let d = o(i[f], a[f]);
                if (d) return d;
            }
            return i.length === a.length ? 0 : o(i[f] ?? c, a[f] ?? c);
        };
        return !r.#e[t] && !n.#e[t] ? 0 : r.#e[t] && !n.#e[t] ? s(r.#s[t], [
            l
        ]) : !r.#e[t] && n.#e[t] ? s([
            l
        ], n.#s[t]) : s(r.#s[t], n.#s[t]);
    }
    get protocol() {
        return this.#e.protocol;
    }
    get username() {
        return this.#e.username;
    }
    get password() {
        return this.#e.password;
    }
    get hostname() {
        return this.#e.hostname;
    }
    get port() {
        return this.#e.port;
    }
    get pathname() {
        return this.#e.pathname;
    }
    get search() {
        return this.#e.search;
    }
    get hash() {
        return this.#e.hash;
    }
    get hasRegExpGroups() {
        return this.#l;
    }
};


if (!globalThis.URLPattern) globalThis.URLPattern = (0, $da37ce670175a8d0$export$a348b14d2b61192c);



var $1aYx7 = parcelRequire("1aYx7");

var $aM14C = parcelRequire("aM14C");


function $fac22966530e4ab6$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, "__esModule", {
        value: true,
        configurable: true
    });
}
function $fac22966530e4ab6$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$exports = {};
$fac22966530e4ab6$var$$parcel$defineInteropFlag($fac22966530e4ab6$var$$3a2ee75a1759d0d8$exports);
$fac22966530e4ab6$var$$parcel$export($fac22966530e4ab6$var$$3a2ee75a1759d0d8$exports, "History", ()=>$fac22966530e4ab6$export$84202caead5689ba);
$fac22966530e4ab6$var$$parcel$export($fac22966530e4ab6$var$$3a2ee75a1759d0d8$exports, "default", ()=>$fac22966530e4ab6$var$$3a2ee75a1759d0d8$export$2e2bcd8739ae039);
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_a, $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_b;
const { location: $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$location, history: $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$history } = window;
const $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$baseURL = (($fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_a = document.querySelector("base")) === null || $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_a === void 0 ? void 0 : $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_a.href) || $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$location.origin, $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$originalTitle = ($fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_b = document.querySelector("title")) === null || $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_b === void 0 ? void 0 : $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$_b.textContent.trim();
let $fac22966530e4ab6$export$84202caead5689ba = (()=>{
    var _a, _History_path_accessor_storage, _History_oldPath_accessor_storage;
    let _instanceExtraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _oldPath_decorators;
    let _oldPath_initializers = [];
    let _oldPath_extraInitializers = [];
    let _push_decorators;
    return _a = class History {
        get path() {
            return $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet(this, _History_path_accessor_storage, "f");
        }
        set path(value) {
            $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet(this, _History_path_accessor_storage, value, "f");
        }
        get oldPath() {
            return $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet(this, _History_oldPath_accessor_storage, "f");
        }
        set oldPath(value) {
            $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet(this, _History_oldPath_accessor_storage, value, "f");
        }
        constructor(){
            _History_path_accessor_storage.set(this, ($fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _instanceExtraInitializers), $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _path_initializers, void 0)));
            _History_oldPath_accessor_storage.set(this, ($fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _path_extraInitializers), $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _oldPath_initializers, void 0)));
            Object.defineProperty(this, "restore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _oldPath_extraInitializers), ()=>{
                    const { state: state } = $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$history;
                    this.push();
                    document.title = (state === null || state === void 0 ? void 0 : state.title) || this.titleOf() || $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$originalTitle || $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$location.href;
                })
            });
            Object.defineProperty(this, "handleForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event, form)=>{
                    const { method: method, target: target } = form;
                    if (method !== "get" || (target || "_self") !== "_self") return;
                    event.preventDefault();
                    const path = form.getAttribute("action"), data = (0, $1aYx7.buildURLData)((0, $1aYx7.formToJSON)(form));
                    this.push(`${path}?${data}`);
                }
            });
            this.restore();
            window.addEventListener("hashchange", this.restore);
            window.addEventListener("popstate", this.restore);
            document.addEventListener("click", (0, $1aYx7.delegate)("a[href], area[href]", this.handleLink.bind(this)));
            document.addEventListener("submit", (0, $1aYx7.delegate)("form[action]", this.handleForm));
        }
        push(path = $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$location.href) {
            path = path.replace($fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$baseURL, "");
            if (path === this.path) return path;
            this.oldPath = this.path;
            return this.path = path;
        }
        static dataOf(path) {
            const [before, after] = path.split("#");
            return (0, $1aYx7.parseURLData)(after || before);
        }
        static match(pattern, path) {
            var _b;
            if (!path) return;
            const { pathname: pathname, hash: hash } = new URLPattern(pattern, $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$baseURL).exec(new URL(path.split("?")[0], $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$baseURL)) || {};
            return (_b = hash || pathname) === null || _b === void 0 ? void 0 : _b.groups;
        }
        static getTitle(root) {
            return root.title || (0, $1aYx7.getVisibleText)(root);
        }
        titleOf(path = this.path) {
            path = path.replace(/^\//, "");
            if (path) for (const node of document.querySelectorAll(`a[href="${path}"], area[href="${path}"]`)){
                const title = _a.getTitle(node);
                if (title) return title;
            }
        }
        handleLink(event, link) {
            const path = link.getAttribute("href");
            if ((link.target || "_self") !== "_self" || (0, $1aYx7.isXDomain)(path)) return;
            event.preventDefault();
            if (path.startsWith("#")) try {
                if (document.querySelector(path) || path === "#top") return (0, $1aYx7.scrollTo)(path, event.currentTarget);
            } catch (_b) {}
            const title = _a.getTitle(link);
            $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$history.pushState({
                title: title
            }, document.title = title, path);
            this.push(path);
        }
    }, _History_path_accessor_storage = new WeakMap(), _History_oldPath_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _path_decorators = [
            (0, $aM14C.observable)
        ];
        _oldPath_decorators = [
            (0, $aM14C.observable)
        ];
        _push_decorators = [
            (0, $aM14C.action)
        ];
        $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _oldPath_decorators, {
            kind: "accessor",
            name: "oldPath",
            static: false,
            private: false,
            access: {
                has: (obj)=>"oldPath" in obj,
                get: (obj)=>obj.oldPath,
                set: (obj, value)=>{
                    obj.oldPath = value;
                }
            },
            metadata: _metadata
        }, _oldPath_initializers, _oldPath_extraInitializers);
        $fac22966530e4ab6$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _push_decorators, {
            kind: "method",
            name: "push",
            static: false,
            private: false,
            access: {
                has: (obj)=>"push" in obj,
                get: (obj)=>obj.push
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $fac22966530e4ab6$var$$3a2ee75a1759d0d8$export$2e2bcd8739ae039 = new $fac22966530e4ab6$export$84202caead5689ba();
var $fac22966530e4ab6$var$$0e8e8fd52ec9970a$exports = {};
$fac22966530e4ab6$var$$parcel$export($fac22966530e4ab6$var$$0e8e8fd52ec9970a$exports, "CellRoute", ()=>$fac22966530e4ab6$export$d6c529ca17cdd16f);
var $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $fac22966530e4ab6$export$d6c529ca17cdd16f = (()=>{
    var _CellRoute_path_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "cell-route",
            transitible: true
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _get_matched_decorators;
    var CellRoute = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CellRoute_path_accessor_storage.set(this, ($fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _instanceExtraInitializers), $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _path_initializers, void 0)));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _path_extraInitializers)
            });
        }
        get path() {
            return $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRoute_path_accessor_storage, "f");
        }
        set path(value) {
            $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRoute_path_accessor_storage, value, "f");
        }
        get matched() {
            return $fac22966530e4ab6$export$84202caead5689ba.match(this.path, $fac22966530e4ab6$var$$3a2ee75a1759d0d8$export$2e2bcd8739ae039.path);
        }
        render() {
            const { component: Tag, matched: matched } = this, { path: path } = $fac22966530e4ab6$var$$3a2ee75a1759d0d8$export$2e2bcd8739ae039;
            return matched ? (0, $4d842655b16a6eb0$exports.jsx)(Tag, Object.assign({}, matched, $fac22966530e4ab6$export$84202caead5689ba.dataOf(path), {
                path: path,
                history: $fac22966530e4ab6$var$$3a2ee75a1759d0d8$export$2e2bcd8739ae039
            })) : (0, $4d842655b16a6eb0$exports.jsx)((0, $4d842655b16a6eb0$exports.Fragment), {});
        }
    };
    _CellRoute_path_accessor_storage = new WeakMap();
    $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__setFunctionName(_classThis, "CellRoute");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _path_decorators = [
            (0, $658a8f813065c2f1$export$af4b9a83f4b00434),
            (0, $aM14C.observable)
        ];
        _get_matched_decorators = [
            (0, $aM14C.computed)
        ];
        $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_matched_decorators, {
            kind: "getter",
            name: "matched",
            static: false,
            private: false,
            access: {
                has: (obj)=>"matched" in obj,
                get: (obj)=>obj.matched
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CellRoute = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $fac22966530e4ab6$var$$0e8e8fd52ec9970a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CellRoute = _classThis;
})();
var $fac22966530e4ab6$var$$3d03e8579c0b9ff1$exports = {};
var $fac22966530e4ab6$var$$7b488c9460f448a0$exports = {};
$fac22966530e4ab6$var$$parcel$export($fac22966530e4ab6$var$$7b488c9460f448a0$exports, "createRouter", ()=>$fac22966530e4ab6$export$baddd0131ee8c05b);
var $fac22966530e4ab6$var$$7b488c9460f448a0$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $fac22966530e4ab6$export$baddd0131ee8c05b(_a = {}) {
    var { mode: mode = "hash" } = _a, scopeProps = $fac22966530e4ab6$var$$7b488c9460f448a0$var$__rest(_a, [
        "mode"
    ]);
    const prefix = mode === "hash" ? "#" : "";
    return {
        Route: (_a)=>{
            var { path: path } = _a, props = $fac22966530e4ab6$var$$7b488c9460f448a0$var$__rest(_a, [
                "path"
            ]);
            return (0, $4d842655b16a6eb0$exports.jsx)($fac22966530e4ab6$export$d6c529ca17cdd16f, Object.assign({}, props, scopeProps, {
                path: prefix + path
            }));
        },
        Link: (_a)=>{
            var { to: to, children: children } = _a, props = $fac22966530e4ab6$var$$7b488c9460f448a0$var$__rest(_a, [
                "to",
                "children"
            ]);
            return (0, $4d842655b16a6eb0$exports.jsx)("a", Object.assign({}, props, {
                href: prefix + to,
                children: children
            }));
        },
        // @ts-ignore
        Form: (_a)=>{
            var { action: action, children: children } = _a, props = $fac22966530e4ab6$var$$7b488c9460f448a0$var$__rest(_a, [
                "action",
                "children"
            ]);
            return (0, $4d842655b16a6eb0$exports.jsx)("form", Object.assign({}, props, {
                action: prefix + action,
                children: children
            }));
        }
    };
}


var $cb296ebeb08e4c65$exports = {};
$cb296ebeb08e4c65$exports = new URL("WebCell-0.f9823b00.png", import.meta.url).toString();




var $aM14C = parcelRequire("aM14C");

var $7887ccde2f829353$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7887ccde2f829353$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7887ccde2f829353$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $7887ccde2f829353$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7887ccde2f829353$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $7887ccde2f829353$export$bf420caf3cb24263 = (()=>{
    var _CellClock_time_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "cell-clock"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _time_decorators;
    let _time_initializers = [];
    let _time_extraInitializers = [];
    var CellClock = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CellClock_time_accessor_storage.set(this, $7887ccde2f829353$var$__runInitializers(this, _time_initializers, new Date()));
            this.timer = $7887ccde2f829353$var$__runInitializers(this, _time_extraInitializers);
        }
        get time() {
            return $7887ccde2f829353$var$__classPrivateFieldGet(this, _CellClock_time_accessor_storage, "f");
        }
        set time(value) {
            $7887ccde2f829353$var$__classPrivateFieldSet(this, _CellClock_time_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.timer = self.setInterval(()=>this.time = new Date(), 1000);
        }
        disconnectedCallback() {
            clearInterval(this.timer);
        }
        render() {
            const { time: time } = this;
            return (0, $4d842655b16a6eb0$exports.jsx)("time", {
                dateTime: time.toJSON(),
                children: time.toLocaleString()
            });
        }
    };
    _CellClock_time_accessor_storage = new WeakMap();
    $7887ccde2f829353$var$__setFunctionName(_classThis, "CellClock");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _time_decorators = [
            (0, $aM14C.observable)
        ];
        $7887ccde2f829353$var$__esDecorate(_classThis, null, _time_decorators, {
            kind: "accessor",
            name: "time",
            static: false,
            private: false,
            access: {
                has: (obj)=>"time" in obj,
                get: (obj)=>obj.time,
                set: (obj, value)=>{
                    obj.time = value;
                }
            },
            metadata: _metadata
        }, _time_initializers, _time_extraInitializers);
        $7887ccde2f829353$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CellClock = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $7887ccde2f829353$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CellClock = _classThis;
})();



var $457093948543ff32$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $457093948543ff32$export$f7bfe31b45496d55 = (_a)=>{
    var { name: name = "World" } = _a, props = $457093948543ff32$var$__rest(_a, [
        "name"
    ]);
    return (0, $4d842655b16a6eb0$exports.jsxs)("h1", Object.assign({}, props, {
        children: [
            "Hello, ",
            name,
            "!"
        ]
    }));
};





var $aM14C = parcelRequire("aM14C");

var $aM14C = parcelRequire("aM14C");

var $1aYx7 = parcelRequire("1aYx7");
function $65266c53861a64ab$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $65266c53861a64ab$var$$c6af500b4433b08b$exports = {};
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$c6af500b4433b08b$exports, "SpeechSynthesisState", function() {
    return $65266c53861a64ab$export$bf098d6e10b5582a;
});
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$c6af500b4433b08b$exports, "SpeechSynthesisModel", function() {
    return $65266c53861a64ab$export$6c5d58455f3ab236;
});
var $65266c53861a64ab$var$$c6af500b4433b08b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $65266c53861a64ab$var$$c6af500b4433b08b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $65266c53861a64ab$var$$c6af500b4433b08b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $65266c53861a64ab$var$$c6af500b4433b08b$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $65266c53861a64ab$var$$c6af500b4433b08b$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $65266c53861a64ab$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($65266c53861a64ab$export$bf098d6e10b5582a || ($65266c53861a64ab$export$bf098d6e10b5582a = {}));
let $65266c53861a64ab$export$6c5d58455f3ab236 = (()=>{
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    let _instanceExtraInitializers = [];
    let _state_decorators;
    let _state_initializers = [];
    let _state_extraInitializers = [];
    let _get_language_decorators;
    return _a = class SpeechSynthesisModel {
        get state() {
            return $65266c53861a64ab$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
        }
        set state(value) {
            $65266c53861a64ab$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
        }
        get language() {
            var _b, _c;
            return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
        }
        constructor(i18n){
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($65266c53861a64ab$var$$c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $65266c53861a64ab$var$$c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $65266c53861a64ab$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $65266c53861a64ab$var$$c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    var _b;
                    this.state = $65266c53861a64ab$export$bf098d6e10b5582a.Clear;
                    (_b = $65266c53861a64ab$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $65266c53861a64ab$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $aM14C.reaction)(()=>i18n.currentLanguage, this.clear), "f");
            globalThis.addEventListener("unload", this.clear);
        }
        static getVoices() {
            const voices = speechSynthesis.getVoices();
            return voices[0] ? Promise.resolve(voices) : new Promise((resolve)=>{
                (0, $1aYx7.sleep)(1).then(()=>resolve([]));
                speechSynthesis.onvoiceschanged = ()=>resolve(speechSynthesis.getVoices());
            });
        }
        speak(text) {
            return $65266c53861a64ab$var$$c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function*() {
                const { language: language } = this, content = new SpeechSynthesisUtterance(text), voices = yield _a.getVoices();
                content.voice = voices.find(({ localService: localService, lang: lang })=>localService && lang === language) || voices.find(({ default: backup })=>backup);
                const result = new Promise((resolve, reject)=>{
                    content.onend = resolve;
                    content.onerror = reject;
                });
                speechSynthesis.speak(content);
                this.state = $65266c53861a64ab$export$bf098d6e10b5582a.Speaking;
                try {
                    yield result;
                } finally{
                    this.clear();
                }
            });
        }
        toggle() {
            if (this.state === $65266c53861a64ab$export$bf098d6e10b5582a.Speaking) {
                speechSynthesis.pause();
                this.state = $65266c53861a64ab$export$bf098d6e10b5582a.Pause;
            } else {
                speechSynthesis.resume();
                this.state = $65266c53861a64ab$export$bf098d6e10b5582a.Speaking;
            }
        }
        static *walk(range) {
            const { commonAncestorContainer: commonAncestorContainer, endContainer: endContainer } = range;
            const walker = document.createNodeIterator(commonAncestorContainer);
            var current;
            while(current = walker.nextNode()){
                if (range.intersectsNode(current)) yield current;
                if (commonAncestorContainer !== endContainer && current === endContainer) break;
            }
        }
        static getSelectedText(box) {
            var _b;
            const range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
            if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError("No text selected");
            return [
                ...this.walk(range)
            ].filter(({ nodeType: nodeType, parentNode: parentNode })=>{
                if (nodeType !== 3) return;
                const { width: width, height: height } = parentNode.getBoundingClientRect();
                return width && height;
            }).map(({ nodeValue: nodeValue }, index, { length: length })=>nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity)).filter((text)=>text.trim()).join("").trim();
        }
        static getReadableText(box) {
            try {
                return this.getSelectedText(box);
            } catch (_b) {
                return (0, $1aYx7.getVisibleText)(box);
            }
        }
    }, _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $aM14C.observable)
        ];
        _get_language_decorators = [
            (0, $aM14C.computed)
        ];
        $65266c53861a64ab$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: (obj)=>"state" in obj,
                get: (obj)=>obj.state,
                set: (obj, value)=>{
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $65266c53861a64ab$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: (obj)=>"language" in obj,
                get: (obj)=>obj.language
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $65266c53861a64ab$var$$d1a4b21e19b1b67c$exports = {};
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$d1a4b21e19b1b67c$exports, "TranslationModel", function() {
    return $65266c53861a64ab$export$d91823dfc159395b;
});
var $65266c53861a64ab$var$$552a56cc5ff3f479$exports = {};
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $65266c53861a64ab$export$df0b442c7f8df5c1;
});
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $65266c53861a64ab$export$d977f7cd0cb45fe1;
});
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$552a56cc5ff3f479$exports, "parseCookie", function() {
    return $65266c53861a64ab$export$d0eaf3e94be578f6;
});
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$552a56cc5ff3f479$exports, "setCookie", function() {
    return $65266c53861a64ab$export$110700823644f4a6;
});
$65266c53861a64ab$var$$parcel$export($65266c53861a64ab$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $65266c53861a64ab$export$2557e81a557a81ea;
});
const $65266c53861a64ab$export$df0b442c7f8df5c1 = (raw = "")=>new RegExp("\\p{N}", "u").test(raw) || new RegExp("\\p{Ll}", "u").test(raw.toLowerCase());
const $65266c53861a64ab$export$d977f7cd0cb45fe1 = (...parts)=>parts.map((raw, index)=>{
        var _a;
        const isNL = $65266c53861a64ab$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        const diff = isNL !== $65266c53861a64ab$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? " " : "");
    }).join("");
const $65266c53861a64ab$export$d0eaf3e94be578f6 = (value = globalThis.document.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split("="))) : {};
function $65266c53861a64ab$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === "boolean" ? value ? key : "" : `${key}=${value}`).filter(Boolean).join("; ");
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
const $65266c53861a64ab$export$2557e81a557a81ea = (value)=>value.split(",").map((language)=>{
        const [name, quantity = ""] = language.split(";");
        const [_, value = "1"] = quantity.split("=");
        return [
            name.trim(),
            +value
        ];
    }).sort(([_, a], [__, b])=>b - a).map(([name])=>name);
var $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $65266c53861a64ab$export$d91823dfc159395b = (()=>{
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    let _instanceExtraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _currentLanguage_decorators;
    let _currentLanguage_initializers = [];
    let _currentLanguage_extraInitializers = [];
    let _currentMap_decorators;
    let _currentMap_initializers = [];
    let _currentMap_extraInitializers = [];
    let _get_defaultMap_decorators;
    let _changeLanguage_decorators;
    return _a = class TranslationModel {
        get loading() {
            return $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
        }
        set loading(value) {
            $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
        }
        get currentLanguage() {
            return $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
        }
        set currentLanguage(value) {
            $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
        }
        get currentMap() {
            return $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
        }
        set currentMap(value) {
            $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
        }
        get defaultMap() {
            return this.configuration[this.defaultLanguage];
        }
        constructor(configuration){
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers)
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ""));
            _TranslationModel_currentMap_accessor_storage.set(this, ($65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(const name in configuration)if (typeof configuration[name] !== "function") this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError("One static language map is required");
            if (!globalThis.window) return;
            const languages = [
                $65266c53861a64ab$export$d0eaf3e94be578f6().language,
                ...navigator.languages || [
                    this.defaultLanguage
                ]
            ].filter(Boolean);
            this.loadLanguages(languages);
            window.addEventListener("languagechange", ()=>this.changeLanguage(navigator.language));
        }
        onLanguageChange(handler) {
            (0, $aM14C.reaction)(()=>this.currentLanguage, (currentLanguage, lastLanguage)=>{
                if (lastLanguage) handler.call(this, currentLanguage);
            });
        }
        setLanguage(name) {
            var _b;
            this.currentLanguage = name;
            if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) $65266c53861a64ab$export$110700823644f4a6("language", document.documentElement.lang = name, {
                path: "/"
            });
        }
        changeLanguage(name) {
            return $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                const language = this.configuration[name];
                if (typeof language !== "function") {
                    this.setLanguage(name);
                    return this.currentMap = language;
                }
                this.loading = true;
                const { default: map } = yield language();
                this.loading = false;
                this.setLanguage(name);
                return this.currentMap = this.configuration[name] = map;
            });
        }
        loadLanguages(names) {
            return $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                const languages = Object.keys(this.configuration).sort(({ length: a }, { length: b })=>b - a);
                for (const name of names){
                    const language = languages.includes(name) ? name : languages.find((language)=>name.startsWith(language) || language.startsWith(name));
                    if (language) try {
                        return yield this.changeLanguage(language);
                    } catch (_b) {}
                }
                return this.changeLanguage(this.defaultLanguage);
            });
        }
        textOf(key, data) {
            const value = this.currentMap[key] || this.defaultMap[key];
            if (typeof value !== "function") return value;
            if (!data) throw ReferenceError("Input data is required for Translation Resolver");
            return value(data);
        }
    }, _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $aM14C.observable)
        ];
        _currentLanguage_decorators = [
            (0, $aM14C.observable)
        ];
        _currentMap_decorators = [
            (0, $aM14C.observable)
        ];
        _get_defaultMap_decorators = [
            (0, $aM14C.computed)
        ];
        _changeLanguage_decorators = [
            (0, $aM14C.action)
        ];
        $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentLanguage" in obj,
                get: (obj)=>obj.currentLanguage,
                set: (obj, value)=>{
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentMap" in obj,
                get: (obj)=>obj.currentMap,
                set: (obj, value)=>{
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defaultMap" in obj,
                get: (obj)=>obj.defaultMap
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $65266c53861a64ab$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _changeLanguage_decorators, {
            kind: "method",
            name: "changeLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"changeLanguage" in obj,
                get: (obj)=>obj.changeLanguage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();






var $1aYx7 = parcelRequire("1aYx7");
var $d1b4eb187dad9a3b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d1b4eb187dad9a3b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d1b4eb187dad9a3b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d1b4eb187dad9a3b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $d1b4eb187dad9a3b$export$ea4bacb7eec73803 = (()=>{
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "camera-view",
            mode: "open"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var CameraView = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            this.cssCode = (0, $1aYx7.stringifyCSS)({
                ":host": {
                    display: "block"
                },
                video: {
                    width: "100%",
                    height: "100%"
                }
            });
            this.handleCapture = (event)=>$d1b4eb187dad9a3b$var$__awaiter(this, void 0, void 0, function*() {
                    const video = event.currentTarget;
                    if (video.paused) return video.play();
                    video.pause();
                    const { width: width, height: height } = getComputedStyle(video);
                    const canvas = new OffscreenCanvas(parseFloat(width), parseFloat(height));
                    const context = canvas.getContext("2d");
                    context.drawImage(video, 0, 0);
                    const blob = yield canvas.convertToBlob();
                    this.emit("capture", blob);
                });
        }
        init(video) {
            return $d1b4eb187dad9a3b$var$__awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: "environment",
                        width: {
                            ideal: 1280
                        },
                        height: {
                            ideal: 720
                        }
                    }
                });
                video.srcObject = stream;
                video.play();
            });
        }
        render() {
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $4d842655b16a6eb0$exports.Fragment), {
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("style", {
                        children: this.cssCode
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("video", {
                        ref: this.init,
                        onClick: this.handleCapture
                    })
                ]
            });
        }
    };
    $d1b4eb187dad9a3b$var$__setFunctionName(_classThis, "CameraView");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $d1b4eb187dad9a3b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CameraView = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $d1b4eb187dad9a3b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CameraView = _classThis;
})();



var $aM14C = parcelRequire("aM14C");

var $aM14C = parcelRequire("aM14C");

var $1aYx7 = parcelRequire("1aYx7");
var $9f9ad051847c8abe$exports = {};

$parcel$export($9f9ad051847c8abe$exports, "promisifyRequest", () => $9f9ad051847c8abe$export$b327150396135fe7);
$parcel$export($9f9ad051847c8abe$exports, "createStore", () => $9f9ad051847c8abe$export$f51a9068ac82ea43);
$parcel$export($9f9ad051847c8abe$exports, "get", () => $9f9ad051847c8abe$export$3988ae62b71be9a3);
$parcel$export($9f9ad051847c8abe$exports, "set", () => $9f9ad051847c8abe$export$adaa4cf7ef1b65be);
$parcel$export($9f9ad051847c8abe$exports, "setMany", () => $9f9ad051847c8abe$export$daa0a5170277c7a8);
$parcel$export($9f9ad051847c8abe$exports, "getMany", () => $9f9ad051847c8abe$export$5df405cccea42673);
$parcel$export($9f9ad051847c8abe$exports, "update", () => $9f9ad051847c8abe$export$722fbec263ad908a);
$parcel$export($9f9ad051847c8abe$exports, "del", () => $9f9ad051847c8abe$export$1d2f21e549771e67);
$parcel$export($9f9ad051847c8abe$exports, "delMany", () => $9f9ad051847c8abe$export$c8aa84257229cac8);
$parcel$export($9f9ad051847c8abe$exports, "clear", () => $9f9ad051847c8abe$export$42ffd38884aecdac);
$parcel$export($9f9ad051847c8abe$exports, "keys", () => $9f9ad051847c8abe$export$ed97f33186d4b816);
$parcel$export($9f9ad051847c8abe$exports, "values", () => $9f9ad051847c8abe$export$68c286be0e7e55b7);
$parcel$export($9f9ad051847c8abe$exports, "entries", () => $9f9ad051847c8abe$export$3e9f948b41964866);
function $9f9ad051847c8abe$var$_slicedToArray(arr, i) {
    return $9f9ad051847c8abe$var$_arrayWithHoles(arr) || $9f9ad051847c8abe$var$_iterableToArrayLimit(arr, i) || $9f9ad051847c8abe$var$_unsupportedIterableToArray(arr, i) || $9f9ad051847c8abe$var$_nonIterableRest();
}
function $9f9ad051847c8abe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9f9ad051847c8abe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9f9ad051847c8abe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9f9ad051847c8abe$var$_arrayLikeToArray(o, minLen);
}
function $9f9ad051847c8abe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9f9ad051847c8abe$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9f9ad051847c8abe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9f9ad051847c8abe$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $9f9ad051847c8abe$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $9f9ad051847c8abe$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $9f9ad051847c8abe$var$defaultGetStoreFunc;
function $9f9ad051847c8abe$var$defaultGetStore() {
    if (!$9f9ad051847c8abe$var$defaultGetStoreFunc) $9f9ad051847c8abe$var$defaultGetStoreFunc = $9f9ad051847c8abe$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $9f9ad051847c8abe$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $9f9ad051847c8abe$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $9f9ad051847c8abe$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($9f9ad051847c8abe$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
function $9f9ad051847c8abe$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $9f9ad051847c8abe$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $9f9ad051847c8abe$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $9f9ad051847c8abe$export$b327150396135fe7(store.getAll());
        var items = [];
        return $9f9ad051847c8abe$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $9f9ad051847c8abe$export$b327150396135fe7(store.getAllKeys()),
            $9f9ad051847c8abe$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $9f9ad051847c8abe$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $9f9ad051847c8abe$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


var $31af1400a13a9390$exports = {};
"use strict";
"use strict";
"use strict";
var $5cebaf28941ec4e5$exports = {};
"use strict";
var $321821ab316477fa$exports = {};
"use strict";
var $321821ab316477fa$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$321821ab316477fa$exports = // eslint-disable-next-line es/no-global-this -- safe
$321821ab316477fa$var$check(typeof globalThis == "object" && globalThis) || $321821ab316477fa$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$321821ab316477fa$var$check(typeof self == "object" && self) || $321821ab316477fa$var$check(typeof $parcel$global == "object" && $parcel$global) || $321821ab316477fa$var$check(typeof $321821ab316477fa$exports == "object" && $321821ab316477fa$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $9eba49c84552505c$export$2d1720544b23b823;
"use strict";
var $662220f635148e9e$exports = {};
"use strict";
var $bc4867304bac101c$exports = {};
"use strict";
$bc4867304bac101c$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$662220f635148e9e$exports = !$bc4867304bac101c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $95617c3e1592e9a7$exports = {};
"use strict";
var $4942706a8bbbc2b1$exports = {};
"use strict";

$4942706a8bbbc2b1$exports = !$bc4867304bac101c$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $95617c3e1592e9a7$var$call = Function.prototype.call;
$95617c3e1592e9a7$exports = $4942706a8bbbc2b1$exports ? $95617c3e1592e9a7$var$call.bind($95617c3e1592e9a7$var$call) : function() {
    return $95617c3e1592e9a7$var$call.apply($95617c3e1592e9a7$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $81acc0a8b4647c22$export$2d1720544b23b823;
"use strict";
var $81acc0a8b4647c22$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81acc0a8b4647c22$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $81acc0a8b4647c22$var$NASHORN_BUG = $81acc0a8b4647c22$var$getOwnPropertyDescriptor && !$81acc0a8b4647c22$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$81acc0a8b4647c22$export$2d1720544b23b823 = $81acc0a8b4647c22$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $81acc0a8b4647c22$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $81acc0a8b4647c22$var$$propertyIsEnumerable;


var $6854d5e41e583d71$exports = {};
"use strict";
$6854d5e41e583d71$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $6dde291a20368b2f$exports = {};
"use strict";
var $7566f357ab2c63f5$exports = {};
"use strict";
var $2bec4c654af9cae3$exports = {};
"use strict";

var $2bec4c654af9cae3$var$FunctionPrototype = Function.prototype;
var $2bec4c654af9cae3$var$call = $2bec4c654af9cae3$var$FunctionPrototype.call;
var $2bec4c654af9cae3$var$uncurryThisWithBind = $4942706a8bbbc2b1$exports && $2bec4c654af9cae3$var$FunctionPrototype.bind.bind($2bec4c654af9cae3$var$call, $2bec4c654af9cae3$var$call);
$2bec4c654af9cae3$exports = $4942706a8bbbc2b1$exports ? $2bec4c654af9cae3$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $2bec4c654af9cae3$var$call.apply(fn, arguments);
    };
};



var $054635c9948980fc$exports = {};
"use strict";

var $054635c9948980fc$var$toString = $2bec4c654af9cae3$exports({}.toString);
var $054635c9948980fc$var$stringSlice = $2bec4c654af9cae3$exports("".slice);
$054635c9948980fc$exports = function(it) {
    return $054635c9948980fc$var$stringSlice($054635c9948980fc$var$toString(it), 8, -1);
};


var $7566f357ab2c63f5$var$$Object = Object;
var $7566f357ab2c63f5$var$split = $2bec4c654af9cae3$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$7566f357ab2c63f5$exports = $bc4867304bac101c$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$7566f357ab2c63f5$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $054635c9948980fc$exports(it) === "String" ? $7566f357ab2c63f5$var$split(it, "") : $7566f357ab2c63f5$var$$Object(it);
} : $7566f357ab2c63f5$var$$Object;


var $3c987812112845db$exports = {};
"use strict";
var $e922e6344cadecfd$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$e922e6344cadecfd$exports = function(it) {
    return it === null || it === undefined;
};


var $3c987812112845db$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$3c987812112845db$exports = function(it) {
    if ($e922e6344cadecfd$exports(it)) throw new $3c987812112845db$var$$TypeError("Can't call method on " + it);
    return it;
};


$6dde291a20368b2f$exports = function(it) {
    return $7566f357ab2c63f5$exports($3c987812112845db$exports(it));
};


var $038db1c53a328128$exports = {};
"use strict";
var $e409f7e30edc1d9d$exports = {};
"use strict";

var $c989e06804ef7492$exports = {};
"use strict";
var $9db74248a53aaffc$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $9db74248a53aaffc$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$9db74248a53aaffc$exports = typeof $9db74248a53aaffc$var$documentAll == "undefined" && $9db74248a53aaffc$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $9db74248a53aaffc$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$c989e06804ef7492$exports = function(it) {
    return typeof it == "object" ? it !== null : $9db74248a53aaffc$exports(it);
};


var $1e71f34f7060b1d1$exports = {};
"use strict";
var $468e1877ee71c3bf$exports = {};
"use strict";


var $468e1877ee71c3bf$var$aFunction = function(argument) {
    return $9db74248a53aaffc$exports(argument) ? argument : undefined;
};
$468e1877ee71c3bf$exports = function(namespace, method) {
    return arguments.length < 2 ? $468e1877ee71c3bf$var$aFunction($321821ab316477fa$exports[namespace]) : $321821ab316477fa$exports[namespace] && $321821ab316477fa$exports[namespace][method];
};



var $a1c5b000dc4b288b$exports = {};
"use strict";

$a1c5b000dc4b288b$exports = $2bec4c654af9cae3$exports({}.isPrototypeOf);


var $865c3065e9b68027$exports = {};
"use strict";
var $403174526970b3f2$exports = {};
"use strict";
var $e72f88ba60a79d93$exports = {};
"use strict";

var $f71d06fbcf6e0bb5$exports = {};
"use strict";

var $f71d06fbcf6e0bb5$var$navigator = $321821ab316477fa$exports.navigator;
var $f71d06fbcf6e0bb5$var$userAgent = $f71d06fbcf6e0bb5$var$navigator && $f71d06fbcf6e0bb5$var$navigator.userAgent;
$f71d06fbcf6e0bb5$exports = $f71d06fbcf6e0bb5$var$userAgent ? String($f71d06fbcf6e0bb5$var$userAgent) : "";


var $e72f88ba60a79d93$var$process = $321821ab316477fa$exports.process;
var $e72f88ba60a79d93$var$Deno = $321821ab316477fa$exports.Deno;
var $e72f88ba60a79d93$var$versions = $e72f88ba60a79d93$var$process && $e72f88ba60a79d93$var$process.versions || $e72f88ba60a79d93$var$Deno && $e72f88ba60a79d93$var$Deno.version;
var $e72f88ba60a79d93$var$v8 = $e72f88ba60a79d93$var$versions && $e72f88ba60a79d93$var$versions.v8;
var $e72f88ba60a79d93$var$match, $e72f88ba60a79d93$var$version;
if ($e72f88ba60a79d93$var$v8) {
    $e72f88ba60a79d93$var$match = $e72f88ba60a79d93$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e72f88ba60a79d93$var$version = $e72f88ba60a79d93$var$match[0] > 0 && $e72f88ba60a79d93$var$match[0] < 4 ? 1 : +($e72f88ba60a79d93$var$match[0] + $e72f88ba60a79d93$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e72f88ba60a79d93$var$version && $f71d06fbcf6e0bb5$exports) {
    $e72f88ba60a79d93$var$match = $f71d06fbcf6e0bb5$exports.match(/Edge\/(\d+)/);
    if (!$e72f88ba60a79d93$var$match || $e72f88ba60a79d93$var$match[1] >= 74) {
        $e72f88ba60a79d93$var$match = $f71d06fbcf6e0bb5$exports.match(/Chrome\/(\d+)/);
        if ($e72f88ba60a79d93$var$match) $e72f88ba60a79d93$var$version = +$e72f88ba60a79d93$var$match[1];
    }
}
$e72f88ba60a79d93$exports = $e72f88ba60a79d93$var$version;




var $403174526970b3f2$var$$String = $321821ab316477fa$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$403174526970b3f2$exports = !!Object.getOwnPropertySymbols && !$bc4867304bac101c$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$403174526970b3f2$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $e72f88ba60a79d93$exports && $e72f88ba60a79d93$exports < 41;
});


$865c3065e9b68027$exports = $403174526970b3f2$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $1e71f34f7060b1d1$var$$Object = Object;
$1e71f34f7060b1d1$exports = $865c3065e9b68027$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $468e1877ee71c3bf$exports("Symbol");
    return $9db74248a53aaffc$exports($Symbol) && $a1c5b000dc4b288b$exports($Symbol.prototype, $1e71f34f7060b1d1$var$$Object(it));
};


var $a5a2983e8d4c2cc9$exports = {};
"use strict";
var $35fd29c4b881594d$exports = {};
"use strict";

var $3474e834edbef1ad$exports = {};
"use strict";
var $3474e834edbef1ad$var$$String = String;
$3474e834edbef1ad$exports = function(argument) {
    try {
        return $3474e834edbef1ad$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $35fd29c4b881594d$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$35fd29c4b881594d$exports = function(argument) {
    if ($9db74248a53aaffc$exports(argument)) return argument;
    throw new $35fd29c4b881594d$var$$TypeError($3474e834edbef1ad$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$a5a2983e8d4c2cc9$exports = function(V, P) {
    var func = V[P];
    return $e922e6344cadecfd$exports(func) ? undefined : $35fd29c4b881594d$exports(func);
};


var $dd225e4303dd866d$exports = {};
"use strict";



var $dd225e4303dd866d$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$dd225e4303dd866d$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $9db74248a53aaffc$exports(fn = input.toString) && !$c989e06804ef7492$exports(val = $95617c3e1592e9a7$exports(fn, input))) return val;
    if ($9db74248a53aaffc$exports(fn = input.valueOf) && !$c989e06804ef7492$exports(val = $95617c3e1592e9a7$exports(fn, input))) return val;
    if (pref !== "string" && $9db74248a53aaffc$exports(fn = input.toString) && !$c989e06804ef7492$exports(val = $95617c3e1592e9a7$exports(fn, input))) return val;
    throw new $dd225e4303dd866d$var$$TypeError("Can't convert object to primitive value");
};


var $52dcd2f12662ee00$exports = {};
"use strict";

var $56ca3d0fdf4ecfb7$exports = {};
"use strict";
var $49985cb207407415$exports = {};
"use strict";
var $3a92d99f6c30b995$exports = {};
"use strict";
$3a92d99f6c30b995$exports = false;



var $02945691cb8d57a8$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $02945691cb8d57a8$var$defineProperty = Object.defineProperty;
$02945691cb8d57a8$exports = function(key, value) {
    try {
        $02945691cb8d57a8$var$defineProperty($321821ab316477fa$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $321821ab316477fa$exports[key] = value;
    }
    return value;
};


var $49985cb207407415$var$SHARED = "__core-js_shared__";
var $49985cb207407415$var$store = $49985cb207407415$exports = $321821ab316477fa$exports[$49985cb207407415$var$SHARED] || $02945691cb8d57a8$exports($49985cb207407415$var$SHARED, {});
($49985cb207407415$var$store.versions || ($49985cb207407415$var$store.versions = [])).push({
    version: "3.38.1",
    mode: $3a92d99f6c30b995$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$56ca3d0fdf4ecfb7$exports = function(key, value) {
    return $49985cb207407415$exports[key] || ($49985cb207407415$exports[key] = value || {});
};


var $afe7abd14249b56c$exports = {};
"use strict";

var $851542d85ae21a90$exports = {};
"use strict";

var $851542d85ae21a90$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$851542d85ae21a90$exports = function(argument) {
    return $851542d85ae21a90$var$$Object($3c987812112845db$exports(argument));
};


var $afe7abd14249b56c$var$hasOwnProperty = $2bec4c654af9cae3$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$afe7abd14249b56c$exports = Object.hasOwn || function hasOwn(it, key) {
    return $afe7abd14249b56c$var$hasOwnProperty($851542d85ae21a90$exports(it), key);
};


var $374c164acb0b3685$exports = {};
"use strict";

var $374c164acb0b3685$var$id = 0;
var $374c164acb0b3685$var$postfix = Math.random();
var $374c164acb0b3685$var$toString = $2bec4c654af9cae3$exports(1.0.toString);
$374c164acb0b3685$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $374c164acb0b3685$var$toString(++$374c164acb0b3685$var$id + $374c164acb0b3685$var$postfix, 36);
};




var $52dcd2f12662ee00$var$Symbol = $321821ab316477fa$exports.Symbol;
var $52dcd2f12662ee00$var$WellKnownSymbolsStore = $56ca3d0fdf4ecfb7$exports("wks");
var $52dcd2f12662ee00$var$createWellKnownSymbol = $865c3065e9b68027$exports ? $52dcd2f12662ee00$var$Symbol["for"] || $52dcd2f12662ee00$var$Symbol : $52dcd2f12662ee00$var$Symbol && $52dcd2f12662ee00$var$Symbol.withoutSetter || $374c164acb0b3685$exports;
$52dcd2f12662ee00$exports = function(name) {
    if (!$afe7abd14249b56c$exports($52dcd2f12662ee00$var$WellKnownSymbolsStore, name)) $52dcd2f12662ee00$var$WellKnownSymbolsStore[name] = $403174526970b3f2$exports && $afe7abd14249b56c$exports($52dcd2f12662ee00$var$Symbol, name) ? $52dcd2f12662ee00$var$Symbol[name] : $52dcd2f12662ee00$var$createWellKnownSymbol("Symbol." + name);
    return $52dcd2f12662ee00$var$WellKnownSymbolsStore[name];
};


var $e409f7e30edc1d9d$var$$TypeError = TypeError;
var $e409f7e30edc1d9d$var$TO_PRIMITIVE = $52dcd2f12662ee00$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$e409f7e30edc1d9d$exports = function(input, pref) {
    if (!$c989e06804ef7492$exports(input) || $1e71f34f7060b1d1$exports(input)) return input;
    var exoticToPrim = $a5a2983e8d4c2cc9$exports(input, $e409f7e30edc1d9d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $95617c3e1592e9a7$exports(exoticToPrim, input, pref);
        if (!$c989e06804ef7492$exports(result) || $1e71f34f7060b1d1$exports(result)) return result;
        throw new $e409f7e30edc1d9d$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $dd225e4303dd866d$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$038db1c53a328128$exports = function(argument) {
    var key = $e409f7e30edc1d9d$exports(argument, "string");
    return $1e71f34f7060b1d1$exports(key) ? key : key + "";
};



var $87fc7d3333b61432$exports = {};
"use strict";


var $4825d048b09f0d5e$exports = {};
"use strict";


var $4825d048b09f0d5e$var$document = $321821ab316477fa$exports.document;
// typeof document.createElement is 'object' in old IE
var $4825d048b09f0d5e$var$EXISTS = $c989e06804ef7492$exports($4825d048b09f0d5e$var$document) && $c989e06804ef7492$exports($4825d048b09f0d5e$var$document.createElement);
$4825d048b09f0d5e$exports = function(it) {
    return $4825d048b09f0d5e$var$EXISTS ? $4825d048b09f0d5e$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$87fc7d3333b61432$exports = !$662220f635148e9e$exports && !$bc4867304bac101c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($4825d048b09f0d5e$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9eba49c84552505c$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$9eba49c84552505c$export$2d1720544b23b823 = $662220f635148e9e$exports ? $9eba49c84552505c$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $6dde291a20368b2f$exports(O);
    P = $038db1c53a328128$exports(P);
    if ($87fc7d3333b61432$exports) try {
        return $9eba49c84552505c$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($afe7abd14249b56c$exports(O, P)) return $6854d5e41e583d71$exports(!$95617c3e1592e9a7$exports($81acc0a8b4647c22$export$2d1720544b23b823, O, P), O[P]);
};


var $5cebaf28941ec4e5$require$getOwnPropertyDescriptor = $9eba49c84552505c$export$2d1720544b23b823;
var $63d3184036d668c6$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $8508f7795b5ab674$export$2d1720544b23b823;
"use strict";


var $cce7bd3ae9993088$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$cce7bd3ae9993088$exports = $662220f635148e9e$exports && $bc4867304bac101c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $e524200f7829c91a$exports = {};
"use strict";

var $e524200f7829c91a$var$$String = String;
var $e524200f7829c91a$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$e524200f7829c91a$exports = function(argument) {
    if ($c989e06804ef7492$exports(argument)) return argument;
    throw new $e524200f7829c91a$var$$TypeError($e524200f7829c91a$var$$String(argument) + " is not an object");
};



var $8508f7795b5ab674$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $8508f7795b5ab674$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8508f7795b5ab674$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8508f7795b5ab674$var$ENUMERABLE = "enumerable";
var $8508f7795b5ab674$var$CONFIGURABLE = "configurable";
var $8508f7795b5ab674$var$WRITABLE = "writable";
$8508f7795b5ab674$export$2d1720544b23b823 = $662220f635148e9e$exports ? $cce7bd3ae9993088$exports ? function defineProperty(O, P, Attributes) {
    $e524200f7829c91a$exports(O);
    P = $038db1c53a328128$exports(P);
    $e524200f7829c91a$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $8508f7795b5ab674$var$WRITABLE in Attributes && !Attributes[$8508f7795b5ab674$var$WRITABLE]) {
        var current = $8508f7795b5ab674$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$8508f7795b5ab674$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $8508f7795b5ab674$var$CONFIGURABLE in Attributes ? Attributes[$8508f7795b5ab674$var$CONFIGURABLE] : current[$8508f7795b5ab674$var$CONFIGURABLE],
                enumerable: $8508f7795b5ab674$var$ENUMERABLE in Attributes ? Attributes[$8508f7795b5ab674$var$ENUMERABLE] : current[$8508f7795b5ab674$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $8508f7795b5ab674$var$$defineProperty(O, P, Attributes);
} : $8508f7795b5ab674$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $e524200f7829c91a$exports(O);
    P = $038db1c53a328128$exports(P);
    $e524200f7829c91a$exports(Attributes);
    if ($87fc7d3333b61432$exports) try {
        return $8508f7795b5ab674$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $8508f7795b5ab674$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$63d3184036d668c6$exports = $662220f635148e9e$exports ? function(object, key, value) {
    return $8508f7795b5ab674$export$2d1720544b23b823(object, key, $6854d5e41e583d71$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $1675d88d56a1053c$exports = {};
"use strict";


var $77c1236bf6ec69fc$exports = {};
"use strict";





var $bec6e0be9e23b3ad$exports = {};
"use strict";


var $bec6e0be9e23b3ad$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bec6e0be9e23b3ad$var$getDescriptor = $662220f635148e9e$exports && Object.getOwnPropertyDescriptor;
var $bec6e0be9e23b3ad$var$EXISTS = $afe7abd14249b56c$exports($bec6e0be9e23b3ad$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $bec6e0be9e23b3ad$var$PROPER = $bec6e0be9e23b3ad$var$EXISTS && (function something() {}).name === "something";
var $bec6e0be9e23b3ad$var$CONFIGURABLE = $bec6e0be9e23b3ad$var$EXISTS && (!$662220f635148e9e$exports || $662220f635148e9e$exports && $bec6e0be9e23b3ad$var$getDescriptor($bec6e0be9e23b3ad$var$FunctionPrototype, "name").configurable);
$bec6e0be9e23b3ad$exports = {
    EXISTS: $bec6e0be9e23b3ad$var$EXISTS,
    PROPER: $bec6e0be9e23b3ad$var$PROPER,
    CONFIGURABLE: $bec6e0be9e23b3ad$var$CONFIGURABLE
};


var $77c1236bf6ec69fc$require$CONFIGURABLE_FUNCTION_NAME = $bec6e0be9e23b3ad$exports.CONFIGURABLE;
var $84d2f2a3878469f6$exports = {};
"use strict";



var $84d2f2a3878469f6$var$functionToString = $2bec4c654af9cae3$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$9db74248a53aaffc$exports($49985cb207407415$exports.inspectSource)) $49985cb207407415$exports.inspectSource = function(it) {
    return $84d2f2a3878469f6$var$functionToString(it);
};
$84d2f2a3878469f6$exports = $49985cb207407415$exports.inspectSource;


var $74d2f26957bcf6d2$exports = {};
"use strict";
var $4ce8ca9201052e1d$exports = {};
"use strict";


var $4ce8ca9201052e1d$var$WeakMap = $321821ab316477fa$exports.WeakMap;
$4ce8ca9201052e1d$exports = $9db74248a53aaffc$exports($4ce8ca9201052e1d$var$WeakMap) && /native code/.test(String($4ce8ca9201052e1d$var$WeakMap));







var $0c13f2755052ab35$exports = {};
"use strict";


var $0c13f2755052ab35$var$keys = $56ca3d0fdf4ecfb7$exports("keys");
$0c13f2755052ab35$exports = function(key) {
    return $0c13f2755052ab35$var$keys[key] || ($0c13f2755052ab35$var$keys[key] = $374c164acb0b3685$exports(key));
};


var $fe8997206581d5bf$exports = {};
"use strict";
$fe8997206581d5bf$exports = {};


var $74d2f26957bcf6d2$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $74d2f26957bcf6d2$var$TypeError = $321821ab316477fa$exports.TypeError;
var $74d2f26957bcf6d2$var$WeakMap = $321821ab316477fa$exports.WeakMap;
var $74d2f26957bcf6d2$var$set, $74d2f26957bcf6d2$var$get, $74d2f26957bcf6d2$var$has;
var $74d2f26957bcf6d2$var$enforce = function(it) {
    return $74d2f26957bcf6d2$var$has(it) ? $74d2f26957bcf6d2$var$get(it) : $74d2f26957bcf6d2$var$set(it, {});
};
var $74d2f26957bcf6d2$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$c989e06804ef7492$exports(it) || (state = $74d2f26957bcf6d2$var$get(it)).type !== TYPE) throw new $74d2f26957bcf6d2$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($4ce8ca9201052e1d$exports || $49985cb207407415$exports.state) {
    var $74d2f26957bcf6d2$var$store = $49985cb207407415$exports.state || ($49985cb207407415$exports.state = new $74d2f26957bcf6d2$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $74d2f26957bcf6d2$var$store.get = $74d2f26957bcf6d2$var$store.get;
    $74d2f26957bcf6d2$var$store.has = $74d2f26957bcf6d2$var$store.has;
    $74d2f26957bcf6d2$var$store.set = $74d2f26957bcf6d2$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $74d2f26957bcf6d2$var$set = function(it, metadata) {
        if ($74d2f26957bcf6d2$var$store.has(it)) throw new $74d2f26957bcf6d2$var$TypeError($74d2f26957bcf6d2$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $74d2f26957bcf6d2$var$store.set(it, metadata);
        return metadata;
    };
    $74d2f26957bcf6d2$var$get = function(it) {
        return $74d2f26957bcf6d2$var$store.get(it) || {};
    };
    $74d2f26957bcf6d2$var$has = function(it) {
        return $74d2f26957bcf6d2$var$store.has(it);
    };
} else {
    var $74d2f26957bcf6d2$var$STATE = $0c13f2755052ab35$exports("state");
    $fe8997206581d5bf$exports[$74d2f26957bcf6d2$var$STATE] = true;
    $74d2f26957bcf6d2$var$set = function(it, metadata) {
        if ($afe7abd14249b56c$exports(it, $74d2f26957bcf6d2$var$STATE)) throw new $74d2f26957bcf6d2$var$TypeError($74d2f26957bcf6d2$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $63d3184036d668c6$exports(it, $74d2f26957bcf6d2$var$STATE, metadata);
        return metadata;
    };
    $74d2f26957bcf6d2$var$get = function(it) {
        return $afe7abd14249b56c$exports(it, $74d2f26957bcf6d2$var$STATE) ? it[$74d2f26957bcf6d2$var$STATE] : {};
    };
    $74d2f26957bcf6d2$var$has = function(it) {
        return $afe7abd14249b56c$exports(it, $74d2f26957bcf6d2$var$STATE);
    };
}
$74d2f26957bcf6d2$exports = {
    set: $74d2f26957bcf6d2$var$set,
    get: $74d2f26957bcf6d2$var$get,
    has: $74d2f26957bcf6d2$var$has,
    enforce: $74d2f26957bcf6d2$var$enforce,
    getterFor: $74d2f26957bcf6d2$var$getterFor
};


var $77c1236bf6ec69fc$var$enforceInternalState = $74d2f26957bcf6d2$exports.enforce;
var $77c1236bf6ec69fc$var$getInternalState = $74d2f26957bcf6d2$exports.get;
var $77c1236bf6ec69fc$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $77c1236bf6ec69fc$var$defineProperty = Object.defineProperty;
var $77c1236bf6ec69fc$var$stringSlice = $2bec4c654af9cae3$exports("".slice);
var $77c1236bf6ec69fc$var$replace = $2bec4c654af9cae3$exports("".replace);
var $77c1236bf6ec69fc$var$join = $2bec4c654af9cae3$exports([].join);
var $77c1236bf6ec69fc$var$CONFIGURABLE_LENGTH = $662220f635148e9e$exports && !$bc4867304bac101c$exports(function() {
    return $77c1236bf6ec69fc$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $77c1236bf6ec69fc$var$TEMPLATE = String(String).split("String");
var $77c1236bf6ec69fc$var$makeBuiltIn = $77c1236bf6ec69fc$exports = function(value, name, options) {
    if ($77c1236bf6ec69fc$var$stringSlice($77c1236bf6ec69fc$var$$String(name), 0, 7) === "Symbol(") name = "[" + $77c1236bf6ec69fc$var$replace($77c1236bf6ec69fc$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$afe7abd14249b56c$exports(value, "name") || $77c1236bf6ec69fc$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($662220f635148e9e$exports) $77c1236bf6ec69fc$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($77c1236bf6ec69fc$var$CONFIGURABLE_LENGTH && options && $afe7abd14249b56c$exports(options, "arity") && value.length !== options.arity) $77c1236bf6ec69fc$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $afe7abd14249b56c$exports(options, "constructor") && options.constructor) {
            if ($662220f635148e9e$exports) $77c1236bf6ec69fc$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $77c1236bf6ec69fc$var$enforceInternalState(value);
    if (!$afe7abd14249b56c$exports(state, "source")) state.source = $77c1236bf6ec69fc$var$join($77c1236bf6ec69fc$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $77c1236bf6ec69fc$var$makeBuiltIn(function toString() {
    return $9db74248a53aaffc$exports(this) && $77c1236bf6ec69fc$var$getInternalState(this).source || $84d2f2a3878469f6$exports(this);
}, "toString");



$1675d88d56a1053c$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($9db74248a53aaffc$exports(value)) $77c1236bf6ec69fc$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $02945691cb8d57a8$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $8508f7795b5ab674$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $39569098c8b1c047$exports = {};
"use strict";

var $3823d4d2cd507e65$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $1208eae005db486d$export$2d1720544b23b823;
"use strict";
var $357fa63087643b51$exports = {};
"use strict";



var $e3ecb257b5a31a2b$exports = {};
"use strict";

var $f897786d0c0d115b$exports = {};
"use strict";
var $b8df8c3fc3c6ada8$exports = {};
"use strict";
var $63fe81cd4a78e65f$exports = {};
"use strict";
var $63fe81cd4a78e65f$var$ceil = Math.ceil;
var $63fe81cd4a78e65f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$63fe81cd4a78e65f$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $63fe81cd4a78e65f$var$floor : $63fe81cd4a78e65f$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b8df8c3fc3c6ada8$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $63fe81cd4a78e65f$exports(number);
};


var $f897786d0c0d115b$var$max = Math.max;
var $f897786d0c0d115b$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$f897786d0c0d115b$exports = function(index, length) {
    var integer = $b8df8c3fc3c6ada8$exports(index);
    return integer < 0 ? $f897786d0c0d115b$var$max(integer + length, 0) : $f897786d0c0d115b$var$min(integer, length);
};


var $57aab5ddedfa6f80$exports = {};
"use strict";
var $e787b7809654f652$exports = {};
"use strict";

var $e787b7809654f652$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$e787b7809654f652$exports = function(argument) {
    var len = $b8df8c3fc3c6ada8$exports(argument);
    return len > 0 ? $e787b7809654f652$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$57aab5ddedfa6f80$exports = function(obj) {
    return $e787b7809654f652$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $e3ecb257b5a31a2b$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6dde291a20368b2f$exports($this);
        var length = $57aab5ddedfa6f80$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $f897786d0c0d115b$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e3ecb257b5a31a2b$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e3ecb257b5a31a2b$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e3ecb257b5a31a2b$var$createMethod(false)
};


var $357fa63087643b51$require$indexOf = $e3ecb257b5a31a2b$exports.indexOf;

var $357fa63087643b51$var$push = $2bec4c654af9cae3$exports([].push);
$357fa63087643b51$exports = function(object, names) {
    var O = $6dde291a20368b2f$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$afe7abd14249b56c$exports($fe8997206581d5bf$exports, key) && $afe7abd14249b56c$exports(O, key) && $357fa63087643b51$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($afe7abd14249b56c$exports(O, key = names[i++])) ~$357fa63087643b51$require$indexOf(result, key) || $357fa63087643b51$var$push(result, key);
    return result;
};


var $69b1ed0c65574bf4$exports = {};
"use strict";
// IE8- don't enum bug keys
$69b1ed0c65574bf4$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $1208eae005db486d$var$hiddenKeys = $69b1ed0c65574bf4$exports.concat("length", "prototype");
$1208eae005db486d$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $357fa63087643b51$exports(O, $1208eae005db486d$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $351408f99287713b$export$2d1720544b23b823;
"use strict";
$351408f99287713b$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $3823d4d2cd507e65$var$concat = $2bec4c654af9cae3$exports([].concat);
// all object keys, includes non-enumerable and symbols
$3823d4d2cd507e65$exports = $468e1877ee71c3bf$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $1208eae005db486d$export$2d1720544b23b823($e524200f7829c91a$exports(it));
    var getOwnPropertySymbols = $351408f99287713b$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $3823d4d2cd507e65$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$39569098c8b1c047$exports = function(target, source, exceptions) {
    var keys = $3823d4d2cd507e65$exports(source);
    var defineProperty = $8508f7795b5ab674$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $9eba49c84552505c$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$afe7abd14249b56c$exports(target, key) && !(exceptions && $afe7abd14249b56c$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $c6b26959ea9d3c8c$exports = {};
"use strict";


var $c6b26959ea9d3c8c$var$replacement = /#|\.prototype\./;
var $c6b26959ea9d3c8c$var$isForced = function(feature, detection) {
    var value = $c6b26959ea9d3c8c$var$data[$c6b26959ea9d3c8c$var$normalize(feature)];
    return value === $c6b26959ea9d3c8c$var$POLYFILL ? true : value === $c6b26959ea9d3c8c$var$NATIVE ? false : $9db74248a53aaffc$exports(detection) ? $bc4867304bac101c$exports(detection) : !!detection;
};
var $c6b26959ea9d3c8c$var$normalize = $c6b26959ea9d3c8c$var$isForced.normalize = function(string) {
    return String(string).replace($c6b26959ea9d3c8c$var$replacement, ".").toLowerCase();
};
var $c6b26959ea9d3c8c$var$data = $c6b26959ea9d3c8c$var$isForced.data = {};
var $c6b26959ea9d3c8c$var$NATIVE = $c6b26959ea9d3c8c$var$isForced.NATIVE = "N";
var $c6b26959ea9d3c8c$var$POLYFILL = $c6b26959ea9d3c8c$var$isForced.POLYFILL = "P";
$c6b26959ea9d3c8c$exports = $c6b26959ea9d3c8c$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $5cebaf28941ec4e5$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $321821ab316477fa$exports;
    else if (STATIC) target = $321821ab316477fa$exports[TARGET] || $02945691cb8d57a8$exports(TARGET, {});
    else target = $321821ab316477fa$exports[TARGET] && $321821ab316477fa$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $5cebaf28941ec4e5$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $c6b26959ea9d3c8c$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $39569098c8b1c047$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $63d3184036d668c6$exports(sourceProperty, "sham", true);
        $1675d88d56a1053c$exports(target, key, sourceProperty, options);
    }
};



var $1a3022feea6a0422$exports = {};
"use strict";
var $60018c4349d987dc$exports = {};
"use strict";



var $60018c4349d987dc$var$userAgentStartsWith = function(string) {
    return $f71d06fbcf6e0bb5$exports.slice(0, string.length) === string;
};
$60018c4349d987dc$exports = function() {
    if ($60018c4349d987dc$var$userAgentStartsWith("Bun/")) return "BUN";
    if ($60018c4349d987dc$var$userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if ($60018c4349d987dc$var$userAgentStartsWith("Deno/")) return "DENO";
    if ($60018c4349d987dc$var$userAgentStartsWith("Node.js/")) return "NODE";
    if ($321821ab316477fa$exports.Bun && typeof Bun.version == "string") return "BUN";
    if ($321821ab316477fa$exports.Deno && typeof Deno.version == "object") return "DENO";
    if ($054635c9948980fc$exports($321821ab316477fa$exports.process) === "process") return "NODE";
    if ($321821ab316477fa$exports.window && $321821ab316477fa$exports.document) return "BROWSER";
    return "REST";
}();


$1a3022feea6a0422$exports = $60018c4349d987dc$exports === "NODE";





var $6607873162a0bb07$exports = {};
"use strict";
var $32571be65e66d15c$exports = {};
"use strict";


$32571be65e66d15c$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $2bec4c654af9cae3$exports($35fd29c4b881594d$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $1a07e6779cea5b3e$exports = {};
"use strict";
var $f16c3a0db07c5024$exports = {};
"use strict";

$f16c3a0db07c5024$exports = function(argument) {
    return $c989e06804ef7492$exports(argument) || argument === null;
};


var $1a07e6779cea5b3e$var$$String = String;
var $1a07e6779cea5b3e$var$$TypeError = TypeError;
$1a07e6779cea5b3e$exports = function(argument) {
    if ($f16c3a0db07c5024$exports(argument)) return argument;
    throw new $1a07e6779cea5b3e$var$$TypeError("Can't set " + $1a07e6779cea5b3e$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$6607873162a0bb07$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $32571be65e66d15c$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $3c987812112845db$exports(O);
        $1a07e6779cea5b3e$exports(proto);
        if (!$c989e06804ef7492$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


var $96869fd4dde2c2ff$exports = {};
"use strict";

var $96869fd4dde2c2ff$require$defineProperty = $8508f7795b5ab674$export$2d1720544b23b823;


var $96869fd4dde2c2ff$var$TO_STRING_TAG = $52dcd2f12662ee00$exports("toStringTag");
$96869fd4dde2c2ff$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$afe7abd14249b56c$exports(target, $96869fd4dde2c2ff$var$TO_STRING_TAG)) $96869fd4dde2c2ff$require$defineProperty(target, $96869fd4dde2c2ff$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $4afca5ad01105dc9$exports = {};
"use strict";

var $6ca3377fcc1b5b2f$exports = {};
"use strict";


$6ca3377fcc1b5b2f$exports = function(target, name, descriptor) {
    if (descriptor.get) $77c1236bf6ec69fc$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $77c1236bf6ec69fc$exports(descriptor.set, name, {
        setter: true
    });
    return $8508f7795b5ab674$export$2d1720544b23b823(target, name, descriptor);
};




var $4afca5ad01105dc9$var$SPECIES = $52dcd2f12662ee00$exports("species");
$4afca5ad01105dc9$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $468e1877ee71c3bf$exports(CONSTRUCTOR_NAME);
    if ($662220f635148e9e$exports && Constructor && !Constructor[$4afca5ad01105dc9$var$SPECIES]) $6ca3377fcc1b5b2f$exports(Constructor, $4afca5ad01105dc9$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};





var $327baf66fc03f9b2$exports = {};
"use strict";

var $327baf66fc03f9b2$var$$TypeError = TypeError;
$327baf66fc03f9b2$exports = function(it, Prototype) {
    if ($a1c5b000dc4b288b$exports(Prototype, it)) return it;
    throw new $327baf66fc03f9b2$var$$TypeError("Incorrect invocation");
};


var $95623804ec6be0e0$exports = {};
"use strict";

var $86c9c078dabafd74$exports = {};
"use strict";
var $54cefdb8d765bd48$exports = {};
"use strict";



var $6e905fe571724af0$exports = {};
"use strict";
var $eba581b8ae85e2a4$exports = {};
"use strict";

var $eba581b8ae85e2a4$var$TO_STRING_TAG = $52dcd2f12662ee00$exports("toStringTag");
var $eba581b8ae85e2a4$var$test = {};
$eba581b8ae85e2a4$var$test[$eba581b8ae85e2a4$var$TO_STRING_TAG] = "z";
$eba581b8ae85e2a4$exports = String($eba581b8ae85e2a4$var$test) === "[object z]";





var $6e905fe571724af0$var$TO_STRING_TAG = $52dcd2f12662ee00$exports("toStringTag");
var $6e905fe571724af0$var$$Object = Object;
// ES3 wrong here
var $6e905fe571724af0$var$CORRECT_ARGUMENTS = $054635c9948980fc$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $6e905fe571724af0$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$6e905fe571724af0$exports = $eba581b8ae85e2a4$exports ? $054635c9948980fc$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $6e905fe571724af0$var$tryGet(O = $6e905fe571724af0$var$$Object(it), $6e905fe571724af0$var$TO_STRING_TAG)) == "string" ? tag : $6e905fe571724af0$var$CORRECT_ARGUMENTS ? $054635c9948980fc$exports(O) : (result = $054635c9948980fc$exports(O)) === "Object" && $9db74248a53aaffc$exports(O.callee) ? "Arguments" : result;
};




var $54cefdb8d765bd48$var$noop = function() {};
var $54cefdb8d765bd48$var$construct = $468e1877ee71c3bf$exports("Reflect", "construct");
var $54cefdb8d765bd48$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $54cefdb8d765bd48$var$exec = $2bec4c654af9cae3$exports($54cefdb8d765bd48$var$constructorRegExp.exec);
var $54cefdb8d765bd48$var$INCORRECT_TO_STRING = !$54cefdb8d765bd48$var$constructorRegExp.test($54cefdb8d765bd48$var$noop);
var $54cefdb8d765bd48$var$isConstructorModern = function isConstructor(argument) {
    if (!$9db74248a53aaffc$exports(argument)) return false;
    try {
        $54cefdb8d765bd48$var$construct($54cefdb8d765bd48$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $54cefdb8d765bd48$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$9db74248a53aaffc$exports(argument)) return false;
    switch($6e905fe571724af0$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $54cefdb8d765bd48$var$INCORRECT_TO_STRING || !!$54cefdb8d765bd48$var$exec($54cefdb8d765bd48$var$constructorRegExp, $84d2f2a3878469f6$exports(argument));
    } catch (error) {
        return true;
    }
};
$54cefdb8d765bd48$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$54cefdb8d765bd48$exports = !$54cefdb8d765bd48$var$construct || $bc4867304bac101c$exports(function() {
    var called;
    return $54cefdb8d765bd48$var$isConstructorModern($54cefdb8d765bd48$var$isConstructorModern.call) || !$54cefdb8d765bd48$var$isConstructorModern(Object) || !$54cefdb8d765bd48$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $54cefdb8d765bd48$var$isConstructorLegacy : $54cefdb8d765bd48$var$isConstructorModern;



var $86c9c078dabafd74$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$86c9c078dabafd74$exports = function(argument) {
    if ($54cefdb8d765bd48$exports(argument)) return argument;
    throw new $86c9c078dabafd74$var$$TypeError($3474e834edbef1ad$exports(argument) + " is not a constructor");
};




var $95623804ec6be0e0$var$SPECIES = $52dcd2f12662ee00$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$95623804ec6be0e0$exports = function(O, defaultConstructor) {
    var C = $e524200f7829c91a$exports(O).constructor;
    var S;
    return C === undefined || $e922e6344cadecfd$exports(S = $e524200f7829c91a$exports(C)[$95623804ec6be0e0$var$SPECIES]) ? defaultConstructor : $86c9c078dabafd74$exports(S);
};


var $49451c5a93d65766$exports = {};
"use strict";

var $4da5ccbf2cf59c39$exports = {};
"use strict";

var $4da5ccbf2cf59c39$var$FunctionPrototype = Function.prototype;
var $4da5ccbf2cf59c39$var$apply = $4da5ccbf2cf59c39$var$FunctionPrototype.apply;
var $4da5ccbf2cf59c39$var$call = $4da5ccbf2cf59c39$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$4da5ccbf2cf59c39$exports = typeof Reflect == "object" && Reflect.apply || ($4942706a8bbbc2b1$exports ? $4da5ccbf2cf59c39$var$call.bind($4da5ccbf2cf59c39$var$apply) : function() {
    return $4da5ccbf2cf59c39$var$call.apply($4da5ccbf2cf59c39$var$apply, arguments);
});


var $652324ae414274b9$exports = {};
"use strict";
var $e5c4dbd1844d9ec5$exports = {};
"use strict";


$e5c4dbd1844d9ec5$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($054635c9948980fc$exports(fn) === "Function") return $2bec4c654af9cae3$exports(fn);
};




var $652324ae414274b9$var$bind = $e5c4dbd1844d9ec5$exports($e5c4dbd1844d9ec5$exports.bind);
// optional / simple context binding
$652324ae414274b9$exports = function(fn, that) {
    $35fd29c4b881594d$exports(fn);
    return that === undefined ? fn : $4942706a8bbbc2b1$exports ? $652324ae414274b9$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $7bef19c609a66507$exports = {};
"use strict";

$7bef19c609a66507$exports = $468e1877ee71c3bf$exports("document", "documentElement");


var $4ea376ded9305ca2$exports = {};
"use strict";

$4ea376ded9305ca2$exports = $2bec4c654af9cae3$exports([].slice);



var $88aac3218a371097$exports = {};
"use strict";
var $88aac3218a371097$var$$TypeError = TypeError;
$88aac3218a371097$exports = function(passed, required) {
    if (passed < required) throw new $88aac3218a371097$var$$TypeError("Not enough arguments");
    return passed;
};


var $b2f62aaa282d7a2b$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$b2f62aaa282d7a2b$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($f71d06fbcf6e0bb5$exports);



var $49451c5a93d65766$var$set = $321821ab316477fa$exports.setImmediate;
var $49451c5a93d65766$var$clear = $321821ab316477fa$exports.clearImmediate;
var $49451c5a93d65766$var$process = $321821ab316477fa$exports.process;
var $49451c5a93d65766$var$Dispatch = $321821ab316477fa$exports.Dispatch;
var $49451c5a93d65766$var$Function = $321821ab316477fa$exports.Function;
var $49451c5a93d65766$var$MessageChannel = $321821ab316477fa$exports.MessageChannel;
var $49451c5a93d65766$var$String = $321821ab316477fa$exports.String;
var $49451c5a93d65766$var$counter = 0;
var $49451c5a93d65766$var$queue = {};
var $49451c5a93d65766$var$ONREADYSTATECHANGE = "onreadystatechange";
var $49451c5a93d65766$var$$location, $49451c5a93d65766$var$defer, $49451c5a93d65766$var$channel, $49451c5a93d65766$var$port;
$bc4867304bac101c$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $49451c5a93d65766$var$$location = $321821ab316477fa$exports.location;
});
var $49451c5a93d65766$var$run = function(id) {
    if ($afe7abd14249b56c$exports($49451c5a93d65766$var$queue, id)) {
        var fn = $49451c5a93d65766$var$queue[id];
        delete $49451c5a93d65766$var$queue[id];
        fn();
    }
};
var $49451c5a93d65766$var$runner = function(id) {
    return function() {
        $49451c5a93d65766$var$run(id);
    };
};
var $49451c5a93d65766$var$eventListener = function(event) {
    $49451c5a93d65766$var$run(event.data);
};
var $49451c5a93d65766$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $321821ab316477fa$exports.postMessage($49451c5a93d65766$var$String(id), $49451c5a93d65766$var$$location.protocol + "//" + $49451c5a93d65766$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$49451c5a93d65766$var$set || !$49451c5a93d65766$var$clear) {
    $49451c5a93d65766$var$set = function setImmediate(handler) {
        $88aac3218a371097$exports(arguments.length, 1);
        var fn = $9db74248a53aaffc$exports(handler) ? handler : $49451c5a93d65766$var$Function(handler);
        var args = $4ea376ded9305ca2$exports(arguments, 1);
        $49451c5a93d65766$var$queue[++$49451c5a93d65766$var$counter] = function() {
            $4da5ccbf2cf59c39$exports(fn, undefined, args);
        };
        $49451c5a93d65766$var$defer($49451c5a93d65766$var$counter);
        return $49451c5a93d65766$var$counter;
    };
    $49451c5a93d65766$var$clear = function clearImmediate(id) {
        delete $49451c5a93d65766$var$queue[id];
    };
    // Node.js 0.8-
    if ($1a3022feea6a0422$exports) $49451c5a93d65766$var$defer = function(id) {
        $49451c5a93d65766$var$process.nextTick($49451c5a93d65766$var$runner(id));
    };
    else if ($49451c5a93d65766$var$Dispatch && $49451c5a93d65766$var$Dispatch.now) $49451c5a93d65766$var$defer = function(id) {
        $49451c5a93d65766$var$Dispatch.now($49451c5a93d65766$var$runner(id));
    };
    else if ($49451c5a93d65766$var$MessageChannel && !$b2f62aaa282d7a2b$exports) {
        $49451c5a93d65766$var$channel = new $49451c5a93d65766$var$MessageChannel();
        $49451c5a93d65766$var$port = $49451c5a93d65766$var$channel.port2;
        $49451c5a93d65766$var$channel.port1.onmessage = $49451c5a93d65766$var$eventListener;
        $49451c5a93d65766$var$defer = $652324ae414274b9$exports($49451c5a93d65766$var$port.postMessage, $49451c5a93d65766$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($321821ab316477fa$exports.addEventListener && $9db74248a53aaffc$exports($321821ab316477fa$exports.postMessage) && !$321821ab316477fa$exports.importScripts && $49451c5a93d65766$var$$location && $49451c5a93d65766$var$$location.protocol !== "file:" && !$bc4867304bac101c$exports($49451c5a93d65766$var$globalPostMessageDefer)) {
        $49451c5a93d65766$var$defer = $49451c5a93d65766$var$globalPostMessageDefer;
        $321821ab316477fa$exports.addEventListener("message", $49451c5a93d65766$var$eventListener, false);
    // IE8-
    } else if ($49451c5a93d65766$var$ONREADYSTATECHANGE in $4825d048b09f0d5e$exports("script")) $49451c5a93d65766$var$defer = function(id) {
        $7bef19c609a66507$exports.appendChild($4825d048b09f0d5e$exports("script"))[$49451c5a93d65766$var$ONREADYSTATECHANGE] = function() {
            $7bef19c609a66507$exports.removeChild(this);
            $49451c5a93d65766$var$run(id);
        };
    };
    else $49451c5a93d65766$var$defer = function(id) {
        setTimeout($49451c5a93d65766$var$runner(id), 0);
    };
}
$49451c5a93d65766$exports = {
    set: $49451c5a93d65766$var$set,
    clear: $49451c5a93d65766$var$clear
};


var $3f5c5526d7fee5d7$require$task = $49451c5a93d65766$exports.set;
var $f76f1a062a8a45da$exports = {};
"use strict";

var $597fbc7e79ac21ec$exports = {};
"use strict";


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $597fbc7e79ac21ec$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
$597fbc7e79ac21ec$exports = function(name) {
    if (!$662220f635148e9e$exports) return $321821ab316477fa$exports[name];
    var descriptor = $597fbc7e79ac21ec$var$getOwnPropertyDescriptor($321821ab316477fa$exports, name);
    return descriptor && descriptor.value;
};




var $f76f1a062a8a45da$require$macrotask = $49451c5a93d65766$exports.set;
var $103d2d0f7e159ded$exports = {};
"use strict";
var $103d2d0f7e159ded$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$103d2d0f7e159ded$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$103d2d0f7e159ded$exports = $103d2d0f7e159ded$var$Queue;



var $8b84011358c529e4$exports = {};
"use strict";

$8b84011358c529e4$exports = /ipad|iphone|ipod/i.test($f71d06fbcf6e0bb5$exports) && typeof Pebble != "undefined";


var $18199b989a7832d7$exports = {};
"use strict";

$18199b989a7832d7$exports = /web0s(?!.*chrome)/i.test($f71d06fbcf6e0bb5$exports);



var $f76f1a062a8a45da$var$MutationObserver = $321821ab316477fa$exports.MutationObserver || $321821ab316477fa$exports.WebKitMutationObserver;
var $f76f1a062a8a45da$var$document = $321821ab316477fa$exports.document;
var $f76f1a062a8a45da$var$process = $321821ab316477fa$exports.process;
var $f76f1a062a8a45da$var$Promise = $321821ab316477fa$exports.Promise;
var $f76f1a062a8a45da$var$microtask = $597fbc7e79ac21ec$exports("queueMicrotask");
var $f76f1a062a8a45da$var$notify, $f76f1a062a8a45da$var$toggle, $f76f1a062a8a45da$var$node, $f76f1a062a8a45da$var$promise, $f76f1a062a8a45da$var$then;
// modern engines have queueMicrotask method
if (!$f76f1a062a8a45da$var$microtask) {
    var $f76f1a062a8a45da$var$queue = new $103d2d0f7e159ded$exports();
    var $f76f1a062a8a45da$var$flush = function() {
        var parent, fn;
        if ($1a3022feea6a0422$exports && (parent = $f76f1a062a8a45da$var$process.domain)) parent.exit();
        while(fn = $f76f1a062a8a45da$var$queue.get())try {
            fn();
        } catch (error) {
            if ($f76f1a062a8a45da$var$queue.head) $f76f1a062a8a45da$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$b2f62aaa282d7a2b$exports && !$1a3022feea6a0422$exports && !$18199b989a7832d7$exports && $f76f1a062a8a45da$var$MutationObserver && $f76f1a062a8a45da$var$document) {
        $f76f1a062a8a45da$var$toggle = true;
        $f76f1a062a8a45da$var$node = $f76f1a062a8a45da$var$document.createTextNode("");
        new $f76f1a062a8a45da$var$MutationObserver($f76f1a062a8a45da$var$flush).observe($f76f1a062a8a45da$var$node, {
            characterData: true
        });
        $f76f1a062a8a45da$var$notify = function() {
            $f76f1a062a8a45da$var$node.data = $f76f1a062a8a45da$var$toggle = !$f76f1a062a8a45da$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$8b84011358c529e4$exports && $f76f1a062a8a45da$var$Promise && $f76f1a062a8a45da$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $f76f1a062a8a45da$var$promise = $f76f1a062a8a45da$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $f76f1a062a8a45da$var$promise.constructor = $f76f1a062a8a45da$var$Promise;
        $f76f1a062a8a45da$var$then = $652324ae414274b9$exports($f76f1a062a8a45da$var$promise.then, $f76f1a062a8a45da$var$promise);
        $f76f1a062a8a45da$var$notify = function() {
            $f76f1a062a8a45da$var$then($f76f1a062a8a45da$var$flush);
        };
    // Node.js without promises
    } else if ($1a3022feea6a0422$exports) $f76f1a062a8a45da$var$notify = function() {
        $f76f1a062a8a45da$var$process.nextTick($f76f1a062a8a45da$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $f76f1a062a8a45da$require$macrotask = $652324ae414274b9$exports($f76f1a062a8a45da$require$macrotask, $321821ab316477fa$exports);
        $f76f1a062a8a45da$var$notify = function() {
            $f76f1a062a8a45da$require$macrotask($f76f1a062a8a45da$var$flush);
        };
    }
    $f76f1a062a8a45da$var$microtask = function(fn) {
        if (!$f76f1a062a8a45da$var$queue.head) $f76f1a062a8a45da$var$notify();
        $f76f1a062a8a45da$var$queue.add(fn);
    };
}
$f76f1a062a8a45da$exports = $f76f1a062a8a45da$var$microtask;


var $17dd7cd8d6db7c83$exports = {};
"use strict";
$17dd7cd8d6db7c83$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $c72a4a0a91592955$exports = {};
"use strict";
$c72a4a0a91592955$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $70036dd3bda909a3$exports = {};
"use strict";

$70036dd3bda909a3$exports = $321821ab316477fa$exports.Promise;


var $9f396b151913828c$exports = {};
"use strict";









var $9f396b151913828c$var$NativePromisePrototype = $70036dd3bda909a3$exports && $70036dd3bda909a3$exports.prototype;
var $9f396b151913828c$var$SPECIES = $52dcd2f12662ee00$exports("species");
var $9f396b151913828c$var$SUBCLASSING = false;
var $9f396b151913828c$var$NATIVE_PROMISE_REJECTION_EVENT = $9db74248a53aaffc$exports($321821ab316477fa$exports.PromiseRejectionEvent);
var $9f396b151913828c$var$FORCED_PROMISE_CONSTRUCTOR = $c6b26959ea9d3c8c$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $84d2f2a3878469f6$exports($70036dd3bda909a3$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($70036dd3bda909a3$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $e72f88ba60a79d93$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($3a92d99f6c30b995$exports && !($9f396b151913828c$var$NativePromisePrototype["catch"] && $9f396b151913828c$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$e72f88ba60a79d93$exports || $e72f88ba60a79d93$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $70036dd3bda909a3$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$9f396b151913828c$var$SPECIES] = FakePromise;
        $9f396b151913828c$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$9f396b151913828c$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($60018c4349d987dc$exports === "BROWSER" || $60018c4349d987dc$exports === "DENO") && !$9f396b151913828c$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$9f396b151913828c$exports = {
    CONSTRUCTOR: $9f396b151913828c$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $9f396b151913828c$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $9f396b151913828c$var$SUBCLASSING
};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $d2e3d0e4d6d7f4bb$export$2d1720544b23b823;
"use strict";

var $d2e3d0e4d6d7f4bb$var$$TypeError = TypeError;
var $d2e3d0e4d6d7f4bb$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $d2e3d0e4d6d7f4bb$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $35fd29c4b881594d$exports(resolve);
    this.reject = $35fd29c4b881594d$exports(reject);
};
$d2e3d0e4d6d7f4bb$export$2d1720544b23b823 = function(C) {
    return new $d2e3d0e4d6d7f4bb$var$PromiseCapability(C);
};


var $3f5c5526d7fee5d7$var$PROMISE = "Promise";
var $3f5c5526d7fee5d7$var$FORCED_PROMISE_CONSTRUCTOR = $9f396b151913828c$exports.CONSTRUCTOR;
var $3f5c5526d7fee5d7$var$NATIVE_PROMISE_REJECTION_EVENT = $9f396b151913828c$exports.REJECTION_EVENT;
var $3f5c5526d7fee5d7$var$NATIVE_PROMISE_SUBCLASSING = $9f396b151913828c$exports.SUBCLASSING;
var $3f5c5526d7fee5d7$var$getInternalPromiseState = $74d2f26957bcf6d2$exports.getterFor($3f5c5526d7fee5d7$var$PROMISE);
var $3f5c5526d7fee5d7$var$setInternalState = $74d2f26957bcf6d2$exports.set;
var $3f5c5526d7fee5d7$var$NativePromisePrototype = $70036dd3bda909a3$exports && $70036dd3bda909a3$exports.prototype;
var $3f5c5526d7fee5d7$var$PromiseConstructor = $70036dd3bda909a3$exports;
var $3f5c5526d7fee5d7$var$PromisePrototype = $3f5c5526d7fee5d7$var$NativePromisePrototype;
var $3f5c5526d7fee5d7$var$TypeError = $321821ab316477fa$exports.TypeError;
var $3f5c5526d7fee5d7$var$document = $321821ab316477fa$exports.document;
var $3f5c5526d7fee5d7$var$process = $321821ab316477fa$exports.process;
var $3f5c5526d7fee5d7$var$newPromiseCapability = $d2e3d0e4d6d7f4bb$export$2d1720544b23b823;
var $3f5c5526d7fee5d7$var$newGenericPromiseCapability = $3f5c5526d7fee5d7$var$newPromiseCapability;
var $3f5c5526d7fee5d7$var$DISPATCH_EVENT = !!($3f5c5526d7fee5d7$var$document && $3f5c5526d7fee5d7$var$document.createEvent && $321821ab316477fa$exports.dispatchEvent);
var $3f5c5526d7fee5d7$var$UNHANDLED_REJECTION = "unhandledrejection";
var $3f5c5526d7fee5d7$var$REJECTION_HANDLED = "rejectionhandled";
var $3f5c5526d7fee5d7$var$PENDING = 0;
var $3f5c5526d7fee5d7$var$FULFILLED = 1;
var $3f5c5526d7fee5d7$var$REJECTED = 2;
var $3f5c5526d7fee5d7$var$HANDLED = 1;
var $3f5c5526d7fee5d7$var$UNHANDLED = 2;
var $3f5c5526d7fee5d7$var$Internal, $3f5c5526d7fee5d7$var$OwnPromiseCapability, $3f5c5526d7fee5d7$var$PromiseWrapper, $3f5c5526d7fee5d7$var$nativeThen;
// helpers
var $3f5c5526d7fee5d7$var$isThenable = function(it) {
    var then;
    return $c989e06804ef7492$exports(it) && $9db74248a53aaffc$exports(then = it.then) ? then : false;
};
var $3f5c5526d7fee5d7$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $3f5c5526d7fee5d7$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $3f5c5526d7fee5d7$var$UNHANDLED) $3f5c5526d7fee5d7$var$onHandleUnhandled(state);
                state.rejection = $3f5c5526d7fee5d7$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $3f5c5526d7fee5d7$var$TypeError("Promise-chain cycle"));
            else if (then = $3f5c5526d7fee5d7$var$isThenable(result)) $95617c3e1592e9a7$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $3f5c5526d7fee5d7$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $f76f1a062a8a45da$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$3f5c5526d7fee5d7$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $3f5c5526d7fee5d7$var$onUnhandled(state);
    });
};
var $3f5c5526d7fee5d7$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($3f5c5526d7fee5d7$var$DISPATCH_EVENT) {
        event = $3f5c5526d7fee5d7$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $321821ab316477fa$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$3f5c5526d7fee5d7$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $321821ab316477fa$exports["on" + name])) handler(event);
    else if (name === $3f5c5526d7fee5d7$var$UNHANDLED_REJECTION) $17dd7cd8d6db7c83$exports("Unhandled promise rejection", reason);
};
var $3f5c5526d7fee5d7$var$onUnhandled = function(state) {
    $95617c3e1592e9a7$exports($3f5c5526d7fee5d7$require$task, $321821ab316477fa$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $3f5c5526d7fee5d7$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $c72a4a0a91592955$exports(function() {
                if ($1a3022feea6a0422$exports) $3f5c5526d7fee5d7$var$process.emit("unhandledRejection", value, promise);
                else $3f5c5526d7fee5d7$var$dispatchEvent($3f5c5526d7fee5d7$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $1a3022feea6a0422$exports || $3f5c5526d7fee5d7$var$isUnhandled(state) ? $3f5c5526d7fee5d7$var$UNHANDLED : $3f5c5526d7fee5d7$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $3f5c5526d7fee5d7$var$isUnhandled = function(state) {
    return state.rejection !== $3f5c5526d7fee5d7$var$HANDLED && !state.parent;
};
var $3f5c5526d7fee5d7$var$onHandleUnhandled = function(state) {
    $95617c3e1592e9a7$exports($3f5c5526d7fee5d7$require$task, $321821ab316477fa$exports, function() {
        var promise = state.facade;
        if ($1a3022feea6a0422$exports) $3f5c5526d7fee5d7$var$process.emit("rejectionHandled", promise);
        else $3f5c5526d7fee5d7$var$dispatchEvent($3f5c5526d7fee5d7$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $3f5c5526d7fee5d7$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $3f5c5526d7fee5d7$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $3f5c5526d7fee5d7$var$REJECTED;
    $3f5c5526d7fee5d7$var$notify(state, true);
};
var $3f5c5526d7fee5d7$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $3f5c5526d7fee5d7$var$TypeError("Promise can't be resolved itself");
        var then = $3f5c5526d7fee5d7$var$isThenable(value);
        if (then) $f76f1a062a8a45da$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $95617c3e1592e9a7$exports(then, value, $3f5c5526d7fee5d7$var$bind($3f5c5526d7fee5d7$var$internalResolve, wrapper, state), $3f5c5526d7fee5d7$var$bind($3f5c5526d7fee5d7$var$internalReject, wrapper, state));
            } catch (error) {
                $3f5c5526d7fee5d7$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $3f5c5526d7fee5d7$var$FULFILLED;
            $3f5c5526d7fee5d7$var$notify(state, false);
        }
    } catch (error) {
        $3f5c5526d7fee5d7$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($3f5c5526d7fee5d7$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $3f5c5526d7fee5d7$var$PromiseConstructor = function Promise(executor) {
        $327baf66fc03f9b2$exports(this, $3f5c5526d7fee5d7$var$PromisePrototype);
        $35fd29c4b881594d$exports(executor);
        $95617c3e1592e9a7$exports($3f5c5526d7fee5d7$var$Internal, this);
        var state = $3f5c5526d7fee5d7$var$getInternalPromiseState(this);
        try {
            executor($3f5c5526d7fee5d7$var$bind($3f5c5526d7fee5d7$var$internalResolve, state), $3f5c5526d7fee5d7$var$bind($3f5c5526d7fee5d7$var$internalReject, state));
        } catch (error) {
            $3f5c5526d7fee5d7$var$internalReject(state, error);
        }
    };
    $3f5c5526d7fee5d7$var$PromisePrototype = $3f5c5526d7fee5d7$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $3f5c5526d7fee5d7$var$Internal = function Promise(executor) {
        $3f5c5526d7fee5d7$var$setInternalState(this, {
            type: $3f5c5526d7fee5d7$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $103d2d0f7e159ded$exports(),
            rejection: false,
            state: $3f5c5526d7fee5d7$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $3f5c5526d7fee5d7$var$Internal.prototype = $1675d88d56a1053c$exports($3f5c5526d7fee5d7$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $3f5c5526d7fee5d7$var$getInternalPromiseState(this);
        var reaction = $3f5c5526d7fee5d7$var$newPromiseCapability($95623804ec6be0e0$exports(this, $3f5c5526d7fee5d7$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $9db74248a53aaffc$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $9db74248a53aaffc$exports(onRejected) && onRejected;
        reaction.domain = $1a3022feea6a0422$exports ? $3f5c5526d7fee5d7$var$process.domain : undefined;
        if (state.state === $3f5c5526d7fee5d7$var$PENDING) state.reactions.add(reaction);
        else $f76f1a062a8a45da$exports(function() {
            $3f5c5526d7fee5d7$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $3f5c5526d7fee5d7$var$OwnPromiseCapability = function() {
        var promise = new $3f5c5526d7fee5d7$var$Internal();
        var state = $3f5c5526d7fee5d7$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $3f5c5526d7fee5d7$var$bind($3f5c5526d7fee5d7$var$internalResolve, state);
        this.reject = $3f5c5526d7fee5d7$var$bind($3f5c5526d7fee5d7$var$internalReject, state);
    };
    $d2e3d0e4d6d7f4bb$export$2d1720544b23b823 = $3f5c5526d7fee5d7$var$newPromiseCapability = function(C) {
        return C === $3f5c5526d7fee5d7$var$PromiseConstructor || C === $3f5c5526d7fee5d7$var$PromiseWrapper ? new $3f5c5526d7fee5d7$var$OwnPromiseCapability(C) : $3f5c5526d7fee5d7$var$newGenericPromiseCapability(C);
    };
    if (!$3a92d99f6c30b995$exports && $9db74248a53aaffc$exports($70036dd3bda909a3$exports) && $3f5c5526d7fee5d7$var$NativePromisePrototype !== Object.prototype) {
        $3f5c5526d7fee5d7$var$nativeThen = $3f5c5526d7fee5d7$var$NativePromisePrototype.then;
        if (!$3f5c5526d7fee5d7$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $1675d88d56a1053c$exports($3f5c5526d7fee5d7$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $3f5c5526d7fee5d7$var$PromiseConstructor(function(resolve, reject) {
                $95617c3e1592e9a7$exports($3f5c5526d7fee5d7$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $3f5c5526d7fee5d7$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($6607873162a0bb07$exports) $6607873162a0bb07$exports($3f5c5526d7fee5d7$var$NativePromisePrototype, $3f5c5526d7fee5d7$var$PromisePrototype);
    }
}
$5cebaf28941ec4e5$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $3f5c5526d7fee5d7$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $3f5c5526d7fee5d7$var$PromiseConstructor
});
$96869fd4dde2c2ff$exports($3f5c5526d7fee5d7$var$PromiseConstructor, $3f5c5526d7fee5d7$var$PROMISE, false, true);
$4afca5ad01105dc9$exports($3f5c5526d7fee5d7$var$PROMISE);


"use strict";





var $2edc7939131f352e$exports = {};
"use strict";




var $d1f92422b1d36d6b$exports = {};
"use strict";

var $1570bdb8a9d03e0e$exports = {};
"use strict";
$1570bdb8a9d03e0e$exports = {};


var $d1f92422b1d36d6b$var$ITERATOR = $52dcd2f12662ee00$exports("iterator");
var $d1f92422b1d36d6b$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$d1f92422b1d36d6b$exports = function(it) {
    return it !== undefined && ($1570bdb8a9d03e0e$exports.Array === it || $d1f92422b1d36d6b$var$ArrayPrototype[$d1f92422b1d36d6b$var$ITERATOR] === it);
};




var $894dd992d5ac162d$exports = {};
"use strict";




var $2a8055dcd6b3e870$exports = {};
"use strict";





var $2a8055dcd6b3e870$var$ITERATOR = $52dcd2f12662ee00$exports("iterator");
$2a8055dcd6b3e870$exports = function(it) {
    if (!$e922e6344cadecfd$exports(it)) return $a5a2983e8d4c2cc9$exports(it, $2a8055dcd6b3e870$var$ITERATOR) || $a5a2983e8d4c2cc9$exports(it, "@@iterator") || $1570bdb8a9d03e0e$exports[$6e905fe571724af0$exports(it)];
};


var $894dd992d5ac162d$var$$TypeError = TypeError;
$894dd992d5ac162d$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $2a8055dcd6b3e870$exports(argument) : usingIterator;
    if ($35fd29c4b881594d$exports(iteratorMethod)) return $e524200f7829c91a$exports($95617c3e1592e9a7$exports(iteratorMethod, argument));
    throw new $894dd992d5ac162d$var$$TypeError($3474e834edbef1ad$exports(argument) + " is not iterable");
};



var $5fe7b146992a8aed$exports = {};
"use strict";



$5fe7b146992a8aed$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $e524200f7829c91a$exports(iterator);
    try {
        innerResult = $a5a2983e8d4c2cc9$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $95617c3e1592e9a7$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $e524200f7829c91a$exports(innerResult);
    return value;
};


var $2edc7939131f352e$var$$TypeError = TypeError;
var $2edc7939131f352e$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $2edc7939131f352e$var$ResultPrototype = $2edc7939131f352e$var$Result.prototype;
$2edc7939131f352e$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $652324ae414274b9$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5fe7b146992a8aed$exports(iterator, "normal", condition);
        return new $2edc7939131f352e$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $e524200f7829c91a$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $2a8055dcd6b3e870$exports(iterable);
        if (!iterFn) throw new $2edc7939131f352e$var$$TypeError($3474e834edbef1ad$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($d1f92422b1d36d6b$exports(iterFn)) {
            for(index = 0, length = $57aab5ddedfa6f80$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $a1c5b000dc4b288b$exports($2edc7939131f352e$var$ResultPrototype, result)) return result;
            }
            return new $2edc7939131f352e$var$Result(false);
        }
        iterator = $894dd992d5ac162d$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $95617c3e1592e9a7$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5fe7b146992a8aed$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $a1c5b000dc4b288b$exports($2edc7939131f352e$var$ResultPrototype, result)) return result;
    }
    return new $2edc7939131f352e$var$Result(false);
};


var $11f0b10bb6c1c19d$exports = {};
"use strict";

var $ea1ad607b41c9023$exports = {};
"use strict";

var $ea1ad607b41c9023$var$ITERATOR = $52dcd2f12662ee00$exports("iterator");
var $ea1ad607b41c9023$var$SAFE_CLOSING = false;
try {
    var $ea1ad607b41c9023$var$called = 0;
    var $ea1ad607b41c9023$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$ea1ad607b41c9023$var$called++
            };
        },
        "return": function() {
            $ea1ad607b41c9023$var$SAFE_CLOSING = true;
        }
    };
    $ea1ad607b41c9023$var$iteratorWithReturn[$ea1ad607b41c9023$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($ea1ad607b41c9023$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$ea1ad607b41c9023$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$ea1ad607b41c9023$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$ea1ad607b41c9023$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $11f0b10bb6c1c19d$require$FORCED_PROMISE_CONSTRUCTOR = $9f396b151913828c$exports.CONSTRUCTOR;
$11f0b10bb6c1c19d$exports = $11f0b10bb6c1c19d$require$FORCED_PROMISE_CONSTRUCTOR || !$ea1ad607b41c9023$exports(function(iterable) {
    $70036dd3bda909a3$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$5cebaf28941ec4e5$exports({
    target: "Promise",
    stat: true,
    forced: $11f0b10bb6c1c19d$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $d2e3d0e4d6d7f4bb$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $c72a4a0a91592955$exports(function() {
            var $promiseResolve = $35fd29c4b881594d$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $2edc7939131f352e$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $95617c3e1592e9a7$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $0c5ab965f25b8dfd$require$FORCED_PROMISE_CONSTRUCTOR = $9f396b151913828c$exports.CONSTRUCTOR;




var $0c5ab965f25b8dfd$var$NativePromisePrototype = $70036dd3bda909a3$exports && $70036dd3bda909a3$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$5cebaf28941ec4e5$exports({
    target: "Promise",
    proto: true,
    forced: $0c5ab965f25b8dfd$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$3a92d99f6c30b995$exports && $9db74248a53aaffc$exports($70036dd3bda909a3$exports)) {
    var $0c5ab965f25b8dfd$var$method = $468e1877ee71c3bf$exports("Promise").prototype["catch"];
    if ($0c5ab965f25b8dfd$var$NativePromisePrototype["catch"] !== $0c5ab965f25b8dfd$var$method) $1675d88d56a1053c$exports($0c5ab965f25b8dfd$var$NativePromisePrototype, "catch", $0c5ab965f25b8dfd$var$method, {
        unsafe: true
    });
}


"use strict";







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$5cebaf28941ec4e5$exports({
    target: "Promise",
    stat: true,
    forced: $11f0b10bb6c1c19d$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $d2e3d0e4d6d7f4bb$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $c72a4a0a91592955$exports(function() {
            var $promiseResolve = $35fd29c4b881594d$exports(C.resolve);
            $2edc7939131f352e$exports(iterable, function(promise) {
                $95617c3e1592e9a7$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $32341d79a768a989$require$FORCED_PROMISE_CONSTRUCTOR = $9f396b151913828c$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$5cebaf28941ec4e5$exports({
    target: "Promise",
    stat: true,
    forced: $32341d79a768a989$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $d2e3d0e4d6d7f4bb$export$2d1720544b23b823(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});


"use strict";





var $15a91279bac2872b$require$FORCED_PROMISE_CONSTRUCTOR = $9f396b151913828c$exports.CONSTRUCTOR;
var $f1a23890072d0cf4$exports = {};
"use strict";



$f1a23890072d0cf4$exports = function(C, x) {
    $e524200f7829c91a$exports(C);
    if ($c989e06804ef7492$exports(x) && x.constructor === C) return x;
    var promiseCapability = $d2e3d0e4d6d7f4bb$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $15a91279bac2872b$var$PromiseConstructorWrapper = $468e1877ee71c3bf$exports("Promise");
var $15a91279bac2872b$var$CHECK_WRAPPER = $3a92d99f6c30b995$exports && !$15a91279bac2872b$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$5cebaf28941ec4e5$exports({
    target: "Promise",
    stat: true,
    forced: $3a92d99f6c30b995$exports || $15a91279bac2872b$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $f1a23890072d0cf4$exports($15a91279bac2872b$var$CHECK_WRAPPER && this === $15a91279bac2872b$var$PromiseConstructorWrapper ? $70036dd3bda909a3$exports : this, x);
    }
});




"use strict";


// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$5cebaf28941ec4e5$exports({
    target: "Promise",
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $d2e3d0e4d6d7f4bb$export$2d1720544b23b823(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});




var $ae12bd65068304e6$exports = {};
"use strict";

$ae12bd65068304e6$exports = $321821ab316477fa$exports;


var $31af1400a13a9390$var$Promise = $ae12bd65068304e6$exports.Promise;
var $31af1400a13a9390$var$promiseWithResolvers = $31af1400a13a9390$var$Promise.withResolvers;
$31af1400a13a9390$exports = function withResolvers() {
    return $95617c3e1592e9a7$exports($31af1400a13a9390$var$promiseWithResolvers, $9db74248a53aaffc$exports(this) ? this : $31af1400a13a9390$var$Promise);
};



var $1aYx7 = parcelRequire("1aYx7");
function $18d652d68c6da19f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $18d652d68c6da19f$var$$eef213ff4197108b$exports = {};
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$eef213ff4197108b$exports, "Stack", function() {
    return $18d652d68c6da19f$export$694e0d28c7ffc90c;
});
const { push: $18d652d68c6da19f$var$$eef213ff4197108b$var$push } = Array.prototype;
class $18d652d68c6da19f$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $18d652d68c6da19f$var$$eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $18d652d68c6da19f$var$$0fe1f1400993ba8a$exports = {};
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $18d652d68c6da19f$export$4125cfe7e08e2040;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $18d652d68c6da19f$export$aa9d629c530f62a7;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "headerParser", function() {
    return $18d652d68c6da19f$export$b725a69477e4d33f;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $18d652d68c6da19f$export$eea2c1c5e1a37e50;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "parseBody", function() {
    return $18d652d68c6da19f$export$3b629cd0ff482602;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $18d652d68c6da19f$export$4f2a8c8c11a6373a;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $18d652d68c6da19f$export$bda27a3e49197b9;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $18d652d68c6da19f$export$ba14d9a5a581e827;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "iterateFetchBody", function() {
    return $18d652d68c6da19f$export$a95ada708dd8b125;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $18d652d68c6da19f$export$b7b86d31099674dc;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$0fe1f1400993ba8a$exports, "request", function() {
    return $18d652d68c6da19f$export$b5fe3f66a567bec0;
});
var $18d652d68c6da19f$var$$22de11b45b0eeb97$exports = {};
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "parseDocument", function() {
    return $18d652d68c6da19f$export$b6a9369736b19f4d;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "makeFormData", function() {
    return $18d652d68c6da19f$export$2c28ab2e118e73f1;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "serializeNode", function() {
    return $18d652d68c6da19f$export$a0beee2e55fb5dd1;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "serialize", function() {
    return $18d652d68c6da19f$export$dfdc1655ccc5b9cb;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $18d652d68c6da19f$export$f8162fcba31fa547;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "FileMethod", function() {
    return $18d652d68c6da19f$export$226b21d2db5eaf9f;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "readAs", function() {
    return $18d652d68c6da19f$export$e209cbb66c5b18c;
});
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $18d652d68c6da19f$export$8fb536984ec8b4d7;
});
/**
 * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/70}
 */ AbortSignal.prototype.throwIfAborted ||= function() {
    const { aborted: aborted, reason: reason = "Aborted" } = this;
    if (!aborted) return;
    throw reason instanceof DOMException ? reason : new DOMException(reason instanceof Error ? reason.message : reason + "", "AbortError");
};
/**
 * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/73#issuecomment-2085543258}
 */ AbortSignal.any ||= (iterable)=>{
    const controller = new AbortController();
    function abort() {
        controller.abort(this.reason);
        clean();
    }
    function clean() {
        for (const signal of iterable)signal.removeEventListener("abort", abort);
    }
    for (const signal of iterable)if (signal.aborted) {
        controller.abort(signal.reason);
        break;
    } else signal.addEventListener("abort", abort);
    return controller.signal;
};
async function $18d652d68c6da19f$export$b6a9369736b19f4d(text, contentType = "") {
    const [type] = contentType?.split(";") || [];
    return new DOMParser().parseFromString(text, type || "text/html");
}
function $18d652d68c6da19f$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== "string" && (0, $1aYx7.likeArray)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === "object") formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $18d652d68c6da19f$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? "image/svg" : root instanceof HTMLDocument || root instanceof HTMLElement ? "text/html" : "application/xml",
        data: (0, $1aYx7.stringifyDOM)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: "multipart/form-data",
        data: new FormData(root)
    };
    const data = (0, $1aYx7.formToJSON)(root);
    switch(contentType = root.enctype){
        case "text/plain":
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join("\n")
            };
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data) + ""
            };
        default:
            return {
                contentType: "application/json",
                data: JSON.stringify(data)
            };
    }
}
function $18d652d68c6da19f$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(";") || [];
    switch(type){
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case "multipart/form-data":
            return {
                data: $18d652d68c6da19f$export$2c28ab2e118e73f1(data)
            };
        case "application/json":
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case "text/html":
        case "application/xml":
        case "image/svg":
            return {
                contentType: contentType,
                data: (0, $1aYx7.stringifyDOM)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: "application/x-www-form-urlencoded",
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $18d652d68c6da19f$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $1aYx7.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: "application/octet-stream",
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: "application/json",
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error("Unserialized Object needs a specific Content-Type");
}
const $18d652d68c6da19f$export$f8162fcba31fa547 = (target)=>(0, $1aYx7.createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            if (loaded < total) next({
                loaded: loaded,
                total: total
            });
            else {
                if (loaded === total) next({
                    loaded: loaded,
                    total: total
                });
                complete();
            }
        };
        target.addEventListener("progress", handleProgress);
        target.addEventListener("error", error);
        return ()=>{
            target.removeEventListener("progress", handleProgress);
            target.removeEventListener("error", error);
        };
    });
var $18d652d68c6da19f$export$226b21d2db5eaf9f;
(function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
})($18d652d68c6da19f$export$226b21d2db5eaf9f || ($18d652d68c6da19f$export$226b21d2db5eaf9f = {}));
function $18d652d68c6da19f$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    const result = new Promise((resolve, reject)=>{
        reader.onerror = reject;
        reader.onload = ()=>resolve(reader.result);
        reader[$18d652d68c6da19f$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $18d652d68c6da19f$export$f8162fcba31fa547(reader),
        result: result
    };
}
const $18d652d68c6da19f$var$$22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
async function $18d652d68c6da19f$export$8fb536984ec8b4d7(raw) {
    if (raw instanceof Blob) {
        const text = await $18d652d68c6da19f$export$e209cbb66c5b18c(raw, "dataURL").result;
        return ($18d652d68c6da19f$var$$22de11b45b0eeb97$var$DataURI.exec(text) || "")[4];
    }
    const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+("0x" + p1)));
    return btoa(text);
}
var $18d652d68c6da19f$export$4125cfe7e08e2040;
(function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
})($18d652d68c6da19f$export$4125cfe7e08e2040 || ($18d652d68c6da19f$export$4125cfe7e08e2040 = {}));
class $18d652d68c6da19f$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message);
        this.request = request;
        this.response = response;
    }
}
const $18d652d68c6da19f$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $18d652d68c6da19f$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $18d652d68c6da19f$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $18d652d68c6da19f$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes("json")) return (0, $1aYx7.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return $18d652d68c6da19f$export$b6a9369736b19f4d(raw, contentType);
    } catch  {}
    if (contentType.includes("text")) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $18d652d68c6da19f$export$4f2a8c8c11a6373a({ method: method = "GET", path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest(), header_list = headers instanceof Array ? headers : headers?.[Symbol.iterator] instanceof Function ? [
        ...headers
    ] : Object.entries(headers);
    const abort = ()=>request.abort();
    signal?.addEventListener("abort", abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
            if (readyState !== 4 || !status && !signal?.aborted) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $18d652d68c6da19f$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== "text" ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        request.open(method, path + "");
        for (const [key, value] of header_list)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        request.send(body);
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader("Content-Type") || "";
        if (typeof body === "string" && !contentType.includes("text")) body = $18d652d68c6da19f$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener("abort", abort));
    return {
        response: response,
        upload: $18d652d68c6da19f$export$f8162fcba31fa547(request.upload),
        download: $18d652d68c6da19f$export$f8162fcba31fa547(request)
    };
}
function $18d652d68c6da19f$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === "text" ? {
        ...headers,
        Accept: "text/plain"
    } : responseType === "json" ? {
        ...headers,
        Accept: "application/json"
    } : responseType === "document" ? {
        ...headers,
        Accept: "text/html, application/xhtml+xml, application/xml"
    } : responseType === "arraybuffer" || responseType === "blob" ? {
        ...headers,
        Accept: "application/octet-stream"
    } : headers;
    const responsePromise = fetch(path + "", {
        method: method,
        headers: headers,
        credentials: withCredentials ? "include" : "omit",
        body: body,
        signal: signals[0] && AbortSignal.any(signals)
    });
    return {
        response: $18d652d68c6da19f$export$ba14d9a5a581e827(responsePromise, responseType),
        download: $18d652d68c6da19f$export$a95ada708dd8b125(responsePromise)
    };
}
async function $18d652d68c6da19f$export$ba14d9a5a581e827(responsePromise, responseType) {
    const { status: status, statusText: statusText, headers: headers, body: body } = (await responsePromise).clone();
    const contentType = headers.get("Content-Type") || "";
    const header = $18d652d68c6da19f$export$eea2c1c5e1a37e50([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join("\n"));
    const rBody = status === 204 ? undefined : await $18d652d68c6da19f$export$b7b86d31099674dc(body, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $18d652d68c6da19f$export$b7b86d31099674dc(stream, contentType, responseType) {
    const chunks = [];
    for await (const chunk of stream)chunks.push(chunk);
    const blob = new Blob(chunks, {
        type: contentType
    });
    if (responseType === "blob") return blob;
    if (responseType === "arraybuffer") return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === "text") return text;
    return $18d652d68c6da19f$export$3b629cd0ff482602(text, contentType);
}
async function* $18d652d68c6da19f$export$a95ada708dd8b125(responsePromise) {
    const { headers: headers, body: body } = (await responsePromise).clone();
    const total = +headers.get("Content-Length");
    var loaded = 0;
    for await (const { byteLength: byteLength } of body){
        loaded += byteLength;
        yield {
            total: total,
            loaded: loaded
        };
    }
}
const $18d652d68c6da19f$export$b5fe3f66a567bec0 = (options)=>typeof globalThis.XMLHttpRequest === "function" ? $18d652d68c6da19f$export$4f2a8c8c11a6373a(options) : $18d652d68c6da19f$export$bda27a3e49197b9(options);
var $18d652d68c6da19f$var$$cbd22d3323bef9ca$exports = {};
$18d652d68c6da19f$var$$parcel$export($18d652d68c6da19f$var$$cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $18d652d68c6da19f$export$45cf759b359d3d24;
});
const { splice: $18d652d68c6da19f$var$$cbd22d3323bef9ca$var$splice } = Array.prototype;
class $18d652d68c6da19f$export$45cf759b359d3d24 extends $18d652d68c6da19f$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, ...options } = {}){
        super();
        this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = "GET", headers: headers = {}, body: body } = request;
            if (method in $18d652d68c6da19f$export$4125cfe7e08e2040 && body && typeof body === "object") {
                const { contentType: contentType, data: data } = $18d652d68c6da19f$export$dfdc1655ccc5b9cb(body, headers["Content-Type"]);
                if (contentType) headers["Content-Type"] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $18d652d68c6da19f$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI, this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + "", this.baseURI) + "";
            Object.assign(response, await $18d652d68c6da19f$export$b5fe3f66a567bec0({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $18d652d68c6da19f$var$$cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: "HEAD",
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: "GET",
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: "POST",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: "PUT",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: "PATCH",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: "DELETE",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { "Content-Length": length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { "Content-Range": range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split("/").pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}


var $4d6c1e40732b8be5$exports = {};

$parcel$export($4d6c1e40732b8be5$exports, "FileSystemDirectoryHandle", () => (parcelRequire("2Fv9o")).default);
$parcel$export($4d6c1e40732b8be5$exports, "FileSystemFileHandle", () => (parcelRequire("ggMY5")).default);
$parcel$export($4d6c1e40732b8be5$exports, "FileSystemHandle", () => (parcelRequire("bAgeV")).default);
$parcel$export($4d6c1e40732b8be5$exports, "FileSystemWritableFileStream", () => (parcelRequire("gnYLk")).default);
$parcel$export($4d6c1e40732b8be5$exports, "getOriginPrivateDirectory", () => $a2b6548d31efdf58$export$2e2bcd8739ae039);
$parcel$export($4d6c1e40732b8be5$exports, "showDirectoryPicker", () => $ad29246aa7344157$export$2e2bcd8739ae039);
$parcel$export($4d6c1e40732b8be5$exports, "showOpenFilePicker", () => $0640d4e43c7e61d0$export$2e2bcd8739ae039);
$parcel$export($4d6c1e40732b8be5$exports, "showSaveFilePicker", () => $1f9e5b323df984d3$export$2e2bcd8739ae039);
/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ const $ad29246aa7344157$var$native = globalThis.showDirectoryPicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemDirectoryHandle>}
 */ async function $ad29246aa7344157$export$6030ffa7b5d2eb28(options = {}) {
    if ($ad29246aa7344157$var$native && !options._preferPolyfill) return $ad29246aa7344157$var$native(options);
    const input = document.createElement("input");
    input.type = "file";
    input.webkitdirectory = true;
    // Fallback to multiple files input for iOS Safari
    input.multiple = true;
    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
    input.style.position = "fixed";
    input.style.top = "-100000px";
    input.style.left = "-100000px";
    document.body.appendChild(input);
    // Lazy load while the user is choosing the directory
    const p = Promise.resolve((parcelRequire("jG9Jm")));
    await new Promise((resolve)=>{
        input.addEventListener("change", resolve);
        input.click();
    });
    return p.then((mod)=>mod.getDirHandlesFromInput(input));
}
var $ad29246aa7344157$export$2e2bcd8739ae039 = $ad29246aa7344157$export$6030ffa7b5d2eb28;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ const $0640d4e43c7e61d0$var$def = {
    accepts: []
};
const $0640d4e43c7e61d0$var$native = globalThis.showOpenFilePicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options.multiple] If you want to allow more than one file
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.accepts] Files you want to accept
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemFileHandle[]>}
 */ async function $0640d4e43c7e61d0$export$9a17f2258b27c445(options = {}) {
    const opts = {
        ...$0640d4e43c7e61d0$var$def,
        ...options
    };
    if ($0640d4e43c7e61d0$var$native && !options._preferPolyfill) return $0640d4e43c7e61d0$var$native(opts);
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = opts.multiple;
    input.accept = (opts.accepts || []).map((e)=>[
            ...(e.extensions || []).map((e)=>"." + e),
            ...e.mimeTypes || []
        ]).flat().join(",");
    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
    Object.assign(input.style, {
        position: "fixed",
        top: "-100000px",
        left: "-100000px"
    });
    document.body.appendChild(input);
    // Lazy load while the user is choosing the directory
    const p = Promise.resolve((parcelRequire("jG9Jm")));
    await new Promise((resolve)=>{
        input.addEventListener("change", resolve, {
            once: true
        });
        input.click();
    });
    input.remove();
    return p.then((m)=>m.getFileHandlesFromInput(input));
}
var $0640d4e43c7e61d0$export$2e2bcd8739ae039 = $0640d4e43c7e61d0$export$9a17f2258b27c445;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ const $1f9e5b323df984d3$var$native = globalThis.showSaveFilePicker;


/**
 * @param {Object} [options]
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.types] Files you want to accept
 * @param {string} [options.suggestedName] the name to fall back to when using polyfill
 * @param {string} [options._name] the name to fall back to when using polyfill
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @return {Promise<FileSystemFileHandle>}
 */ async function $1f9e5b323df984d3$export$f8b17fb0c2d91989(options = {}) {
    if ($1f9e5b323df984d3$var$native && !options._preferPolyfill) return $1f9e5b323df984d3$var$native(options);
    if (options._name) {
        console.warn("deprecated _name, spec now have `suggestedName`");
        options.suggestedName = options._name;
    }
    const { FileSystemFileHandle: FileSystemFileHandle } = await (parcelRequire("8O2Cb"));
    const { FileHandle: FileHandle } = await (parcelRequire("gMgVc"));
    return new FileSystemFileHandle(new FileHandle(options.suggestedName));
}
var $1f9e5b323df984d3$export$2e2bcd8739ae039 = $1f9e5b323df984d3$export$f8b17fb0c2d91989;


/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ 


if (globalThis.DataTransferItem && !DataTransferItem.prototype.getAsFileSystemHandle) DataTransferItem.prototype.getAsFileSystemHandle = async function() {
    const entry = this.webkitGetAsEntry();
    const [{ FileHandle: FileHandle, FolderHandle: FolderHandle }, { FileSystemDirectoryHandle: FileSystemDirectoryHandle }, { FileSystemFileHandle: FileSystemFileHandle }] = await Promise.all([
        (parcelRequire("9aeU0")),
        (parcelRequire("dzTwg")),
        (parcelRequire("8O2Cb"))
    ]);
    return entry.isFile ? new FileSystemFileHandle(new FileHandle(entry, false)) : new FileSystemDirectoryHandle(new FolderHandle(entry, false));
};

/**
 * @param {object=} driver
 * @return {Promise<FileSystemDirectoryHandle>}
 */ async function $a2b6548d31efdf58$var$getOriginPrivateDirectory(driver, options = {}) {
    if (!driver) return globalThis.navigator?.storage?.getDirectory() || globalThis.getOriginPrivateDirectory();
    const { FileSystemDirectoryHandle: FileSystemDirectoryHandle } = await (parcelRequire("dzTwg"));
    const module = await driver;
    const sandbox = await (module.default ? module.default(options) : module(options));
    return new FileSystemDirectoryHandle(sandbox);
}
var $a2b6548d31efdf58$export$2e2bcd8739ae039 = $a2b6548d31efdf58$var$getOriginPrivateDirectory;



var $gnYLk = parcelRequire("gnYLk");

var $2Fv9o = parcelRequire("2Fv9o");

var $ggMY5 = parcelRequire("ggMY5");

var $bAgeV = parcelRequire("bAgeV");



var $i3JFt = parcelRequire("i3JFt");
function $9e9c5688c76adff9$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $9e9c5688c76adff9$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $9e9c5688c76adff9$var$$082ef78710a13331$exports = {};
var $9e9c5688c76adff9$var$$80184bab4212ab17$exports = {};
var $9e9c5688c76adff9$var$$400caf514fe4dd82$exports = {};
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $9e9c5688c76adff9$export$e03c1c3201ee8bb7;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $9e9c5688c76adff9$export$6287f85d0f6a9342;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$400caf514fe4dd82$exports, "persist", function() {
    return $9e9c5688c76adff9$export$9a6132153fba2e0;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$400caf514fe4dd82$exports, "restore", function() {
    return $9e9c5688c76adff9$export$db239ef39aadc7fe;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $9e9c5688c76adff9$export$b1fb4cac938035f7;
});
var $9e9c5688c76adff9$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $9e9c5688c76adff9$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $9e9c5688c76adff9$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === "number" ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === "number" ? --value : false);
                }
            });
        };
}
function $9e9c5688c76adff9$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $9e9c5688c76adff9$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === "granted") return new Notification(typeof message === "function" ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
const $9e9c5688c76adff9$var$$400caf514fe4dd82$var$PersistKeys = new WeakMap();
function $9e9c5688c76adff9$export$9a6132153fba2e0(patcher = {}) {
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $9e9c5688c76adff9$var$$400caf514fe4dd82$var$PersistKeys.get(this) || [];
            list.push(Object.assign(Object.assign({}, patcher), {
                key: name.toString()
            }));
            $9e9c5688c76adff9$var$$400caf514fe4dd82$var$PersistKeys.set(this, list);
        });
    };
}
function $9e9c5688c76adff9$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $9e9c5688c76adff9$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        var _a;
        const { get: load, set: save } = yield $9f9ad051847c8abe$exports, list = $9e9c5688c76adff9$var$$400caf514fe4dd82$var$PersistKeys.get(classInstance) || [], restoredData = {};
        for (const { key: key, get: get, set: set } of list){
            const itemKey = `${storeKey}-${key}`;
            const value = yield load(itemKey);
            const patchedValue = (_a = get === null || get === void 0 ? void 0 : get(value)) !== null && _a !== void 0 ? _a : value;
            if (patchedValue != null) {
                Reflect.set(classInstance, key, patchedValue);
                restoredData[key] = patchedValue;
            }
            (0, $aM14C.reaction)(()=>classInstance[key], (value)=>{
                const patchedValue = set === null || set === void 0 ? void 0 : set(value);
                return save(itemKey, patchedValue !== null && patchedValue !== void 0 ? patchedValue : (0, $aM14C.toJS)(value));
            });
        }
        if ((0, $1aYx7.isEmpty)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $9e9c5688c76adff9$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $9e9c5688c76adff9$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const { del: del } = yield $9f9ad051847c8abe$exports, list = $9e9c5688c76adff9$var$$400caf514fe4dd82$var$PersistKeys.get(classInstance) || [];
        for (const { key: key } of list){
            const itemKey = `${storeKey}-${key}`;
            yield del(itemKey);
        }
    });
}
$9e9c5688c76adff9$var$$parcel$exportWildcard($9e9c5688c76adff9$var$$082ef78710a13331$exports, $9e9c5688c76adff9$var$$80184bab4212ab17$exports);
$9e9c5688c76adff9$var$$parcel$exportWildcard($9e9c5688c76adff9$var$$082ef78710a13331$exports, $9e9c5688c76adff9$var$$400caf514fe4dd82$exports);
var $9e9c5688c76adff9$var$$16892940cfb7bd51$exports = {};
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $9e9c5688c76adff9$export$d12e20a4eec10acf;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $9e9c5688c76adff9$export$673dbc4a8d0cb20a;
});
var $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $9e9c5688c76adff9$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $aM14C.observable)
        ];
        _uploading_decorators = [
            (0, $aM14C.observable)
        ];
        _clear_decorators = [
            (0, $aM14C.action)
        ];
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $9e9c5688c76adff9$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $9e9c5688c76adff9$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + "");
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), "id")
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $aM14C.observable)
        ];
        _clearCurrent_decorators = [
            (0, $aM14C.action)
        ];
        _updateOne_decorators = [
            $9e9c5688c76adff9$export$e03c1c3201ee8bb7("uploading")
        ];
        _getOne_decorators = [
            $9e9c5688c76adff9$export$e03c1c3201ee8bb7("downloading")
        ];
        _deleteOne_decorators = [
            $9e9c5688c76adff9$export$e03c1c3201ee8bb7("uploading")
        ];
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $9e9c5688c76adff9$var$$5766c49bacaeb5b8$exports = {};
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $9e9c5688c76adff9$export$36e5777a1ba4b7c3;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $9e9c5688c76adff9$export$a143d493d941bafc;
});
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $9e9c5688c76adff9$export$6a4eb2e7fc9e8903;
});
var $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $9e9c5688c76adff9$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage;
    let _classSuper = $9e9c5688c76adff9$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        get pageIndex() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $aM14C.toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $1aYx7.splitArray)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $1aYx7.splitArray)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAll() {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageSize = this.pageSize) {
                while(!this.noMore)yield this.getList(filter, undefined, pageSize);
                return this.allItems;
            });
        }
        countAll(keys_1) {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $1aYx7.countBy)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers);
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _pageIndex_decorators = [
            (0, $aM14C.observable)
        ];
        _pageSize_decorators = [
            (0, $aM14C.observable)
        ];
        _filter_decorators = [
            (0, $aM14C.observable)
        ];
        _totalCount_decorators = [
            (0, $aM14C.observable)
        ];
        _pageList_decorators = [
            (0, $aM14C.observable)
        ];
        _get_currentPage_decorators = [
            (0, $aM14C.computed)
        ];
        _get_pageCount_decorators = [
            (0, $aM14C.computed)
        ];
        _get_allItems_decorators = [
            (0, $aM14C.computed)
        ];
        _get_noMore_decorators = [
            (0, $aM14C.computed)
        ];
        _statistic_decorators = [
            (0, $aM14C.observable)
        ];
        _clearList_decorators = [
            (0, $aM14C.action)
        ];
        _restoreList_decorators = [
            (0, $aM14C.action)
        ];
        _turnTo_decorators = [
            (0, $aM14C.action)
        ];
        _getList_decorators = [
            $9e9c5688c76adff9$export$e03c1c3201ee8bb7("downloading")
        ];
        _deleteOne_decorators = [
            $9e9c5688c76adff9$export$e03c1c3201ee8bb7("uploading")
        ];
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $9e9c5688c76adff9$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $aM14C.action),
                $9e9c5688c76adff9$export$e03c1c3201ee8bb7("downloading")
            ];
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $9e9c5688c76adff9$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $1aYx7.splitArray)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $9e9c5688c76adff9$export$e03c1c3201ee8bb7("downloading")
            ];
            $9e9c5688c76adff9$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}
var $9e9c5688c76adff9$var$$5bda69183db6db33$exports = {};
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$5bda69183db6db33$exports, "Downloader", function() {
    return $9e9c5688c76adff9$export$ef06e7620d37c296;
});
var $9e9c5688c76adff9$var$$71107f2a0d00cd1d$exports = {};
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$71107f2a0d00cd1d$exports, "HTTPDownloadTask", function() {
    return $9e9c5688c76adff9$export$54a5aef4e85ae85;
});
var $9e9c5688c76adff9$var$$d278b456907e9c31$exports = {};
$9e9c5688c76adff9$var$$parcel$export($9e9c5688c76adff9$var$$d278b456907e9c31$exports, "DownloadTask", function() {
    return $9e9c5688c76adff9$export$e9ba70c733fe1cb8;
});
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9e9c5688c76adff9$var$$d278b456907e9c31$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
let $9e9c5688c76adff9$export$e9ba70c733fe1cb8 = (()=>{
    var _a, _DownloadTask_id_accessor_storage, _DownloadTask_name_accessor_storage, _DownloadTask_path_accessor_storage, _DownloadTask_fsHandle_accessor_storage, _DownloadTask_total_accessor_storage, _DownloadTask_loaded_accessor_storage, _DownloadTask_percent_accessor_storage, _DownloadTask_executing_accessor_storage, _DownloadTask_options_accessor_storage;
    var _b;
    let _instanceExtraInitializers = [];
    let _id_decorators;
    let _id_initializers = [];
    let _id_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _fsHandle_decorators;
    let _fsHandle_initializers = [];
    let _fsHandle_extraInitializers = [];
    let _total_decorators;
    let _total_initializers = [];
    let _total_extraInitializers = [];
    let _loaded_decorators;
    let _loaded_initializers = [];
    let _loaded_extraInitializers = [];
    let _percent_decorators;
    let _percent_initializers = [];
    let _percent_extraInitializers = [];
    let _executing_decorators;
    let _executing_initializers = [];
    let _executing_extraInitializers = [];
    let _options_decorators;
    let _options_initializers = [];
    let _options_extraInitializers = [];
    let _get_totalSize_decorators;
    let _get_loadedSize_decorators;
    return _a = class DownloadTask {
        get id() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_id_accessor_storage, "f");
        }
        set id(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_id_accessor_storage, value, "f");
        }
        get name() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_name_accessor_storage, "f");
        }
        set name(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_name_accessor_storage, value, "f");
        }
        get path() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_path_accessor_storage, "f");
        }
        set path(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_path_accessor_storage, value, "f");
        }
        get fsHandle() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_fsHandle_accessor_storage, "f");
        }
        set fsHandle(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_fsHandle_accessor_storage, value, "f");
        }
        get total() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_total_accessor_storage, "f");
        }
        set total(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_total_accessor_storage, value, "f");
        }
        get loaded() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_loaded_accessor_storage, "f");
        }
        set loaded(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_loaded_accessor_storage, value, "f");
        }
        get percent() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_percent_accessor_storage, "f");
        }
        set percent(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_percent_accessor_storage, value, "f");
        }
        get executing() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_executing_accessor_storage, "f");
        }
        set executing(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_executing_accessor_storage, value, "f");
        }
        get options() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_options_accessor_storage, "f");
        }
        set options(value) {
            $9e9c5688c76adff9$var$$d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_options_accessor_storage, value, "f");
        }
        get totalSize() {
            return new (0, $1aYx7.ByteSize)(this.total);
        }
        get loadedSize() {
            return new (0, $1aYx7.ByteSize)(this.loaded);
        }
        static nameOf(URI) {
            return decodeURI(new URL(URI).pathname.split("/").filter(Boolean).at(-1));
        }
        constructor(path, name = _a.nameOf(path)){
            _DownloadTask_id_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _instanceExtraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _id_initializers, "")));
            _DownloadTask_name_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _id_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _name_initializers, "")));
            _DownloadTask_path_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _name_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _path_initializers, "")));
            _DownloadTask_fsHandle_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _path_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _fsHandle_initializers, void 0)));
            _DownloadTask_total_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _fsHandle_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _total_initializers, 0)));
            _DownloadTask_loaded_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _total_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _loaded_initializers, 0)));
            _DownloadTask_percent_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _loaded_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _percent_initializers, 0)));
            _DownloadTask_executing_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _percent_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _executing_initializers, false)));
            _DownloadTask_options_accessor_storage.set(this, ($9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _executing_extraInitializers), $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _options_initializers, void 0)));
            Object.defineProperty(this, "stream", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $9e9c5688c76adff9$var$$d278b456907e9c31$var$__runInitializers(this, _options_extraInitializers)
            });
            this.path = path;
            this.name = name;
        }
        toJSON() {
            const { id: id, name: name, path: path, fsHandle: fsHandle, total: total, loaded: loaded, percent: percent, options: options } = this;
            return Object.assign({
                id: id,
                name: name,
                path: path,
                fsHandle: fsHandle,
                options: options
            }, {
                total: total,
                loaded: loaded,
                percent: percent
            });
        }
        saveMeta(data = {}) {
            const { buffer: buffer } = data, progress = $9e9c5688c76adff9$var$$d278b456907e9c31$var$__rest(data, [
                "buffer"
            ]);
            Object.assign(this, progress);
            return data;
        }
        start() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__awaiter(this, arguments, void 0, function*(options = this.options) {
                this.options = options;
                const started = Promise.withResolvers();
                const [innerStream, outerStream] = (yield $i3JFt).ReadableStream.from(this.loadStream(options)).tee();
                (()=>$9e9c5688c76adff9$var$$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                        var _b, e_1, _c, _d;
                        try {
                            try {
                                for(var _e = true, innerStream_1 = $9e9c5688c76adff9$var$$d278b456907e9c31$var$__asyncValues(innerStream), innerStream_1_1; innerStream_1_1 = yield innerStream_1.next(), _b = innerStream_1_1.done, !_b; _e = true){
                                    _d = innerStream_1_1.value;
                                    _e = false;
                                    const chunk = _d;
                                    started.resolve();
                                    console.table(chunk);
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (!_e && !_b && (_c = innerStream_1.return)) yield _c.call(innerStream_1);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                        } catch (error) {
                            started.reject(error);
                        }
                    }))();
                yield started.promise;
                return this.stream = outerStream;
            });
        }
        pause() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                this.executing = false;
            });
        }
        destroy() {
            return $9e9c5688c76adff9$var$$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pause();
                return $9e9c5688c76adff9$export$b1fb4cac938035f7(this, this.id);
            });
        }
    }, _DownloadTask_id_accessor_storage = new WeakMap(), _DownloadTask_name_accessor_storage = new WeakMap(), _DownloadTask_path_accessor_storage = new WeakMap(), _DownloadTask_fsHandle_accessor_storage = new WeakMap(), _DownloadTask_total_accessor_storage = new WeakMap(), _DownloadTask_loaded_accessor_storage = new WeakMap(), _DownloadTask_percent_accessor_storage = new WeakMap(), _DownloadTask_executing_accessor_storage = new WeakMap(), _DownloadTask_options_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _name_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _path_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _fsHandle_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (_b = (0, $aM14C.observable)).ref.bind(_b)
        ];
        _total_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _loaded_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _percent_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _executing_decorators = [
            (0, $aM14C.observable)
        ];
        _options_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0(),
            (0, $aM14C.observable)
        ];
        _get_totalSize_decorators = [
            (0, $aM14C.computed)
        ];
        _get_loadedSize_decorators = [
            (0, $aM14C.computed)
        ];
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: (obj)=>"id" in obj,
                get: (obj)=>obj.id,
                set: (obj, value)=>{
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"name" in obj,
                get: (obj)=>obj.name,
                set: (obj, value)=>{
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _fsHandle_decorators, {
            kind: "accessor",
            name: "fsHandle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fsHandle" in obj,
                get: (obj)=>obj.fsHandle,
                set: (obj, value)=>{
                    obj.fsHandle = value;
                }
            },
            metadata: _metadata
        }, _fsHandle_initializers, _fsHandle_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _total_decorators, {
            kind: "accessor",
            name: "total",
            static: false,
            private: false,
            access: {
                has: (obj)=>"total" in obj,
                get: (obj)=>obj.total,
                set: (obj, value)=>{
                    obj.total = value;
                }
            },
            metadata: _metadata
        }, _total_initializers, _total_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _loaded_decorators, {
            kind: "accessor",
            name: "loaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loaded" in obj,
                get: (obj)=>obj.loaded,
                set: (obj, value)=>{
                    obj.loaded = value;
                }
            },
            metadata: _metadata
        }, _loaded_initializers, _loaded_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _percent_decorators, {
            kind: "accessor",
            name: "percent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"percent" in obj,
                get: (obj)=>obj.percent,
                set: (obj, value)=>{
                    obj.percent = value;
                }
            },
            metadata: _metadata
        }, _percent_initializers, _percent_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _executing_decorators, {
            kind: "accessor",
            name: "executing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executing" in obj,
                get: (obj)=>obj.executing,
                set: (obj, value)=>{
                    obj.executing = value;
                }
            },
            metadata: _metadata
        }, _executing_initializers, _executing_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _options_decorators, {
            kind: "accessor",
            name: "options",
            static: false,
            private: false,
            access: {
                has: (obj)=>"options" in obj,
                get: (obj)=>obj.options,
                set: (obj, value)=>{
                    obj.options = value;
                }
            },
            metadata: _metadata
        }, _options_initializers, _options_extraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _get_totalSize_decorators, {
            kind: "getter",
            name: "totalSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalSize" in obj,
                get: (obj)=>obj.totalSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$d278b456907e9c31$var$__esDecorate(_a, null, _get_loadedSize_decorators, {
            kind: "getter",
            name: "loadedSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadedSize" in obj,
                get: (obj)=>obj.loadedSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await = function(v) {
    return this instanceof $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await ? (this.v = v, this) : new $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(v);
};
var $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $9e9c5688c76adff9$export$54a5aef4e85ae85 extends $9e9c5688c76adff9$export$e9ba70c733fe1cb8 {
    constructor(path, name){
        super(path, name);
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, $18d652d68c6da19f$export$45cf759b359d3d24)({
                responseType: "arraybuffer"
            })
        });
        this.id = `http-download-task-${this.name}`;
        $9e9c5688c76adff9$export$db239ef39aadc7fe(this, this.id);
    }
    loadStream(options) {
        return $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__asyncGenerator(this, arguments, function* loadStream_1() {
            var _a, e_1, _b, _c;
            const { path: path } = this;
            const suggestedName = $9e9c5688c76adff9$export$e9ba70c733fe1cb8.nameOf(path);
            this.fsHandle || (this.fsHandle = yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await((yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await($4d6c1e40732b8be5$exports)).showSaveFilePicker({
                suggestedName: suggestedName
            })));
            const writer = yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(this.fsHandle.createWritable({
                keepExistingData: true
            })), stream = this.client.download(path, Object.assign({
                range: [
                    this.loaded
                ]
            }, options));
            try {
                this.executing = true;
                try {
                    for(var _d = true, stream_1 = $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(stream_1.next()), _a = stream_1_1.done, !_a; _d = true){
                        _c = stream_1_1.value;
                        _d = false;
                        const chunk = _c;
                        yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(writer.write({
                            type: "write",
                            position: this.loaded,
                            data: chunk.buffer
                        }));
                        yield yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(this.saveMeta(chunk));
                        if (!this.executing) break;
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = stream_1.return)) yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(_b.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            } finally{
                yield $9e9c5688c76adff9$var$$71107f2a0d00cd1d$var$__await(writer.close());
                this.executing = false;
            }
        });
    }
}
var $9e9c5688c76adff9$var$$5bda69183db6db33$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9e9c5688c76adff9$var$$5bda69183db6db33$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9e9c5688c76adff9$var$$5bda69183db6db33$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9e9c5688c76adff9$var$$5bda69183db6db33$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9e9c5688c76adff9$var$$5bda69183db6db33$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $9e9c5688c76adff9$export$ef06e7620d37c296 = (()=>{
    var _a, _Downloader_tasks_accessor_storage;
    let _instanceExtraInitializers = [];
    let _tasks_decorators;
    let _tasks_initializers = [];
    let _tasks_extraInitializers = [];
    let _get_unfinishedCount_decorators;
    let _get_executingCount_decorators;
    return _a = class Downloader {
        static createTask(path, name) {
            const [protocol] = path.split(":");
            const ProtocolTask = _a.protocolMap[protocol];
            if (!ProtocolTask) throw new URIError(`Protocol "${protocol} has not been registered"`);
            return new ProtocolTask(path, name);
        }
        constructor(){
            _Downloader_tasks_accessor_storage.set(this, ($9e9c5688c76adff9$var$$5bda69183db6db33$var$__runInitializers(this, _instanceExtraInitializers), $9e9c5688c76adff9$var$$5bda69183db6db33$var$__runInitializers(this, _tasks_initializers, [])));
            $9e9c5688c76adff9$var$$5bda69183db6db33$var$__runInitializers(this, _tasks_extraInitializers);
            $9e9c5688c76adff9$export$db239ef39aadc7fe(this, "downloader");
        }
        get tasks() {
            return $9e9c5688c76adff9$var$$5bda69183db6db33$var$__classPrivateFieldGet(this, _Downloader_tasks_accessor_storage, "f");
        }
        set tasks(value) {
            $9e9c5688c76adff9$var$$5bda69183db6db33$var$__classPrivateFieldSet(this, _Downloader_tasks_accessor_storage, value, "f");
        }
        get unfinishedCount() {
            return this.tasks.filter(({ percent: percent })=>percent < 100).length;
        }
        get executingCount() {
            return this.tasks.filter(({ executing: executing })=>executing).length;
        }
        createTask(path, name) {
            const { tasks: tasks } = this;
            const sameTask = tasks.find((task)=>task.path === path);
            if (sameTask) return sameTask;
            const task = _a.createTask(path, name);
            this.tasks = [
                ...tasks,
                task
            ];
            return task;
        }
        destroyTask(name) {
            return $9e9c5688c76adff9$var$$5bda69183db6db33$var$__awaiter(this, void 0, void 0, function*() {
                const { tasks: tasks } = this;
                const index = tasks.findIndex(({ name: N })=>N === name);
                if (index < 0) throw new ReferenceError(`${name} isn't found`);
                yield tasks[index].destroy();
                this.tasks = [
                    ...tasks.slice(0, index),
                    ...tasks.slice(index + 1)
                ];
            });
        }
    }, _Downloader_tasks_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tasks_decorators = [
            $9e9c5688c76adff9$export$9a6132153fba2e0({
                set: (tasks)=>tasks.map(({ name: name, path: path })=>({
                            name: name,
                            path: path
                        })),
                get: (list)=>list === null || list === void 0 ? void 0 : list.map(({ name: name, path: path })=>$9e9c5688c76adff9$export$ef06e7620d37c296.createTask(path, name))
            }),
            (0, $aM14C.observable)
        ];
        _get_unfinishedCount_decorators = [
            (0, $aM14C.computed)
        ];
        _get_executingCount_decorators = [
            (0, $aM14C.computed)
        ];
        $9e9c5688c76adff9$var$$5bda69183db6db33$var$__esDecorate(_a, null, _tasks_decorators, {
            kind: "accessor",
            name: "tasks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tasks" in obj,
                get: (obj)=>obj.tasks,
                set: (obj, value)=>{
                    obj.tasks = value;
                }
            },
            metadata: _metadata
        }, _tasks_initializers, _tasks_extraInitializers);
        $9e9c5688c76adff9$var$$5bda69183db6db33$var$__esDecorate(_a, null, _get_unfinishedCount_decorators, {
            kind: "getter",
            name: "unfinishedCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"unfinishedCount" in obj,
                get: (obj)=>obj.unfinishedCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $9e9c5688c76adff9$var$$5bda69183db6db33$var$__esDecorate(_a, null, _get_executingCount_decorators, {
            kind: "getter",
            name: "executingCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executingCount" in obj,
                get: (obj)=>obj.executingCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), Object.defineProperty(_a, "protocolMap", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            http: $9e9c5688c76adff9$export$54a5aef4e85ae85,
            https: $9e9c5688c76adff9$export$54a5aef4e85ae85
        }
    }), _a;
})();
$9e9c5688c76adff9$var$$parcel$exportWildcard($9e9c5688c76adff9$var$$5bda69183db6db33$exports, $9e9c5688c76adff9$var$$71107f2a0d00cd1d$exports);
$9e9c5688c76adff9$var$$parcel$exportWildcard($9e9c5688c76adff9$var$$5bda69183db6db33$exports, $9e9c5688c76adff9$var$$d278b456907e9c31$exports);


var $6f4fef37bd1ca6c7$exports = {};
/**
 *
 * Entry point for tesseract.js, should be the entry when bundling.
 *
 * @fileoverview entry point for tesseract.js
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */ var $a8bc6f2ba36ecdad$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a8bc6f2ba36ecdad$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $a8bc6f2ba36ecdad$exports));
try {
    regeneratorRuntime = $a8bc6f2ba36ecdad$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a8bc6f2ba36ecdad$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a8bc6f2ba36ecdad$var$runtime);
}


var $49b16ef1d785ce5e$exports = {};
var $2420845b524afba2$exports = {};
var $552eb34024e7eafe$exports = {};
$552eb34024e7eafe$exports = (prefix, cnt)=>`${prefix}-${cnt}-${Math.random().toString(16).slice(3, 8)}`;


let $2420845b524afba2$var$jobCounter = 0;
$2420845b524afba2$exports = ({ id: _id, action: action, payload: payload = {} })=>{
    let id = _id;
    if (typeof id === "undefined") {
        id = $552eb34024e7eafe$exports("Job", $2420845b524afba2$var$jobCounter);
        $2420845b524afba2$var$jobCounter += 1;
    }
    return {
        id: id,
        action: action,
        payload: payload
    };
};


var $783866df820a0c01$exports = {};
let $783866df820a0c01$var$logging = false;
$783866df820a0c01$exports.logging = $783866df820a0c01$var$logging;
$783866df820a0c01$exports.setLogging = (_logging)=>{
    $783866df820a0c01$var$logging = _logging;
};
$783866df820a0c01$exports.log = (...args)=>$783866df820a0c01$var$logging ? console.log.apply($783866df820a0c01$exports, args) : null;


var $49b16ef1d785ce5e$require$log = $783866df820a0c01$exports.log;

let $49b16ef1d785ce5e$var$schedulerCounter = 0;
$49b16ef1d785ce5e$exports = ()=>{
    const id = $552eb34024e7eafe$exports("Scheduler", $49b16ef1d785ce5e$var$schedulerCounter);
    const workers = {};
    const runningWorkers = {};
    let jobQueue = [];
    $49b16ef1d785ce5e$var$schedulerCounter += 1;
    const getQueueLen = ()=>jobQueue.length;
    const getNumWorkers = ()=>Object.keys(workers).length;
    const dequeue = ()=>{
        if (jobQueue.length !== 0) {
            const wIds = Object.keys(workers);
            for(let i = 0; i < wIds.length; i += 1)if (typeof runningWorkers[wIds[i]] === "undefined") {
                jobQueue[0](workers[wIds[i]]);
                break;
            }
        }
    };
    const queue = (action, payload)=>new Promise((resolve, reject)=>{
            const job = $2420845b524afba2$exports({
                action: action,
                payload: payload
            });
            jobQueue.push(async (w)=>{
                jobQueue.shift();
                runningWorkers[w.id] = job;
                try {
                    resolve(await w[action].apply($49b16ef1d785ce5e$exports, [
                        ...payload,
                        job.id
                    ]));
                } catch (err) {
                    reject(err);
                } finally{
                    delete runningWorkers[w.id];
                    dequeue();
                }
            });
            $49b16ef1d785ce5e$require$log(`[${id}]: Add ${job.id} to JobQueue`);
            $49b16ef1d785ce5e$require$log(`[${id}]: JobQueue length=${jobQueue.length}`);
            dequeue();
        });
    const addWorker = (w)=>{
        workers[w.id] = w;
        $49b16ef1d785ce5e$require$log(`[${id}]: Add ${w.id}`);
        $49b16ef1d785ce5e$require$log(`[${id}]: Number of workers=${getNumWorkers()}`);
        dequeue();
        return w.id;
    };
    const addJob = async (action, ...payload)=>{
        if (getNumWorkers() === 0) throw Error(`[${id}]: You need to have at least one worker before adding jobs`);
        return queue(action, payload);
    };
    const terminate = async ()=>{
        Object.keys(workers).forEach(async (wid)=>{
            await workers[wid].terminate();
        });
        jobQueue = [];
    };
    return {
        addWorker: addWorker,
        addJob: addJob,
        terminate: terminate,
        getQueueLen: getQueueLen,
        getNumWorkers: getNumWorkers
    };
};


var $f08c933b5bf54dd4$exports = {};
var $1703fd713744fe14$exports = {};

const $1703fd713744fe14$var$isBrowser = (parcelRequire("hhKM0"))("type") === "browser";
const $1703fd713744fe14$var$resolveURL = $1703fd713744fe14$var$isBrowser ? (s)=>new URL(s, window.location.href).href : (s)=>s; // eslint-disable-line
$1703fd713744fe14$exports = (options)=>{
    const opts = {
        ...options
    };
    [
        "corePath",
        "workerPath",
        "langPath"
    ].forEach((key)=>{
        if (options[key]) opts[key] = $1703fd713744fe14$var$resolveURL(opts[key]);
    });
    return opts;
};


var $b5196e02c1ee8991$exports = {};
/**
 * In the recognition result of tesseract, there
 * is a deep JSON object for details, it has around
 *
 * The result of dump.js is a big JSON tree
 * which can be easily serialized (for instance
 * to be sent from a webworker to the main app
 * or through Node's IPC), but we want
 * a (circular) DOM-like interface for walking
 * through the data.
 *
 * @fileoverview DOM-like interface for walking through data
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */ $b5196e02c1ee8991$exports = (page)=>{
    const blocks = [];
    const paragraphs = [];
    const lines = [];
    const words = [];
    const symbols = [];
    if (page.blocks) page.blocks.forEach((block)=>{
        block.paragraphs.forEach((paragraph)=>{
            paragraph.lines.forEach((line)=>{
                line.words.forEach((word)=>{
                    word.symbols.forEach((sym)=>{
                        symbols.push({
                            ...sym,
                            page: page,
                            block: block,
                            paragraph: paragraph,
                            line: line,
                            word: word
                        });
                    });
                    words.push({
                        ...word,
                        page: page,
                        block: block,
                        paragraph: paragraph,
                        line: line
                    });
                });
                lines.push({
                    ...line,
                    page: page,
                    block: block,
                    paragraph: paragraph
                });
            });
            paragraphs.push({
                ...paragraph,
                page: page,
                block: block
            });
        });
        blocks.push({
            ...block,
            page: page
        });
    });
    return {
        ...page,
        blocks: blocks,
        paragraphs: paragraphs,
        lines: lines,
        words: words,
        symbols: symbols
    };
};




var $f08c933b5bf54dd4$require$log = $783866df820a0c01$exports.log;

var $02848974905aa098$exports = {};
/*
 * OEM = OCR Engine Mode, and there are 4 possible modes.
 *
 * By default tesseract.js uses LSTM_ONLY mode.
 *
 */ $02848974905aa098$exports = {
    TESSERACT_ONLY: 0,
    LSTM_ONLY: 1,
    TESSERACT_LSTM_COMBINED: 2,
    DEFAULT: 3
};


var $f569e342fe509aab$exports = {};
/**
 *
 * Tesseract Worker adapter for browser
 *
 * @fileoverview Tesseract Worker adapter for browser
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */ var $3d48c5ed83ed8309$exports = {};
var $56fec806e039b80f$exports = {};
$56fec806e039b80f$exports = JSON.parse('{"name":"tesseract.js","version":"5.1.1","description":"Pure Javascript Multilingual OCR","main":"src/index.js","types":"src/index.d.ts","unpkg":"dist/tesseract.min.js","jsdelivr":"dist/tesseract.min.js","scripts":{"start":"node scripts/server.js","build":"rimraf dist && webpack --config scripts/webpack.config.prod.js && rollup -c scripts/rollup.esm.mjs","profile:tesseract":"webpack-bundle-analyzer dist/tesseract-stats.json","profile:worker":"webpack-bundle-analyzer dist/worker-stats.json","prepublishOnly":"npm run build","wait":"rimraf dist && wait-on http://localhost:3000/dist/tesseract.min.js","test":"npm-run-all -p -r start test:all","test:all":"npm-run-all wait test:browser:* test:node:all","test:node":"nyc mocha --exit --bail --require ./scripts/test-helper.js","test:node:all":"npm run test:node -- ./tests/*.test.js","test:browser-tpl":"mocha-headless-chrome -a incognito -a no-sandbox -a disable-setuid-sandbox -a disable-logging -t 300000","test:browser:detect":"npm run test:browser-tpl -- -f ./tests/detect.test.html","test:browser:recognize":"npm run test:browser-tpl -- -f ./tests/recognize.test.html","test:browser:scheduler":"npm run test:browser-tpl -- -f ./tests/scheduler.test.html","test:browser:FS":"npm run test:browser-tpl -- -f ./tests/FS.test.html","lint":"eslint src","lint:fix":"eslint --fix src","postinstall":"opencollective-postinstall || true"},"browser":{"./src/worker/node/index.js":"./src/worker/browser/index.js"},"author":"","contributors":["jeromewu"],"license":"Apache-2.0","devDependencies":{"@babel/core":"^7.21.4","@babel/eslint-parser":"^7.21.3","@babel/preset-env":"^7.21.4","@rollup/plugin-commonjs":"^24.1.0","acorn":"^8.8.2","babel-loader":"^9.1.2","buffer":"^6.0.3","cors":"^2.8.5","eslint":"^7.32.0","eslint-config-airbnb-base":"^14.2.1","eslint-plugin-import":"^2.27.5","expect.js":"^0.3.1","express":"^4.18.2","mocha":"^10.2.0","mocha-headless-chrome":"^4.0.0","npm-run-all":"^4.1.5","nyc":"^15.1.0","rimraf":"^5.0.0","rollup":"^3.20.7","wait-on":"^7.0.1","webpack":"^5.79.0","webpack-bundle-analyzer":"^4.8.0","webpack-cli":"^5.0.1","webpack-dev-middleware":"^6.0.2","rollup-plugin-sourcemaps":"^0.6.3"},"dependencies":{"bmp-js":"^0.1.0","idb-keyval":"^6.2.0","is-electron":"^2.2.2","is-url":"^1.2.4","node-fetch":"^2.6.9","opencollective-postinstall":"^2.0.3","regenerator-runtime":"^0.13.3","tesseract.js-core":"^5.1.1","wasm-feature-detect":"^1.2.11","zlibjs":"^0.3.1"},"overrides":{"@rollup/pluginutils":"^5.0.2"},"repository":{"type":"git","url":"https://github.com/naptha/tesseract.js.git"},"bugs":{"url":"https://github.com/naptha/tesseract.js/issues"},"homepage":"https://github.com/naptha/tesseract.js","collective":{"type":"opencollective","url":"https://opencollective.com/tesseractjs"}}');


var $3d48c5ed83ed8309$require$version = $56fec806e039b80f$exports.version;
var $4ef628a13c9a50bb$exports = {};
$4ef628a13c9a50bb$exports = {
    /*
   * Use BlobURL for worker script by default
   * TODO: remove this option
   *
   */ workerBlobURL: true,
    logger: ()=>{}
};


/*
 * Default options for browser worker
 */ $3d48c5ed83ed8309$exports = {
    ...$4ef628a13c9a50bb$exports,
    workerPath: `https://cdn.jsdelivr.net/npm/tesseract.js@v${$3d48c5ed83ed8309$require$version}/dist/worker.min.js`
};


var $dc4ce1bcd9c71bc4$exports = {};
/**
 * spawnWorker
 *
 * @name spawnWorker
 * @function create a new Worker in browser
 * @access public
 */ $dc4ce1bcd9c71bc4$exports = ({ workerPath: workerPath, workerBlobURL: workerBlobURL })=>{
    let worker;
    if (Blob && URL && workerBlobURL) {
        const blob = new Blob([
            `importScripts("${workerPath}");`
        ], {
            type: "application/javascript"
        });
        worker = new Worker(URL.createObjectURL(blob));
    } else worker = new Worker(workerPath);
    return worker;
};


var $b5be2307f486bcb3$exports = {};
/**
 * terminateWorker
 *
 * @name terminateWorker
 * @function terminate worker
 * @access public
 */ $b5be2307f486bcb3$exports = (worker)=>{
    worker.terminate();
};


var $25d5d421bf3f04cf$exports = {};
$25d5d421bf3f04cf$exports = (worker, handler)=>{
    worker.onmessage = ({ data: data })=>{
        handler(data);
    };
};


var $cf8782ccd490659e$exports = {};
/**
 * send
 *
 * @name send
 * @function send packet to worker and create a job
 * @access public
 */ $cf8782ccd490659e$exports = async (worker, packet)=>{
    worker.postMessage(packet);
};


var $d087b061c7b0a036$exports = {};
/**
 * readFromBlobOrFile
 *
 * @name readFromBlobOrFile
 * @function
 * @access private
 */ const $d087b061c7b0a036$var$readFromBlobOrFile = (blob)=>new Promise((resolve, reject)=>{
        const fileReader = new FileReader();
        fileReader.onload = ()=>{
            resolve(fileReader.result);
        };
        fileReader.onerror = ({ target: { error: { code: code } } })=>{
            reject(Error(`File could not be read! Code=${code}`));
        };
        fileReader.readAsArrayBuffer(blob);
    });
/**
 * loadImage
 *
 * @name loadImage
 * @function load image from different source
 * @access private
 */ const $d087b061c7b0a036$var$loadImage = async (image)=>{
    let data = image;
    if (typeof image === "undefined") return "undefined";
    if (typeof image === "string") {
        // Base64 Image
        if (/data:image\/([a-zA-Z]*);base64,([^"]*)/.test(image)) data = atob(image.split(",")[1]).split("").map((c)=>c.charCodeAt(0));
        else {
            const resp = await fetch(image);
            data = await resp.arrayBuffer();
        }
    } else if (typeof HTMLElement !== "undefined" && image instanceof HTMLElement) {
        if (image.tagName === "IMG") data = await $d087b061c7b0a036$var$loadImage(image.src);
        if (image.tagName === "VIDEO") data = await $d087b061c7b0a036$var$loadImage(image.poster);
        if (image.tagName === "CANVAS") await new Promise((resolve)=>{
            image.toBlob(async (blob)=>{
                data = await $d087b061c7b0a036$var$readFromBlobOrFile(blob);
                resolve();
            });
        });
    } else if (typeof OffscreenCanvas !== "undefined" && image instanceof OffscreenCanvas) {
        const blob = await image.convertToBlob();
        data = await $d087b061c7b0a036$var$readFromBlobOrFile(blob);
    } else if (image instanceof File || image instanceof Blob) data = await $d087b061c7b0a036$var$readFromBlobOrFile(image);
    return new Uint8Array(data);
};
$d087b061c7b0a036$exports = $d087b061c7b0a036$var$loadImage;


$f569e342fe509aab$exports = {
    defaultOptions: $3d48c5ed83ed8309$exports,
    spawnWorker: $dc4ce1bcd9c71bc4$exports,
    terminateWorker: $b5be2307f486bcb3$exports,
    onMessage: $25d5d421bf3f04cf$exports,
    send: $cf8782ccd490659e$exports,
    loadImage: $d087b061c7b0a036$exports
};


var $f08c933b5bf54dd4$require$defaultOptions = $f569e342fe509aab$exports.defaultOptions;
var $f08c933b5bf54dd4$require$spawnWorker = $f569e342fe509aab$exports.spawnWorker;
var $f08c933b5bf54dd4$require$terminateWorker = $f569e342fe509aab$exports.terminateWorker;
var $f08c933b5bf54dd4$require$onMessage = $f569e342fe509aab$exports.onMessage;
var $f08c933b5bf54dd4$require$loadImage = $f569e342fe509aab$exports.loadImage;
var $f08c933b5bf54dd4$require$send = $f569e342fe509aab$exports.send;
let $f08c933b5bf54dd4$var$workerCounter = 0;
$f08c933b5bf54dd4$exports = async (langs = "eng", oem = $02848974905aa098$exports.LSTM_ONLY, _options = {}, config = {})=>{
    const id = $552eb34024e7eafe$exports("Worker", $f08c933b5bf54dd4$var$workerCounter);
    const { logger: logger, errorHandler: errorHandler, ...options } = $1703fd713744fe14$exports({
        ...$f08c933b5bf54dd4$require$defaultOptions,
        ..._options
    });
    const resolves = {};
    const rejects = {};
    // Current langs, oem, and config file.
    // Used if the user ever re-initializes the worker using `worker.reinitialize`.
    const currentLangs = typeof langs === "string" ? langs.split("+") : langs;
    let currentOem = oem;
    let currentConfig = config;
    const lstmOnlyCore = [
        $02848974905aa098$exports.DEFAULT,
        $02848974905aa098$exports.LSTM_ONLY
    ].includes(oem) && !options.legacyCore;
    let workerResReject;
    let workerResResolve;
    const workerRes = new Promise((resolve, reject)=>{
        workerResResolve = resolve;
        workerResReject = reject;
    });
    const workerError = (event)=>{
        workerResReject(event.message);
    };
    let worker = $f08c933b5bf54dd4$require$spawnWorker(options);
    worker.onerror = workerError;
    $f08c933b5bf54dd4$var$workerCounter += 1;
    const setResolve = (promiseId, res)=>{
        resolves[promiseId] = res;
    };
    const setReject = (promiseId, rej)=>{
        rejects[promiseId] = rej;
    };
    const startJob = ({ id: jobId, action: action, payload: payload })=>new Promise((resolve, reject)=>{
            $f08c933b5bf54dd4$require$log(`[${id}]: Start ${jobId}, action=${action}`);
            // Using both `action` and `jobId` in case user provides non-unique `jobId`.
            const promiseId = `${action}-${jobId}`;
            setResolve(promiseId, resolve);
            setReject(promiseId, reject);
            $f08c933b5bf54dd4$require$send(worker, {
                workerId: id,
                jobId: jobId,
                action: action,
                payload: payload
            });
        });
    const load = ()=>console.warn("`load` is depreciated and should be removed from code (workers now come pre-loaded)");
    const loadInternal = (jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "load",
            payload: {
                options: {
                    lstmOnly: lstmOnlyCore,
                    corePath: options.corePath,
                    logging: options.logging
                }
            }
        }));
    const writeText = (path, text, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "FS",
            payload: {
                method: "writeFile",
                args: [
                    path,
                    text
                ]
            }
        }));
    const readText = (path, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "FS",
            payload: {
                method: "readFile",
                args: [
                    path,
                    {
                        encoding: "utf8"
                    }
                ]
            }
        }));
    const removeFile = (path, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "FS",
            payload: {
                method: "unlink",
                args: [
                    path
                ]
            }
        }));
    const FS = (method, args, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "FS",
            payload: {
                method: method,
                args: args
            }
        }));
    const loadLanguage = ()=>console.warn("`loadLanguage` is depreciated and should be removed from code (workers now come with language pre-loaded)");
    const loadLanguageInternal = (_langs, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "loadLanguage",
            payload: {
                langs: _langs,
                options: {
                    langPath: options.langPath,
                    dataPath: options.dataPath,
                    cachePath: options.cachePath,
                    cacheMethod: options.cacheMethod,
                    gzip: options.gzip,
                    lstmOnly: [
                        $02848974905aa098$exports.DEFAULT,
                        $02848974905aa098$exports.LSTM_ONLY
                    ].includes(currentOem) && !options.legacyLang
                }
            }
        }));
    const initialize = ()=>console.warn("`initialize` is depreciated and should be removed from code (workers now come pre-initialized)");
    const initializeInternal = (_langs, _oem, _config, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "initialize",
            payload: {
                langs: _langs,
                oem: _oem,
                config: _config
            }
        }));
    const reinitialize = (langs = "eng", oem, config, jobId)=>{
        if (lstmOnlyCore && [
            $02848974905aa098$exports.TESSERACT_ONLY,
            $02848974905aa098$exports.TESSERACT_LSTM_COMBINED
        ].includes(oem)) throw Error("Legacy model requested but code missing.");
        const _oem = oem || currentOem;
        currentOem = _oem;
        const _config = config || currentConfig;
        currentConfig = _config;
        // Only load langs that are not already loaded.
        // This logic fails if the user downloaded the LSTM-only English data for a language
        // and then uses `worker.reinitialize` to switch to the Legacy engine.
        // However, the correct data will still be downloaded after initialization fails
        // and this can be avoided entirely if the user loads the correct data ahead of time.
        const langsArr = typeof langs === "string" ? langs.split("+") : langs;
        const _langs = langsArr.filter((x)=>!currentLangs.includes(x));
        currentLangs.push(..._langs);
        if (_langs.length > 0) return loadLanguageInternal(_langs, jobId).then(()=>initializeInternal(langs, _oem, _config, jobId));
        return initializeInternal(langs, _oem, _config, jobId);
    };
    const setParameters = (params = {}, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "setParameters",
            payload: {
                params: params
            }
        }));
    const recognize = async (image, opts = {}, output = {
        blocks: true,
        text: true,
        hocr: true,
        tsv: true
    }, jobId)=>startJob($2420845b524afba2$exports({
            id: jobId,
            action: "recognize",
            payload: {
                image: await $f08c933b5bf54dd4$require$loadImage(image),
                options: opts,
                output: output
            }
        }));
    const getPDF = (title = "Tesseract OCR Result", textonly = false, jobId)=>{
        console.log("`getPDF` function is depreciated. `recognize` option `savePDF` should be used instead.");
        return startJob($2420845b524afba2$exports({
            id: jobId,
            action: "getPDF",
            payload: {
                title: title,
                textonly: textonly
            }
        }));
    };
    const detect = async (image, jobId)=>{
        if (lstmOnlyCore) throw Error("`worker.detect` requires Legacy model, which was not loaded.");
        return startJob($2420845b524afba2$exports({
            id: jobId,
            action: "detect",
            payload: {
                image: await $f08c933b5bf54dd4$require$loadImage(image)
            }
        }));
    };
    const terminate = async ()=>{
        if (worker !== null) {
            /*
      await startJob(createJob({
        id: jobId,
        action: 'terminate',
      }));
      */ $f08c933b5bf54dd4$require$terminateWorker(worker);
            worker = null;
        }
        return Promise.resolve();
    };
    $f08c933b5bf54dd4$require$onMessage(worker, ({ workerId: workerId, jobId: jobId, status: status, action: action, data: data })=>{
        const promiseId = `${action}-${jobId}`;
        if (status === "resolve") {
            $f08c933b5bf54dd4$require$log(`[${workerId}]: Complete ${jobId}`);
            let d = data;
            if (action === "recognize") d = $b5196e02c1ee8991$exports(data);
            else if (action === "getPDF") d = Array.from({
                ...data,
                length: Object.keys(data).length
            });
            resolves[promiseId]({
                jobId: jobId,
                data: d
            });
        } else if (status === "reject") {
            rejects[promiseId](data);
            if (action === "load") workerResReject(data);
            if (errorHandler) errorHandler(data);
            else throw Error(data);
        } else if (status === "progress") logger({
            ...data,
            userJobId: jobId
        });
    });
    const resolveObj = {
        id: id,
        worker: worker,
        setResolve: setResolve,
        setReject: setReject,
        load: load,
        writeText: writeText,
        readText: readText,
        removeFile: removeFile,
        FS: FS,
        loadLanguage: loadLanguage,
        initialize: initialize,
        reinitialize: reinitialize,
        setParameters: setParameters,
        recognize: recognize,
        getPDF: getPDF,
        detect: detect,
        terminate: terminate
    };
    loadInternal().then(()=>loadLanguageInternal(langs)).then(()=>initializeInternal(langs, oem, config)).then(()=>workerResResolve(resolveObj)).catch(()=>{});
    return workerRes;
};


var $d6093d9ad0868e0c$exports = {};

const $d6093d9ad0868e0c$var$recognize = async (image, langs, options)=>{
    const worker = await $f08c933b5bf54dd4$exports(langs, 1, options);
    return worker.recognize(image).finally(async ()=>{
        await worker.terminate();
    });
};
const $d6093d9ad0868e0c$var$detect = async (image, options)=>{
    const worker = await $f08c933b5bf54dd4$exports("osd", 0, options);
    return worker.detect(image).finally(async ()=>{
        await worker.terminate();
    });
};
$d6093d9ad0868e0c$exports = {
    recognize: $d6093d9ad0868e0c$var$recognize,
    detect: $d6093d9ad0868e0c$var$detect
};


var $a812971455cc989d$exports = {};
/*
 * languages with existing tesseract traineddata
 * https://tesseract-ocr.github.io/tessdoc/Data-Files#data-files-for-version-400-november-29-2016
 */ /**
 * @typedef {object} Languages
 * @property {string} AFR Afrikaans
 * @property {string} AMH Amharic
 * @property {string} ARA Arabic
 * @property {string} ASM Assamese
 * @property {string} AZE Azerbaijani
 * @property {string} AZE_CYRL Azerbaijani - Cyrillic
 * @property {string} BEL Belarusian
 * @property {string} BEN Bengali
 * @property {string} BOD Tibetan
 * @property {string} BOS Bosnian
 * @property {string} BUL Bulgarian
 * @property {string} CAT Catalan; Valencian
 * @property {string} CEB Cebuano
 * @property {string} CES Czech
 * @property {string} CHI_SIM Chinese - Simplified
 * @property {string} CHI_TRA Chinese - Traditional
 * @property {string} CHR Cherokee
 * @property {string} CYM Welsh
 * @property {string} DAN Danish
 * @property {string} DEU German
 * @property {string} DZO Dzongkha
 * @property {string} ELL Greek, Modern (1453-)
 * @property {string} ENG English
 * @property {string} ENM English, Middle (1100-1500)
 * @property {string} EPO Esperanto
 * @property {string} EST Estonian
 * @property {string} EUS Basque
 * @property {string} FAS Persian
 * @property {string} FIN Finnish
 * @property {string} FRA French
 * @property {string} FRK German Fraktur
 * @property {string} FRM French, Middle (ca. 1400-1600)
 * @property {string} GLE Irish
 * @property {string} GLG Galician
 * @property {string} GRC Greek, Ancient (-1453)
 * @property {string} GUJ Gujarati
 * @property {string} HAT Haitian; Haitian Creole
 * @property {string} HEB Hebrew
 * @property {string} HIN Hindi
 * @property {string} HRV Croatian
 * @property {string} HUN Hungarian
 * @property {string} IKU Inuktitut
 * @property {string} IND Indonesian
 * @property {string} ISL Icelandic
 * @property {string} ITA Italian
 * @property {string} ITA_OLD Italian - Old
 * @property {string} JAV Javanese
 * @property {string} JPN Japanese
 * @property {string} KAN Kannada
 * @property {string} KAT Georgian
 * @property {string} KAT_OLD Georgian - Old
 * @property {string} KAZ Kazakh
 * @property {string} KHM Central Khmer
 * @property {string} KIR Kirghiz; Kyrgyz
 * @property {string} KOR Korean
 * @property {string} KUR Kurdish
 * @property {string} LAO Lao
 * @property {string} LAT Latin
 * @property {string} LAV Latvian
 * @property {string} LIT Lithuanian
 * @property {string} MAL Malayalam
 * @property {string} MAR Marathi
 * @property {string} MKD Macedonian
 * @property {string} MLT Maltese
 * @property {string} MSA Malay
 * @property {string} MYA Burmese
 * @property {string} NEP Nepali
 * @property {string} NLD Dutch; Flemish
 * @property {string} NOR Norwegian
 * @property {string} ORI Oriya
 * @property {string} PAN Panjabi; Punjabi
 * @property {string} POL Polish
 * @property {string} POR Portuguese
 * @property {string} PUS Pushto; Pashto
 * @property {string} RON Romanian; Moldavian; Moldovan
 * @property {string} RUS Russian
 * @property {string} SAN Sanskrit
 * @property {string} SIN Sinhala; Sinhalese
 * @property {string} SLK Slovak
 * @property {string} SLV Slovenian
 * @property {string} SPA Spanish; Castilian
 * @property {string} SPA_OLD Spanish; Castilian - Old
 * @property {string} SQI Albanian
 * @property {string} SRP Serbian
 * @property {string} SRP_LATN Serbian - Latin
 * @property {string} SWA Swahili
 * @property {string} SWE Swedish
 * @property {string} SYR Syriac
 * @property {string} TAM Tamil
 * @property {string} TEL Telugu
 * @property {string} TGK Tajik
 * @property {string} TGL Tagalog
 * @property {string} THA Thai
 * @property {string} TIR Tigrinya
 * @property {string} TUR Turkish
 * @property {string} UIG Uighur; Uyghur
 * @property {string} UKR Ukrainian
 * @property {string} URD Urdu
 * @property {string} UZB Uzbek
 * @property {string} UZB_CYRL Uzbek - Cyrillic
 * @property {string} VIE Vietnamese
 * @property {string} YID Yiddish
 */ /**
  * @type {Languages}
  */ $a812971455cc989d$exports = {
    AFR: "afr",
    AMH: "amh",
    ARA: "ara",
    ASM: "asm",
    AZE: "aze",
    AZE_CYRL: "aze_cyrl",
    BEL: "bel",
    BEN: "ben",
    BOD: "bod",
    BOS: "bos",
    BUL: "bul",
    CAT: "cat",
    CEB: "ceb",
    CES: "ces",
    CHI_SIM: "chi_sim",
    CHI_TRA: "chi_tra",
    CHR: "chr",
    CYM: "cym",
    DAN: "dan",
    DEU: "deu",
    DZO: "dzo",
    ELL: "ell",
    ENG: "eng",
    ENM: "enm",
    EPO: "epo",
    EST: "est",
    EUS: "eus",
    FAS: "fas",
    FIN: "fin",
    FRA: "fra",
    FRK: "frk",
    FRM: "frm",
    GLE: "gle",
    GLG: "glg",
    GRC: "grc",
    GUJ: "guj",
    HAT: "hat",
    HEB: "heb",
    HIN: "hin",
    HRV: "hrv",
    HUN: "hun",
    IKU: "iku",
    IND: "ind",
    ISL: "isl",
    ITA: "ita",
    ITA_OLD: "ita_old",
    JAV: "jav",
    JPN: "jpn",
    KAN: "kan",
    KAT: "kat",
    KAT_OLD: "kat_old",
    KAZ: "kaz",
    KHM: "khm",
    KIR: "kir",
    KOR: "kor",
    KUR: "kur",
    LAO: "lao",
    LAT: "lat",
    LAV: "lav",
    LIT: "lit",
    MAL: "mal",
    MAR: "mar",
    MKD: "mkd",
    MLT: "mlt",
    MSA: "msa",
    MYA: "mya",
    NEP: "nep",
    NLD: "nld",
    NOR: "nor",
    ORI: "ori",
    PAN: "pan",
    POL: "pol",
    POR: "por",
    PUS: "pus",
    RON: "ron",
    RUS: "rus",
    SAN: "san",
    SIN: "sin",
    SLK: "slk",
    SLV: "slv",
    SPA: "spa",
    SPA_OLD: "spa_old",
    SQI: "sqi",
    SRP: "srp",
    SRP_LATN: "srp_latn",
    SWA: "swa",
    SWE: "swe",
    SYR: "syr",
    TAM: "tam",
    TEL: "tel",
    TGK: "tgk",
    TGL: "tgl",
    THA: "tha",
    TIR: "tir",
    TUR: "tur",
    UIG: "uig",
    UKR: "ukr",
    URD: "urd",
    UZB: "uzb",
    UZB_CYRL: "uzb_cyrl",
    VIE: "vie",
    YID: "yid"
};



var $daa65cb765258a24$exports = {};
/*
 * PSM = Page Segmentation Mode
 */ $daa65cb765258a24$exports = {
    OSD_ONLY: "0",
    AUTO_OSD: "1",
    AUTO_ONLY: "2",
    AUTO: "3",
    SINGLE_COLUMN: "4",
    SINGLE_BLOCK_VERT_TEXT: "5",
    SINGLE_BLOCK: "6",
    SINGLE_LINE: "7",
    SINGLE_WORD: "8",
    CIRCLE_WORD: "9",
    SINGLE_CHAR: "10",
    SPARSE_TEXT: "11",
    SPARSE_TEXT_OSD: "12",
    RAW_LINE: "13"
};



var $6f4fef37bd1ca6c7$require$setLogging = $783866df820a0c01$exports.setLogging;
$6f4fef37bd1ca6c7$exports = {
    languages: $a812971455cc989d$exports,
    OEM: $02848974905aa098$exports,
    PSM: $daa65cb765258a24$exports,
    createScheduler: $49b16ef1d785ce5e$exports,
    createWorker: $f08c933b5bf54dd4$exports,
    setLogging: $6f4fef37bd1ca6c7$require$setLogging,
    ...$d6093d9ad0868e0c$exports
};


var $61d53a34622b4779$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $61d53a34622b4779$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $61d53a34622b4779$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $61d53a34622b4779$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $61d53a34622b4779$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $61d53a34622b4779$export$91b4fa26d661bfc9 = (()=>{
    var _a, _OCRModel_currentProgress_accessor_storage, _OCRModel_resultText_accessor_storage;
    let _classSuper = (0, $9e9c5688c76adff9$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _currentProgress_decorators;
    let _currentProgress_initializers = [];
    let _currentProgress_extraInitializers = [];
    let _get_currentPercent_decorators;
    let _resultText_decorators;
    let _resultText_initializers = [];
    let _resultText_extraInitializers = [];
    let _recognize_decorators;
    return _a = class OCRModel extends _classSuper {
        constructor(language = "chi_sim"){
            super();
            this.language = ($61d53a34622b4779$var$__runInitializers(this, _instanceExtraInitializers), language);
            _OCRModel_currentProgress_accessor_storage.set(this, $61d53a34622b4779$var$__runInitializers(this, _currentProgress_initializers, void 0));
            _OCRModel_resultText_accessor_storage.set(this, ($61d53a34622b4779$var$__runInitializers(this, _currentProgress_extraInitializers), $61d53a34622b4779$var$__runInitializers(this, _resultText_initializers, void 0)));
            $61d53a34622b4779$var$__runInitializers(this, _resultText_extraInitializers);
            this.language = language;
        }
        get currentProgress() {
            return $61d53a34622b4779$var$__classPrivateFieldGet(this, _OCRModel_currentProgress_accessor_storage, "f");
        }
        set currentProgress(value) {
            $61d53a34622b4779$var$__classPrivateFieldSet(this, _OCRModel_currentProgress_accessor_storage, value, "f");
        }
        get currentPercent() {
            var _b;
            return (((_b = this.currentProgress) === null || _b === void 0 ? void 0 : _b.progress) || 0) * 100;
        }
        get resultText() {
            return $61d53a34622b4779$var$__classPrivateFieldGet(this, _OCRModel_resultText_accessor_storage, "f");
        }
        set resultText(value) {
            $61d53a34622b4779$var$__classPrivateFieldSet(this, _OCRModel_resultText_accessor_storage, value, "f");
        }
        recognize(image) {
            return $61d53a34622b4779$var$__awaiter(this, void 0, void 0, function*() {
                const worker = yield (0, $6f4fef37bd1ca6c7$exports.createWorker)(this.language, 1, {
                    logger: (message)=>this.currentProgress = message
                });
                const { data: data } = yield worker.recognize(image);
                yield worker.terminate();
                const text = data.text.replace(/(?<=[\p{Script=Han}])\s+(?=[\p{Script=Han}])/gu, "");
                return this.resultText = text;
            });
        }
    }, _OCRModel_currentProgress_accessor_storage = new WeakMap(), _OCRModel_resultText_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentProgress_decorators = [
            (0, $aM14C.observable)
        ];
        _get_currentPercent_decorators = [
            (0, $aM14C.computed)
        ];
        _resultText_decorators = [
            (0, $aM14C.observable)
        ];
        _recognize_decorators = [
            (0, $9e9c5688c76adff9$export$e03c1c3201ee8bb7)("uploading")
        ];
        $61d53a34622b4779$var$__esDecorate(_a, null, _currentProgress_decorators, {
            kind: "accessor",
            name: "currentProgress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentProgress" in obj,
                get: (obj)=>obj.currentProgress,
                set: (obj, value)=>{
                    obj.currentProgress = value;
                }
            },
            metadata: _metadata
        }, _currentProgress_initializers, _currentProgress_extraInitializers);
        $61d53a34622b4779$var$__esDecorate(_a, null, _get_currentPercent_decorators, {
            kind: "getter",
            name: "currentPercent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPercent" in obj,
                get: (obj)=>obj.currentPercent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $61d53a34622b4779$var$__esDecorate(_a, null, _resultText_decorators, {
            kind: "accessor",
            name: "resultText",
            static: false,
            private: false,
            access: {
                has: (obj)=>"resultText" in obj,
                get: (obj)=>obj.resultText,
                set: (obj, value)=>{
                    obj.resultText = value;
                }
            },
            metadata: _metadata
        }, _resultText_initializers, _resultText_extraInitializers);
        $61d53a34622b4779$var$__esDecorate(_a, null, _recognize_decorators, {
            kind: "method",
            name: "recognize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"recognize" in obj,
                get: (obj)=>obj.recognize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $4b6741e6925a057b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4b6741e6925a057b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4b6741e6925a057b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4b6741e6925a057b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4b6741e6925a057b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $4b6741e6925a057b$export$36d69433c4f81145 = (()=>{
    var _HomePage_cameraOpened_accessor_storage;
    let _classDecorators = [
        (0, $658a8f813065c2f1$export$d8556a2a8f973135)({
            tagName: "home-page"
        }),
        (0, $658a8f813065c2f1$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _cameraOpened_decorators;
    let _cameraOpened_initializers = [];
    let _cameraOpened_extraInitializers = [];
    var HomePage = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            this.storeOCR = new (0, $61d53a34622b4779$export$91b4fa26d661bfc9)();
            this.storeTTS = new (0, $65266c53861a64ab$export$6c5d58455f3ab236)();
            _HomePage_cameraOpened_accessor_storage.set(this, $4b6741e6925a057b$var$__runInitializers(this, _cameraOpened_initializers, false));
            this.handleRecognition = ($4b6741e6925a057b$var$__runInitializers(this, _cameraOpened_extraInitializers), ({ detail: detail })=>{
                this.cameraOpened = false;
                this.storeOCR.recognize(detail);
            });
            this.toggleSpeaking = ()=>{
                const { storeTTS: storeTTS } = this;
                if (storeTTS.state !== (0, $65266c53861a64ab$export$bf098d6e10b5582a).Clear) return storeTTS.toggle();
                const text = (0, $65266c53861a64ab$export$6c5d58455f3ab236).getReadableText(this.querySelector("article"));
                storeTTS.speak(text);
            };
        }
        get cameraOpened() {
            return $4b6741e6925a057b$var$__classPrivateFieldGet(this, _HomePage_cameraOpened_accessor_storage, "f");
        }
        set cameraOpened(value) {
            $4b6741e6925a057b$var$__classPrivateFieldSet(this, _HomePage_cameraOpened_accessor_storage, value, "f");
        }
        render() {
            const { storeOCR: storeOCR, storeTTS: storeTTS, cameraOpened: cameraOpened } = this;
            const { uploading: uploading, currentPercent: currentPercent, resultText: resultText } = storeOCR;
            const recognizing = uploading > 0, speaking = storeTTS.state === (0, $65266c53861a64ab$export$bf098d6e10b5582a).Speaking;
            return (0, $4d842655b16a6eb0$exports.jsxs)((0, $ecf668de0cd72cb2$export$d4c790f923031725), {
                className: "d-flex flex-column gap-3 py-3",
                cover: recognizing,
                children: [
                    (0, $4d842655b16a6eb0$exports.jsxs)("header", {
                        className: "d-flex justify-content-around",
                        children: [
                            (0, $4d842655b16a6eb0$exports.jsx)((0, $ecf668de0cd72cb2$export$353f5b6fc5456de1), {
                                variant: "danger",
                                size: "lg",
                                onClick: ()=>this.cameraOpened = true,
                                children: "\uD83D\uDCF7"
                            }),
                            (0, $4d842655b16a6eb0$exports.jsx)((0, $ecf668de0cd72cb2$export$353f5b6fc5456de1), {
                                variant: speaking ? "warning" : "info",
                                size: "lg",
                                onClick: this.toggleSpeaking,
                                children: speaking ? "\uD83D\uDD07" : "\uD83D\uDCE2"
                            })
                        ]
                    }),
                    cameraOpened && (0, $4d842655b16a6eb0$exports.jsx)("div", {
                        className: "position-fixed start-0 top-0 w-100 h-100 bg-black",
                        children: (0, $4d842655b16a6eb0$exports.jsx)((0, $d1b4eb187dad9a3b$export$ea4bacb7eec73803), {
                            className: "h-100",
                            onCapture: this.handleRecognition
                        })
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)((0, $ecf668de0cd72cb2$export$c17561cb55d4db30), {
                        now: currentPercent,
                        label: (value)=>{
                            var _a;
                            return `${value === null || value === void 0 ? void 0 : value.toFixed(2)}% ${(_a = storeOCR.currentProgress) === null || _a === void 0 ? void 0 : _a.status}`;
                        }
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)("article", {
                        children: resultText
                    })
                ]
            });
        }
    };
    _HomePage_cameraOpened_accessor_storage = new WeakMap();
    $4b6741e6925a057b$var$__setFunctionName(_classThis, "HomePage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _cameraOpened_decorators = [
            (0, $aM14C.observable)
        ];
        $4b6741e6925a057b$var$__esDecorate(_classThis, null, _cameraOpened_decorators, {
            kind: "accessor",
            name: "cameraOpened",
            static: false,
            private: false,
            access: {
                has: (obj)=>"cameraOpened" in obj,
                get: (obj)=>obj.cameraOpened,
                set: (obj, value)=>{
                    obj.cameraOpened = value;
                }
            },
            metadata: _metadata
        }, _cameraOpened_initializers, _cameraOpened_extraInitializers);
        $4b6741e6925a057b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        HomePage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4b6741e6925a057b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return HomePage = _classThis;
})();


const $f1ce7503a99226dc$var$menu = [
    {
        title: "Hello",
        href: "/hello"
    },
    {
        title: "Clock",
        href: "/clock"
    },
    {
        title: "GitHub source",
        href: "https://github.com/Open-Source-Bazaar/PaperBookReader"
    }
];
const { Route: $f1ce7503a99226dc$var$Route } = (0, $fac22966530e4ab6$export$baddd0131ee8c05b)();
const $f1ce7503a99226dc$export$953c2efc134d7f79 = ()=>(0, $4d842655b16a6eb0$exports.jsxs)("div", {
        className: "d-flex flex-column vh-100",
        children: [
            (0, $4d842655b16a6eb0$exports.jsx)((0, $ecf668de0cd72cb2$export$d31319d8cbfdaf50), {
                variant: "dark",
                expand: "md",
                sticky: "top",
                fluid: "lg",
                brand: (0, $4d842655b16a6eb0$exports.jsxs)((0, $ecf668de0cd72cb2$export$2df9f3e5f6d355f6), {
                    children: [
                        (0, $4d842655b16a6eb0$exports.jsx)("img", {
                            className: "me-2",
                            style: {
                                width: "2rem"
                            },
                            alt: "WebCell",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cb296ebeb08e4c65$exports)))
                        }),
                        "PaperBookReader"
                    ]
                }),
                children: (0, $4d842655b16a6eb0$exports.jsx)((0, $ecf668de0cd72cb2$export$39140c7d8b0ba7b3), {
                    className: "justify-content-end flex-fill gap-3",
                    children: $f1ce7503a99226dc$var$menu.map(({ title: title, href: href })=>(0, $4d842655b16a6eb0$exports.jsx)((0, $ecf668de0cd72cb2$export$b0d92dbee9b5b60d), {
                            href: href.startsWith("http") ? href : `#${href}`,
                            children: title
                        }))
                })
            }),
            (0, $4d842655b16a6eb0$exports.jsxs)("main", {
                className: "container flex-fill",
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)($f1ce7503a99226dc$var$Route, {
                        path: "",
                        component: (0, $4b6741e6925a057b$export$36d69433c4f81145)
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)($f1ce7503a99226dc$var$Route, {
                        path: "/clock",
                        component: (0, $7887ccde2f829353$export$bf420caf3cb24263)
                    }),
                    (0, $4d842655b16a6eb0$exports.jsx)($f1ce7503a99226dc$var$Route, {
                        path: "/hello",
                        component: (0, $457093948543ff32$export$f7bfe31b45496d55)
                    })
                ]
            }),
            (0, $4d842655b16a6eb0$exports.jsxs)("footer", {
                className: "text-center bg-light py-5",
                children: [
                    (0, $4d842655b16a6eb0$exports.jsx)("img", {
                        className: "mx-1",
                        style: {
                            width: "1.5rem"
                        },
                        alt: "WebCell",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cb296ebeb08e4c65$exports)))
                    }),
                    "Proudly developed with",
                    (0, $4d842655b16a6eb0$exports.jsx)("a", {
                        className: "mx-1",
                        target: "_blank",
                        href: "https://web-cell.dev/",
                        rel: "noreferrer",
                        children: "WebCell v3"
                    }),
                    "&",
                    (0, $4d842655b16a6eb0$exports.jsx)("a", {
                        className: "mx-1",
                        target: "_blank",
                        href: "https://bootstrap.web-cell.dev/",
                        rel: "noreferrer",
                        children: "BootCell v2"
                    })
                ]
            })
        ]
    });


(0, $5ec47347fc6130b4$export$dfb5619354ba860)();
(0, $aM14C.configure)({
    enforceActions: "never"
});
self.addEventListener("unhandledrejection", ({ reason: reason })=>{
    const { message: message } = reason;
    if (message) self.alert(message);
});
const { serviceWorker: $ce967277cb0dfddc$var$serviceWorker } = window.navigator;
$ce967277cb0dfddc$var$serviceWorker === null || $ce967277cb0dfddc$var$serviceWorker === void 0 || $ce967277cb0dfddc$var$serviceWorker.register("sw.js").then((0, $1aYx7.serviceWorkerUpdate)).then((worker)=>{
    if (window.confirm("New version of this Web App detected, update now?")) worker.postMessage({
        type: "SKIP_WAITING"
    });
});
$ce967277cb0dfddc$var$serviceWorker === null || $ce967277cb0dfddc$var$serviceWorker === void 0 || $ce967277cb0dfddc$var$serviceWorker.addEventListener("controllerchange", ()=>window.location.reload());
(0, $1aYx7.documentReady).then(()=>new (0, $53a0e53619b2c4c1$exports.DOMRenderer)().render((0, $4d842655b16a6eb0$exports.jsx)((0, $f1ce7503a99226dc$export$953c2efc134d7f79), {})));


//# sourceMappingURL=index.f11b538e.js.map
